/*
 CanvasJS HTML5 & JavaScript Charts - v2.0.1 GA - https://canvasjs.com/
 Copyright 2017 fenopix

  --------------------- License Information --------------------
 CanvasJS is a commercial product which requires purchase of license. Without a commercial license you can use it for evaluation purposes for upto 30 days. Please refer to the following link for further details.
     https://canvasjs.com/license-canvasjs/

*/
/*eslint-disable*/
(function () {
  function ma(p, t) {
    p.prototype = Ya(t.prototype);
    p.prototype.constructor = p;
    p.base = t.prototype;
  }
  function Ya(p) {
    function t() {}
    t.prototype = p;
    return new t();
  }
  function Sa(p, t, s) {
    "millisecond" === s
      ? p.setMilliseconds(p.getMilliseconds() + 1 * t)
      : "second" === s
      ? p.setSeconds(p.getSeconds() + 1 * t)
      : "minute" === s
      ? p.setMinutes(p.getMinutes() + 1 * t)
      : "hour" === s
      ? p.setHours(p.getHours() + 1 * t)
      : "day" === s
      ? p.setDate(p.getDate() + 1 * t)
      : "week" === s
      ? p.setDate(p.getDate() + 7 * t)
      : "month" === s
      ? p.setMonth(p.getMonth() + 1 * t)
      : "year" === s && p.setFullYear(p.getFullYear() + 1 * t);
    return p;
  }
  function ea(p, t) {
    var s = !1;
    0 > p && ((s = !0), (p *= -1));
    p = "" + p;
    for (t = t ? t : 1; p.length < t; ) p = "0" + p;
    return s ? "-" + p : p;
  }
  function Ea(p) {
    if (!p) return p;
    p = p.replace(/^\s\s*/, "");
    for (var t = /\s/, s = p.length; t.test(p.charAt(--s)); );
    return p.slice(0, s + 1);
  }
  function Aa(p) {
    p.roundRect = function (p, s, v, y, x, B, S, z) {
      S && (this.fillStyle = S);
      z && (this.strokeStyle = z);
      "undefined" === typeof x && (x = 5);
      this.lineWidth = B;
      this.beginPath();
      this.moveTo(p + x, s);
      this.lineTo(p + v - x, s);
      this.quadraticCurveTo(p + v, s, p + v, s + x);
      this.lineTo(p + v, s + y - x);
      this.quadraticCurveTo(p + v, s + y, p + v - x, s + y);
      this.lineTo(p + x, s + y);
      this.quadraticCurveTo(p, s + y, p, s + y - x);
      this.lineTo(p, s + x);
      this.quadraticCurveTo(p, s, p + x, s);
      this.closePath();
      S && this.fill();
      z && 0 < B && this.stroke();
    };
  }
  function Oa(p, t) {
    return p - t;
  }
  function R(p) {
    var t = ((p & 16711680) >> 16).toString(16),
      s = ((p & 65280) >> 8).toString(16);
    p = ((p & 255) >> 0).toString(16);
    t = 2 > t.length ? "0" + t : t;
    s = 2 > s.length ? "0" + s : s;
    p = 2 > p.length ? "0" + p : p;
    return "#" + t + s + p;
  }
  function Za(p, t) {
    var s = this.length >>> 0,
      v = Number(t) || 0,
      v = 0 > v ? Math.ceil(v) : Math.floor(v);
    for (0 > v && (v += s); v < s; v++)
      if (v in this && this[v] === p) return v;
    return -1;
  }
  function y(p) {
    return null === p || "undefined" === typeof p;
  }
  function Ba(p) {
    p.indexOf || (p.indexOf = Za);
    return p;
  }
  function $a(p) {
    if (Fa.fSDec)
      p[ha("`eeDwdouMhrudods")](ha("e`u`@ohl`uhnoHuds`uhnoDoe"), function () {
        Fa._fTWm && Fa._fTWm(p);
      });
  }
  function Ta(p, t, s) {
    s = s || "normal";
    var v = p + "_" + t + "_" + s,
      y = Ua[v];
    if (isNaN(y)) {
      try {
        p =
          "position:absolute; left:0px; top:-20000px; padding:0px;margin:0px;border:none;white-space:pre;line-height:normal;font-family:" +
          p +
          "; font-size:" +
          t +
          "px; font-weight:" +
          s +
          ";";
        if (!oa) {
          var x = document.body;
          oa = document.createElement("span");
          oa.innerHTML = "";
          var B = document.createTextNode("Mpgyi");
          oa.appendChild(B);
          x.appendChild(oa);
        }
        oa.style.display = "";
        oa.setAttribute("style", p);
        y = Math.round(oa.offsetHeight);
        oa.style.display = "none";
      } catch (S) {
        y = Math.ceil(1.1 * t);
      }
      y = Math.max(y, t);
      Ua[v] = y;
    }
    return y;
  }
  function F(p, t) {
    var s = [];
    if (
      (s = {
        solid: [],
        shortDash: [3, 1],
        shortDot: [1, 1],
        shortDashDot: [3, 1, 1, 1],
        shortDashDotDot: [3, 1, 1, 1, 1, 1],
        dot: [1, 2],
        dash: [4, 2],
        dashDot: [4, 2, 1, 2],
        longDash: [8, 2],
        longDashDot: [8, 2, 1, 2],
        longDashDotDot: [8, 2, 1, 2, 1, 2],
      }[p || "solid"])
    )
      for (var v = 0; v < s.length; v++) s[v] *= t;
    else s = [];
    return s;
  }
  function P(p, t, s, v) {
    return p.addEventListener
      ? (p.addEventListener(t, s, v || !1), s)
      : p.attachEvent
      ? ((v = function (t) {
          t = t || window.event;
          t.preventDefault =
            t.preventDefault ||
            function () {
              t.returnValue = !1;
            };
          t.stopPropagation =
            t.stopPropagation ||
            function () {
              t.cancelBubble = !0;
            };
          s.call(p, t);
        }),
        p.attachEvent("on" + t, v),
        v)
      : !1;
  }
  function Va(p, t, s) {
    p *= ga;
    t *= ga;
    p = s.getImageData(p, t, 2, 2).data;
    t = !0;
    for (s = 0; 4 > s; s++)
      if ((p[s] !== p[s + 4]) | (p[s] !== p[s + 8]) | (p[s] !== p[s + 12])) {
        t = !1;
        break;
      }
    return t ? (p[0] << 16) | (p[1] << 8) | p[2] : 0;
  }
  function ka(p, t, s) {
    return p in t ? t[p] : s[p];
  }
  function Ga(p, t, s) {
    if (v && Wa) {
      var y = p.getContext("2d");
      Ka =
        y.webkitBackingStorePixelRatio ||
        y.mozBackingStorePixelRatio ||
        y.msBackingStorePixelRatio ||
        y.oBackingStorePixelRatio ||
        y.backingStorePixelRatio ||
        1;
      ga = Pa / Ka;
      p.width = t * ga;
      p.height = s * ga;
      Pa !== Ka &&
        ((p.style.width = t + "px"),
        (p.style.height = s + "px"),
        y.scale(ga, ga));
    } else (p.width = t), (p.height = s);
  }
  function ab(p) {
    if (!bb) {
      var t = !1,
        s = !1;
      "undefined" === typeof sa.Chart.creditHref
        ? ((p.creditHref = ha("iuuqr;..b`ow`rkr/bnl.")),
          (p.creditText = ha("B`ow`rKR/bnl")))
        : ((t = p.updateOption("creditText")),
          (s = p.updateOption("creditHref")));
      if (p.creditHref && p.creditText) {
        p._creditLink ||
          ((p._creditLink = document.createElement("a")),
          p._creditLink.setAttribute("class", "canvasjs-chart-credit"),
          p._creditLink.setAttribute(
            "style",
            "outline:none;margin:0px;position:absolute;right:2px;top:" +
              (p.height - 14) +
              "px;color:dimgrey;text-decoration:none;font-size:11px;font-family: Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif"
          ),
          p._creditLink.setAttribute("tabIndex", -1),
          p._creditLink.setAttribute("target", "_blank"));
        if (0 === p.renderCount || t || s)
          p._creditLink.setAttribute("href", p.creditHref),
            (p._creditLink.innerHTML = p.creditText);
        p._creditLink && p.creditHref && p.creditText
          ? (p._creditLink.parentElement ||
              p._canvasJSContainer.appendChild(p._creditLink),
            (p._creditLink.style.top = p.height - 14 + "px"))
          : p._creditLink.parentElement &&
            p._canvasJSContainer.removeChild(p._creditLink);
      }
    }
  }
  function ta(p, t) {
    var s = document.createElement("canvas");
    s.setAttribute("class", "canvasjs-chart-canvas");
    Ga(s, p, t);
    v ||
      "undefined" === typeof G_vmlCanvasManager ||
      G_vmlCanvasManager.initElement(s);
    return s;
  }
  function na(p, t, s) {
    for (var v in s) t.style[v] = s[v];
  }
  function ua(p, t, s) {
    t.getAttribute("state") ||
      ((t.style.backgroundColor = p.toolbar.backgroundColor),
      (t.style.color = p.toolbar.fontColor),
      (t.style.border = "none"),
      na(p, t, {
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
      }));
    t.getAttribute("state") !== s &&
      (t.setAttribute("state", s),
      t.setAttribute("type", "button"),
      na(p, t, {
        padding: "5px 12px",
        cursor: "pointer",
        float: "left",
        width: "40px",
        height: "25px",
        outline: "0px",
        verticalAlign: "baseline",
        lineHeight: "0",
      }),
      t.setAttribute("title", p._cultureInfo[s + "Text"]),
      (t.innerHTML =
        "<img style='height:95%;' src='" +
        cb[s].image +
        "' alt='" +
        p._cultureInfo[s + "Text"] +
        "' />"));
  }
  function La() {
    for (var p = null, t = 0; t < arguments.length; t++)
      (p = arguments[t]), p.style && (p.style.display = "inline");
  }
  function va() {
    for (var p = null, t = 0; t < arguments.length; t++)
      (p = arguments[t]) && p.style && (p.style.display = "none");
  }
  function T(p, t, s, v, x) {
    this._defaultsKey = p;
    this._themeOptionsKey = t;
    this._index = v;
    this.parent = x;
    this._eventListeners = [];
    p = {};
    this.theme && y(t) && y(v)
      ? (p = y(xa[this.theme]) ? xa.light1 : xa[this.theme])
      : this.parent &&
        this.parent.themeOptions &&
        this.parent.themeOptions[t] &&
        (null === v
          ? (p = this.parent.themeOptions[t])
          : 0 < this.parent.themeOptions[t].length &&
            ((v = Math.min(this.parent.themeOptions[t].length - 1, v)),
            (p = this.parent.themeOptions[t][v])));
    this.themeOptions = p;
    this.options = s ? s : { _isPlaceholder: !0 };
    this.setOptions(this.options, p);
  }
  function Ca(p, t, s, v, y) {
    "undefined" === typeof y && (y = 0);
    this._padding = y;
    this._x1 = p;
    this._y1 = t;
    this._x2 = s;
    this._y2 = v;
    this._rightOccupied =
      this._leftOccupied =
      this._bottomOccupied =
      this._topOccupied =
        this._padding;
  }
  function ia(p, t) {
    ia.base.constructor.call(this, "TextBlock", null, t, null, null);
    this.ctx = p;
    this._isDirty = !0;
    this._wrappedText = null;
    this._initialize();
  }
  function Qa(p, t) {
    Qa.base.constructor.call(this, "Toolbar", "toolbar", t, null, p);
    this.chart = p;
    this.canvas = p.canvas;
    this.ctx = this.chart.ctx;
    this.optionsName = "toolbar";
  }
  function Ha(p, t) {
    Ha.base.constructor.call(this, "Title", "title", t, null, p);
    this.chart = p;
    this.canvas = p.canvas;
    this.ctx = this.chart.ctx;
    this.optionsName = "title";
    if (y(this.options.margin) && p.options.subtitles)
      for (var s = p.options.subtitles, v = 0; v < s.length; v++)
        if (
          ((y(s[v].horizontalAlign) && "center" === this.horizontalAlign) ||
            s[v].horizontalAlign === this.horizontalAlign) &&
          ((y(s[v].verticalAlign) && "top" === this.verticalAlign) ||
            s[v].verticalAlign === this.verticalAlign) &&
          !s[v].dockInsidePlotArea === !this.dockInsidePlotArea
        ) {
          this.margin = 0;
          break;
        }
    "undefined" === typeof this.options.fontSize &&
      (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
    this.height = this.width = null;
    this.bounds = { x1: null, y1: null, x2: null, y2: null };
  }
  function Ma(p, t, s) {
    Ma.base.constructor.call(this, "Subtitle", "subtitles", t, s, p);
    this.chart = p;
    this.canvas = p.canvas;
    this.ctx = this.chart.ctx;
    this.optionsName = "subtitles";
    this.isOptionsInArray = !0;
    "undefined" === typeof this.options.fontSize &&
      (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
    this.height = this.width = null;
    this.bounds = { x1: null, y1: null, x2: null, y2: null };
  }
  function Ia(p) {
    var t;
    p && Ja[p] && (t = Ja[p]);
    Ia.base.constructor.call(this, "CultureInfo", null, t, null, null);
  }
  var Fa = {},
    v = !!document.createElement("canvas").getContext,
    sa = {
      Chart: {
        width: 500,
        height: 400,
        zoomEnabled: !1,
        zoomType: "x",
        backgroundColor: "white",
        theme: "light1",
        animationEnabled: !1,
        animationDuration: 1200,
        dataPointWidth: null,
        dataPointMinWidth: null,
        dataPointMaxWidth: null,
        colorSet: "colorSet1",
        culture: "en",
        creditHref: "",
        creditText: "CanvasJS",
        interactivityEnabled: !0,
        exportEnabled: !1,
        exportFileName: "Chart",
        rangeChanging: null,
        rangeChanged: null,
        publicProperties: {
          title: "readWrite",
          subtitles: "readWrite",
          toolbar: "readWrite",
          toolTip: "readWrite",
          legend: "readWrite",
          axisX: "readWrite",
          axisY: "readWrite",
          axisX2: "readWrite",
          axisY2: "readWrite",
          data: "readWrite",
          options: "readWrite",
          bounds: "readOnly",
          container: "readOnly",
        },
      },
      Title: {
        padding: 0,
        text: null,
        verticalAlign: "top",
        horizontalAlign: "center",
        fontSize: 20,
        fontFamily: "Calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        borderThickness: 0,
        borderColor: "black",
        cornerRadius: 0,
        backgroundColor: v ? "transparent" : null,
        margin: 5,
        wrap: !0,
        maxWidth: null,
        dockInsidePlotArea: !1,
        publicProperties: {
          options: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Subtitle: {
        padding: 0,
        text: null,
        verticalAlign: "top",
        horizontalAlign: "center",
        fontSize: 14,
        fontFamily: "Calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        borderThickness: 0,
        borderColor: "black",
        cornerRadius: 0,
        backgroundColor: null,
        margin: 2,
        wrap: !0,
        maxWidth: null,
        dockInsidePlotArea: !1,
        publicProperties: {
          options: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Toolbar: {
        backgroundColor: "white",
        backgroundColorOnHover: "#2196f3",
        borderColor: "#2196f3",
        borderThickness: 1,
        fontColor: "black",
        fontColorOnHover: "white",
        publicProperties: { options: "readWrite", chart: "readOnly" },
      },
      Legend: {
        name: null,
        verticalAlign: "center",
        horizontalAlign: "right",
        fontSize: 14,
        fontFamily: "calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        cursor: null,
        itemmouseover: null,
        itemmouseout: null,
        itemmousemove: null,
        itemclick: null,
        dockInsidePlotArea: !1,
        reversed: !1,
        backgroundColor: v ? "transparent" : null,
        borderColor: v ? "transparent" : null,
        borderThickness: 0,
        cornerRadius: 0,
        maxWidth: null,
        maxHeight: null,
        markerMargin: null,
        itemMaxWidth: null,
        itemWidth: null,
        itemWrap: !0,
        itemTextFormatter: null,
        publicProperties: {
          options: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      ToolTip: {
        enabled: !0,
        shared: !1,
        animationEnabled: !0,
        content: null,
        contentFormatter: null,
        reversed: !1,
        backgroundColor: v ? "rgba(255,255,255,.9)" : "rgb(255,255,255)",
        borderColor: null,
        borderThickness: 2,
        cornerRadius: 5,
        fontSize: 14,
        fontColor: "black",
        fontFamily: "Calibri, Arial, Georgia, serif;",
        fontWeight: "normal",
        fontStyle: "italic",
        publicProperties: { options: "readWrite", chart: "readOnly" },
      },
      Axis: {
        minimum: null,
        maximum: null,
        viewportMinimum: null,
        viewportMaximum: null,
        interval: null,
        intervalType: null,
        reversed: !1,
        logarithmic: !1,
        logarithmBase: 10,
        title: null,
        titleFontColor: "black",
        titleFontSize: 20,
        titleFontFamily: "arial",
        titleFontWeight: "normal",
        titleFontStyle: "normal",
        titleWrap: !0,
        titleMaxWidth: null,
        titleBackgroundColor: v ? "transparent" : null,
        titleBorderColor: v ? "transparent" : null,
        titleBorderThickness: 0,
        titleCornerRadius: 0,
        labelAngle: 0,
        labelFontFamily: "arial",
        labelFontColor: "black",
        labelFontSize: 12,
        labelFontWeight: "normal",
        labelFontStyle: "normal",
        labelAutoFit: !0,
        labelWrap: !0,
        labelMaxWidth: null,
        labelFormatter: null,
        labelBackgroundColor: v ? "transparent" : null,
        labelBorderColor: v ? "transparent" : null,
        labelBorderThickness: 0,
        labelCornerRadius: 0,
        labelPlacement: "outside",
        prefix: "",
        suffix: "",
        includeZero: !0,
        tickLength: 5,
        tickColor: "black",
        tickThickness: 1,
        lineColor: "black",
        lineThickness: 1,
        lineDashType: "solid",
        gridColor: "A0A0A0",
        gridThickness: 0,
        gridDashType: "solid",
        interlacedColor: v ? "transparent" : null,
        valueFormatString: null,
        margin: 2,
        publicProperties: {
          options: "readWrite",
          stripLines: "readWrite",
          scaleBreaks: "readWrite",
          crosshair: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      StripLine: {
        value: null,
        startValue: null,
        endValue: null,
        color: "orange",
        opacity: null,
        thickness: 2,
        lineDashType: "solid",
        label: "",
        labelPlacement: "inside",
        labelAlign: "far",
        labelWrap: !0,
        labelMaxWidth: null,
        labelBackgroundColor: null,
        labelBorderColor: v ? "transparent" : null,
        labelBorderThickness: 0,
        labelCornerRadius: 0,
        labelFontFamily: "arial",
        labelFontColor: "orange",
        labelFontSize: 12,
        labelFontWeight: "normal",
        labelFontStyle: "normal",
        labelFormatter: null,
        showOnTop: !1,
        publicProperties: {
          options: "readWrite",
          axis: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      ScaleBreaks: {
        autoCalculate: !1,
        collapsibleThreshold: "25%",
        maxNumberOfAutoBreaks: 2,
        spacing: 8,
        type: "straight",
        color: "#FFFFFF",
        fillOpacity: 0.9,
        lineThickness: 2,
        lineColor: "#E16E6E",
        lineDashType: "solid",
        publicProperties: {
          options: "readWrite",
          customBreaks: "readWrite",
          axis: "readOnly",
          autoBreaks: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Break: {
        startValue: null,
        endValue: null,
        spacing: 8,
        type: "straight",
        color: "#FFFFFF",
        fillOpacity: 0.9,
        lineThickness: 2,
        lineColor: "#E16E6E",
        lineDashType: "solid",
        publicProperties: {
          options: "readWrite",
          scaleBreaks: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Crosshair: {
        enabled: !1,
        snapToDataPoint: !1,
        color: "grey",
        opacity: null,
        thickness: 2,
        lineDashType: "solid",
        label: "",
        labelWrap: !0,
        labelMaxWidth: null,
        labelBackgroundColor: v ? "grey" : null,
        labelBorderColor: v ? "grey" : null,
        labelBorderThickness: 0,
        labelCornerRadius: 0,
        labelFontFamily: v
          ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif"
          : "calibri",
        labelFontSize: 12,
        labelFontColor: "#fff",
        labelFontWeight: "normal",
        labelFontStyle: "normal",
        labelFormatter: null,
        valueFormatString: null,
        publicProperties: {
          options: "readWrite",
          axis: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      DataSeries: {
        name: null,
        dataPoints: null,
        label: "",
        bevelEnabled: !1,
        highlightEnabled: !0,
        cursor: "default",
        indexLabel: "",
        indexLabelPlacement: "auto",
        indexLabelOrientation: "horizontal",
        indexLabelFontColor: "black",
        indexLabelFontSize: 12,
        indexLabelFontStyle: "normal",
        indexLabelFontFamily: "Arial",
        indexLabelFontWeight: "normal",
        indexLabelBackgroundColor: null,
        indexLabelLineColor: "grey",
        indexLabelLineThickness: 1,
        indexLabelLineDashType: "solid",
        indexLabelMaxWidth: null,
        indexLabelWrap: !0,
        indexLabelFormatter: null,
        lineThickness: 2,
        lineDashType: "solid",
        connectNullData: !1,
        nullDataLineDashType: "dash",
        color: null,
        lineColor: null,
        risingColor: "white",
        fallingColor: "red",
        fillOpacity: null,
        startAngle: 0,
        radius: null,
        innerRadius: null,
        neckHeight: null,
        neckWidth: null,
        reversed: !1,
        valueRepresents: null,
        linkedDataSeriesIndex: null,
        whiskerThickness: 2,
        whiskerDashType: "solid",
        whiskerColor: null,
        whiskerLength: null,
        stemThickness: 2,
        stemColor: null,
        stemDashType: "solid",
        upperBoxColor: "white",
        lowerBoxColor: "white",
        type: "column",
        xValueType: "number",
        axisXType: "primary",
        axisYType: "primary",
        axisXIndex: 0,
        axisYIndex: 0,
        xValueFormatString: null,
        yValueFormatString: null,
        zValueFormatString: null,
        percentFormatString: null,
        showInLegend: null,
        legendMarkerType: null,
        legendMarkerColor: null,
        legendText: null,
        legendMarkerBorderColor: v ? "transparent" : null,
        legendMarkerBorderThickness: 0,
        markerType: "circle",
        markerColor: null,
        markerSize: null,
        markerBorderColor: v ? "transparent" : null,
        markerBorderThickness: 0,
        mouseover: null,
        mouseout: null,
        mousemove: null,
        click: null,
        toolTipContent: null,
        visible: !0,
        publicProperties: {
          options: "readWrite",
          axisX: "readWrite",
          axisY: "readWrite",
          chart: "readOnly",
        },
      },
      TextBlock: {
        x: 0,
        y: 0,
        width: null,
        height: null,
        maxWidth: null,
        maxHeight: null,
        padding: 0,
        angle: 0,
        text: "",
        horizontalAlign: "center",
        fontSize: 12,
        fontFamily: "calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        borderThickness: 0,
        borderColor: "black",
        cornerRadius: 0,
        backgroundColor: null,
        textBaseline: "top",
      },
      CultureInfo: {
        decimalSeparator: ".",
        digitGroupSeparator: ",",
        zoomText: "Zoom",
        panText: "Pan",
        resetText: "Reset",
        menuText: "More Options",
        saveJPGText: "Save as JPEG",
        savePNGText: "Save as PNG",
        printText: "Print",
        days: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(
          " "
        ),
        shortDays: "Sun Mon Tue Wed Thu Fri Sat".split(" "),
        months:
          "January February March April May June July August September October November December".split(
            " "
          ),
        shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(
          " "
        ),
      },
    },
    Ja = { en: {} },
    x = v ? "Trebuchet MS, Helvetica, sans-serif" : "Arial",
    Da = v ? "Impact, Charcoal, sans-serif" : "Arial",
    ya = {
      colorSet1:
        "#4F81BC #C0504E #9BBB58 #23BFAA #8064A1 #4AACC5 #F79647 #7F6084 #77A033 #33558B #E59566".split(
          " "
        ),
      colorSet2:
        "#6D78AD #51CDA0 #DF7970 #4C9CA0 #AE7D99 #C9D45C #5592AD #DF874D #52BCA8 #8E7AA3 #E3CB64 #C77B85 #C39762 #8DD17E #B57952 #FCC26C".split(
          " "
        ),
      colorSet3:
        "#8CA1BC #36845C #017E82 #8CB9D0 #708C98 #94838D #F08891 #0366A7 #008276 #EE7757 #E5BA3A #F2990B #03557B #782970".split(
          " "
        ),
    },
    J,
    da,
    U,
    $,
    aa;
  da = "#333333";
  U = "#000000";
  J = "#666666";
  aa = $ = "#000000";
  var Y = 20,
    B = 14,
    Ra = {
      colorSet: "colorSet1",
      backgroundColor: "#FFFFFF",
      title: {
        fontFamily: Da,
        fontSize: 32,
        fontColor: da,
        fontWeight: "normal",
        verticalAlign: "top",
        margin: 5,
      },
      subtitles: [
        {
          fontFamily: Da,
          fontSize: B,
          fontColor: da,
          fontWeight: "normal",
          verticalAlign: "top",
          margin: 5,
        },
      ],
      data: [
        {
          indexLabelFontFamily: x,
          indexLabelFontSize: B,
          indexLabelFontColor: da,
          indexLabelFontWeight: "normal",
          indexLabelLineThickness: 1,
        },
      ],
      axisX: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: da,
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: U,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: J,
          tickThickness: 1,
          tickColor: J,
          gridThickness: 0,
          gridColor: J,
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: aa,
            color: $,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisX2: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: da,
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: U,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: J,
          tickThickness: 1,
          tickColor: J,
          gridThickness: 0,
          gridColor: J,
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: aa,
            color: $,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: da,
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: U,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: J,
          tickThickness: 1,
          tickColor: J,
          gridThickness: 1,
          gridColor: J,
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: aa,
            color: $,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY2: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: da,
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: U,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: J,
          tickThickness: 1,
          tickColor: J,
          gridThickness: 1,
          gridColor: J,
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: aa,
            color: $,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      legend: {
        fontFamily: x,
        fontSize: 14,
        fontColor: da,
        fontWeight: "bold",
        verticalAlign: "bottom",
        horizontalAlign: "center",
      },
      toolTip: {
        fontFamily: x,
        fontSize: 14,
        fontStyle: "normal",
        cornerRadius: 0,
        borderThickness: 1,
      },
    };
  U = da = "#F5F5F5";
  J = "#FFFFFF";
  $ = "#40BAF1";
  aa = "#F5F5F5";
  var Y = 20,
    B = 14,
    Xa = {
      colorSet: "colorSet2",
      title: {
        fontFamily: x,
        fontSize: 33,
        fontColor: "#3A3A3A",
        fontWeight: "bold",
        verticalAlign: "top",
        margin: 5,
      },
      subtitles: [
        {
          fontFamily: x,
          fontSize: B,
          fontColor: "#3A3A3A",
          fontWeight: "normal",
          verticalAlign: "top",
          margin: 5,
        },
      ],
      data: [
        {
          indexLabelFontFamily: x,
          indexLabelFontSize: B,
          indexLabelFontColor: "#666666",
          indexLabelFontWeight: "normal",
          indexLabelLineThickness: 1,
        },
      ],
      axisX: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: "#BBBBBB",
          tickThickness: 1,
          tickColor: "#BBBBBB",
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisX2: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: "#BBBBBB",
          tickColor: "#BBBBBB",
          tickThickness: 1,
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 0,
          lineColor: "#BBBBBB",
          tickColor: "#BBBBBB",
          tickThickness: 1,
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY2: [
        {
          titleFontFamily: x,
          titleFontSize: Y,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 0,
          lineColor: "#BBBBBB",
          tickColor: "#BBBBBB",
          tickThickness: 1,
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      legend: {
        fontFamily: x,
        fontSize: 14,
        fontColor: "#3A3A3A",
        fontWeight: "bold",
        verticalAlign: "bottom",
        horizontalAlign: "center",
      },
      toolTip: {
        fontFamily: x,
        fontSize: 14,
        fontStyle: "normal",
        cornerRadius: 0,
        borderThickness: 1,
      },
    };
  U = da = "#F5F5F5";
  J = "#FFFFFF";
  $ = "#40BAF1";
  aa = "#F5F5F5";
  Y = 20;
  B = 14;
  Da = {
    colorSet: "colorSet12",
    backgroundColor: "#2A2A2A",
    title: {
      fontFamily: Da,
      fontSize: 32,
      fontColor: da,
      fontWeight: "normal",
      verticalAlign: "top",
      margin: 5,
    },
    subtitles: [
      {
        fontFamily: Da,
        fontSize: B,
        fontColor: da,
        fontWeight: "normal",
        verticalAlign: "top",
        margin: 5,
      },
    ],
    toolbar: {
      backgroundColor: "#666666",
      backgroundColorOnHover: "#FF7372",
      borderColor: "#FF7372",
      borderThickness: 1,
      fontColor: "#F5F5F5",
      fontColorOnHover: "#F5F5F5",
    },
    data: [
      {
        indexLabelFontFamily: x,
        indexLabelFontSize: B,
        indexLabelFontColor: U,
        indexLabelFontWeight: "normal",
        indexLabelLineThickness: 1,
      },
    ],
    axisX: [
      {
        titleFontFamily: x,
        titleFontSize: Y,
        titleFontColor: U,
        titleFontWeight: "normal",
        labelFontFamily: x,
        labelFontSize: B,
        labelFontColor: U,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: J,
        tickThickness: 1,
        tickColor: J,
        gridThickness: 0,
        gridColor: J,
        stripLines: [
          {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: aa,
          color: $,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisX2: [
      {
        titleFontFamily: x,
        titleFontSize: Y,
        titleFontColor: U,
        titleFontWeight: "normal",
        labelFontFamily: x,
        labelFontSize: B,
        labelFontColor: U,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: J,
        tickThickness: 1,
        tickColor: J,
        gridThickness: 0,
        gridColor: J,
        stripLines: [
          {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: aa,
          color: $,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisY: [
      {
        titleFontFamily: x,
        titleFontSize: Y,
        titleFontColor: U,
        titleFontWeight: "normal",
        labelFontFamily: x,
        labelFontSize: B,
        labelFontColor: U,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: J,
        tickThickness: 1,
        tickColor: J,
        gridThickness: 1,
        gridColor: J,
        stripLines: [
          {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: aa,
          color: $,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisY2: [
      {
        titleFontFamily: x,
        titleFontSize: Y,
        titleFontColor: U,
        titleFontWeight: "normal",
        labelFontFamily: x,
        labelFontSize: B,
        labelFontColor: U,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: J,
        tickThickness: 1,
        tickColor: J,
        gridThickness: 1,
        gridColor: J,
        stripLines: [
          {
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: x,
          labelFontSize: B,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: aa,
          color: $,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    legend: {
      fontFamily: x,
      fontSize: 14,
      fontColor: da,
      fontWeight: "bold",
      verticalAlign: "bottom",
      horizontalAlign: "center",
    },
    toolTip: {
      fontFamily: x,
      fontSize: 14,
      fontStyle: "normal",
      cornerRadius: 0,
      borderThickness: 1,
      fontColor: U,
      backgroundColor: "rgba(0, 0, 0, .7)",
    },
  };
  J = "#FFFFFF";
  U = da = "#FAFAFA";
  $ = "#40BAF1";
  aa = "#F5F5F5";
  var Y = 20,
    B = 14,
    xa = {
      light1: Ra,
      light2: Xa,
      dark1: Da,
      dark2: {
        colorSet: "colorSet2",
        backgroundColor: "#32373A",
        title: {
          fontFamily: x,
          fontSize: 32,
          fontColor: da,
          fontWeight: "normal",
          verticalAlign: "top",
          margin: 5,
        },
        subtitles: [
          {
            fontFamily: x,
            fontSize: B,
            fontColor: da,
            fontWeight: "normal",
            verticalAlign: "top",
            margin: 5,
          },
        ],
        toolbar: {
          backgroundColor: "#666666",
          backgroundColorOnHover: "#FF7372",
          borderColor: "#FF7372",
          borderThickness: 1,
          fontColor: "#F5F5F5",
          fontColorOnHover: "#F5F5F5",
        },
        data: [
          {
            indexLabelFontFamily: x,
            indexLabelFontSize: B,
            indexLabelFontColor: U,
            indexLabelFontWeight: "normal",
            indexLabelLineThickness: 1,
          },
        ],
        axisX: [
          {
            titleFontFamily: x,
            titleFontSize: Y,
            titleFontColor: U,
            titleFontWeight: "normal",
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: U,
            labelFontWeight: "normal",
            lineThickness: 1,
            lineColor: J,
            tickThickness: 1,
            tickColor: J,
            gridThickness: 0,
            gridColor: J,
            stripLines: [
              {
                labelFontFamily: x,
                labelFontSize: B,
                labelFontColor: "#FF7300",
                labelFontWeight: "normal",
                labelBackgroundColor: null,
                color: "#FF7300",
                thickness: 1,
              },
            ],
            crosshair: {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#000000",
              labelFontWeight: "normal",
              labelBackgroundColor: aa,
              color: $,
              thickness: 1,
              lineDashType: "dash",
            },
            scaleBreaks: {
              type: "zigzag",
              spacing: "2%",
              lineColor: "#777777",
              lineThickness: 1,
              lineDashType: "solid",
              color: "#111111",
            },
          },
        ],
        axisX2: [
          {
            titleFontFamily: x,
            titleFontSize: Y,
            titleFontColor: U,
            titleFontWeight: "normal",
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: U,
            labelFontWeight: "normal",
            lineThickness: 1,
            lineColor: J,
            tickThickness: 1,
            tickColor: J,
            gridThickness: 0,
            gridColor: J,
            stripLines: [
              {
                labelFontFamily: x,
                labelFontSize: B,
                labelFontColor: "#FF7300",
                labelFontWeight: "normal",
                labelBackgroundColor: null,
                color: "#FF7300",
                thickness: 1,
              },
            ],
            crosshair: {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#000000",
              labelFontWeight: "normal",
              labelBackgroundColor: aa,
              color: $,
              thickness: 1,
              lineDashType: "dash",
            },
            scaleBreaks: {
              type: "zigzag",
              spacing: "2%",
              lineColor: "#777777",
              lineThickness: 1,
              lineDashType: "solid",
              color: "#111111",
            },
          },
        ],
        axisY: [
          {
            titleFontFamily: x,
            titleFontSize: Y,
            titleFontColor: U,
            titleFontWeight: "normal",
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: U,
            labelFontWeight: "normal",
            lineThickness: 0,
            lineColor: J,
            tickThickness: 1,
            tickColor: J,
            gridThickness: 1,
            gridColor: J,
            stripLines: [
              {
                labelFontFamily: x,
                labelFontSize: B,
                labelFontColor: "#FF7300",
                labelFontWeight: "normal",
                labelBackgroundColor: null,
                color: "#FF7300",
                thickness: 1,
              },
            ],
            crosshair: {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#000000",
              labelFontWeight: "normal",
              labelBackgroundColor: aa,
              color: $,
              thickness: 1,
              lineDashType: "dash",
            },
            scaleBreaks: {
              type: "zigzag",
              spacing: "2%",
              lineColor: "#777777",
              lineThickness: 1,
              lineDashType: "solid",
              color: "#111111",
            },
          },
        ],
        axisY2: [
          {
            titleFontFamily: x,
            titleFontSize: Y,
            titleFontColor: U,
            titleFontWeight: "normal",
            labelFontFamily: x,
            labelFontSize: B,
            labelFontColor: U,
            labelFontWeight: "normal",
            lineThickness: 0,
            lineColor: J,
            tickThickness: 1,
            tickColor: J,
            gridThickness: 1,
            gridColor: J,
            stripLines: [
              {
                labelFontFamily: x,
                labelFontSize: B,
                labelFontColor: "#FF7300",
                labelFontWeight: "normal",
                labelBackgroundColor: null,
                color: "#FF7300",
                thickness: 1,
              },
            ],
            crosshair: {
              labelFontFamily: x,
              labelFontSize: B,
              labelFontColor: "#000000",
              labelFontWeight: "normal",
              labelBackgroundColor: aa,
              color: $,
              thickness: 1,
              lineDashType: "dash",
            },
            scaleBreaks: {
              type: "zigzag",
              spacing: "2%",
              lineColor: "#777777",
              lineThickness: 1,
              lineDashType: "solid",
              color: "#111111",
            },
          },
        ],
        legend: {
          fontFamily: x,
          fontSize: 14,
          fontColor: da,
          fontWeight: "bold",
          verticalAlign: "bottom",
          horizontalAlign: "center",
        },
        toolTip: {
          fontFamily: x,
          fontSize: 14,
          fontStyle: "normal",
          cornerRadius: 0,
          borderThickness: 1,
          fontColor: U,
          backgroundColor: "rgba(0, 0, 0, .7)",
        },
      },
      theme1: Ra,
      theme2: Xa,
      theme3: Ra,
    },
    V = {
      numberDuration: 1,
      yearDuration: 314496e5,
      monthDuration: 2592e6,
      weekDuration: 6048e5,
      dayDuration: 864e5,
      hourDuration: 36e5,
      minuteDuration: 6e4,
      secondDuration: 1e3,
      millisecondDuration: 1,
      dayOfWeekFromInt:
        "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
    },
    Ua = {},
    oa = null,
    za = (function () {
      var p =
          /D{1,4}|M{1,4}|Y{1,4}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|f{1,3}|t{1,2}|T{1,2}|K|z{1,3}|"[^"]*"|'[^']*'/g,
        t = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(
          " "
        ),
        s = "Sun Mon Tue Wed Thu Fri Sat".split(" "),
        v =
          "January February March April May June July August September October November December".split(
            " "
          ),
        y = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
        x =
          /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        B = /[^-+\dA-Z]/g;
      return function (S, z, Q) {
        var F = Q ? Q.days : t,
          J = Q ? Q.months : v,
          R = Q ? Q.shortDays : s,
          P = Q ? Q.shortMonths : y;
        Q = "";
        var V = !1;
        S = S && S.getTime ? S : S ? new Date(S) : new Date();
        if (isNaN(S)) throw SyntaxError("invalid date");
        "UTC:" === z.slice(0, 4) && ((z = z.slice(4)), (V = !0));
        Q = V ? "getUTC" : "get";
        var T = S[Q + "Date"](),
          W = S[Q + "Day"](),
          U = S[Q + "Month"](),
          X = S[Q + "FullYear"](),
          L = S[Q + "Hours"](),
          fa = S[Q + "Minutes"](),
          a = S[Q + "Seconds"](),
          f = S[Q + "Milliseconds"](),
          b = V ? 0 : S.getTimezoneOffset();
        return (Q = z.replace(p, function (c) {
          switch (c) {
            case "D":
              return T;
            case "DD":
              return ea(T, 2);
            case "DDD":
              return R[W];
            case "DDDD":
              return F[W];
            case "M":
              return U + 1;
            case "MM":
              return ea(U + 1, 2);
            case "MMM":
              return P[U];
            case "MMMM":
              return J[U];
            case "Y":
              return parseInt(String(X).slice(-2));
            case "YY":
              return ea(String(X).slice(-2), 2);
            case "YYY":
              return ea(String(X).slice(-3), 3);
            case "YYYY":
              return ea(X, 4);
            case "h":
              return L % 12 || 12;
            case "hh":
              return ea(L % 12 || 12, 2);
            case "H":
              return L;
            case "HH":
              return ea(L, 2);
            case "m":
              return fa;
            case "mm":
              return ea(fa, 2);
            case "s":
              return a;
            case "ss":
              return ea(a, 2);
            case "f":
              return String(f).slice(0, 1);
            case "ff":
              return ea(String(f).slice(0, 2), 2);
            case "fff":
              return ea(String(f).slice(0, 3), 3);
            case "t":
              return 12 > L ? "a" : "p";
            case "tt":
              return 12 > L ? "am" : "pm";
            case "T":
              return 12 > L ? "A" : "P";
            case "TT":
              return 12 > L ? "AM" : "PM";
            case "K":
              return V
                ? "UTC"
                : (String(S).match(x) || [""]).pop().replace(B, "");
            case "z":
              return (0 < b ? "-" : "+") + Math.floor(Math.abs(b) / 60);
            case "zz":
              return (0 < b ? "-" : "+") + ea(Math.floor(Math.abs(b) / 60), 2);
            case "zzz":
              return (
                (0 < b ? "-" : "+") +
                ea(Math.floor(Math.abs(b) / 60), 2) +
                ea(Math.abs(b) % 60, 2)
              );
            default:
              return c.slice(1, c.length - 1);
          }
        }));
      };
    })(),
    X = function (p, t, s) {
      if (null === p) return "";
      if (!isFinite(p)) return p;
      p = Number(p);
      var v = 0 > p ? !0 : !1;
      v && (p *= -1);
      var y = s ? s.decimalSeparator : ".",
        x = s ? s.digitGroupSeparator : ",",
        B = "";
      t = String(t);
      var B = 1,
        S = (s = ""),
        z = -1,
        Q = [],
        F = [],
        J = 0,
        R = 0,
        V = 0,
        P = !1,
        U = 0,
        S = t.match(/"[^"]*"|'[^']*'|[eE][+-]*[0]+|[,]+[.]|\u2030|./g);
      t = null;
      for (var W = 0; S && W < S.length; W++)
        if (((t = S[W]), "." === t && 0 > z)) z = W;
        else {
          if ("%" === t) B *= 100;
          else if ("\u2030" === t) {
            B *= 1e3;
            continue;
          } else if ("," === t[0] && "." === t[t.length - 1]) {
            B /= Math.pow(1e3, t.length - 1);
            z = W + t.length - 1;
            continue;
          } else
            ("E" !== t[0] && "e" !== t[0]) ||
              "0" !== t[t.length - 1] ||
              (P = !0);
          0 > z
            ? (Q.push(t), "#" === t || "0" === t ? J++ : "," === t && V++)
            : (F.push(t), ("#" !== t && "0" !== t) || R++);
        }
      P &&
        ((t = Math.floor(p)),
        (S = -Math.floor(Math.log(p) / Math.LN10 + 1)),
        (U = 0 === p ? 0 : 0 === t ? -(J + S) : String(t).length - J),
        (B /= Math.pow(10, U)));
      0 > z && (z = W);
      B = (p * B).toFixed(R);
      t = B.split(".");
      B = (t[0] + "").split("");
      p = (t[1] + "").split("");
      B && "0" === B[0] && B.shift();
      for (P = S = W = R = z = 0; 0 < Q.length; )
        if (((t = Q.pop()), "#" === t || "0" === t))
          if ((z++, z === J)) {
            var T = B,
              B = [];
            if ("0" === t)
              for (t = J - R - (T ? T.length : 0); 0 < t; ) T.unshift("0"), t--;
            for (; 0 < T.length; )
              (s = T.pop() + s),
                P++,
                0 === P % S && W === V && 0 < T.length && (s = x + s);
          } else
            0 < B.length
              ? ((s = B.pop() + s), R++, P++)
              : "0" === t && ((s = "0" + s), R++, P++),
              0 === P % S && W === V && 0 < B.length && (s = x + s);
        else
          ("E" !== t[0] && "e" !== t[0]) ||
          "0" !== t[t.length - 1] ||
          !/[eE][+-]*[0]+/.test(t)
            ? "," === t
              ? (W++, (S = P), (P = 0), 0 < B.length && (s = x + s))
              : (s =
                  1 < t.length &&
                  (('"' === t[0] && '"' === t[t.length - 1]) ||
                    ("'" === t[0] && "'" === t[t.length - 1]))
                    ? t.slice(1, t.length - 1) + s
                    : t + s)
            : ((t =
                0 > U
                  ? t.replace("+", "").replace("-", "")
                  : t.replace("-", "")),
              (s += t.replace(/[0]+/, function (p) {
                return ea(U, p.length);
              })));
      x = "";
      for (Q = !1; 0 < F.length; )
        (t = F.shift()),
          "#" === t || "0" === t
            ? 0 < p.length && 0 !== Number(p.join(""))
              ? ((x += p.shift()), (Q = !0))
              : "0" === t && ((x += "0"), (Q = !0))
            : 1 < t.length &&
              (('"' === t[0] && '"' === t[t.length - 1]) ||
                ("'" === t[0] && "'" === t[t.length - 1]))
            ? (x += t.slice(1, t.length - 1))
            : ("E" !== t[0] && "e" !== t[0]) ||
              "0" !== t[t.length - 1] ||
              !/[eE][+-]*[0]+/.test(t)
            ? (x += t)
            : ((t =
                0 > U
                  ? t.replace("+", "").replace("-", "")
                  : t.replace("-", "")),
              (x += t.replace(/[0]+/, function (p) {
                return ea(U, p.length);
              })));
      s += (Q ? y : "") + x;
      return v ? "-" + s : s;
    },
    Na = function (p) {
      var t = 0,
        s = 0;
      p = p || window.event;
      p.offsetX || 0 === p.offsetX
        ? ((t = p.offsetX), (s = p.offsetY))
        : p.layerX || 0 == p.layerX
        ? ((t = p.layerX), (s = p.layerY))
        : ((t = p.pageX - p.target.offsetLeft),
          (s = p.pageY - p.target.offsetTop));
      return { x: t, y: s };
    },
    Wa = !0,
    Pa = window.devicePixelRatio || 1,
    Ka = 1,
    ga = Wa ? Pa / Ka : 1,
    ha = function (p) {
      for (var t = "", s = 0; s < p.length; s++)
        t += String.fromCharCode(
          Math.ceil(p.length / 57 / 5) ^ p.charCodeAt(s)
        );
      return t;
    },
    bb =
      window &&
      window[ha("mnb`uhno")] &&
      window[ha("mnb`uhno")].href &&
      window[ha("mnb`uhno")].href.indexOf &&
      (-1 !== window[ha("mnb`uhno")].href.indexOf(ha("b`ow`rkr/bnl")) ||
        -1 !== window[ha("mnb`uhno")].href.indexOf(ha("gdonqhy/bnl")) ||
        -1 !== window[ha("mnb`uhno")].href.indexOf(ha("gheemd"))),
    cb = {
      reset: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPjSURBVFhHxVdJaFNRFP1J/jwkP5MxsbaC1WJEglSxOFAXIsFpVRE3ggi1K90obioRRBA33XXnQnciirhQcMCdorgQxBkXWlREkFKsWkv5npvckp/XnzRpKh64kLw733fffe9L/wrL0+mVUdO8uTSZ3MBL/we2qg4rkuSpodCELstXE46ziVkLQ6FQcGOmeSSq6wd4aV50d3drWjj8kQKZJTUc9kxFGenv79dZrDksTSTWWJp2QYtEPiErysyzdX0LsxsCQR8keX8gs6RHIk8ysdgKFg2G53mhuOPsshTlBjKaFo1g7SqLNoShKLdFXT8huQ/paLSbxatYnc2mHMM4hr18Vi8TIvCmXF3vYrW6cF23gGTOk0M1wA4RKvOmq6vLZRVJipvmSWT6tZ6CSEYkco5V50VPT4+D7RwOqi6RiSZm0fJ+vggSqkeoypdsNmuyelNwbXsbgvkWYMtzDWNvWaijoyOBqE+hVK8abcssUeXQ/YfKyi0gFYv1Ipgfoj34fYGTJLOYJA0ODirok32GLN8XhUWCwSes1hIwBg6LydJ/tEeRRapAdUp+wSAiZchtZZWWgAZ+JNpD8peYXQVK9UwUxNpzOK8pq97kURZhYTCKBwPD7h2zK+js7Myi7D8Fod+0TkMI8+EMAngLGc/WtBFWawkFHFnoj/t9KLgGmF0B3QfkxC+EarxkdhnFYlFLY06USqUwL7UMjICHfh/wOc2sCqhpxGbCkLvL7EUDbF73+6DkmVWB6zi7xUDQSLeYvWjAILvm9zEnkJhlbRcDQZcv6Kg2AipyT/Axw6wKlqVSqxDdjF8Izfod13qURdrG/nxehY+xGh+h0CSzKygGvSNQIcc097BI24jb9hax6kj2E7OrMFX1il+ICEf2NrPbhiXLl+fYl+U7zK4iYdsDcyLGf+ofFlkwcN+s10KhmpuYhhtm0hCLVIFL0MDsqNlDIqy9x2CLs1jL6OvrI7vPRbtohXG6eFmsFnHDGAp6n9AgyuVySRZrGvROxRgIfLXhzjrNYnNBUxNX/dMgRWT1mt4XLDovaApD53E9W3ilNX5M55LJHpRtIsgAvciR4WWcgK2Dvb1YqgXevmF8z2zEBTcKG39EfSKsT9EbhVUaI2FZO+oZIqImxol6j66/hcAu4sSN4vc1ZPoKeoE6RGhYL2YYA+ymOSSi0Z0wWntbtkGUWCvfSDXIxONraZ/FY90KUfNTpfC5spnNLgxoYNnR9RO4F8ofXEHOgogCQE99w+fF2Xw+b7O59rEOsyRqGEfpVoaDMQQ1CZrG46bcM6AZ0C/wPqNfHliqejyTySxh9TqQpL+xmbIlkB9SlAAAAABJRU5ErkJggg==",
      },
      pan: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAICSURBVEhLxZbPahNRGMUn/5MpuAiBEAIufQGfzr5E40YptBXajYzudCEuGqS+gGlrFwquDGRTutBdYfydzJ3LzeQmJGZue+Dw/Z17Mnfmu5Pof9Hr9Z61Wq0bWZMKj263O6xWq99wU9lOpzPMKgEhEcRucNOcioOK+0RzBhNvt9tPV4nmVF19+OWhVqt9xXgFXZq+8lCv119UKpUJ7iX2FmvFTKz8RH34YdBsNk8wVtjE4fGYwm8wrrDi3WBG5oKXZGRSS9hGuNFojLTe2lFz5xThWZIktayyiE2FdT3rzXBXz7krKiL8c17wAKFDjCus2AvW+YGZ9y2JF0VFRuMPfI//rsCE/C+s26s4gQu9ul7r4NteKx7H8XOC724xNNGbaNu++IrBqbOV7Tj3FgMRvc/YKOr3+3sE47wgEt/Bl/gaK5cHbNU11vYSXylfpK7XOvjuumPp4Wcoipu30Qsez2uMXYz4lfI+mOmwothY+SLiXJy7mKVpWs3Si0CoOMfeI9Od43Wic+jO+ZVv+crsm9QSNhUW9LXSeoPBYLXopthGuFQgdIxxhY+UDwlt1x5CZ1hX+NTUdt/OIvjKaDSmuOJfaIVNPKX+W18j/PLA2/kR44p5Sd8HbHngT/yTfNRWUXX14ZcL3wmX0+TLf8YO7CGT8yFE5zB3/gney25/OETRP9CtPDFe5jShAAAAAElFTkSuQmCC",
      },
      zoom: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALWSURBVEhLvZZLaBNRFIabyftBIgEfqCCBoCC6MYqiXYiIj4U76U4X7sUHbhQhUBfixhZEUBDB16YuFERaUaQLK7ooCOJj4UKtYEFU0EptShO/A9Ph3js3k8lo/eHnP7n3nP/M3LlzMz1hkUwmNziOcyKRSFyFt+LxeD/c2Wq1Ym7Kv0M2m11Os1OxWGycn1OwZXCGuXfwIhezkd9/jRgNT2L4ldhs1pbkX5OLJe4euVxuGQaPCa3mnUjtJx7BDuKusJTCV6jVVGHTMuYRjxma7yIOhTgFY6jNaAKew2xPKpVay9ganmkvj+M448/MfJdT5K5Gg4HJacRngPFgqVRaRNwW1B4i7yehWfsEDdz1K+A01AoxPIqGAiuwGfkOTY8+1A6u7AyiFTB2Hu0KPIrdiOnzHLWDybeImvy+Wq2mZa5bUHsD0Zpz+KxHdWQymV6kAb1ElqeORgJLvgnRdj1+R1AfzkIvSUjxVjQSarVakrueIPT8+H1F5jSUy+WXiJrUYBVWyVxU4PEU8TzhfaijUqnMIWrjaY492eWRwdKOIqrnIxnXwLLeRLwk2GQzrEMjg0avEbXxkIxr4OoOImpj2QwyFgms1koa/SZUG8s+0iGnEhNfCNXEhzIXBVz0McTzEvJ+70P9oNFtxEzei3aFYrFYxmuSUPWSv9Yi9IMm2xE1We56Mp1OV4nDwqFmBDV9gk9AEh4gZtFHNt8W4kAUCoXF5MorY9Z/kDni9nDv7hc0i2fhgLvTtX8a99PoMPPagTFPxofRzmDJ9yM+AyEmTfgGysYbQcfhDzPPJDmX0c7gDg4gs9BqFIWhm/Nct5H8gtBq1I7UfIbtvmIuoaGQcp+fdpbbSM43eEH5wrwLbXmhm/fU63VHXjcuok7hEByFY/AeHGC8L5/PL3HT5xGH1uYwfPOICGo+CBcU0vwO1BqzUqILDl/z/9VYIMfpddiAc47jDP8BsUpb13wOLRwAAAAASUVORK5CYII=",
      },
      menu: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADoSURBVFhH7dc9CsJAFATgRxIIBCwCqZKATX5sbawsY2MvWOtF9AB6AU8gguAJbD2AnZ2VXQT/Ko2TYGCL2OYtYQc+BuYA+1hCtnCVwMm27SGaXpDJIAiCvCkVR05hGOZNN3HkFMdx3nQRR06+76/R1IcFLJlNQEWlmWlBTwJtKLKHynehZqnjOGM0PYWRVXk61C37p7xlZ3Hk5HneCk1dmMH811xGoKLSzDiQwIBZB4ocoPJdqNkDt2yKlueWRVGUtzy3rPwo3sWRU3nLjuLI6OO67oZM00wMw3hrmpZx0XU9syxrR0T0BeMpb9dneSR2AAAAAElFTkSuQmCC",
      },
    };
  T.prototype.setOptions = function (p, t) {
    if (sa[this._defaultsKey]) {
      var s = sa[this._defaultsKey],
        v;
      for (v in s)
        "publicProperties" !== v &&
          s.hasOwnProperty(v) &&
          (this[v] = p && v in p ? p[v] : t && v in t ? t[v] : s[v]);
    }
  };
  T.prototype.get = function (p) {
    var t = sa[this._defaultsKey];
    if ("options" === p)
      return this.options && this.options._isPlaceholder ? null : this.options;
    if (
      t.hasOwnProperty(p) ||
      (t.publicProperties && t.publicProperties.hasOwnProperty(p))
    )
      return this[p];
    window.console &&
      window.console.log(
        'Property "' + p + "\" doesn't exist. Please check for typo."
      );
  };
  T.prototype.set = function (p, t, s) {
    s = "undefined" === typeof s ? !0 : s;
    var v = sa[this._defaultsKey];
    if ("options" === p) this.createUserOptions(t);
    else if (
      v.hasOwnProperty(p) ||
      (v.publicProperties &&
        v.publicProperties.hasOwnProperty(p) &&
        "readWrite" === v.publicProperties[p])
    )
      this.options._isPlaceholder && this.createUserOptions(),
        (this.options[p] = t);
    else {
      window.console &&
        (v.publicProperties &&
        v.publicProperties.hasOwnProperty(p) &&
        "readOnly" === v.publicProperties[p]
          ? window.console.log('Property "' + p + '" is read-only.')
          : window.console.log(
              'Property "' + p + "\" doesn't exist. Please check for typo."
            ));
      return;
    }
    s && (this.chart || this).render();
  };
  T.prototype.addTo = function (p, t, s, v) {
    v = "undefined" === typeof v ? !0 : v;
    var y = sa[this._defaultsKey];
    y.hasOwnProperty(p) ||
    (y.publicProperties &&
      y.publicProperties.hasOwnProperty(p) &&
      "readWrite" === y.publicProperties[p])
      ? (this.options._isPlaceholder && this.createUserOptions(),
        "undefined" === typeof this.options[p] && (this.options[p] = []),
        (p = this.options[p]),
        (s = "undefined" === typeof s || null === s ? p.length : s),
        p.splice(s, 0, t),
        v && (this.chart || this).render())
      : window.console &&
        (y.publicProperties &&
        y.publicProperties.hasOwnProperty(p) &&
        "readOnly" === y.publicProperties[p]
          ? window.console.log('Property "' + p + '" is read-only.')
          : window.console.log(
              'Property "' + p + "\" doesn't exist. Please check for typo."
            ));
  };
  T.prototype.createUserOptions = function (p) {
    if ("undefined" !== typeof p || this.options._isPlaceholder)
      if (
        (this.parent.options._isPlaceholder && this.parent.createUserOptions(),
        this.isOptionsInArray)
      ) {
        this.parent.options[this.optionsName] ||
          (this.parent.options[this.optionsName] = []);
        var t = this.parent.options[this.optionsName],
          v = t.length;
        this.options._isPlaceholder || (Ba(t), (v = t.indexOf(this.options)));
        this.options = "undefined" === typeof p ? {} : p;
        t[v] = this.options;
      } else
        (this.options = "undefined" === typeof p ? {} : p),
          (p = this.parent.options),
          this.optionsName
            ? (t = this.optionsName)
            : (t = this._defaultsKey) && 0 !== t.length
            ? ((v = t.charAt(0).toLowerCase()),
              1 < t.length && (v = v.concat(t.slice(1))),
              (t = v))
            : (t = void 0),
          (p[t] = this.options);
  };
  T.prototype.remove = function (p) {
    p = "undefined" === typeof p ? !0 : p;
    if (this.isOptionsInArray) {
      var t = this.parent.options[this.optionsName];
      Ba(t);
      var v = t.indexOf(this.options);
      0 <= v && t.splice(v, 1);
    } else delete this.parent.options[this.optionsName];
    p && (this.chart || this).render();
  };
  T.prototype.updateOption = function (p) {
    var t = sa[this._defaultsKey],
      v = {},
      x = this[p],
      B = this._themeOptionsKey,
      F = this._index;
    this.theme && y(B) && y(F)
      ? (v = y(xa[this.theme]) ? xa.light1 : xa[this.theme])
      : this.parent &&
        this.parent.themeOptions &&
        this.parent.themeOptions[B] &&
        (null === F
          ? (v = this.parent.themeOptions[B])
          : 0 < this.parent.themeOptions[B].length &&
            ((v = Math.min(this.parent.themeOptions[B].length - 1, F)),
            (v = this.parent.themeOptions[B][v])));
    this.themeOptions = v;
    p in t &&
      (x = p in this.options ? this.options[p] : v && p in v ? v[p] : t[p]);
    if (x === this[p]) return !1;
    this[p] = x;
    return !0;
  };
  T.prototype.trackChanges = function (p) {
    if (!this.sessionVariables) throw "Session Variable Store not set";
    this.sessionVariables[p] = this.options[p];
  };
  T.prototype.isBeingTracked = function (p) {
    this.options._oldOptions || (this.options._oldOptions = {});
    return this.options._oldOptions[p] ? !0 : !1;
  };
  T.prototype.hasOptionChanged = function (p) {
    if (!this.sessionVariables) throw "Session Variable Store not set";
    return this.sessionVariables[p] !== this.options[p];
  };
  T.prototype.addEventListener = function (p, v, s) {
    p &&
      v &&
      ((this._eventListeners[p] = this._eventListeners[p] || []),
      this._eventListeners[p].push({ context: s || this, eventHandler: v }));
  };
  T.prototype.removeEventListener = function (p, v) {
    if (p && v && this._eventListeners[p])
      for (var s = this._eventListeners[p], y = 0; y < s.length; y++)
        if (s[y].eventHandler === v) {
          s[y].splice(y, 1);
          break;
        }
  };
  T.prototype.removeAllEventListeners = function () {
    this._eventListeners = [];
  };
  T.prototype.dispatchEvent = function (p, v, s) {
    if (p && this._eventListeners[p]) {
      v = v || {};
      for (var y = this._eventListeners[p], x = 0; x < y.length; x++)
        y[x].eventHandler.call(y[x].context, v);
    }
    "function" === typeof this[p] && this[p].call(s || this.chart, v);
  };
  Ca.prototype.registerSpace = function (p, v) {
    "top" === p
      ? (this._topOccupied += v.height)
      : "bottom" === p
      ? (this._bottomOccupied += v.height)
      : "left" === p
      ? (this._leftOccupied += v.width)
      : "right" === p && (this._rightOccupied += v.width);
  };
  Ca.prototype.unRegisterSpace = function (p, v) {
    "top" === p
      ? (this._topOccupied -= v.height)
      : "bottom" === p
      ? (this._bottomOccupied -= v.height)
      : "left" === p
      ? (this._leftOccupied -= v.width)
      : "right" === p && (this._rightOccupied -= v.width);
  };
  Ca.prototype.getFreeSpace = function () {
    return {
      x1: this._x1 + this._leftOccupied,
      y1: this._y1 + this._topOccupied,
      x2: this._x2 - this._rightOccupied,
      y2: this._y2 - this._bottomOccupied,
      width: this._x2 - this._x1 - this._rightOccupied - this._leftOccupied,
      height: this._y2 - this._y1 - this._bottomOccupied - this._topOccupied,
    };
  };
  Ca.prototype.reset = function () {
    this._rightOccupied =
      this._leftOccupied =
      this._bottomOccupied =
      this._topOccupied =
        this._padding;
  };
  ma(ia, T);
  ia.prototype._initialize = function () {
    y(this.padding) || "object" !== typeof this.padding
      ? (this.topPadding =
          this.rightPadding =
          this.bottomPadding =
          this.leftPadding =
            Number(this.padding) | 0)
      : ((this.topPadding = y(this.padding.top)
          ? 0
          : Number(this.padding.top) | 0),
        (this.rightPadding = y(this.padding.right)
          ? 0
          : Number(this.padding.right) | 0),
        (this.bottomPadding = y(this.padding.bottom)
          ? 0
          : Number(this.padding.bottom) | 0),
        (this.leftPadding = y(this.padding.left)
          ? 0
          : Number(this.padding.left) | 0));
  };
  ia.prototype.render = function (p) {
    if (0 !== this.fontSize) {
      p && this.ctx.save();
      var v = this.ctx.font;
      this.ctx.textBaseline = this.textBaseline;
      var s = 0;
      this._isDirty && this.measureText(this.ctx);
      this.ctx.translate(this.x, this.y + s);
      "middle" === this.textBaseline && (s = -this._lineHeight / 2);
      this.ctx.font = this._getFontString();
      this.ctx.rotate((Math.PI / 180) * this.angle);
      var y = 0,
        x = this.topPadding,
        B = null;
      this.ctx.roundRect || Aa(this.ctx);
      ((0 < this.borderThickness && this.borderColor) ||
        this.backgroundColor) &&
        this.ctx.roundRect(
          0,
          s,
          this.width,
          this.height,
          this.cornerRadius,
          this.borderThickness,
          this.backgroundColor,
          this.borderColor
        );
      this.ctx.fillStyle = this.fontColor;
      for (s = 0; s < this._wrappedText.lines.length; s++)
        (B = this._wrappedText.lines[s]),
          "right" === this.horizontalAlign
            ? (y =
                (this.width - (this.leftPadding + this.rightPadding)) / 2 -
                B.width / 2 +
                this.leftPadding)
            : "left" === this.horizontalAlign
            ? (y = this.leftPadding)
            : "center" === this.horizontalAlign &&
              (y =
                (this.width - (this.leftPadding + this.rightPadding)) / 2 -
                B.width / 2 +
                this.leftPadding),
          this.ctx.fillText(B.text, y, x),
          (x += B.height);
      this.ctx.font = v;
      p && this.ctx.restore();
    }
  };
  ia.prototype.setText = function (p) {
    this.text = p;
    this._isDirty = !0;
    this._wrappedText = null;
  };
  ia.prototype.measureText = function () {
    this._lineHeight = Ta(this.fontFamily, this.fontSize, this.fontWeight);
    if (null === this.maxWidth)
      throw "Please set maxWidth and height for TextBlock";
    this._wrapText(this.ctx);
    this._isDirty = !1;
    return { width: this.width, height: this.height };
  };
  ia.prototype._getLineWithWidth = function (p, v, s) {
    p = String(p);
    if (!p) return { text: "", width: 0 };
    var y = (s = 0),
      x = p.length - 1,
      B = Infinity;
    for (this.ctx.font = this._getFontString(); y <= x; ) {
      var B = Math.floor((y + x) / 2),
        F = p.substr(0, B + 1);
      s = this.ctx.measureText(F).width;
      if (s < v) y = B + 1;
      else if (s > v) x = B - 1;
      else break;
    }
    s > v &&
      1 < F.length &&
      ((F = F.substr(0, F.length - 1)), (s = this.ctx.measureText(F).width));
    v = !0;
    if (F.length === p.length || " " === p[F.length]) v = !1;
    v &&
      ((p = F.split(" ")),
      1 < p.length && p.pop(),
      (F = p.join(" ")),
      (s = this.ctx.measureText(F).width));
    return { text: F, width: s };
  };
  ia.prototype._wrapText = function () {
    var p = new String(Ea(String(this.text))),
      v = [],
      s = this.ctx.font,
      y = 0,
      x = 0;
    this.ctx.font = this._getFontString();
    if (0 === this.frontSize) x = y = 0;
    else
      for (; 0 < p.length; ) {
        var B = this.maxHeight - (this.topPadding + this.bottomPadding),
          F = this._getLineWithWidth(
            p,
            this.maxWidth - (this.leftPadding + this.rightPadding),
            !1
          );
        F.height = this._lineHeight;
        v.push(F);
        var S = x,
          x = Math.max(x, F.width),
          y = y + F.height,
          p = Ea(p.slice(F.text.length, p.length));
        B && y > B && ((F = v.pop()), (y -= F.height), (x = S));
      }
    this._wrappedText = { lines: v, width: x, height: y };
    this.width = x + (this.leftPadding + this.rightPadding);
    this.height = y + (this.topPadding + this.bottomPadding);
    this.ctx.font = s;
  };
  ia.prototype._getFontString = function () {
    var p;
    p = "" + (this.fontStyle ? this.fontStyle + " " : "");
    p += this.fontWeight ? this.fontWeight + " " : "";
    p += this.fontSize ? this.fontSize + "px " : "";
    var t = this.fontFamily ? this.fontFamily + "" : "";
    !v &&
      t &&
      ((t = t.split(",")[0]),
      "'" !== t[0] && '"' !== t[0] && (t = "'" + t + "'"));
    return (p += t);
  };
  ma(Qa, T);
  ma(Ha, T);
  Ha.prototype.render = function () {
    if (this.text) {
      var p = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
        v = p.layoutManager.getFreeSpace(),
        s = v.x1,
        x = v.y1,
        B = 0,
        F = 0,
        R =
          this.chart._menuButton &&
          this.chart.exportEnabled &&
          "top" === this.verticalAlign
            ? 22
            : 0,
        S,
        z;
      "top" === this.verticalAlign || "bottom" === this.verticalAlign
        ? (null === this.maxWidth &&
            (this.maxWidth =
              v.width - 4 - R * ("center" === this.horizontalAlign ? 2 : 1)),
          (F = 0.5 * v.height - this.margin - 2),
          (B = 0))
        : "center" === this.verticalAlign &&
          ("left" === this.horizontalAlign || "right" === this.horizontalAlign
            ? (null === this.maxWidth && (this.maxWidth = v.height - 4),
              (F = 0.5 * v.width - this.margin - 2))
            : "center" === this.horizontalAlign &&
              (null === this.maxWidth && (this.maxWidth = v.width - 4),
              (F = 0.5 * v.height - 4)));
      var Q;
      y(this.padding) || "number" !== typeof this.padding
        ? y(this.padding) ||
          "object" !== typeof this.padding ||
          ((Q = this.padding.top
            ? this.padding.top
            : this.padding.bottom
            ? this.padding.bottom
            : 0),
          (Q += this.padding.bottom
            ? this.padding.bottom
            : this.padding.top
            ? this.padding.top
            : 0),
          (Q *= 1.25))
        : (Q = 2.5 * this.padding);
      this.wrap ||
        (F = Math.min(F, Math.max(1.5 * this.fontSize, this.fontSize + Q)));
      F = new ia(this.ctx, {
        fontSize: this.fontSize,
        fontFamily: this.fontFamily,
        fontColor: this.fontColor,
        fontStyle: this.fontStyle,
        fontWeight: this.fontWeight,
        horizontalAlign: this.horizontalAlign,
        verticalAlign: this.verticalAlign,
        borderColor: this.borderColor,
        borderThickness: this.borderThickness,
        backgroundColor: this.backgroundColor,
        maxWidth: this.maxWidth,
        maxHeight: F,
        cornerRadius: this.cornerRadius,
        text: this.text,
        padding: this.padding,
        textBaseline: "top",
      });
      Q = F.measureText();
      "top" === this.verticalAlign || "bottom" === this.verticalAlign
        ? ("top" === this.verticalAlign
            ? ((x = v.y1 + 2), (z = "top"))
            : "bottom" === this.verticalAlign &&
              ((x = v.y2 - 2 - Q.height), (z = "bottom")),
          "left" === this.horizontalAlign
            ? (s = v.x1 + 2)
            : "center" === this.horizontalAlign
            ? (s = v.x1 + v.width / 2 - Q.width / 2)
            : "right" === this.horizontalAlign && (s = v.x2 - 2 - Q.width - R),
          (S = this.horizontalAlign),
          (this.width = Q.width),
          (this.height = Q.height))
        : "center" === this.verticalAlign &&
          ("left" === this.horizontalAlign
            ? ((s = v.x1 + 2),
              (x = v.y2 - 2 - (this.maxWidth / 2 - Q.width / 2)),
              (B = -90),
              (z = "left"),
              (this.width = Q.height),
              (this.height = Q.width))
            : "right" === this.horizontalAlign
            ? ((s = v.x2 - 2),
              (x = v.y1 + 2 + (this.maxWidth / 2 - Q.width / 2)),
              (B = 90),
              (z = "right"),
              (this.width = Q.height),
              (this.height = Q.width))
            : "center" === this.horizontalAlign &&
              ((x = p.y1 + (p.height / 2 - Q.height / 2)),
              (s = p.x1 + (p.width / 2 - Q.width / 2)),
              (z = "center"),
              (this.width = Q.width),
              (this.height = Q.height)),
          (S = "center"));
      F.x = s;
      F.y = x;
      F.angle = B;
      F.horizontalAlign = S;
      F.render(!0);
      p.layoutManager.registerSpace(z, {
        width:
          this.width + ("left" === z || "right" === z ? this.margin + 2 : 0),
        height:
          this.height + ("top" === z || "bottom" === z ? this.margin + 2 : 0),
      });
      this.bounds = { x1: s, y1: x, x2: s + this.width, y2: x + this.height };
      this.ctx.textBaseline = "top";
    }
  };
  ma(Ma, T);
  Ma.prototype.render = Ha.prototype.render;
  ma(Ia, T);
  x = {
    addTheme: function (p, v) {
      xa[p] = v;
    },
    addColorSet: function (p, v) {
      ya[p] = v;
    },
    addCultureInfo: function (p, v) {
      Ja[p] = v;
    },
    formatNumber: function (p, v, s) {
      s = s || "en";
      if (Ja[s]) return X(p, v || "#,##0.##", new Ia(s));
      throw "Unknown Culture Name";
    },
    formatDate: function (v, y, s) {
      s = s || "en";
      if (Ja[s]) return za(v, y || "DD MMM YYYY", new Ia(s));
      throw "Unknown Culture Name";
    },
  };
  window.CanvasJS = x;
  x.Chart = (function () {
    function p(a, f) {
      return a.x - f.x;
    }
    function t(a, f, b) {
      if (a && f && b) {
        b = b + "." + f;
        var c = "image/" + f;
        a = a.toDataURL(c);
        var e = !1,
          g = document.createElement("a");
        g.download = b;
        g.href = a;
        if ("undefined" !== typeof Blob && new Blob()) {
          for (
            var h = a.replace(/^data:[a-z\/]*;base64,/, ""),
              h = atob(h),
              l = new ArrayBuffer(h.length),
              l = new Uint8Array(l),
              n = 0;
            n < h.length;
            n++
          )
            l[n] = h.charCodeAt(n);
          f = new Blob([l.buffer], { type: "image/" + f });
          try {
            window.navigator.msSaveBlob(f, b), (e = !0);
          } catch (k) {
            (g.dataset.downloadurl = [c, g.download, g.href].join(":")),
              (g.href = window.URL.createObjectURL(f));
          }
        }
        if (!e)
          try {
            (event = document.createEvent("MouseEvents")),
              event.initMouseEvent(
                "click",
                !0,
                !1,
                window,
                0,
                0,
                0,
                0,
                0,
                !1,
                !1,
                !1,
                !1,
                0,
                null
              ),
              g.dispatchEvent
                ? g.dispatchEvent(event)
                : g.fireEvent && g.fireEvent("onclick");
          } catch (r) {
            (f = window.open()),
              f.document.write(
                "<img src='" +
                  a +
                  "'></img><div>Please right click on the image and save it to your device</div>"
              ),
              f.document.close();
          }
      }
    }
    function s(a, f) {
      f = f || {};
      this.theme = y(f.theme) || y(xa[f.theme]) ? "light1" : f.theme;
      s.base.constructor.call(this, "Chart", null, f, null, null);
      var b = this;
      this._containerId = a;
      this._objectsInitialized = !1;
      this.overlaidCanvasCtx = this.ctx = null;
      this._indexLabels = [];
      this._panTimerId = 0;
      this._lastTouchEventType = "";
      this._lastTouchData = null;
      this.isAnimating = !1;
      this.renderCount = 0;
      this.panEnabled = this.disableToolTip = this.animatedRender = !1;
      this._defaultCursor = "default";
      this.plotArea = {
        canvas: null,
        ctx: null,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        width: 0,
        height: 0,
      };
      this._dataInRenderedOrder = [];
      if (
        (this.container =
          "string" === typeof this._containerId
            ? document.getElementById(this._containerId)
            : this._containerId)
      ) {
        this.container.innerHTML = "";
        var c = 0,
          e = 0,
          c = this.options.width
            ? this.width
            : 0 < this.container.clientWidth
            ? this.container.clientWidth
            : this.width,
          e = this.options.height
            ? this.height
            : 0 < this.container.clientHeight
            ? this.container.clientHeight
            : this.height;
        this.width = c;
        this.height = e;
        this.x1 = this.y1 = 0;
        this.x2 = this.width;
        this.y2 = this.height;
        this._selectedColorSet =
          "undefined" !== typeof ya[this.colorSet]
            ? ya[this.colorSet]
            : ya.colorSet1;
        this._canvasJSContainer = document.createElement("div");
        this._canvasJSContainer.setAttribute(
          "class",
          "canvasjs-chart-container"
        );
        this._canvasJSContainer.style.position = "relative";
        this._canvasJSContainer.style.textAlign = "left";
        this._canvasJSContainer.style.cursor = "auto";
        v || (this._canvasJSContainer.style.height = "0px");
        this.container.appendChild(this._canvasJSContainer);
        this.canvas = ta(c, e);
        this._preRenderCanvas = ta(c, e);
        this.canvas.style.position = "absolute";
        this.canvas.getContext &&
          (this._canvasJSContainer.appendChild(this.canvas),
          (this.ctx = this.canvas.getContext("2d")),
          (this.ctx.textBaseline = "top"),
          Aa(this.ctx),
          (this._preRenderCtx = this._preRenderCanvas.getContext("2d")),
          (this._preRenderCtx.textBaseline = "top"),
          Aa(this._preRenderCtx),
          v
            ? (this.plotArea.ctx = this.ctx)
            : ((this.plotArea.canvas = ta(c, e)),
              (this.plotArea.canvas.style.position = "absolute"),
              this.plotArea.canvas.setAttribute("class", "plotAreaCanvas"),
              this._canvasJSContainer.appendChild(this.plotArea.canvas),
              (this.plotArea.ctx = this.plotArea.canvas.getContext("2d"))),
          (this.overlaidCanvas = ta(c, e)),
          (this.overlaidCanvas.style.position = "absolute"),
          (this.overlaidCanvas.style.webkitTapHighlightColor = "transparent"),
          this.overlaidCanvas.getContext &&
            (this._canvasJSContainer.appendChild(this.overlaidCanvas),
            (this.overlaidCanvasCtx = this.overlaidCanvas.getContext("2d")),
            (this.overlaidCanvasCtx.textBaseline = "top"),
            Aa(this.overlaidCanvasCtx)),
          (this._eventManager = new aa(this)),
          (this.windowResizeHandler = P(window, "resize", function () {
            b._updateSize() && b.render();
          })),
          (this._toolBar = document.createElement("div")),
          this._toolBar.setAttribute("class", "canvasjs-chart-toolbar"),
          (this._toolBar.style.cssText =
            "position: absolute; right: 1px; top: 1px;"),
          this._canvasJSContainer.appendChild(this._toolBar),
          (this.bounds = { x1: 0, y1: 0, x2: this.width, y2: this.height }),
          P(this.overlaidCanvas, "click", function (a) {
            b._mouseEventHandler(a);
          }),
          P(this.overlaidCanvas, "mousemove", function (a) {
            b._mouseEventHandler(a);
          }),
          P(this.overlaidCanvas, "mouseup", function (a) {
            b._mouseEventHandler(a);
          }),
          P(this.overlaidCanvas, "mousedown", function (a) {
            b._mouseEventHandler(a);
            va(b._dropdownMenu);
          }),
          P(this.overlaidCanvas, "mouseout", function (a) {
            b._mouseEventHandler(a);
          }),
          P(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart",
            function (a) {
              b._touchEventHandler(a);
            }
          ),
          P(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove",
            function (a) {
              b._touchEventHandler(a);
            }
          ),
          P(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend",
            function (a) {
              b._touchEventHandler(a);
            }
          ),
          P(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled
              ? "MSPointerCancel"
              : "touchcancel",
            function (a) {
              b._touchEventHandler(a);
            }
          ),
          (this.toolTip = new $(this, this.options.toolTip)),
          (this.data = null),
          (this.axisX = []),
          (this.axisX2 = []),
          (this.axisY = []),
          (this.axisY2 = []),
          (this.sessionVariables = {
            axisX: [],
            axisX2: [],
            axisY: [],
            axisY2: [],
          }));
      } else
        window.console &&
          window.console.log(
            'CanvasJS Error: Chart Container with id "' +
              this._containerId +
              '" was not found'
          );
    }
    function x(a, f) {
      for (var b = [], c, e = 0; e < a.length; e++)
        if (0 == e) b.push(a[0]);
        else {
          var g, h, l;
          l = e - 1;
          g = 0 === l ? 0 : l - 1;
          h = l === a.length - 1 ? l : l + 1;
          c =
            (Math.abs(
              (a[h].x - a[g].x) /
                (0 === a[h].x - a[l].x ? 0.01 : a[h].x - a[l].x)
            ) *
              (f - 1)) /
              2 +
            1;
          var n = (a[h].x - a[g].x) / c;
          c = (a[h].y - a[g].y) / c;
          b[b.length] =
            (a[l].x > a[g].x && 0 < n) || (a[l].x < a[g].x && 0 > n)
              ? { x: a[l].x + n / 3, y: a[l].y + c / 3 }
              : { x: a[l].x, y: a[l].y + c / 9 };
          l = e;
          g = 0 === l ? 0 : l - 1;
          h = l === a.length - 1 ? l : l + 1;
          c =
            (Math.abs(
              (a[h].x - a[g].x) /
                (0 === a[l].x - a[g].x ? 0.01 : a[l].x - a[g].x)
            ) *
              (f - 1)) /
              2 +
            1;
          n = (a[h].x - a[g].x) / c;
          c = (a[h].y - a[g].y) / c;
          b[b.length] =
            (a[l].x > a[g].x && 0 < n) || (a[l].x < a[g].x && 0 > n)
              ? { x: a[l].x - n / 3, y: a[l].y - c / 3 }
              : { x: a[l].x, y: a[l].y - c / 9 };
          b[b.length] = a[e];
        }
      return b;
    }
    function B(a, f, b, c, e, g, h, l, n, k) {
      var r = 0;
      k ? ((h.color = g), (l.color = g)) : (k = 1);
      r = n ? Math.abs(e - b) : Math.abs(c - f);
      r =
        0 < h.trimLength
          ? Math.abs((r * h.trimLength) / 100)
          : Math.abs(r - h.length);
      n ? ((b += r / 2), (e -= r / 2)) : ((f += r / 2), (c -= r / 2));
      var r = 1 === Math.round(h.thickness) % 2 ? 0.5 : 0,
        q = 1 === Math.round(l.thickness) % 2 ? 0.5 : 0;
      a.save();
      a.globalAlpha = k;
      a.strokeStyle = l.color || g;
      a.lineWidth = l.thickness || 2;
      a.setLineDash && a.setLineDash(F(l.dashType, l.thickness));
      a.beginPath();
      n && 0 < l.thickness
        ? (a.moveTo(c - h.thickness / 2, Math.round((b + e) / 2) - q),
          a.lineTo(f + h.thickness / 2, Math.round((b + e) / 2) - q))
        : 0 < l.thickness &&
          (a.moveTo(Math.round((f + c) / 2) - q, b + h.thickness / 2),
          a.lineTo(Math.round((f + c) / 2) - q, e - h.thickness / 2));
      a.stroke();
      a.strokeStyle = h.color || g;
      a.lineWidth = h.thickness || 2;
      a.setLineDash && a.setLineDash(F(h.dashType, h.thickness));
      a.beginPath();
      n && 0 < h.thickness
        ? (a.moveTo(c - r, b),
          a.lineTo(c - r, e),
          a.moveTo(f + r, b),
          a.lineTo(f + r, e))
        : 0 < h.thickness &&
          (a.moveTo(f, b + r),
          a.lineTo(c, b + r),
          a.moveTo(f, e - r),
          a.lineTo(c, e - r));
      a.stroke();
      a.restore();
    }
    function J(a, f, b, c, e) {
      if (null === a || "undefined" === typeof a)
        return "undefined" === typeof b ? f : b;
      a =
        parseFloat(a.toString()) *
        (0 <= a.toString().indexOf("%") ? f / 100 : 1);
      "undefined" !== typeof c &&
        ((a = Math.min(c, a)),
        "undefined" !== typeof e && (a = Math.max(e, a)));
      return !isNaN(a) && a <= f && 0 <= a
        ? a
        : "undefined" === typeof b
        ? f
        : b;
    }
    function U(a, f) {
      U.base.constructor.call(this, "Legend", "legend", f, null, a);
      this.chart = a;
      this.canvas = a.canvas;
      this.ctx = this.chart.ctx;
      this.ghostCtx = this.chart._eventManager.ghostCtx;
      this.items = [];
      this.optionsName = "legend";
      this.height = this.width = 0;
      this.orientation = null;
      this.dataSeries = [];
      this.bounds = { x1: null, y1: null, x2: null, y2: null };
      "undefined" === typeof this.options.fontSize &&
        (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
      this.lineHeight = Ta(this.fontFamily, this.fontSize, this.fontWeight);
      this.horizontalSpacing = this.fontSize;
    }
    function S(a, f, b, c) {
      S.base.constructor.call(this, "DataSeries", "data", f, b, a);
      this.chart = a;
      this.canvas = a.canvas;
      this._ctx = a.canvas.ctx;
      this.index = b;
      this.noDataPointsInPlotArea = 0;
      this.id = c;
      this.chart._eventManager.objectMap[c] = {
        id: c,
        objectType: "dataSeries",
        dataSeriesIndex: b,
      };
      a = f.dataPoints ? f.dataPoints.length : 0;
      this.dataPointEOs = [];
      for (f = 0; f < a; f++) this.dataPointEOs[f] = {};
      this.dataPointIds = [];
      this.plotUnit = [];
      this.axisY = this.axisX = null;
      this.optionsName = "data";
      this.isOptionsInArray = !0;
      null === this.fillOpacity &&
        (this.type.match(/area/i)
          ? (this.fillOpacity = 0.7)
          : (this.fillOpacity = 1));
      this.axisPlacement = this.getDefaultAxisPlacement();
      "undefined" === typeof this.options.indexLabelFontSize &&
        (this.indexLabelFontSize = this.chart.getAutoFontSize(
          this.indexLabelFontSize
        ));
    }
    function z(a, f, b, c, e, g) {
      z.base.constructor.call(this, "Axis", f, b, c, a);
      this.chart = a;
      this.canvas = a.canvas;
      this.ctx = a.ctx;
      this.intervalStartPosition = this.maxHeight = this.maxWidth = 0;
      this.labels = [];
      this.dataSeries = [];
      this._stripLineLabels = this._ticks = this._labels = null;
      this.dataInfo = {
        min: Infinity,
        max: -Infinity,
        viewPortMin: Infinity,
        viewPortMax: -Infinity,
        minDiff: Infinity,
      };
      this.isOptionsInArray = !0;
      "axisX" === e
        ? ("left" === g || "bottom" === g
            ? ((this.optionsName = "axisX"),
              y(this.chart.sessionVariables.axisX[c]) &&
                (this.chart.sessionVariables.axisX[c] = {}),
              (this.sessionVariables = this.chart.sessionVariables.axisX[c]))
            : ((this.optionsName = "axisX2"),
              y(this.chart.sessionVariables.axisX2[c]) &&
                (this.chart.sessionVariables.axisX2[c] = {}),
              (this.sessionVariables = this.chart.sessionVariables.axisX2[c])),
          this.options.interval || (this.intervalType = null))
        : "left" === g || "bottom" === g
        ? ((this.optionsName = "axisY"),
          y(this.chart.sessionVariables.axisY[c]) &&
            (this.chart.sessionVariables.axisY[c] = {}),
          (this.sessionVariables = this.chart.sessionVariables.axisY[c]))
        : ((this.optionsName = "axisY2"),
          y(this.chart.sessionVariables.axisY2[c]) &&
            (this.chart.sessionVariables.axisY2[c] = {}),
          (this.sessionVariables = this.chart.sessionVariables.axisY2[c]));
      "undefined" === typeof this.options.titleFontSize &&
        (this.titleFontSize = this.chart.getAutoFontSize(this.titleFontSize));
      "undefined" === typeof this.options.labelFontSize &&
        (this.labelFontSize = this.chart.getAutoFontSize(this.labelFontSize));
      this.type = e;
      "axisX" !== e ||
        (b && "undefined" !== typeof b.gridThickness) ||
        (this.gridThickness = 0);
      this._position = g;
      this.lineCoordinates = {
        x1: null,
        y1: null,
        x2: null,
        y2: null,
        width: null,
      };
      this.labelAngle = ((this.labelAngle % 360) + 360) % 360;
      90 < this.labelAngle && 270 > this.labelAngle
        ? (this.labelAngle -= 180)
        : 270 <= this.labelAngle &&
          360 >= this.labelAngle &&
          (this.labelAngle -= 360);
      this.options.scaleBreaks &&
        (this.scaleBreaks = new Q(
          this.chart,
          this.options.scaleBreaks,
          ++this.chart._eventManager.lastObjectId,
          this
        ));
      this.stripLines = [];
      if (this.options.stripLines && 0 < this.options.stripLines.length)
        for (a = 0; a < this.options.stripLines.length; a++)
          this.stripLines.push(
            new da(
              this.chart,
              this.options.stripLines[a],
              a,
              ++this.chart._eventManager.lastObjectId,
              this
            )
          );
      this.options.crosshair &&
        (this.crosshair = new ea(this.chart, this.options.crosshair, this));
      this._titleTextBlock = null;
      this.hasOptionChanged("viewportMinimum") &&
        null === this.viewportMinimum &&
        ((this.options.viewportMinimum = void 0),
        (this.sessionVariables.viewportMinimum = null));
      this.hasOptionChanged("viewportMinimum") ||
      isNaN(this.sessionVariables.newViewportMinimum) ||
      null === this.sessionVariables.newViewportMinimum
        ? (this.sessionVariables.newViewportMinimum = null)
        : (this.viewportMinimum = this.sessionVariables.newViewportMinimum);
      this.hasOptionChanged("viewportMaximum") &&
        null === this.viewportMaximum &&
        ((this.options.viewportMaximum = void 0),
        (this.sessionVariables.viewportMaximum = null));
      this.hasOptionChanged("viewportMaximum") ||
      isNaN(this.sessionVariables.newViewportMaximum) ||
      null === this.sessionVariables.newViewportMaximum
        ? (this.sessionVariables.newViewportMaximum = null)
        : (this.viewportMaximum = this.sessionVariables.newViewportMaximum);
      null !== this.minimum &&
        null !== this.viewportMinimum &&
        (this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum));
      null !== this.maximum &&
        null !== this.viewportMaximum &&
        (this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum));
      this.trackChanges("viewportMinimum");
      this.trackChanges("viewportMaximum");
    }
    function Q(a, f, b, c) {
      Q.base.constructor.call(this, "ScaleBreaks", "scaleBreaks", f, null, c);
      this.id = b;
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.axis = c;
      this.optionsName = "scaleBreaks";
      this.isOptionsInArray = !1;
      this._appliedBreaks = [];
      this.customBreaks = [];
      this.autoBreaks = [];
      "string" === typeof this.spacing
        ? ((this.spacing = parseFloat(this.spacing)),
          (this.spacing = isNaN(this.spacing)
            ? 8
            : (10 < this.spacing ? 10 : this.spacing) + "%"))
        : "number" !== typeof this.spacing && (this.spacing = 8);
      this.autoCalculate &&
        (this.maxNumberOfAutoBreaks = Math.min(this.maxNumberOfAutoBreaks, 5));
      if (this.options.customBreaks && 0 < this.options.customBreaks.length) {
        for (a = 0; a < this.options.customBreaks.length; a++)
          this.customBreaks.push(
            new Y(
              this.chart,
              "customBreaks",
              this.options.customBreaks[a],
              a,
              ++this.chart._eventManager.lastObjectId,
              this
            )
          ),
            "number" === typeof this.customBreaks[a].startValue &&
              "number" === typeof this.customBreaks[a].endValue &&
              this.customBreaks[a].endValue !==
                this.customBreaks[a].startValue &&
              this._appliedBreaks.push(this.customBreaks[a]);
        this._appliedBreaks.sort(function (a, c) {
          return a.startValue - c.startValue;
        });
        for (a = 0; a < this._appliedBreaks.length - 1; a++)
          this._appliedBreaks[a].endValue >=
            this._appliedBreaks[a + 1].startValue &&
            ((this._appliedBreaks[a].endValue = Math.max(
              this._appliedBreaks[a].endValue,
              this._appliedBreaks[a + 1].endValue
            )),
            window.console &&
              window.console.log(
                "CanvasJS Error: Breaks " +
                  a +
                  " and " +
                  (a + 1) +
                  " are overlapping."
              ),
            this._appliedBreaks.splice(a, 2),
            a--);
      }
    }
    function Y(a, f, b, c, e, g) {
      Y.base.constructor.call(this, "Break", f, b, c, g);
      this.id = e;
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.scaleBreaks = g;
      this.optionsName = f;
      this.isOptionsInArray = !0;
      this.type = b.type ? this.type : g.type;
      this.fillOpacity = y(b.fillOpacity) ? g.fillOpacity : this.fillOpacity;
      this.lineThickness = y(b.lineThickness)
        ? g.lineThickness
        : this.lineThickness;
      this.color = b.color ? this.color : g.color;
      this.lineColor = b.lineColor ? this.lineColor : g.lineColor;
      this.lineDashType = b.lineDashType ? this.lineDashType : g.lineDashType;
      !y(this.startValue) &&
        this.startValue.getTime &&
        (this.startValue = this.startValue.getTime());
      !y(this.endValue) &&
        this.endValue.getTime &&
        (this.endValue = this.endValue.getTime());
      "number" === typeof this.startValue &&
        "number" === typeof this.endValue &&
        this.endValue < this.startValue &&
        ((a = this.startValue),
        (this.startValue = this.endValue),
        (this.endValue = a));
      this.spacing = "undefined" === typeof b.spacing ? g.spacing : b.spacing;
      "string" === typeof this.options.spacing
        ? ((this.spacing = parseFloat(this.spacing)),
          (this.spacing = isNaN(this.spacing)
            ? 0
            : (10 < this.spacing ? 10 : this.spacing) + "%"))
        : "number" !== typeof this.options.spacing &&
          (this.spacing = g.spacing);
      this.size = g.parent.logarithmic ? 1 : 0;
    }
    function da(a, f, b, c, e) {
      da.base.constructor.call(this, "StripLine", "stripLines", f, b, e);
      this.id = c;
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.label = this.label;
      this.axis = e;
      this.optionsName = "stripLines";
      this.isOptionsInArray = !0;
      this._thicknessType = "pixel";
      null !== this.startValue &&
        null !== this.endValue &&
        ((this.value = e.logarithmic
          ? Math.sqrt(
              (this.startValue.getTime
                ? this.startValue.getTime()
                : this.startValue) *
                (this.endValue.getTime
                  ? this.endValue.getTime()
                  : this.endValue)
            )
          : ((this.startValue.getTime
              ? this.startValue.getTime()
              : this.startValue) +
              (this.endValue.getTime
                ? this.endValue.getTime()
                : this.endValue)) /
            2),
        (this._thicknessType = null));
    }
    function ea(a, f, b) {
      ea.base.constructor.call(this, "Crosshair", "crosshair", f, null, b);
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.axis = b;
      this.optionsName = "crosshair";
      this._thicknessType = "pixel";
    }
    function $(a, f) {
      $.base.constructor.call(this, "ToolTip", "toolTip", f, null, a);
      this.chart = a;
      this.canvas = a.canvas;
      this.ctx = this.chart.ctx;
      this.currentDataPointIndex = this.currentSeriesIndex = -1;
      this._timerId = 0;
      this._prevY = this._prevX = NaN;
      this.containerTransitionDuration = 0.1;
      this.mozContainerTransition = this.getContainerTransition(
        this.containerTransitionDuration
      );
      this.optionsName = "toolTip";
      this._initialize();
    }
    function aa(a) {
      this.chart = a;
      this.lastObjectId = 0;
      this.objectMap = [];
      this.rectangularRegionEventSubscriptions = [];
      this.previousDataPointEventObject = null;
      this.ghostCanvas = ta(this.chart.width, this.chart.height);
      this.ghostCtx = this.ghostCanvas.getContext("2d");
      this.mouseoveredObjectMaps = [];
    }
    function ha(a) {
      this.chart = a;
      this.ctx = this.chart.plotArea.ctx;
      this.animations = [];
      this.animationRequestId = null;
    }
    ma(s, T);
    s.prototype.destroy = function () {
      var a = window,
        f = this.windowResizeHandler;
      a.removeEventListener
        ? a.removeEventListener("resize", f)
        : a.detachEvent && a.detachEvent("onresize", f);
    };
    s.prototype._updateOptions = function () {
      var a = this;
      this.updateOption("width");
      this.updateOption("height");
      this.updateOption("dataPointWidth");
      this.updateOption("dataPointMinWidth");
      this.updateOption("dataPointMaxWidth");
      this.updateOption("interactivityEnabled");
      this.updateOption("theme");
      this.updateOption("colorSet") &&
        (this._selectedColorSet =
          "undefined" !== typeof ya[this.colorSet]
            ? ya[this.colorSet]
            : ya.colorSet1);
      this.updateOption("backgroundColor");
      this.backgroundColor || (this.backgroundColor = "rgba(0,0,0,0)");
      this.updateOption("culture");
      this._cultureInfo = new Ia(this.options.culture);
      this.updateOption("animationEnabled");
      this.animationEnabled = this.animationEnabled && v;
      this.updateOption("animationDuration");
      this.updateOption("rangeChanging");
      this.updateOption("rangeChanged");
      this.updateOption("exportEnabled");
      this.updateOption("exportFileName");
      this.updateOption("zoomType");
      if (this.options.zoomEnabled) {
        if (!this._zoomButton) {
          var f = !1;
          va((this._zoomButton = document.createElement("button")));
          ua(this, this._zoomButton, "pan");
          this._toolBar.appendChild(this._zoomButton);
          this._zoomButton.style.borderRight =
            this.toolbar.borderThickness +
            "px solid " +
            this.toolbar.borderColor;
          P(this._zoomButton, "touchstart", function (a) {
            f = !0;
          });
          P(this._zoomButton, "click", function () {
            a.zoomEnabled
              ? ((a.zoomEnabled = !1),
                (a.panEnabled = !0),
                ua(a, a._zoomButton, "zoom"))
              : ((a.zoomEnabled = !0),
                (a.panEnabled = !1),
                ua(a, a._zoomButton, "pan"));
            a.render();
          });
          P(this._zoomButton, "mouseover", function () {
            f
              ? (f = !1)
              : (na(a, a._zoomButton, {
                  backgroundColor: a.toolbar.backgroundColorOnHover,
                  color: a.toolbar.fontColorOnHover,
                  transition: "0.4s",
                  WebkitTransition: "0.4s",
                }),
                0 >= navigator.userAgent.search("MSIE") &&
                  na(a, a._zoomButton.childNodes[0], {
                    WebkitFilter: "invert(100%)",
                    filter: "invert(100%)",
                  }));
          });
          P(this._zoomButton, "mouseout", function () {
            f ||
              (na(a, a._zoomButton, {
                backgroundColor: a.toolbar.backgroundColor,
                color: a.toolbar.fontColor,
                transition: "0.4s",
                WebkitTransition: "0.4s",
              }),
              0 >= navigator.userAgent.search("MSIE") &&
                na(a, a._zoomButton.childNodes[0], {
                  WebkitFilter: "invert(0%)",
                  filter: "invert(0%)",
                }));
          });
        }
        this._resetButton ||
          ((f = !1),
          va((this._resetButton = document.createElement("button"))),
          ua(this, this._resetButton, "reset"),
          (this._resetButton.style.borderRight =
            (this.exportEnabled ? this.toolbar.borderThickness : 0) +
            "px solid " +
            this.toolbar.borderColor),
          this._toolBar.appendChild(this._resetButton),
          P(this._resetButton, "touchstart", function (a) {
            f = !0;
          }),
          P(this._resetButton, "click", function () {
            a.toolTip.hide();
            a.zoomEnabled || a.panEnabled
              ? ((a.zoomEnabled = !0),
                (a.panEnabled = !1),
                ua(a, a._zoomButton, "pan"),
                (a._defaultCursor = "default"),
                (a.overlaidCanvas.style.cursor = a._defaultCursor))
              : ((a.zoomEnabled = !1), (a.panEnabled = !1));
            if (a.sessionVariables.axisX)
              for (var c = 0; c < a.sessionVariables.axisX.length; c++)
                (a.sessionVariables.axisX[c].newViewportMinimum = null),
                  (a.sessionVariables.axisX[c].newViewportMaximum = null);
            if (a.sessionVariables.axisX2)
              for (c = 0; c < a.sessionVariables.axisX2.length; c++)
                (a.sessionVariables.axisX2[c].newViewportMinimum = null),
                  (a.sessionVariables.axisX2[c].newViewportMaximum = null);
            if (a.sessionVariables.axisY)
              for (c = 0; c < a.sessionVariables.axisY.length; c++)
                (a.sessionVariables.axisY[c].newViewportMinimum = null),
                  (a.sessionVariables.axisY[c].newViewportMaximum = null);
            if (a.sessionVariables.axisY2)
              for (c = 0; c < a.sessionVariables.axisY2.length; c++)
                (a.sessionVariables.axisY2[c].newViewportMinimum = null),
                  (a.sessionVariables.axisY2[c].newViewportMaximum = null);
            a.resetOverlayedCanvas();
            va(a._zoomButton, a._resetButton);
            a._dispatchRangeEvent("rangeChanging", "reset");
            a.render();
            a._dispatchRangeEvent("rangeChanged", "reset");
          }),
          P(this._resetButton, "mouseover", function () {
            f ||
              (na(a, a._resetButton, {
                backgroundColor: a.toolbar.backgroundColorOnHover,
                color: a.toolbar.hoverFfontColorOnHoverontColor,
                transition: "0.4s",
                WebkitTransition: "0.4s",
              }),
              0 >= navigator.userAgent.search("MSIE") &&
                na(a, a._resetButton.childNodes[0], {
                  WebkitFilter: "invert(100%)",
                  filter: "invert(100%)",
                }));
          }),
          P(this._resetButton, "mouseout", function () {
            f ||
              (na(a, a._resetButton, {
                backgroundColor: a.toolbar.backgroundColor,
                color: a.toolbar.fontColor,
                transition: "0.4s",
                WebkitTransition: "0.4s",
              }),
              0 >= navigator.userAgent.search("MSIE") &&
                na(a, a._resetButton.childNodes[0], {
                  WebkitFilter: "invert(0%)",
                  filter: "invert(0%)",
                }));
          }),
          (this.overlaidCanvas.style.cursor = a._defaultCursor));
        this.zoomEnabled ||
          this.panEnabled ||
          (this._zoomButton
            ? (a._zoomButton.getAttribute("state") === a._cultureInfo.zoomText
                ? ((this.panEnabled = !0), (this.zoomEnabled = !1))
                : ((this.zoomEnabled = !0), (this.panEnabled = !1)),
              La(a._zoomButton, a._resetButton))
            : ((this.zoomEnabled = !0), (this.panEnabled = !1)));
      } else this.panEnabled = this.zoomEnabled = !1;
      this._menuButton
        ? this.exportEnabled
          ? La(this._menuButton)
          : va(this._menuButton)
        : this.exportEnabled &&
          v &&
          ((f = !1),
          (this._menuButton = document.createElement("button")),
          ua(this, this._menuButton, "menu"),
          this._toolBar.appendChild(this._menuButton),
          P(this._menuButton, "touchstart", function (a) {
            f = !0;
          }),
          P(
            this._menuButton,
            "click",
            function () {
              "none" !== a._dropdownMenu.style.display ||
                (a._dropDownCloseTime &&
                  500 >=
                    new Date().getTime() - a._dropDownCloseTime.getTime()) ||
                ((a._dropdownMenu.style.display = "block"),
                a._menuButton.blur(),
                a._dropdownMenu.focus());
            },
            !0
          ),
          P(
            this._menuButton,
            "mouseover",
            function () {
              f ||
                (na(a, a._menuButton, {
                  backgroundColor: a.toolbar.backgroundColorOnHover,
                  color: a.toolbar.fontColorOnHover,
                }),
                0 >= navigator.userAgent.search("MSIE") &&
                  na(a, a._menuButton.childNodes[0], {
                    WebkitFilter: "invert(100%)",
                    filter: "invert(100%)",
                  }));
            },
            !0
          ),
          P(
            this._menuButton,
            "mouseout",
            function () {
              f ||
                (na(a, a._menuButton, {
                  backgroundColor: a.toolbar.backgroundColor,
                  color: a.toolbar.fontColor,
                }),
                0 >= navigator.userAgent.search("MSIE") &&
                  na(a, a._menuButton.childNodes[0], {
                    WebkitFilter: "invert(0%)",
                    filter: "invert(0%)",
                  }));
            },
            !0
          ));
      if (!this._dropdownMenu && this.exportEnabled && v) {
        f = !1;
        this._dropdownMenu = document.createElement("div");
        this._dropdownMenu.setAttribute("tabindex", -1);
        var b = -1 !== this.theme.indexOf("dark") ? "black" : "#888888";
        this._dropdownMenu.style.cssText =
          "position: absolute; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; cursor: pointer;right: 0px;top: 25px;min-width: 120px;outline: 0;font-size: 14px; font-family: Arial, Helvetica, sans-serif;padding: 5px 0px 5px 0px;text-align: left;line-height: 10px;background-color:" +
          this.toolbar.backgroundColor +
          ";box-shadow: 2px 2px 10px " +
          b;
        a._dropdownMenu.style.display = "none";
        this._toolBar.appendChild(this._dropdownMenu);
        P(
          this._dropdownMenu,
          "blur",
          function () {
            va(a._dropdownMenu);
            a._dropDownCloseTime = new Date();
          },
          !0
        );
        b = document.createElement("div");
        b.style.cssText = "padding: 12px 8px 12px 8px";
        b.innerHTML = this._cultureInfo.printText;
        b.style.backgroundColor = this.toolbar.backgroundColor;
        b.style.color = this.toolbar.fontColor;
        this._dropdownMenu.appendChild(b);
        P(b, "touchstart", function (a) {
          f = !0;
        });
        P(
          b,
          "mouseover",
          function () {
            f ||
              ((this.style.backgroundColor = a.toolbar.backgroundColorOnHover),
              (this.style.color = a.toolbar.fontColorOnHover));
          },
          !0
        );
        P(
          b,
          "mouseout",
          function () {
            f ||
              ((this.style.backgroundColor = a.toolbar.backgroundColor),
              (this.style.color = a.toolbar.fontColor));
          },
          !0
        );
        P(
          b,
          "click",
          function () {
            a.print();
            va(a._dropdownMenu);
          },
          !0
        );
        b = document.createElement("div");
        b.style.cssText = "padding: 12px 8px 12px 8px";
        b.innerHTML = this._cultureInfo.saveJPGText;
        b.style.backgroundColor = this.toolbar.backgroundColor;
        b.style.color = this.toolbar.fontColor;
        this._dropdownMenu.appendChild(b);
        P(b, "touchstart", function (a) {
          f = !0;
        });
        P(
          b,
          "mouseover",
          function () {
            f ||
              ((this.style.backgroundColor = a.toolbar.backgroundColorOnHover),
              (this.style.color = a.toolbar.fontColorOnHover));
          },
          !0
        );
        P(
          b,
          "mouseout",
          function () {
            f ||
              ((this.style.backgroundColor = a.toolbar.backgroundColor),
              (this.style.color = a.toolbar.fontColor));
          },
          !0
        );
        P(
          b,
          "click",
          function () {
            t(a.canvas, "jpeg", a.exportFileName);
            va(a._dropdownMenu);
          },
          !0
        );
        b = document.createElement("div");
        b.style.cssText = "padding: 12px 8px 12px 8px";
        b.innerHTML = this._cultureInfo.savePNGText;
        b.style.backgroundColor = this.toolbar.backgroundColor;
        b.style.color = this.toolbar.fontColor;
        this._dropdownMenu.appendChild(b);
        P(b, "touchstart", function (a) {
          f = !0;
        });
        P(
          b,
          "mouseover",
          function () {
            f ||
              ((this.style.backgroundColor = a.toolbar.backgroundColorOnHover),
              (this.style.color = a.toolbar.fontColorOnHover));
          },
          !0
        );
        P(
          b,
          "mouseout",
          function () {
            f ||
              ((this.style.backgroundColor = a.toolbar.backgroundColor),
              (this.style.color = a.toolbar.fontColor));
          },
          !0
        );
        P(
          b,
          "click",
          function () {
            t(a.canvas, "png", a.exportFileName);
            va(a._dropdownMenu);
          },
          !0
        );
      }
      "none" !== this._toolBar.style.display &&
        this._zoomButton &&
        (this.panEnabled
          ? ua(a, a._zoomButton, "zoom")
          : ua(a, a._zoomButton, "pan"),
        a._resetButton.getAttribute("state") !== a._cultureInfo.resetText &&
          ua(a, a._resetButton, "reset"));
      this.options.toolTip &&
        this.toolTip.options !== this.options.toolTip &&
        (this.toolTip.options = this.options.toolTip);
      for (var c in this.toolTip.options)
        this.toolTip.options.hasOwnProperty(c) && this.toolTip.updateOption(c);
    };
    s.prototype._updateSize = function () {
      var a = 0,
        f = 0;
      this.options.width
        ? (a = this.width)
        : (this.width = a =
            0 < this.container.clientWidth
              ? this.container.clientWidth
              : this.width);
      this.options.height
        ? (f = this.height)
        : (this.height = f =
            0 < this.container.clientHeight
              ? this.container.clientHeight
              : this.height);
      return this.canvas.width !== a * ga || this.canvas.height !== f * ga
        ? (Ga(this.canvas, a, f),
          Ga(this._preRenderCanvas, a, f),
          Ga(this.overlaidCanvas, a, f),
          Ga(this._eventManager.ghostCanvas, a, f),
          (this.bounds = { x1: 0, y1: 0, x2: this.width, y2: this.height }),
          !0)
        : !1;
    };
    s.prototype._initialize = function () {
      this.toolbar = new Qa(this, this.options.toolbar);
      this._animator
        ? this._animator.cancelAllAnimations()
        : (this._animator = new ha(this));
      this.removeAllEventListeners();
      this.disableToolTip = !1;
      this._axes = [];
      this.funnelPyramidClickHandler = this.pieDoughnutClickHandler = null;
      this.animationRequestId &&
        this.cancelRequestAnimFrame.call(window, this.animationRequestId);
      this._updateOptions();
      this.animatedRender =
        v && this.animationEnabled && 0 === this.renderCount;
      this._updateSize();
      this.clearCanvas();
      this.ctx.beginPath();
      this.axisX = [];
      this.axisX2 = [];
      this.axisY = [];
      this.axisY2 = [];
      this._indexLabels = [];
      this._dataInRenderedOrder = [];
      this._events = [];
      this._eventManager && this._eventManager.reset();
      this.plotInfo = { axisPlacement: null, plotTypes: [] };
      this.layoutManager = new Ca(0, 0, this.width, this.height, 2);
      this.plotArea.layoutManager && this.plotArea.layoutManager.reset();
      this.data = [];
      var a = 0,
        f = null;
      if (this.options.data) {
        for (var b = 0; b < this.options.data.length; b++)
          if (
            (a++,
            !this.options.data[b].type ||
              0 <= s._supportedChartTypes.indexOf(this.options.data[b].type))
          ) {
            var c = new S(
              this,
              this.options.data[b],
              a - 1,
              ++this._eventManager.lastObjectId
            );
            "error" === c.type &&
              ((c.linkedDataSeriesIndex = y(
                this.options.data[b].linkedDataSeriesIndex
              )
                ? b - 1
                : this.options.data[b].linkedDataSeriesIndex),
              0 > c.linkedDataSeriesIndex ||
                c.linkedDataSeriesIndex >= this.options.data.length ||
                "number" !== typeof c.linkedDataSeriesIndex ||
                "error" === this.options.data[c.linkedDataSeriesIndex].type) &&
              (c.linkedDataSeriesIndex = null);
            null === c.name && (c.name = "DataSeries " + a);
            null === c.color
              ? 1 < this.options.data.length
                ? ((c._colorSet = [
                    this._selectedColorSet[
                      c.index % this._selectedColorSet.length
                    ],
                  ]),
                  (c.color =
                    this._selectedColorSet[
                      c.index % this._selectedColorSet.length
                    ]))
                : (c._colorSet =
                    "line" === c.type ||
                    "stepLine" === c.type ||
                    "spline" === c.type ||
                    "area" === c.type ||
                    "stepArea" === c.type ||
                    "splineArea" === c.type ||
                    "stackedArea" === c.type ||
                    "stackedArea100" === c.type ||
                    "rangeArea" === c.type ||
                    "rangeSplineArea" === c.type ||
                    "candlestick" === c.type ||
                    "ohlc" === c.type ||
                    "waterfall" === c.type ||
                    "boxAndWhisker" === c.type
                      ? [this._selectedColorSet[0]]
                      : this._selectedColorSet)
              : (c._colorSet = [c.color]);
            null === c.markerSize &&
              ((("line" === c.type ||
                "stepLine" === c.type ||
                "spline" === c.type ||
                0 <= c.type.toLowerCase().indexOf("area")) &&
                c.dataPoints &&
                c.dataPoints.length < this.width / 16) ||
                "scatter" === c.type) &&
              (c.markerSize = 8);
            ("bubble" !== c.type && "scatter" !== c.type) ||
              !c.dataPoints ||
              (c.dataPoints.some
                ? c.dataPoints.some(function (a) {
                    return a.x;
                  }) && c.dataPoints.sort(p)
                : c.dataPoints.sort(p));
            this.data.push(c);
            var e = c.axisPlacement,
              f = f || e,
              g;
            "normal" === e
              ? "xySwapped" === this.plotInfo.axisPlacement
                ? (g = 'You cannot combine "' + c.type + '" with bar chart')
                : "none" === this.plotInfo.axisPlacement
                ? (g = 'You cannot combine "' + c.type + '" with pie chart')
                : null === this.plotInfo.axisPlacement &&
                  (this.plotInfo.axisPlacement = "normal")
              : "xySwapped" === e
              ? "normal" === this.plotInfo.axisPlacement
                ? (g =
                    'You cannot combine "' +
                    c.type +
                    '" with line, area, column or pie chart')
                : "none" === this.plotInfo.axisPlacement
                ? (g = 'You cannot combine "' + c.type + '" with pie chart')
                : null === this.plotInfo.axisPlacement &&
                  (this.plotInfo.axisPlacement = "xySwapped")
              : "none" === e
              ? "normal" === this.plotInfo.axisPlacement
                ? (g =
                    'You cannot combine "' +
                    c.type +
                    '" with line, area, column or bar chart')
                : "xySwapped" === this.plotInfo.axisPlacement
                ? (g = 'You cannot combine "' + c.type + '" with bar chart')
                : null === this.plotInfo.axisPlacement &&
                  (this.plotInfo.axisPlacement = "none")
              : null === e &&
                "none" === this.plotInfo.axisPlacement &&
                (g = 'You cannot combine "' + c.type + '" with pie chart');
            if (g && window.console) {
              window.console.log(g);
              return;
            }
          }
        for (b = 0; b < this.data.length; b++) {
          if ("none" == f && "error" === this.data[b].type && window.console) {
            window.console.log(
              'You cannot combine "' + c.type + '" with error chart'
            );
            return;
          }
          "error" === this.data[b].type &&
            ((this.data[b].axisPlacement = this.plotInfo.axisPlacement =
              f || "normal"),
            (this.data[b]._linkedSeries =
              null === this.data[b].linkedDataSeriesIndex
                ? null
                : this.data[this.data[b].linkedDataSeriesIndex]));
        }
      }
      this._objectsInitialized = !0;
    };
    s._supportedChartTypes = Ba(
      "line stepLine spline column area stepArea splineArea bar bubble scatter stackedColumn stackedColumn100 stackedBar stackedBar100 stackedArea stackedArea100 candlestick ohlc boxAndWhisker rangeColumn error rangeBar rangeArea rangeSplineArea pie doughnut funnel pyramid waterfall".split(
        " "
      )
    );
    s.prototype.render = function (a) {
      a && (this.options = a);
      this._initialize();
      $a(this);
      ab(this);
      var f = [];
      for (a = 0; a < this.data.length; a++)
        if (
          "normal" === this.plotInfo.axisPlacement ||
          "xySwapped" === this.plotInfo.axisPlacement
        ) {
          if (!this.data[a].axisYType || "primary" === this.data[a].axisYType)
            if (this.options.axisY && 0 < this.options.axisY.length) {
              if (!this.axisY.length)
                for (var b = 0; b < this.options.axisY.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisY[b] = new z(
                          this,
                          "axisY",
                          this.options.axisY[b],
                          b,
                          "axisY",
                          "left"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisY[b] = new z(
                          this,
                          "axisY",
                          this.options.axisY[b],
                          b,
                          "axisY",
                          "bottom"
                        ))
                      );
              this.data[a].axisY =
                this.axisY[
                  0 <= this.data[a].axisYIndex &&
                  this.data[a].axisYIndex < this.axisY.length
                    ? this.data[a].axisYIndex
                    : 0
                ];
              this.axisY[
                0 <= this.data[a].axisYIndex &&
                this.data[a].axisYIndex < this.axisY.length
                  ? this.data[a].axisYIndex
                  : 0
              ].dataSeries.push(this.data[a]);
            } else
              this.axisY.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisY[0] = new z(
                        this,
                        "axisY",
                        this.options.axisY,
                        0,
                        "axisY",
                        "left"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisY[0] = new z(
                        this,
                        "axisY",
                        this.options.axisY,
                        0,
                        "axisY",
                        "bottom"
                      ))
                    )),
                (this.data[a].axisY = this.axisY[0]),
                this.axisY[0].dataSeries.push(this.data[a]);
          if ("secondary" === this.data[a].axisYType)
            if (this.options.axisY2 && 0 < this.options.axisY2.length) {
              if (!this.axisY2.length)
                for (b = 0; b < this.options.axisY2.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisY2[b] = new z(
                          this,
                          "axisY2",
                          this.options.axisY2[b],
                          b,
                          "axisY",
                          "right"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisY2[b] = new z(
                          this,
                          "axisY2",
                          this.options.axisY2[b],
                          b,
                          "axisY",
                          "top"
                        ))
                      );
              this.data[a].axisY =
                this.axisY2[
                  0 <= this.data[a].axisYIndex &&
                  this.data[a].axisYIndex < this.axisY2.length
                    ? this.data[a].axisYIndex
                    : 0
                ];
              this.axisY2[
                0 <= this.data[a].axisYIndex &&
                this.data[a].axisYIndex < this.axisY2.length
                  ? this.data[a].axisYIndex
                  : 0
              ].dataSeries.push(this.data[a]);
            } else
              this.axisY2.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisY2[0] = new z(
                        this,
                        "axisY2",
                        this.options.axisY2,
                        0,
                        "axisY",
                        "right"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisY2[0] = new z(
                        this,
                        "axisY2",
                        this.options.axisY2,
                        0,
                        "axisY",
                        "top"
                      ))
                    )),
                (this.data[a].axisY = this.axisY2[0]),
                this.axisY2[0].dataSeries.push(this.data[a]);
          if (!this.data[a].axisXType || "primary" === this.data[a].axisXType)
            if (this.options.axisX && 0 < this.options.axisX.length) {
              if (!this.axisX.length)
                for (b = 0; b < this.options.axisX.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisX[b] = new z(
                          this,
                          "axisX",
                          this.options.axisX[b],
                          b,
                          "axisX",
                          "bottom"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisX[b] = new z(
                          this,
                          "axisX",
                          this.options.axisX[b],
                          b,
                          "axisX",
                          "left"
                        ))
                      );
              this.data[a].axisX =
                this.axisX[
                  0 <= this.data[a].axisXIndex &&
                  this.data[a].axisXIndex < this.axisX.length
                    ? this.data[a].axisXIndex
                    : 0
                ];
              this.axisX[
                0 <= this.data[a].axisXIndex &&
                this.data[a].axisXIndex < this.axisX.length
                  ? this.data[a].axisXIndex
                  : 0
              ].dataSeries.push(this.data[a]);
            } else
              this.axisX.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisX[0] = new z(
                        this,
                        "axisX",
                        this.options.axisX,
                        0,
                        "axisX",
                        "bottom"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisX[0] = new z(
                        this,
                        "axisX",
                        this.options.axisX,
                        0,
                        "axisX",
                        "left"
                      ))
                    )),
                (this.data[a].axisX = this.axisX[0]),
                this.axisX[0].dataSeries.push(this.data[a]);
          if ("secondary" === this.data[a].axisXType)
            if (this.options.axisX2 && 0 < this.options.axisX2.length) {
              if (!this.axisX2.length)
                for (b = 0; b < this.options.axisX2.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisX2[b] = new z(
                          this,
                          "axisX2",
                          this.options.axisX2[b],
                          b,
                          "axisX",
                          "top"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisX2[b] = new z(
                          this,
                          "axisX2",
                          this.options.axisX2[b],
                          b,
                          "axisX",
                          "right"
                        ))
                      );
              this.data[a].axisX =
                this.axisX2[
                  0 <= this.data[a].axisXIndex &&
                  this.data[a].axisXIndex < this.axisX2.length
                    ? this.data[a].axisXIndex
                    : 0
                ];
              this.axisX2[
                0 <= this.data[a].axisXIndex &&
                this.data[a].axisXIndex < this.axisX2.length
                  ? this.data[a].axisXIndex
                  : 0
              ].dataSeries.push(this.data[a]);
            } else
              this.axisX2.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisX2[0] = new z(
                        this,
                        "axisX2",
                        this.options.axisX2,
                        0,
                        "axisX",
                        "top"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisX2[0] = new z(
                        this,
                        "axisX2",
                        this.options.axisX2,
                        0,
                        "axisX",
                        "right"
                      ))
                    )),
                (this.data[a].axisX = this.axisX2[0]),
                this.axisX2[0].dataSeries.push(this.data[a]);
        }
      if (this.axisY) {
        for (b = 1; b < this.axisY.length; b++)
          "undefined" === typeof this.axisY[b].options.gridThickness &&
            (this.axisY[b].gridThickness = 0);
        for (b = 0; b < this.axisY.length - 1; b++)
          "undefined" === typeof this.axisY[b].options.margin &&
            (this.axisY[b].margin = 10);
      }
      if (this.axisY2) {
        for (b = 1; b < this.axisY2.length; b++)
          "undefined" === typeof this.axisY2[b].options.gridThickness &&
            (this.axisY2[b].gridThickness = 0);
        for (b = 0; b < this.axisY2.length - 1; b++)
          "undefined" === typeof this.axisY2[b].options.margin &&
            (this.axisY2[b].margin = 10);
      }
      this.axisY &&
        0 < this.axisY.length &&
        this.axisY2 &&
        0 < this.axisY2.length &&
        (0 < this.axisY[0].gridThickness &&
        "undefined" === typeof this.axisY2[0].options.gridThickness
          ? (this.axisY2[0].gridThickness = 0)
          : 0 < this.axisY2[0].gridThickness &&
            "undefined" === typeof this.axisY[0].options.gridThickness &&
            (this.axisY[0].gridThickness = 0));
      if (this.axisX)
        for (b = 0; b < this.axisX.length; b++)
          "undefined" === typeof this.axisX[b].options.gridThickness &&
            (this.axisX[b].gridThickness = 0);
      if (this.axisX2)
        for (b = 0; b < this.axisX2.length; b++)
          "undefined" === typeof this.axisX2[b].options.gridThickness &&
            (this.axisX2[b].gridThickness = 0);
      this.axisX &&
        0 < this.axisX.length &&
        this.axisX2 &&
        0 < this.axisX2.length &&
        (0 < this.axisX[0].gridThickness &&
        "undefined" === typeof this.axisX2[0].options.gridThickness
          ? (this.axisX2[0].gridThickness = 0)
          : 0 < this.axisX2[0].gridThickness &&
            "undefined" === typeof this.axisX[0].options.gridThickness &&
            (this.axisX[0].gridThickness = 0));
      b = !1;
      if (0 < this._axes.length && (this.zoomEnabled || this.panEnabled))
        for (a = 0; a < this._axes.length; a++)
          if (
            null !== this._axes[a].viewportMinimum ||
            null !== this._axes[a].viewportMaximum
          ) {
            b = !0;
            break;
          }
      b
        ? (La(this._zoomButton, this._resetButton),
          (this._toolBar.style.border =
            this.toolbar.borderThickness +
            "px solid " +
            this.toolbar.borderColor),
          (this._zoomButton.style.borderRight =
            this.toolbar.borderThickness +
            "px solid " +
            this.toolbar.borderColor),
          (this._resetButton.style.borderRight =
            (this.exportEnabled ? this.toolbar.borderThickness : 0) +
            "px solid " +
            this.toolbar.borderColor))
        : (va(this._zoomButton, this._resetButton),
          (this._toolBar.style.border =
            this.toolbar.borderThickness + "px solid transparent"),
          this.options.zoomEnabled &&
            ((this.zoomEnabled = !0), (this.panEnabled = !1)));
      this._processData();
      this.options.title &&
        ((this.title = new Ha(this, this.options.title)),
        this.title.dockInsidePlotArea
          ? f.push(this.title)
          : this.title.render());
      if (this.options.subtitles)
        for (this.subtitles = [], a = 0; a < this.options.subtitles.length; a++)
          (b = new Ma(this, this.options.subtitles[a], a)),
            this.subtitles.push(b),
            b.dockInsidePlotArea ? f.push(b) : b.render();
      this.legend = new U(this, this.options.legend);
      for (a = 0; a < this.data.length; a++)
        (this.data[a].showInLegend ||
          "pie" === this.data[a].type ||
          "doughnut" === this.data[a].type ||
          "funnel" === this.data[a].type ||
          "pyramid" === this.data[a].type) &&
          this.legend.dataSeries.push(this.data[a]);
      this.legend.dockInsidePlotArea
        ? f.push(this.legend)
        : this.legend.render();
      for (a = 0; a < this._axes.length; a++)
        if (
          this._axes[a].scaleBreaks &&
          this._axes[a].scaleBreaks._appliedBreaks.length
        ) {
          v
            ? ((this._breaksCanvas = ta(this.width, this.height, !0)),
              (this._breaksCanvasCtx = this._breaksCanvas.getContext("2d")))
            : ((this._breaksCanvas = this.canvas),
              (this._breaksCanvasCtx = this.ctx));
          break;
        }
      this._preRenderCanvas = ta(this.width, this.height);
      this._preRenderCtx = this._preRenderCanvas.getContext("2d");
      if (
        "normal" === this.plotInfo.axisPlacement ||
        "xySwapped" === this.plotInfo.axisPlacement
      )
        z.setLayoutAndRender(
          this.axisX,
          this.axisX2,
          this.axisY,
          this.axisY2,
          this.plotInfo.axisPlacement,
          this.layoutManager.getFreeSpace()
        );
      else if ("none" === this.plotInfo.axisPlacement) this.preparePlotArea();
      else return;
      for (a = 0; a < f.length; a++) f[a].render();
      var c = [];
      if (this.animatedRender) {
        var e = ta(this.width, this.height);
        e.getContext("2d").drawImage(
          this.canvas,
          0,
          0,
          this.width,
          this.height
        );
      }
      var f = this.ctx.miterLimit,
        g;
      this.ctx.miterLimit = 3;
      v &&
        this._breaksCanvas &&
        (this._preRenderCtx.drawImage(
          this.canvas,
          0,
          0,
          this.width,
          this.height
        ),
        this._preRenderCtx.drawImage(
          this._breaksCanvas,
          0,
          0,
          this.width,
          this.height
        ),
        (this._breaksCanvasCtx.globalCompositeOperation = "source-atop"),
        this._breaksCanvasCtx.drawImage(
          this._preRenderCanvas,
          0,
          0,
          this.width,
          this.height
        ),
        this._preRenderCtx.clearRect(0, 0, this.width, this.height));
      for (a = 0; a < this.plotInfo.plotTypes.length; a++)
        for (
          var h = this.plotInfo.plotTypes[a], l = 0;
          l < h.plotUnits.length;
          l++
        ) {
          var n = h.plotUnits[l],
            k = null;
          n.targetCanvas = null;
          this.animatedRender &&
            ((n.targetCanvas = ta(this.width, this.height)),
            (n.targetCanvasCtx = n.targetCanvas.getContext("2d")),
            (g = n.targetCanvasCtx.miterLimit),
            (n.targetCanvasCtx.miterLimit = 3));
          "line" === n.type
            ? (k = this.renderLine(n))
            : "stepLine" === n.type
            ? (k = this.renderStepLine(n))
            : "spline" === n.type
            ? (k = this.renderSpline(n))
            : "column" === n.type
            ? (k = this.renderColumn(n))
            : "bar" === n.type
            ? (k = this.renderBar(n))
            : "area" === n.type
            ? (k = this.renderArea(n))
            : "stepArea" === n.type
            ? (k = this.renderStepArea(n))
            : "splineArea" === n.type
            ? (k = this.renderSplineArea(n))
            : "stackedColumn" === n.type
            ? (k = this.renderStackedColumn(n))
            : "stackedColumn100" === n.type
            ? (k = this.renderStackedColumn100(n))
            : "stackedBar" === n.type
            ? (k = this.renderStackedBar(n))
            : "stackedBar100" === n.type
            ? (k = this.renderStackedBar100(n))
            : "stackedArea" === n.type
            ? (k = this.renderStackedArea(n))
            : "stackedArea100" === n.type
            ? (k = this.renderStackedArea100(n))
            : "bubble" === n.type
            ? (k = k = this.renderBubble(n))
            : "scatter" === n.type
            ? (k = this.renderScatter(n))
            : "pie" === n.type
            ? this.renderPie(n)
            : "doughnut" === n.type
            ? this.renderPie(n)
            : "funnel" === n.type
            ? (k = this.renderFunnel(n))
            : "pyramid" === n.type
            ? (k = this.renderFunnel(n))
            : "candlestick" === n.type
            ? (k = this.renderCandlestick(n))
            : "ohlc" === n.type
            ? (k = this.renderCandlestick(n))
            : "rangeColumn" === n.type
            ? (k = this.renderRangeColumn(n))
            : "error" === n.type
            ? (k = this.renderError(n))
            : "rangeBar" === n.type
            ? (k = this.renderRangeBar(n))
            : "rangeArea" === n.type
            ? (k = this.renderRangeArea(n))
            : "rangeSplineArea" === n.type
            ? (k = this.renderRangeSplineArea(n))
            : "waterfall" === n.type
            ? (k = this.renderWaterfall(n))
            : "boxAndWhisker" === n.type && (k = this.renderBoxAndWhisker(n));
          for (b = 0; b < n.dataSeriesIndexes.length; b++)
            this._dataInRenderedOrder.push(this.data[n.dataSeriesIndexes[b]]);
          this.animatedRender &&
            ((n.targetCanvasCtx.miterLimit = g), k && c.push(k));
        }
      this.ctx.miterLimit = f;
      this.animatedRender &&
        this._breaksCanvasCtx &&
        c.push({
          source: this._breaksCanvasCtx,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
          startTimePercent: 0.7,
        });
      this.animatedRender &&
        0 < this._indexLabels.length &&
        ((g = ta(this.width, this.height).getContext("2d")),
        c.push(this.renderIndexLabels(g)));
      var r = this;
      if (0 < c.length)
        (r.disableToolTip = !0),
          r._animator.animate(
            200,
            r.animationDuration,
            function (a) {
              r.ctx.clearRect(0, 0, r.width, r.height);
              r.ctx.drawImage(
                e,
                0,
                0,
                Math.floor(r.width * ga),
                Math.floor(r.height * ga),
                0,
                0,
                r.width,
                r.height
              );
              for (var b = 0; b < c.length; b++)
                (k = c[b]),
                  1 > a && "undefined" !== typeof k.startTimePercent
                    ? a >= k.startTimePercent &&
                      k.animationCallback(
                        k.easingFunction(
                          a - k.startTimePercent,
                          0,
                          1,
                          1 - k.startTimePercent
                        ),
                        k
                      )
                    : k.animationCallback(k.easingFunction(a, 0, 1, 1), k);
              r.dispatchEvent("dataAnimationIterationEnd", { chart: r });
            },
            function () {
              c = [];
              for (var a = 0; a < r.plotInfo.plotTypes.length; a++)
                for (
                  var b = r.plotInfo.plotTypes[a], d = 0;
                  d < b.plotUnits.length;
                  d++
                )
                  b.plotUnits[d].targetCanvas = null;
              e = null;
              r.disableToolTip = !1;
            }
          );
      else {
        if (r._breaksCanvas)
          if (v)
            r.plotArea.ctx.drawImage(
              r._breaksCanvas,
              0,
              0,
              this.width,
              this.height
            );
          else for (b = 0; b < r._axes.length; b++) r._axes[b].createMask();
        0 < r._indexLabels.length && r.renderIndexLabels();
        r.dispatchEvent("dataAnimationIterationEnd", { chart: r });
      }
      this.attachPlotAreaEventHandlers();
      this.zoomEnabled ||
        this.panEnabled ||
        !this._zoomButton ||
        "none" === this._zoomButton.style.display ||
        va(this._zoomButton, this._resetButton);
      this.toolTip._updateToolTip();
      this.renderCount++;
      this._breaksCanvas &&
        (delete this._breaksCanvas, delete this._breaksCanvasCtx);
      for (b = 0; b < this._axes.length; b++)
        this._axes[b].maskCanvas &&
          (delete this._axes[b].maskCanvas, delete this._axes[b].maskCtx);
    };
    s.prototype.attachPlotAreaEventHandlers = function () {
      this.attachEvent({
        context: this,
        chart: this,
        mousedown: this._plotAreaMouseDown,
        mouseup: this._plotAreaMouseUp,
        mousemove: this._plotAreaMouseMove,
        cursor: this.panEnabled ? "move" : "default",
        capture: !0,
        bounds: this.plotArea,
      });
    };
    s.prototype.categoriseDataSeries = function () {
      for (var a = "", f = 0; f < this.data.length; f++)
        if (
          ((a = this.data[f]),
          a.dataPoints &&
            0 !== a.dataPoints.length &&
            a.visible &&
            0 <= s._supportedChartTypes.indexOf(a.type))
        ) {
          for (
            var b = null, c = !1, e = null, g = !1, h = 0;
            h < this.plotInfo.plotTypes.length;
            h++
          )
            if (this.plotInfo.plotTypes[h].type === a.type) {
              c = !0;
              b = this.plotInfo.plotTypes[h];
              break;
            }
          c ||
            ((b = { type: a.type, totalDataSeries: 0, plotUnits: [] }),
            this.plotInfo.plotTypes.push(b));
          for (h = 0; h < b.plotUnits.length; h++)
            if (
              b.plotUnits[h].axisYType === a.axisYType &&
              b.plotUnits[h].axisXType === a.axisXType &&
              b.plotUnits[h].axisYIndex === a.axisYIndex &&
              b.plotUnits[h].axisXIndex === a.axisXIndex
            ) {
              g = !0;
              e = b.plotUnits[h];
              break;
            }
          g ||
            ((e = {
              type: a.type,
              previousDataSeriesCount: 0,
              index: b.plotUnits.length,
              plotType: b,
              axisXType: a.axisXType,
              axisYType: a.axisYType,
              axisYIndex: a.axisYIndex,
              axisXIndex: a.axisXIndex,
              axisY:
                "primary" === a.axisYType
                  ? this.axisY[
                      0 <= a.axisYIndex && a.axisYIndex < this.axisY.length
                        ? a.axisYIndex
                        : 0
                    ]
                  : this.axisY2[
                      0 <= a.axisYIndex && a.axisYIndex < this.axisY2.length
                        ? a.axisYIndex
                        : 0
                    ],
              axisX:
                "primary" === a.axisXType
                  ? this.axisX[
                      0 <= a.axisXIndex && a.axisXIndex < this.axisX.length
                        ? a.axisXIndex
                        : 0
                    ]
                  : this.axisX2[
                      0 <= a.axisXIndex && a.axisXIndex < this.axisX2.length
                        ? a.axisXIndex
                        : 0
                    ],
              dataSeriesIndexes: [],
              yTotals: [],
            }),
            b.plotUnits.push(e));
          b.totalDataSeries++;
          e.dataSeriesIndexes.push(f);
          a.plotUnit = e;
        }
      for (f = 0; f < this.plotInfo.plotTypes.length; f++)
        for (
          b = this.plotInfo.plotTypes[f], h = a = 0;
          h < b.plotUnits.length;
          h++
        )
          (b.plotUnits[h].previousDataSeriesCount = a),
            (a += b.plotUnits[h].dataSeriesIndexes.length);
    };
    s.prototype.assignIdToDataPoints = function () {
      for (var a = 0; a < this.data.length; a++) {
        var f = this.data[a];
        if (f.dataPoints)
          for (var b = f.dataPoints.length, c = 0; c < b; c++)
            f.dataPointIds[c] = ++this._eventManager.lastObjectId;
      }
    };
    s.prototype._processData = function () {
      this.assignIdToDataPoints();
      this.categoriseDataSeries();
      for (var a = 0; a < this.plotInfo.plotTypes.length; a++)
        for (
          var f = this.plotInfo.plotTypes[a], b = 0;
          b < f.plotUnits.length;
          b++
        ) {
          var c = f.plotUnits[b];
          "line" === c.type ||
          "stepLine" === c.type ||
          "spline" === c.type ||
          "column" === c.type ||
          "area" === c.type ||
          "stepArea" === c.type ||
          "splineArea" === c.type ||
          "bar" === c.type ||
          "bubble" === c.type ||
          "scatter" === c.type
            ? this._processMultiseriesPlotUnit(c)
            : "stackedColumn" === c.type ||
              "stackedBar" === c.type ||
              "stackedArea" === c.type
            ? this._processStackedPlotUnit(c)
            : "stackedColumn100" === c.type ||
              "stackedBar100" === c.type ||
              "stackedArea100" === c.type
            ? this._processStacked100PlotUnit(c)
            : "candlestick" === c.type ||
              "ohlc" === c.type ||
              "rangeColumn" === c.type ||
              "rangeBar" === c.type ||
              "rangeArea" === c.type ||
              "rangeSplineArea" === c.type ||
              "error" === c.type ||
              "boxAndWhisker" === c.type
            ? this._processMultiYPlotUnit(c)
            : "waterfall" === c.type && this._processSpecificPlotUnit(c);
        }
      this.calculateAutoBreaks();
    };
    s.prototype._processMultiseriesPlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length))
        for (
          var f = a.axisY.dataInfo, b = a.axisX.dataInfo, c, e, g = !1, h = 0;
          h < a.dataSeriesIndexes.length;
          h++
        ) {
          var l = this.data[a.dataSeriesIndexes[h]],
            n = 0,
            k = !1,
            r = !1,
            q;
          if ("normal" === l.axisPlacement || "xySwapped" === l.axisPlacement)
            var m = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : a.axisX.logarithmic
                ? 0
                : -Infinity,
              d = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (l.dataPoints[n].x && l.dataPoints[n].x.getTime) ||
            "dateTime" === l.xValueType
          )
            g = !0;
          for (n = 0; n < l.dataPoints.length; n++) {
            "undefined" === typeof l.dataPoints[n].x &&
              (l.dataPoints[n].x = n + (a.axisX.logarithmic ? 1 : 0));
            l.dataPoints[n].x.getTime
              ? ((g = !0), (c = l.dataPoints[n].x.getTime()))
              : (c = l.dataPoints[n].x);
            e = l.dataPoints[n].y;
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            e < f.min && "number" === typeof e && (f.min = e);
            e > f.max && "number" === typeof e && (f.max = e);
            if (0 < n) {
              if (a.axisX.logarithmic) {
                var w = c / l.dataPoints[n - 1].x;
                1 > w && (w = 1 / w);
                b.minDiff > w && 1 !== w && (b.minDiff = w);
              } else
                (w = c - l.dataPoints[n - 1].x),
                  0 > w && (w *= -1),
                  b.minDiff > w && 0 !== w && (b.minDiff = w);
              null !== e &&
                null !== l.dataPoints[n - 1].y &&
                (a.axisY.logarithmic
                  ? ((w = e / l.dataPoints[n - 1].y),
                    1 > w && (w = 1 / w),
                    f.minDiff > w && 1 !== w && (f.minDiff = w))
                  : ((w = e - l.dataPoints[n - 1].y),
                    0 > w && (w *= -1),
                    f.minDiff > w && 0 !== w && (f.minDiff = w)));
            }
            if (c < m && !k) null !== e && (q = c);
            else {
              if (!k && ((k = !0), 0 < n)) {
                n -= 2;
                continue;
              }
              if (c > d && !r) r = !0;
              else if (c > d && r) continue;
              l.dataPoints[n].label &&
                (a.axisX.labels[c] = l.dataPoints[n].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              null === e
                ? b.viewPortMin === c && q < c && (b.viewPortMin = q)
                : (e < f.viewPortMin &&
                    "number" === typeof e &&
                    (f.viewPortMin = e),
                  e > f.viewPortMax &&
                    "number" === typeof e &&
                    (f.viewPortMax = e));
            }
          }
          l.axisX.valueType = l.xValueType = g ? "dateTime" : "number";
        }
    };
    s.prototype._processStackedPlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
        for (
          var f = a.axisY.dataInfo,
            b = a.axisX.dataInfo,
            c,
            e,
            g = !1,
            h = [],
            l = [],
            n = Infinity,
            k = -Infinity,
            r = 0;
          r < a.dataSeriesIndexes.length;
          r++
        ) {
          var q = this.data[a.dataSeriesIndexes[r]],
            m = 0,
            d = !1,
            w = !1,
            pa;
          if ("normal" === q.axisPlacement || "xySwapped" === q.axisPlacement)
            var C = this.sessionVariables.axisX.newViewportMinimum
                ? this.sessionVariables.axisX.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : -Infinity,
              u = this.sessionVariables.axisX.newViewportMaximum
                ? this.sessionVariables.axisX.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (q.dataPoints[m].x && q.dataPoints[m].x.getTime) ||
            "dateTime" === q.xValueType
          )
            g = !0;
          for (m = 0; m < q.dataPoints.length; m++) {
            "undefined" === typeof q.dataPoints[m].x &&
              (q.dataPoints[m].x = m + (a.axisX.logarithmic ? 1 : 0));
            q.dataPoints[m].x.getTime
              ? ((g = !0), (c = q.dataPoints[m].x.getTime()))
              : (c = q.dataPoints[m].x);
            e = y(q.dataPoints[m].y) ? 0 : q.dataPoints[m].y;
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            if (0 < m) {
              if (a.axisX.logarithmic) {
                var E = c / q.dataPoints[m - 1].x;
                1 > E && (E = 1 / E);
                b.minDiff > E && 1 !== E && (b.minDiff = E);
              } else
                (E = c - q.dataPoints[m - 1].x),
                  0 > E && (E *= -1),
                  b.minDiff > E && 0 !== E && (b.minDiff = E);
              null !== e &&
                null !== q.dataPoints[m - 1].y &&
                (a.axisY.logarithmic
                  ? 0 < e &&
                    ((E = e / q.dataPoints[m - 1].y),
                    1 > E && (E = 1 / E),
                    f.minDiff > E && 1 !== E && (f.minDiff = E))
                  : ((E = e - q.dataPoints[m - 1].y),
                    0 > E && (E *= -1),
                    f.minDiff > E && 0 !== E && (f.minDiff = E)));
            }
            if (c < C && !d) null !== q.dataPoints[m].y && (pa = c);
            else {
              if (!d && ((d = !0), 0 < m)) {
                m -= 2;
                continue;
              }
              if (c > u && !w) w = !0;
              else if (c > u && w) continue;
              q.dataPoints[m].label &&
                (a.axisX.labels[c] = q.dataPoints[m].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              null === q.dataPoints[m].y
                ? b.viewPortMin === c && pa < c && (b.viewPortMin = pa)
                : ((a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + e),
                  0 <= e
                    ? h[c]
                      ? (h[c] += e)
                      : ((h[c] = e), (n = Math.min(e, n)))
                    : l[c]
                    ? (l[c] += e)
                    : ((l[c] = e), (k = Math.max(e, k))));
            }
          }
          a.axisY.scaleBreaks &&
            a.axisY.scaleBreaks.autoCalculate &&
            1 <= a.axisY.scaleBreaks.maxNumberOfAutoBreaks &&
            (f.dataPointYPositiveSums
              ? (f.dataPointYPositiveSums.push.apply(
                  f.dataPointYPositiveSums,
                  h
                ),
                f.dataPointYNegativeSums.push.apply(
                  f.dataPointYPositiveSums,
                  l
                ))
              : ((f.dataPointYPositiveSums = h),
                (f.dataPointYNegativeSums = l)));
          q.axisX.valueType = q.xValueType = g ? "dateTime" : "number";
        }
        for (m in h)
          h.hasOwnProperty(m) &&
            !isNaN(m) &&
            ((a = h[m]),
            a < f.min && (f.min = Math.min(a, n)),
            a > f.max && (f.max = a),
            m < b.viewPortMin ||
              m > b.viewPortMax ||
              (a < f.viewPortMin && (f.viewPortMin = Math.min(a, n)),
              a > f.viewPortMax && (f.viewPortMax = a)));
        for (m in l)
          l.hasOwnProperty(m) &&
            !isNaN(m) &&
            ((a = l[m]),
            a < f.min && (f.min = a),
            a > f.max && (f.max = Math.max(a, k)),
            m < b.viewPortMin ||
              m > b.viewPortMax ||
              (a < f.viewPortMin && (f.viewPortMin = a),
              a > f.viewPortMax && (f.viewPortMax = Math.max(a, k))));
      }
    };
    s.prototype._processStacked100PlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
        for (
          var f = a.axisY.dataInfo,
            b = a.axisX.dataInfo,
            c,
            e,
            g = !1,
            h = !1,
            l = !1,
            n = [],
            k = 0;
          k < a.dataSeriesIndexes.length;
          k++
        ) {
          var r = this.data[a.dataSeriesIndexes[k]],
            q = 0,
            m = !1,
            d = !1,
            w;
          if ("normal" === r.axisPlacement || "xySwapped" === r.axisPlacement)
            var pa = this.sessionVariables.axisX.newViewportMinimum
                ? this.sessionVariables.axisX.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : -Infinity,
              C = this.sessionVariables.axisX.newViewportMaximum
                ? this.sessionVariables.axisX.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (r.dataPoints[q].x && r.dataPoints[q].x.getTime) ||
            "dateTime" === r.xValueType
          )
            g = !0;
          for (q = 0; q < r.dataPoints.length; q++) {
            "undefined" === typeof r.dataPoints[q].x &&
              (r.dataPoints[q].x = q + (a.axisX.logarithmic ? 1 : 0));
            r.dataPoints[q].x.getTime
              ? ((g = !0), (c = r.dataPoints[q].x.getTime()))
              : (c = r.dataPoints[q].x);
            e = y(r.dataPoints[q].y) ? null : r.dataPoints[q].y;
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            if (0 < q) {
              if (a.axisX.logarithmic) {
                var u = c / r.dataPoints[q - 1].x;
                1 > u && (u = 1 / u);
                b.minDiff > u && 1 !== u && (b.minDiff = u);
              } else
                (u = c - r.dataPoints[q - 1].x),
                  0 > u && (u *= -1),
                  b.minDiff > u && 0 !== u && (b.minDiff = u);
              y(e) ||
                null === r.dataPoints[q - 1].y ||
                (a.axisY.logarithmic
                  ? 0 < e &&
                    ((u = e / r.dataPoints[q - 1].y),
                    1 > u && (u = 1 / u),
                    f.minDiff > u && 1 !== u && (f.minDiff = u))
                  : ((u = e - r.dataPoints[q - 1].y),
                    0 > u && (u *= -1),
                    f.minDiff > u && 0 !== u && (f.minDiff = u)));
            }
            if (c < pa && !m) null !== e && (w = c);
            else {
              if (!m && ((m = !0), 0 < q)) {
                q -= 2;
                continue;
              }
              if (c > C && !d) d = !0;
              else if (c > C && d) continue;
              r.dataPoints[q].label &&
                (a.axisX.labels[c] = r.dataPoints[q].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              null === e
                ? b.viewPortMin === c && w < c && (b.viewPortMin = w)
                : ((a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + e),
                  0 <= e ? (h = !0) : 0 > e && (l = !0),
                  (n[c] = n[c] ? n[c] + Math.abs(e) : Math.abs(e)));
            }
          }
          r.axisX.valueType = r.xValueType = g ? "dateTime" : "number";
        }
        a.axisY.logarithmic
          ? ((f.max = y(f.viewPortMax)
              ? 99 * Math.pow(a.axisY.logarithmBase, -0.05)
              : Math.max(
                  f.viewPortMax,
                  99 * Math.pow(a.axisY.logarithmBase, -0.05)
                )),
            (f.min = y(f.viewPortMin) ? 1 : Math.min(f.viewPortMin, 1)))
          : h && !l
          ? ((f.max = y(f.viewPortMax) ? 99 : Math.max(f.viewPortMax, 99)),
            (f.min = y(f.viewPortMin) ? 1 : Math.min(f.viewPortMin, 1)))
          : h && l
          ? ((f.max = y(f.viewPortMax) ? 99 : Math.max(f.viewPortMax, 99)),
            (f.min = y(f.viewPortMin) ? -99 : Math.min(f.viewPortMin, -99)))
          : !h &&
            l &&
            ((f.max = y(f.viewPortMax) ? -1 : Math.max(f.viewPortMax, -1)),
            (f.min = y(f.viewPortMin) ? -99 : Math.min(f.viewPortMin, -99)));
        f.viewPortMin = f.min;
        f.viewPortMax = f.max;
        a.dataPointYSums = n;
      }
    };
    s.prototype._processMultiYPlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length))
        for (
          var f = a.axisY.dataInfo,
            b = a.axisX.dataInfo,
            c,
            e,
            g,
            h,
            l = !1,
            n = 0;
          n < a.dataSeriesIndexes.length;
          n++
        ) {
          var k = this.data[a.dataSeriesIndexes[n]],
            r = 0,
            q = !1,
            m = !1,
            d,
            w,
            pa;
          if ("normal" === k.axisPlacement || "xySwapped" === k.axisPlacement)
            var C = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : a.axisX.logarithmic
                ? 0
                : -Infinity,
              u = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (k.dataPoints[r].x && k.dataPoints[r].x.getTime) ||
            "dateTime" === k.xValueType
          )
            l = !0;
          for (r = 0; r < k.dataPoints.length; r++) {
            "undefined" === typeof k.dataPoints[r].x &&
              (k.dataPoints[r].x = r + (a.axisX.logarithmic ? 1 : 0));
            k.dataPoints[r].x.getTime
              ? ((l = !0), (c = k.dataPoints[r].x.getTime()))
              : (c = k.dataPoints[r].x);
            if ((e = k.dataPoints[r].y) && e.length) {
              g = Math.min.apply(null, e);
              h = Math.max.apply(null, e);
              w = !0;
              for (var E = 0; E < e.length; E++) null === e.k && (w = !1);
              w && (q || (pa = d), (d = c));
            }
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            g < f.min && (f.min = g);
            h > f.max && (f.max = h);
            0 < r &&
              (a.axisX.logarithmic
                ? ((w = c / k.dataPoints[r - 1].x),
                  1 > w && (w = 1 / w),
                  b.minDiff > w && 1 !== w && (b.minDiff = w))
                : ((w = c - k.dataPoints[r - 1].x),
                  0 > w && (w *= -1),
                  b.minDiff > w && 0 !== w && (b.minDiff = w)),
              e &&
                null !== e[0] &&
                k.dataPoints[r - 1].y &&
                null !== k.dataPoints[r - 1].y[0] &&
                (a.axisY.logarithmic
                  ? ((w = e[0] / k.dataPoints[r - 1].y[0]),
                    1 > w && (w = 1 / w),
                    f.minDiff > w && 1 !== w && (f.minDiff = w))
                  : ((w = e[0] - k.dataPoints[r - 1].y[0]),
                    0 > w && (w *= -1),
                    f.minDiff > w && 0 !== w && (f.minDiff = w))));
            if (!(c < C) || q) {
              if (!q && ((q = !0), 0 < r)) {
                r -= 2;
                d = pa;
                continue;
              }
              if (c > u && !m) m = !0;
              else if (c > u && m) continue;
              k.dataPoints[r].label &&
                (a.axisX.labels[c] = k.dataPoints[r].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              if (b.viewPortMin === c && e)
                for (E = 0; E < e.length; E++)
                  if (null === e[E] && d < c) {
                    b.viewPortMin = d;
                    break;
                  }
              null === e
                ? b.viewPortMin === c && d < c && (b.viewPortMin = d)
                : (g < f.viewPortMin && (f.viewPortMin = g),
                  h > f.viewPortMax && (f.viewPortMax = h));
            }
          }
          k.axisX.valueType = k.xValueType = l ? "dateTime" : "number";
        }
    };
    s.prototype._processSpecificPlotUnit = function (a) {
      if (
        "waterfall" === a.type &&
        a.dataSeriesIndexes &&
        !(1 > a.dataSeriesIndexes.length)
      )
        for (
          var f = a.axisY.dataInfo, b = a.axisX.dataInfo, c, e, g = !1, h = 0;
          h < a.dataSeriesIndexes.length;
          h++
        ) {
          var l = this.data[a.dataSeriesIndexes[h]],
            n = 0,
            k = !1,
            r = !1,
            q = (c = 0);
          if ("normal" === l.axisPlacement || "xySwapped" === l.axisPlacement)
            var m = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : a.axisX.logarithmic
                ? 0
                : -Infinity,
              d = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (l.dataPoints[n].x && l.dataPoints[n].x.getTime) ||
            "dateTime" === l.xValueType
          )
            g = !0;
          for (n = 0; n < l.dataPoints.length; n++)
            "undefined" !== typeof l.dataPoints[n].isCumulativeSum &&
            !0 === l.dataPoints[n].isCumulativeSum
              ? ((l.dataPointEOs[n].cumulativeSumYStartValue = 0),
                (l.dataPointEOs[n].cumulativeSum =
                  0 === n ? 0 : l.dataPointEOs[n - 1].cumulativeSum),
                (l.dataPoints[n].y =
                  0 === n ? 0 : l.dataPointEOs[n - 1].cumulativeSum))
              : "undefined" !== typeof l.dataPoints[n].isIntermediateSum &&
                !0 === l.dataPoints[n].isIntermediateSum
              ? ((l.dataPointEOs[n].cumulativeSumYStartValue = q),
                (l.dataPointEOs[n].cumulativeSum =
                  0 === n ? 0 : l.dataPointEOs[n - 1].cumulativeSum),
                (l.dataPoints[n].y = 0 === n ? 0 : c),
                (q = 0 === n ? 0 : l.dataPointEOs[n - 1].cumulativeSum),
                (c = 0))
              : ((e =
                  "number" !== typeof l.dataPoints[n].y
                    ? 0
                    : l.dataPoints[n].y),
                (l.dataPointEOs[n].cumulativeSumYStartValue =
                  0 === n ? 0 : l.dataPointEOs[n - 1].cumulativeSum),
                (l.dataPointEOs[n].cumulativeSum =
                  0 === n ? e : l.dataPointEOs[n - 1].cumulativeSum + e),
                (c += e));
          for (n = 0; n < l.dataPoints.length; n++)
            if (
              ("undefined" === typeof l.dataPoints[n].x &&
                (l.dataPoints[n].x = n + (a.axisX.logarithmic ? 1 : 0)),
              l.dataPoints[n].x.getTime
                ? ((g = !0), (c = l.dataPoints[n].x.getTime()))
                : (c = l.dataPoints[n].x),
              (e = l.dataPoints[n].y),
              c < b.min && (b.min = c),
              c > b.max && (b.max = c),
              l.dataPointEOs[n].cumulativeSum < f.min &&
                (f.min = l.dataPointEOs[n].cumulativeSum),
              l.dataPointEOs[n].cumulativeSum > f.max &&
                (f.max = l.dataPointEOs[n].cumulativeSum),
              0 < n &&
                (a.axisX.logarithmic
                  ? ((q = c / l.dataPoints[n - 1].x),
                    1 > q && (q = 1 / q),
                    b.minDiff > q && 1 !== q && (b.minDiff = q))
                  : ((q = c - l.dataPoints[n - 1].x),
                    0 > q && (q *= -1),
                    b.minDiff > q && 0 !== q && (b.minDiff = q)),
                null !== e &&
                  null !== l.dataPoints[n - 1].y &&
                  (a.axisY.logarithmic
                    ? ((e =
                        l.dataPointEOs[n].cumulativeSum /
                        l.dataPointEOs[n - 1].cumulativeSum),
                      1 > e && (e = 1 / e),
                      f.minDiff > e && 1 !== e && (f.minDiff = e))
                    : ((e =
                        l.dataPointEOs[n].cumulativeSum -
                        l.dataPointEOs[n - 1].cumulativeSum),
                      0 > e && (e *= -1),
                      f.minDiff > e && 0 !== e && (f.minDiff = e)))),
              !(c < m) || k)
            ) {
              if (!k && ((k = !0), 0 < n)) {
                n -= 2;
                continue;
              }
              if (c > d && !r) r = !0;
              else if (c > d && r) continue;
              l.dataPoints[n].label &&
                (a.axisX.labels[c] = l.dataPoints[n].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              0 < n &&
                (l.dataPointEOs[n - 1].cumulativeSum < f.viewPortMin &&
                  (f.viewPortMin = l.dataPointEOs[n - 1].cumulativeSum),
                l.dataPointEOs[n - 1].cumulativeSum > f.viewPortMax &&
                  (f.viewPortMax = l.dataPointEOs[n - 1].cumulativeSum));
              l.dataPointEOs[n].cumulativeSum < f.viewPortMin &&
                (f.viewPortMin = l.dataPointEOs[n].cumulativeSum);
              l.dataPointEOs[n].cumulativeSum > f.viewPortMax &&
                (f.viewPortMax = l.dataPointEOs[n].cumulativeSum);
            }
          l.axisX.valueType = l.xValueType = g ? "dateTime" : "number";
        }
    };
    s.prototype.calculateAutoBreaks = function () {
      function a(a, c, b, e) {
        if (e)
          return (
            (b = Math.pow(Math.min((b * a) / c, c / a), 0.2)),
            1 >= b && (b = Math.pow(1 > a ? 1 / a : Math.min(c / a, a), 0.25)),
            { startValue: a * b, endValue: c / b }
          );
        b = 0.2 * Math.min(b - c + a, c - a);
        0 >= b && (b = 0.25 * Math.min(c - a, Math.abs(a)));
        return { startValue: a + b, endValue: c - b };
      }
      function f(a) {
        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
          var c =
              a.axisX.scaleBreaks &&
              a.axisX.scaleBreaks.autoCalculate &&
              1 <= a.axisX.scaleBreaks.maxNumberOfAutoBreaks,
            b =
              a.axisY.scaleBreaks &&
              a.axisY.scaleBreaks.autoCalculate &&
              1 <= a.axisY.scaleBreaks.maxNumberOfAutoBreaks;
          if (c || b)
            for (
              var f = a.axisY.dataInfo,
                g = a.axisX.dataInfo,
                k,
                h = g.min,
                m = g.max,
                l = f.min,
                n = f.max,
                g = g._dataRanges,
                f = f._dataRanges,
                q,
                r = 0,
                v = 0;
              v < a.dataSeriesIndexes.length;
              v++
            ) {
              var p = e.data[a.dataSeriesIndexes[v]];
              if (!(4 > p.dataPoints.length))
                for (r = 0; r < p.dataPoints.length; r++)
                  if (
                    (c &&
                      ((q =
                        ((m + 1 - h) *
                          Math.max(
                            parseFloat(
                              a.axisX.scaleBreaks.collapsibleThreshold
                            ) || 10,
                            10
                          )) /
                        100),
                      (k = p.dataPoints[r].x.getTime
                        ? p.dataPoints[r].x.getTime()
                        : p.dataPoints[r].x),
                      (q = Math.floor((k - h) / q)),
                      k < g[q].min && (g[q].min = k),
                      k > g[q].max && (g[q].max = k)),
                    b)
                  ) {
                    var s =
                      ((n + 1 - l) *
                        Math.max(
                          parseFloat(
                            a.axisY.scaleBreaks.collapsibleThreshold
                          ) || 10,
                          10
                        )) /
                      100;
                    if (
                      (k =
                        "waterfall" === a.type
                          ? p.dataPointEOs[r].cumulativeSum
                          : p.dataPoints[r].y) &&
                      k.length
                    )
                      for (var t = 0; t < k.length; t++)
                        (q = Math.floor((k[t] - l) / s)),
                          k[t] < f[q].min && (f[q].min = k[t]),
                          k[t] > f[q].max && (f[q].max = k[t]);
                    else
                      y(k) ||
                        ((q = Math.floor((k - l) / s)),
                        k < f[q].min && (f[q].min = k),
                        k > f[q].max && (f[q].max = k));
                  }
            }
        }
      }
      function b(a) {
        if (
          a.dataSeriesIndexes &&
          !(1 > a.dataSeriesIndexes.length) &&
          a.axisX.scaleBreaks &&
          a.axisX.scaleBreaks.autoCalculate &&
          1 <= a.axisX.scaleBreaks.maxNumberOfAutoBreaks
        )
          for (
            var c = a.axisX.dataInfo,
              b = c.min,
              f = c.max,
              g = c._dataRanges,
              k,
              h = 0,
              m = 0;
            m < a.dataSeriesIndexes.length;
            m++
          ) {
            var l = e.data[a.dataSeriesIndexes[m]];
            if (!(4 > l.dataPoints.length))
              for (h = 0; h < l.dataPoints.length; h++)
                (k =
                  ((f + 1 - b) *
                    Math.max(
                      parseFloat(a.axisX.scaleBreaks.collapsibleThreshold) ||
                        10,
                      10
                    )) /
                  100),
                  (c = l.dataPoints[h].x.getTime
                    ? l.dataPoints[h].x.getTime()
                    : l.dataPoints[h].x),
                  (k = Math.floor((c - b) / k)),
                  c < g[k].min && (g[k].min = c),
                  c > g[k].max && (g[k].max = c);
          }
      }
      for (var c, e = this, g = !1, h = 0; h < this._axes.length; h++)
        if (
          this._axes[h].scaleBreaks &&
          this._axes[h].scaleBreaks.autoCalculate &&
          1 <= this._axes[h].scaleBreaks.maxNumberOfAutoBreaks
        ) {
          g = !0;
          this._axes[h].dataInfo._dataRanges = [];
          for (
            var l = 0;
            l <
            100 /
              Math.max(
                parseFloat(this._axes[h].scaleBreaks.collapsibleThreshold) ||
                  10,
                10
              );
            l++
          )
            this._axes[h].dataInfo._dataRanges.push({
              min: Infinity,
              max: -Infinity,
            });
        }
      if (g) {
        for (h = 0; h < this.plotInfo.plotTypes.length; h++)
          for (
            g = this.plotInfo.plotTypes[h], l = 0;
            l < g.plotUnits.length;
            l++
          )
            (c = g.plotUnits[l]),
              "line" === c.type ||
              "stepLine" === c.type ||
              "spline" === c.type ||
              "column" === c.type ||
              "area" === c.type ||
              "stepArea" === c.type ||
              "splineArea" === c.type ||
              "bar" === c.type ||
              "bubble" === c.type ||
              "scatter" === c.type ||
              "candlestick" === c.type ||
              "ohlc" === c.type ||
              "rangeColumn" === c.type ||
              "rangeBar" === c.type ||
              "rangeArea" === c.type ||
              "rangeSplineArea" === c.type ||
              "waterfall" === c.type ||
              "error" === c.type ||
              "boxAndWhisker" === c.type
                ? f(c)
                : 0 <= c.type.indexOf("stacked") && b(c);
        for (h = 0; h < this._axes.length; h++)
          if (this._axes[h].dataInfo._dataRanges) {
            var n = this._axes[h].dataInfo.min;
            c =
              ((this._axes[h].dataInfo.max + 1 - n) *
                Math.max(
                  parseFloat(this._axes[h].scaleBreaks.collapsibleThreshold) ||
                    10,
                  10
                )) /
              100;
            var k = this._axes[h].dataInfo._dataRanges,
              r,
              q,
              g = [];
            if (this._axes[h].dataInfo.dataPointYPositiveSums) {
              var m = this._axes[h].dataInfo.dataPointYPositiveSums;
              r = k;
              for (l in m)
                m.hasOwnProperty(l) &&
                  !isNaN(l) &&
                  ((q = m[l]),
                  y(q) ||
                    ((index = Math.floor((q - n) / c)),
                    q < r[index].min && (r[index].min = q),
                    q > r[index].max && (r[index].max = q)));
              delete this._axes[h].dataInfo.dataPointYPositiveSums;
            }
            if (this._axes[h].dataInfo.dataPointYNegativeSums) {
              m = this._axes[h].dataInfo.dataPointYNegativeSums;
              r = k;
              for (l in m)
                m.hasOwnProperty(l) &&
                  !isNaN(l) &&
                  ((q = -1 * m[l]),
                  y(q) ||
                    ((index = Math.floor((q - n) / c)),
                    q < r[index].min && (r[index].min = q),
                    q > r[index].max && (r[index].max = q)));
              delete this._axes[h].dataInfo.dataPointYNegativeSums;
            }
            for (l = 0; l < k.length - 1; l++)
              if (((r = k[l].max), isFinite(r)))
                for (; l < k.length - 1; )
                  if (((n = k[l + 1].min), isFinite(n))) {
                    q = n - r;
                    q > c && g.push({ diff: q, start: r, end: n });
                    break;
                  } else l++;
            if (this._axes[h].scaleBreaks.customBreaks)
              for (
                l = 0;
                l < this._axes[h].scaleBreaks.customBreaks.length;
                l++
              )
                for (c = 0; c < g.length; c++)
                  if (
                    (this._axes[h].scaleBreaks.customBreaks[l].startValue <=
                      g[c].start &&
                      g[c].start <=
                        this._axes[h].scaleBreaks.customBreaks[l].endValue) ||
                    (this._axes[h].scaleBreaks.customBreaks[l].startValue <=
                      g[c].start &&
                      g[c].start <=
                        this._axes[h].scaleBreaks.customBreaks[l].endValue) ||
                    (g[c].start <=
                      this._axes[h].scaleBreaks.customBreaks[l].startValue &&
                      this._axes[h].scaleBreaks.customBreaks[l].startValue <=
                        g[c].end) ||
                    (g[c].start <=
                      this._axes[h].scaleBreaks.customBreaks[l].endValue &&
                      this._axes[h].scaleBreaks.customBreaks[l].endValue <=
                        g[c].end)
                  )
                    g.splice(c, 1), c--;
            g.sort(function (a, c) {
              return c.diff - a.diff;
            });
            for (
              l = 0;
              l <
              Math.min(
                g.length,
                this._axes[h].scaleBreaks.maxNumberOfAutoBreaks
              );
              l++
            )
              (c = a(
                g[l].start,
                g[l].end,
                this._axes[h].logarithmic
                  ? this._axes[h].dataInfo.max / this._axes[h].dataInfo.min
                  : this._axes[h].dataInfo.max - this._axes[h].dataInfo.min,
                this._axes[h].logarithmic
              )),
                this._axes[h].scaleBreaks.autoBreaks.push(
                  new Y(
                    this,
                    "autoBreaks",
                    c,
                    l,
                    ++this._eventManager.lastObjectId,
                    this._axes[h].scaleBreaks
                  )
                ),
                this._axes[h].scaleBreaks._appliedBreaks.push(
                  this._axes[h].scaleBreaks.autoBreaks[
                    this._axes[h].scaleBreaks.autoBreaks.length - 1
                  ]
                );
            this._axes[h].scaleBreaks._appliedBreaks.sort(function (a, c) {
              return a.startValue - c.startValue;
            });
          }
      }
    };
    s.prototype.getDataPointAtXY = function (a, f, b) {
      b = b || !1;
      for (var c = [], e = this._dataInRenderedOrder.length - 1; 0 <= e; e--) {
        var g = null;
        (g = this._dataInRenderedOrder[e].getDataPointAtXY(a, f, b)) &&
          c.push(g);
      }
      a = null;
      f = !1;
      for (b = 0; b < c.length; b++)
        if (
          "line" === c[b].dataSeries.type ||
          "stepLine" === c[b].dataSeries.type ||
          "area" === c[b].dataSeries.type ||
          "stepArea" === c[b].dataSeries.type
        )
          if (
            ((e = ka("markerSize", c[b].dataPoint, c[b].dataSeries) || 8),
            c[b].distance <= e / 2)
          ) {
            f = !0;
            break;
          }
      for (b = 0; b < c.length; b++)
        (f &&
          "line" !== c[b].dataSeries.type &&
          "stepLine" !== c[b].dataSeries.type &&
          "area" !== c[b].dataSeries.type &&
          "stepArea" !== c[b].dataSeries.type) ||
          (a ? c[b].distance <= a.distance && (a = c[b]) : (a = c[b]));
      return a;
    };
    s.prototype.getObjectAtXY = function (a, f, b) {
      var c = null;
      if ((b = this.getDataPointAtXY(a, f, b || !1)))
        c = b.dataSeries.dataPointIds[b.dataPointIndex];
      else if (v) c = Va(a, f, this._eventManager.ghostCtx);
      else
        for (b = 0; b < this.legend.items.length; b++) {
          var e = this.legend.items[b];
          a >= e.x1 && a <= e.x2 && f >= e.y1 && f <= e.y2 && (c = e.id);
        }
      return c;
    };
    s.prototype.getAutoFontSize = function (a, f, b) {
      f = Math.min(this.width, this.height);
      return Math.max(
        "theme4" === this.theme ? 0 : 300 <= f ? 12 : 10,
        Math.round(f * (a / 400))
      );
    };
    s.prototype.resetOverlayedCanvas = function () {
      this.overlaidCanvasCtx.clearRect(0, 0, this.width, this.height);
    };
    s.prototype.clearCanvas = function () {
      this.ctx.clearRect(0, 0, this.width, this.height);
      this.backgroundColor &&
        ((this.ctx.fillStyle = this.backgroundColor),
        this.ctx.fillRect(0, 0, this.width, this.height));
    };
    s.prototype.attachEvent = function (a) {
      this._events.push(a);
    };
    s.prototype._touchEventHandler = function (a) {
      if (a.changedTouches && this.interactivityEnabled) {
        var f = [],
          b = a.changedTouches,
          c = b ? b[0] : a,
          e = null;
        switch (a.type) {
          case "touchstart":
          case "MSPointerDown":
            f = ["mousemove", "mousedown"];
            this._lastTouchData = Na(c);
            this._lastTouchData.time = new Date();
            break;
          case "touchmove":
          case "MSPointerMove":
            f = ["mousemove"];
            break;
          case "touchend":
          case "MSPointerUp":
            var g =
                this._lastTouchData && this._lastTouchData.time
                  ? new Date() - this._lastTouchData.time
                  : 0,
              f =
                "touchstart" === this._lastTouchEventType ||
                "MSPointerDown" === this._lastTouchEventType ||
                300 > g
                  ? ["mouseup", "click"]
                  : ["mouseup"];
            break;
          default:
            return;
        }
        if (!(b && 1 < b.length)) {
          e = Na(c);
          e.time = new Date();
          try {
            var h = e.y - this._lastTouchData.y,
              g = e.time - this._lastTouchData.time;
            if (15 < Math.abs(h) && (this._lastTouchData.scroll || 300 > g)) {
              this._lastTouchData.scroll = !0;
              var l = window.parent || window;
              l && l.scrollBy && l.scrollBy(0, -h);
            }
          } catch (n) {}
          this._lastTouchEventType = a.type;
          if (this._lastTouchData.scroll && this.zoomEnabled)
            this.isDrag && this.resetOverlayedCanvas(), (this.isDrag = !1);
          else
            for (b = 0; b < f.length; b++)
              (e = f[b]),
                (g = document.createEvent("MouseEvent")),
                g.initMouseEvent(
                  e,
                  !0,
                  !0,
                  window,
                  1,
                  c.screenX,
                  c.screenY,
                  c.clientX,
                  c.clientY,
                  !1,
                  !1,
                  !1,
                  !1,
                  0,
                  null
                ),
                c.target.dispatchEvent(g),
                a.preventManipulation && a.preventManipulation(),
                a.preventDefault && a.preventDefault();
        }
      }
    };
    s.prototype._dispatchRangeEvent = function (a, f) {
      var b = { chart: this };
      b.type = a;
      b.trigger = f;
      var c = [];
      this.axisX && 0 < this.axisX.length && c.push("axisX");
      this.axisX2 && 0 < this.axisX2.length && c.push("axisX2");
      this.axisY && 0 < this.axisY.length && c.push("axisY");
      this.axisY2 && 0 < this.axisY2.length && c.push("axisY2");
      for (var e = 0; e < c.length; e++)
        if ((y(b[c[e]]) && (b[c[e]] = []), "axisY" === c[e]))
          for (var g = 0; g < this.axisY.length; g++)
            b[c[e]].push({
              viewportMinimum:
                this[c[e]][g].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[e]][g].sessionVariables.newViewportMaximum,
            });
        else if ("axisY2" === c[e])
          for (g = 0; g < this.axisY2.length; g++)
            b[c[e]].push({
              viewportMinimum:
                this[c[e]][g].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[e]][g].sessionVariables.newViewportMaximum,
            });
        else if ("axisX" === c[e])
          for (g = 0; g < this.axisX.length; g++)
            b[c[e]].push({
              viewportMinimum:
                this[c[e]][g].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[e]][g].sessionVariables.newViewportMaximum,
            });
        else if ("axisX2" === c[e])
          for (g = 0; g < this.axisX2.length; g++)
            b[c[e]].push({
              viewportMinimum:
                this[c[e]][g].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[e]][g].sessionVariables.newViewportMaximum,
            });
      this.dispatchEvent(a, b, this);
    };
    s.prototype._mouseEventHandler = function (a) {
      "undefined" === typeof a.target &&
        a.srcElement &&
        (a.target = a.srcElement);
      var f = Na(a),
        b = a.type,
        c,
        e;
      a.which ? (e = 3 == a.which) : a.button && (e = 2 == a.button);
      s.capturedEventParam &&
        ((c = s.capturedEventParam),
        "mouseup" === b &&
          ((s.capturedEventParam = null),
          c.chart.overlaidCanvas.releaseCapture
            ? c.chart.overlaidCanvas.releaseCapture()
            : document.documentElement.removeEventListener(
                "mouseup",
                c.chart._mouseEventHandler,
                !1
              )),
        c.hasOwnProperty(b) &&
          ("mouseup" !== b || c.chart.overlaidCanvas.releaseCapture
            ? (a.target !== c.chart.overlaidCanvas && v) ||
              c[b].call(c.context, f.x, f.y)
            : a.target !== c.chart.overlaidCanvas && (c.chart.isDrag = !1)));
      if (this.interactivityEnabled)
        if (this._ignoreNextEvent) this._ignoreNextEvent = !1;
        else if (
          (a.preventManipulation && a.preventManipulation(),
          a.preventDefault && a.preventDefault(),
          !e)
        ) {
          if (!s.capturedEventParam && this._events) {
            for (var g = 0; g < this._events.length; g++)
              if (this._events[g].hasOwnProperty(b))
                if (
                  ((c = this._events[g]),
                  (e = c.bounds),
                  f.x >= e.x1 && f.x <= e.x2 && f.y >= e.y1 && f.y <= e.y2)
                ) {
                  c[b].call(c.context, f.x, f.y);
                  "mousedown" === b && !0 === c.capture
                    ? ((s.capturedEventParam = c),
                      this.overlaidCanvas.setCapture
                        ? this.overlaidCanvas.setCapture()
                        : document.documentElement.addEventListener(
                            "mouseup",
                            this._mouseEventHandler,
                            !1
                          ))
                    : "mouseup" === b &&
                      (c.chart.overlaidCanvas.releaseCapture
                        ? c.chart.overlaidCanvas.releaseCapture()
                        : document.documentElement.removeEventListener(
                            "mouseup",
                            this._mouseEventHandler,
                            !1
                          ));
                  break;
                } else c = null;
            a.target.style.cursor =
              c && c.cursor ? c.cursor : this._defaultCursor;
          }
          b = this.plotArea;
          if (f.x < b.x1 || f.x > b.x2 || f.y < b.y1 || f.y > b.y2)
            this.toolTip && this.toolTip.enabled
              ? this.toolTip.hide()
              : this.resetOverlayedCanvas();
          (this.isDrag && this.zoomEnabled) ||
            !this._eventManager ||
            this._eventManager.mouseEventHandler(a);
        }
    };
    s.prototype._plotAreaMouseDown = function (a, f) {
      this.isDrag = !0;
      this.dragStartPoint = { x: a, y: f };
    };
    s.prototype._plotAreaMouseUp = function (a, f) {
      if (
        ("normal" === this.plotInfo.axisPlacement ||
          "xySwapped" === this.plotInfo.axisPlacement) &&
        this.isDrag
      ) {
        var b = f - this.dragStartPoint.y,
          c = a - this.dragStartPoint.x,
          e = 0 <= this.zoomType.indexOf("x"),
          g = 0 <= this.zoomType.indexOf("y"),
          h = !1;
        this.resetOverlayedCanvas();
        if ("xySwapped" === this.plotInfo.axisPlacement)
          var l = g,
            g = e,
            e = l;
        if (this.panEnabled || this.zoomEnabled) {
          if (this.panEnabled)
            for (e = g = 0; e < this._axes.length; e++)
              (b = this._axes[e]),
                b.logarithmic
                  ? b.viewportMinimum < b.minimum
                    ? ((g = b.minimum / b.viewportMinimum),
                      (b.sessionVariables.newViewportMinimum =
                        b.viewportMinimum * g),
                      (b.sessionVariables.newViewportMaximum =
                        b.viewportMaximum * g),
                      (h = !0))
                    : b.viewportMaximum > b.maximum &&
                      ((g = b.viewportMaximum / b.maximum),
                      (b.sessionVariables.newViewportMinimum =
                        b.viewportMinimum / g),
                      (b.sessionVariables.newViewportMaximum =
                        b.viewportMaximum / g),
                      (h = !0))
                  : b.viewportMinimum < b.minimum
                  ? ((g = b.minimum - b.viewportMinimum),
                    (b.sessionVariables.newViewportMinimum =
                      b.viewportMinimum + g),
                    (b.sessionVariables.newViewportMaximum =
                      b.viewportMaximum + g),
                    (h = !0))
                  : b.viewportMaximum > b.maximum &&
                    ((g = b.viewportMaximum - b.maximum),
                    (b.sessionVariables.newViewportMinimum =
                      b.viewportMinimum - g),
                    (b.sessionVariables.newViewportMaximum =
                      b.viewportMaximum - g),
                    (h = !0));
          else if (
            (!e || 2 < Math.abs(c)) &&
            (!g || 2 < Math.abs(b)) &&
            this.zoomEnabled
          ) {
            if (!this.dragStartPoint) return;
            b = e ? this.dragStartPoint.x : this.plotArea.x1;
            c = g ? this.dragStartPoint.y : this.plotArea.y1;
            e = e ? a : this.plotArea.x2;
            g = g ? f : this.plotArea.y2;
            2 < Math.abs(b - e) &&
              2 < Math.abs(c - g) &&
              this._zoomPanToSelectedRegion(b, c, e, g) &&
              (h = !0);
          }
          h &&
            ((this._ignoreNextEvent = !0),
            this._dispatchRangeEvent("rangeChanging", "zoom"),
            this.render(),
            this._dispatchRangeEvent("rangeChanged", "zoom"),
            h &&
              this.zoomEnabled &&
              "none" === this._zoomButton.style.display &&
              (La(this._zoomButton, this._resetButton),
              ua(this, this._zoomButton, "pan"),
              ua(this, this._resetButton, "reset")));
        }
      }
      this.isDrag = !1;
      if ("none" !== this.plotInfo.axisPlacement) {
        this.resetOverlayedCanvas();
        if (this.axisX && 0 < this.axisX.length)
          for (h = 0; h < this.axisX.length; h++)
            this.axisX[h].crosshair &&
              this.axisX[h].crosshair.enabled &&
              this.axisX[h].renderCrosshair(a, f);
        if (this.axisX2 && 0 < this.axisX2.length)
          for (h = 0; h < this.axisX2.length; h++)
            this.axisX2[h].crosshair &&
              this.axisX2[h].crosshair.enabled &&
              this.axisX2[h].renderCrosshair(a, f);
        if (this.axisY && 0 < this.axisY.length)
          for (h = 0; h < this.axisY.length; h++)
            this.axisY[h].crosshair &&
              this.axisY[h].crosshair.enabled &&
              this.axisY[h].renderCrosshair(a, f);
        if (this.axisY2 && 0 < this.axisY2.length)
          for (h = 0; h < this.axisY2.length; h++)
            this.axisY2[h].crosshair &&
              this.axisY2[h].crosshair.enabled &&
              this.axisY2[h].renderCrosshair(a, f);
      }
    };
    s.prototype._plotAreaMouseMove = function (a, f) {
      if (this.isDrag && "none" !== this.plotInfo.axisPlacement) {
        var b = 0,
          c = 0,
          e = (b = null),
          e = 0 <= this.zoomType.indexOf("x"),
          g = 0 <= this.zoomType.indexOf("y"),
          h = this;
        "xySwapped" === this.plotInfo.axisPlacement &&
          ((b = g), (g = e), (e = b));
        b = this.dragStartPoint.x - a;
        c = this.dragStartPoint.y - f;
        2 < Math.abs(b) &&
        8 > Math.abs(b) &&
        (this.panEnabled || this.zoomEnabled)
          ? this.toolTip.hide()
          : this.panEnabled ||
            this.zoomEnabled ||
            this.toolTip.mouseMoveHandler(a, f);
        if (
          (!e || 2 < Math.abs(b) || !g || 2 < Math.abs(c)) &&
          (this.panEnabled || this.zoomEnabled)
        )
          if (this.panEnabled)
            (e = {
              x1: e ? this.plotArea.x1 + b : this.plotArea.x1,
              y1: g ? this.plotArea.y1 + c : this.plotArea.y1,
              x2: e ? this.plotArea.x2 + b : this.plotArea.x2,
              y2: g ? this.plotArea.y2 + c : this.plotArea.y2,
            }),
              clearTimeout(h._panTimerId),
              (h._panTimerId = setTimeout(
                (function (c, b, e, d) {
                  return function () {
                    h._zoomPanToSelectedRegion(c, b, e, d, !0) &&
                      (h._dispatchRangeEvent("rangeChanging", "pan"),
                      h.render(),
                      h._dispatchRangeEvent("rangeChanged", "pan"),
                      (h.dragStartPoint.x = a),
                      (h.dragStartPoint.y = f));
                  };
                })(e.x1, e.y1, e.x2, e.y2),
                0
              ));
          else if (this.zoomEnabled) {
            this.resetOverlayedCanvas();
            b = this.overlaidCanvasCtx.globalAlpha;
            this.overlaidCanvasCtx.fillStyle = "#A89896";
            var c = e ? this.dragStartPoint.x : this.plotArea.x1,
              l = g ? this.dragStartPoint.y : this.plotArea.y1,
              n = e
                ? a - this.dragStartPoint.x
                : this.plotArea.x2 - this.plotArea.x1,
              k = g
                ? f - this.dragStartPoint.y
                : this.plotArea.y2 - this.plotArea.y1;
            this.validateRegion(
              c,
              l,
              e ? a : this.plotArea.x2 - this.plotArea.x1,
              g ? f : this.plotArea.y2 - this.plotArea.y1,
              "xy" !== this.zoomType
            ).isValid &&
              (this.resetOverlayedCanvas(),
              (this.overlaidCanvasCtx.fillStyle = "#99B2B5"));
            this.overlaidCanvasCtx.globalAlpha = 0.7;
            this.overlaidCanvasCtx.fillRect(c, l, n, k);
            this.overlaidCanvasCtx.globalAlpha = b;
          }
      } else if (
        (this.toolTip.mouseMoveHandler(a, f),
        "none" !== this.plotInfo.axisPlacement)
      ) {
        if (this.axisX && 0 < this.axisX.length)
          for (e = 0; e < this.axisX.length; e++)
            this.axisX[e].crosshair &&
              this.axisX[e].crosshair.enabled &&
              this.axisX[e].renderCrosshair(a, f);
        if (this.axisX2 && 0 < this.axisX2.length)
          for (e = 0; e < this.axisX2.length; e++)
            this.axisX2[e].crosshair &&
              this.axisX2[e].crosshair.enabled &&
              this.axisX2[e].renderCrosshair(a, f);
        if (this.axisY && 0 < this.axisY.length)
          for (e = 0; e < this.axisY.length; e++)
            this.axisY[e].crosshair &&
              this.axisY[e].crosshair.enabled &&
              this.axisY[e].renderCrosshair(a, f);
        if (this.axisY2 && 0 < this.axisY2.length)
          for (e = 0; e < this.axisY2.length; e++)
            this.axisY2[e].crosshair &&
              this.axisY2[e].crosshair.enabled &&
              this.axisY2[e].renderCrosshair(a, f);
      }
    };
    s.prototype._zoomPanToSelectedRegion = function (a, f, b, c, e) {
      a = this.validateRegion(a, f, b, c, e);
      f = a.axesWithValidRange;
      b = a.axesRanges;
      if (a.isValid)
        for (c = 0; c < f.length; c++)
          (e = b[c]), f[c].setViewPortRange(e.val1, e.val2);
      return a.isValid;
    };
    s.prototype.validateRegion = function (a, f, b, c, e) {
      e = e || !1;
      for (
        var g = 0 <= this.zoomType.indexOf("x"),
          h = 0 <= this.zoomType.indexOf("y"),
          l = !1,
          n = [],
          k = [],
          r = [],
          q = 0;
        q < this._axes.length;
        q++
      )
        (("axisX" === this._axes[q].type && g) ||
          ("axisY" === this._axes[q].type && h)) &&
          k.push(this._axes[q]);
      for (h = 0; h < k.length; h++) {
        var q = k[h],
          g = !1,
          m = q.convertPixelToValue({ x: a, y: f }),
          d = q.convertPixelToValue({ x: b, y: c });
        if (m > d)
          var w = d,
            d = m,
            m = w;
        if (q.scaleBreaks)
          for (w = 0; !g && w < q.scaleBreaks._appliedBreaks.length; w++)
            g =
              q.scaleBreaks._appliedBreaks[w].startValue <= m &&
              q.scaleBreaks._appliedBreaks[w].endValue >= d;
        if (isFinite(q.dataInfo.minDiff))
          if (
            ((w = q.getApparentDifference(m, d, null, !0)),
            !(
              g ||
              (!(
                this.panEnabled &&
                q.scaleBreaks &&
                q.scaleBreaks._appliedBreaks.length
              ) &&
                ((q.logarithmic && w < Math.pow(q.dataInfo.minDiff, 3)) ||
                  (!q.logarithmic && w < 3 * Math.abs(q.dataInfo.minDiff)))) ||
              m < q.minimum ||
              d > q.maximum
            ))
          )
            n.push(q), r.push({ val1: m, val2: d }), (l = !0);
          else if (!e) {
            l = !1;
            break;
          }
      }
      return { isValid: l, axesWithValidRange: n, axesRanges: r };
    };
    s.prototype.preparePlotArea = function () {
      var a = this.plotArea;
      !v && (0 < a.x1 || 0 < a.y1) && a.ctx.translate(a.x1, a.y1);
      if (
        (this.axisX[0] || this.axisX2[0]) &&
        (this.axisY[0] || this.axisY2[0])
      ) {
        var f = this.axisX[0]
          ? this.axisX[0].lineCoordinates
          : this.axisX2[0].lineCoordinates;
        if (this.axisY && 0 < this.axisY.length && this.axisY[0]) {
          var b = this.axisY[0];
          a.x1 = f.x1 < f.x2 ? f.x1 : b.lineCoordinates.x1;
          a.y1 = f.y1 < b.lineCoordinates.y1 ? f.y1 : b.lineCoordinates.y1;
          a.x2 = f.x2 > b.lineCoordinates.x2 ? f.x2 : b.lineCoordinates.x2;
          a.y2 = f.y2 > f.y1 ? f.y2 : b.lineCoordinates.y2;
          a.width = a.x2 - a.x1;
          a.height = a.y2 - a.y1;
        }
        this.axisY2 &&
          0 < this.axisY2.length &&
          this.axisY2[0] &&
          ((b = this.axisY2[0]),
          (a.x1 = f.x1 < f.x2 ? f.x1 : b.lineCoordinates.x1),
          (a.y1 = f.y1 < b.lineCoordinates.y1 ? f.y1 : b.lineCoordinates.y1),
          (a.x2 = f.x2 > b.lineCoordinates.x2 ? f.x2 : b.lineCoordinates.x2),
          (a.y2 = f.y2 > f.y1 ? f.y2 : b.lineCoordinates.y2),
          (a.width = a.x2 - a.x1),
          (a.height = a.y2 - a.y1));
      } else
        (f = this.layoutManager.getFreeSpace()),
          (a.x1 = f.x1),
          (a.x2 = f.x2),
          (a.y1 = f.y1),
          (a.y2 = f.y2),
          (a.width = f.width),
          (a.height = f.height);
      v ||
        ((a.canvas.width = a.width),
        (a.canvas.height = a.height),
        (a.canvas.style.left = a.x1 + "px"),
        (a.canvas.style.top = a.y1 + "px"),
        (0 < a.x1 || 0 < a.y1) && a.ctx.translate(-a.x1, -a.y1));
      a.layoutManager = new Ca(a.x1, a.y1, a.x2, a.y2, 2);
    };
    s.prototype.renderIndexLabels = function (a) {
      var f = a || this.plotArea.ctx,
        b = this.plotArea,
        c = 0,
        e = 0,
        g = 0,
        h = 0,
        l = (c = h = e = g = 0),
        n = 0;
      for (a = 0; a < this._indexLabels.length; a++) {
        var k = this._indexLabels[a],
          r = k.chartType.toLowerCase(),
          q,
          m,
          l = ka("indexLabelFontColor", k.dataPoint, k.dataSeries),
          n = ka("indexLabelFontSize", k.dataPoint, k.dataSeries);
        q = ka("indexLabelFontFamily", k.dataPoint, k.dataSeries);
        m = ka("indexLabelFontStyle", k.dataPoint, k.dataSeries);
        var h = ka("indexLabelFontWeight", k.dataPoint, k.dataSeries),
          d = ka("indexLabelBackgroundColor", k.dataPoint, k.dataSeries),
          e = ka("indexLabelMaxWidth", k.dataPoint, k.dataSeries),
          g = ka("indexLabelWrap", k.dataPoint, k.dataSeries),
          w = ka("indexLabelLineDashType", k.dataPoint, k.dataSeries),
          p = ka("indexLabelLineColor", k.dataPoint, k.dataSeries),
          C = y(k.dataPoint.indexLabelLineThickness)
            ? y(k.dataSeries.options.indexLabelLineThickness)
              ? 0
              : k.dataSeries.options.indexLabelLineThickness
            : k.dataPoint.indexLabelLineThickness,
          c =
            0 < C
              ? Math.min(
                  10,
                  ("normal" === this.plotInfo.axisPlacement
                    ? this.plotArea.height
                    : this.plotArea.width) << 0
                )
              : 0,
          u = { percent: null, total: null },
          E = null;
        if (
          0 <= k.dataSeries.type.indexOf("stacked") ||
          "pie" === k.dataSeries.type ||
          "doughnut" === k.dataSeries.type
        )
          u = this.getPercentAndTotal(k.dataSeries, k.dataPoint);
        if (k.dataSeries.indexLabelFormatter || k.dataPoint.indexLabelFormatter)
          E = {
            chart: this,
            dataSeries: k.dataSeries,
            dataPoint: k.dataPoint,
            index: k.indexKeyword,
            total: u.total,
            percent: u.percent,
          };
        var G = k.dataPoint.indexLabelFormatter
          ? k.dataPoint.indexLabelFormatter(E)
          : k.dataPoint.indexLabel
          ? this.replaceKeywordsWithValue(
              k.dataPoint.indexLabel,
              k.dataPoint,
              k.dataSeries,
              null,
              k.indexKeyword
            )
          : k.dataSeries.indexLabelFormatter
          ? k.dataSeries.indexLabelFormatter(E)
          : k.dataSeries.indexLabel
          ? this.replaceKeywordsWithValue(
              k.dataSeries.indexLabel,
              k.dataPoint,
              k.dataSeries,
              null,
              k.indexKeyword
            )
          : null;
        if (null !== G && "" !== G) {
          var u = ka("indexLabelPlacement", k.dataPoint, k.dataSeries),
            E = ka("indexLabelOrientation", k.dataPoint, k.dataSeries),
            s = k.direction,
            t = k.dataSeries.axisX,
            A = k.dataSeries.axisY,
            x = !1,
            d = new ia(f, {
              x: 0,
              y: 0,
              maxWidth: e ? e : 0.5 * this.width,
              maxHeight: g ? 5 * n : 1.5 * n,
              angle: "horizontal" === E ? 0 : -90,
              text: G,
              padding: 0,
              backgroundColor: d,
              horizontalAlign: "left",
              fontSize: n,
              fontFamily: q,
              fontWeight: h,
              fontColor: l,
              fontStyle: m,
              textBaseline: "top",
            });
          d.measureText();
          k.dataSeries.indexLabelMaxWidth = d.maxWidth;
          if ("stackedarea100" === r) {
            if (
              k.point.x < b.x1 ||
              k.point.x > b.x2 ||
              k.point.y < b.y1 - 1 ||
              k.point.y > b.y2 + 1
            )
              continue;
          } else if ("rangearea" === r || "rangesplinearea" === r) {
            if (
              k.dataPoint.x < t.viewportMinimum ||
              k.dataPoint.x > t.viewportMaximum ||
              Math.max.apply(null, k.dataPoint.y) < A.viewportMinimum ||
              Math.min.apply(null, k.dataPoint.y) > A.viewportMaximum
            )
              continue;
          } else if (
            0 <= r.indexOf("line") ||
            0 <= r.indexOf("area") ||
            0 <= r.indexOf("bubble") ||
            0 <= r.indexOf("scatter")
          ) {
            if (
              k.dataPoint.x < t.viewportMinimum ||
              k.dataPoint.x > t.viewportMaximum ||
              k.dataPoint.y < A.viewportMinimum ||
              k.dataPoint.y > A.viewportMaximum
            )
              continue;
          } else if (
            0 <= r.indexOf("column") ||
            "waterfall" === r ||
            ("error" === r && !k.axisSwapped)
          ) {
            if (
              k.dataPoint.x < t.viewportMinimum ||
              k.dataPoint.x > t.viewportMaximum ||
              k.bounds.y1 > b.y2 ||
              k.bounds.y2 < b.y1
            )
              continue;
          } else if (0 <= r.indexOf("bar") || "error" === r) {
            if (
              k.dataPoint.x < t.viewportMinimum ||
              k.dataPoint.x > t.viewportMaximum ||
              k.bounds.x1 > b.x2 ||
              k.bounds.x2 < b.x1
            )
              continue;
          } else if ("candlestick" === r || "ohlc" === r) {
            if (
              k.dataPoint.x < t.viewportMinimum ||
              k.dataPoint.x > t.viewportMaximum ||
              Math.max.apply(null, k.dataPoint.y) < A.viewportMinimum ||
              Math.min.apply(null, k.dataPoint.y) > A.viewportMaximum
            )
              continue;
          } else if (
            k.dataPoint.x < t.viewportMinimum ||
            k.dataPoint.x > t.viewportMaximum
          )
            continue;
          e = h = 2;
          "horizontal" === E
            ? ((l = d.width), (n = d.height))
            : ((n = d.width), (l = d.height));
          if ("normal" === this.plotInfo.axisPlacement) {
            if (0 <= r.indexOf("line") || 0 <= r.indexOf("area"))
              (u = "auto"), (h = 4);
            else if (0 <= r.indexOf("stacked")) "auto" === u && (u = "inside");
            else if ("bubble" === r || "scatter" === r) u = "inside";
            q = k.point.x - l / 2;
            "inside" !== u
              ? ((e = b.y1),
                (g = b.y2),
                0 < s
                  ? ((m = k.point.y - n - h - c),
                    m < e &&
                      ((m =
                        "auto" === u
                          ? Math.max(k.point.y, e) + h + c
                          : e + h + c),
                      (x = m + n > k.point.y)))
                  : ((m = k.point.y + h + c),
                    m > g - n - h - c &&
                      ((m =
                        "auto" === u
                          ? Math.min(k.point.y, g) - n - h - c
                          : g - n - h - c),
                      (x = m < k.point.y))))
              : ((e = Math.max(k.bounds.y1, b.y1)),
                (g = Math.min(k.bounds.y2, b.y2)),
                (c =
                  0 <= r.indexOf("range") || "error" === r
                    ? 0 < s
                      ? Math.max(k.bounds.y1, b.y1) + n / 2 + h
                      : Math.min(k.bounds.y2, b.y2) - n / 2 - h
                    : (Math.max(k.bounds.y1, b.y1) +
                        Math.min(k.bounds.y2, b.y2)) /
                      2),
                0 < s
                  ? ((m = Math.max(k.point.y, c) - n / 2),
                    m < e &&
                      ("bubble" === r || "scatter" === r) &&
                      (m = Math.max(k.point.y - n - h, b.y1 + h)))
                  : ((m = Math.min(k.point.y, c) - n / 2),
                    m > g - n - h &&
                      ("bubble" === r || "scatter" === r) &&
                      (m = Math.min(k.point.y + h, b.y2 - n - h))),
                (m = Math.min(m, g - n)));
          } else
            0 <= r.indexOf("line") ||
            0 <= r.indexOf("area") ||
            0 <= r.indexOf("scatter")
              ? ((u = "auto"), (e = 4))
              : 0 <= r.indexOf("stacked")
              ? "auto" === u && (u = "inside")
              : "bubble" === r && (u = "inside"),
              (m = k.point.y - n / 2),
              "inside" !== u
                ? ((h = b.x1),
                  (g = b.x2),
                  0 > s
                    ? ((q = k.point.x - l - e - c),
                      q < h &&
                        ((q =
                          "auto" === u
                            ? Math.max(k.point.x, h) + e + c
                            : h + e + c),
                        (x = q + l > k.point.x)))
                    : ((q = k.point.x + e + c),
                      q > g - l - e - c &&
                        ((q =
                          "auto" === u
                            ? Math.min(k.point.x, g) - l - e - c
                            : g - l - e - c),
                        (x = q < k.point.x))))
                : ((h = Math.max(k.bounds.x1, b.x1)),
                  Math.min(k.bounds.x2, b.x2),
                  (c =
                    0 <= r.indexOf("range") || "error" === r
                      ? 0 > s
                        ? Math.max(k.bounds.x1, b.x1) + l / 2 + e
                        : Math.min(k.bounds.x2, b.x2) - l / 2 - e
                      : (Math.max(k.bounds.x1, b.x1) +
                          Math.min(k.bounds.x2, b.x2)) /
                        2),
                  (q =
                    0 > s
                      ? Math.max(k.point.x, c) - l / 2
                      : Math.min(k.point.x, c) - l / 2),
                  (q = Math.max(q, h)));
          "vertical" === E && (m += n);
          d.x = q;
          d.y = m;
          d.render(!0);
          C &&
            "inside" !== u &&
            ((0 > r.indexOf("bar") &&
              ("error" !== r || !k.axisSwapped) &&
              k.point.x > b.x1 &&
              k.point.x < b.x2) ||
              !x) &&
            ((0 > r.indexOf("column") &&
              ("error" !== r || k.axisSwapped) &&
              k.point.y > b.y1 &&
              k.point.y < b.y2) ||
              !x) &&
            ((f.lineWidth = C),
            (f.strokeStyle = p ? p : "grey"),
            f.setLineDash && f.setLineDash(F(w, C)),
            f.beginPath(),
            f.moveTo(k.point.x, k.point.y),
            0 <= r.indexOf("bar") || ("error" === r && k.axisSwapped)
              ? f.lineTo(
                  q + (0 < k.direction ? 0 : l),
                  m + ("horizontal" === E ? n : -n) / 2
                )
              : 0 <= r.indexOf("column") || ("error" === r && !k.axisSwapped)
              ? f.lineTo(
                  q + l / 2,
                  m +
                    ((0 < k.direction ? n : -n) +
                      ("horizontal" === E ? n : -n)) /
                      2
                )
              : f.lineTo(
                  q + l / 2,
                  m +
                    ((m < k.point.y ? n : -n) + ("horizontal" === E ? n : -n)) /
                      2
                ),
            f.stroke());
        }
      }
      f = {
        source: f,
        dest: this.plotArea.ctx,
        animationCallback: L.fadeInAnimation,
        easingFunction: L.easing.easeInQuad,
        animationBase: 0,
        startTimePercent: 0.7,
      };
      for (a = 0; a < this._indexLabels.length; a++)
        (k = this._indexLabels[a]),
          (d = ka("indexLabelBackgroundColor", k.dataPoint, k.dataSeries)),
          (k.dataSeries.indexLabelBackgroundColor = y(d)
            ? v
              ? "transparent"
              : null
            : d);
      return f;
    };
    s.prototype.renderLine = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this._eventManager.ghostCtx;
        b.save();
        var e = this.plotArea;
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        for (var g = [], h, l = 0; l < a.dataSeriesIndexes.length; l++) {
          var n = a.dataSeriesIndexes[l],
            k = this.data[n];
          b.lineWidth = k.lineThickness;
          var r = k.dataPoints,
            q = "solid";
          if (b.setLineDash) {
            var m = F(k.nullDataLineDashType, k.lineThickness),
              q = k.lineDashType,
              d = F(q, k.lineThickness);
            b.setLineDash(d);
          }
          var w = k.id;
          this._eventManager.objectMap[w] = {
            objectType: "dataSeries",
            dataSeriesIndex: n,
          };
          w = R(w);
          c.strokeStyle = w;
          c.lineWidth = 0 < k.lineThickness ? Math.max(k.lineThickness, 4) : 0;
          var w = k._colorSet,
            p =
              (w =
              k.lineColor =
                k.options.lineColor ? k.options.lineColor : w[0]);
          b.strokeStyle = w;
          var C = !0,
            u = 0,
            E,
            G;
          b.beginPath();
          if (0 < r.length) {
            for (var s = !1, u = 0; u < r.length; u++)
              if (
                ((E = r[u].x.getTime ? r[u].x.getTime() : r[u].x),
                !(
                  E < a.axisX.dataInfo.viewPortMin ||
                  (E > a.axisX.dataInfo.viewPortMax &&
                    (!k.connectNullData || !s))
                ))
              )
                if ("number" !== typeof r[u].y)
                  0 < u &&
                    !(k.connectNullData || s || C) &&
                    (b.stroke(), v && c.stroke()),
                    (s = !0);
                else {
                  E = a.axisX.convertValueToPixel(E);
                  G = a.axisY.convertValueToPixel(r[u].y);
                  var t = k.dataPointIds[u];
                  this._eventManager.objectMap[t] = {
                    id: t,
                    objectType: "dataPoint",
                    dataSeriesIndex: n,
                    dataPointIndex: u,
                    x1: E,
                    y1: G,
                  };
                  C || s
                    ? (!C && k.connectNullData
                        ? (b.setLineDash &&
                            (k.options.nullDataLineDashType ||
                              (q === k.lineDashType &&
                                k.lineDashType !== k.nullDataLineDashType)) &&
                            (b.stroke(),
                            b.beginPath(),
                            b.moveTo(h.x, h.y),
                            (q = k.nullDataLineDashType),
                            b.setLineDash(m)),
                          b.lineTo(E, G),
                          v && c.lineTo(E, G))
                        : (b.beginPath(),
                          b.moveTo(E, G),
                          v && (c.beginPath(), c.moveTo(E, G))),
                      (s = C = !1))
                    : (b.lineTo(E, G),
                      v && c.lineTo(E, G),
                      0 == u % 500 &&
                        (b.stroke(),
                        b.beginPath(),
                        b.moveTo(E, G),
                        v && (c.stroke(), c.beginPath(), c.moveTo(E, G))));
                  h = { x: E, y: G };
                  u < r.length - 1 &&
                    (p !== (r[u].lineColor || w) ||
                      q !== (r[u].lineDashType || k.lineDashType)) &&
                    (b.stroke(),
                    b.beginPath(),
                    b.moveTo(E, G),
                    (p = r[u].lineColor || w),
                    (b.strokeStyle = p),
                    b.setLineDash &&
                      (r[u].lineDashType
                        ? ((q = r[u].lineDashType),
                          b.setLineDash(F(q, k.lineThickness)))
                        : ((q = k.lineDashType), b.setLineDash(d))));
                  if (0 < r[u].markerSize || 0 < k.markerSize) {
                    var A = k.getMarkerProperties(u, E, G, b);
                    g.push(A);
                    t = R(t);
                    v &&
                      g.push({
                        x: E,
                        y: G,
                        ctx: c,
                        type: A.type,
                        size: A.size,
                        color: t,
                        borderColor: t,
                        borderThickness: A.borderThickness,
                      });
                  }
                  (r[u].indexLabel ||
                    k.indexLabel ||
                    r[u].indexLabelFormatter ||
                    k.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "line",
                      dataPoint: r[u],
                      dataSeries: k,
                      point: { x: E, y: G },
                      direction: 0 > r[u].y === a.axisY.reversed ? 1 : -1,
                      color: w,
                    });
                }
            b.stroke();
            v && c.stroke();
          }
        }
        fa.drawMarkers(g);
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          c.beginPath());
        b.restore();
        b.beginPath();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStepLine = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this._eventManager.ghostCtx;
        b.save();
        var e = this.plotArea;
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        for (var g = [], h, l = 0; l < a.dataSeriesIndexes.length; l++) {
          var n = a.dataSeriesIndexes[l],
            k = this.data[n];
          b.lineWidth = k.lineThickness;
          var r = k.dataPoints,
            q = "solid";
          if (b.setLineDash) {
            var m = F(k.nullDataLineDashType, k.lineThickness),
              q = k.lineDashType,
              d = F(q, k.lineThickness);
            b.setLineDash(d);
          }
          var w = k.id;
          this._eventManager.objectMap[w] = {
            objectType: "dataSeries",
            dataSeriesIndex: n,
          };
          w = R(w);
          c.strokeStyle = w;
          c.lineWidth = 0 < k.lineThickness ? Math.max(k.lineThickness, 4) : 0;
          var w = k._colorSet,
            p =
              (w =
              k.lineColor =
                k.options.lineColor ? k.options.lineColor : w[0]);
          b.strokeStyle = w;
          var C = !0,
            u = 0,
            E,
            G;
          b.beginPath();
          if (0 < r.length) {
            for (var s = !1, u = 0; u < r.length; u++)
              if (
                ((E = r[u].getTime ? r[u].x.getTime() : r[u].x),
                !(
                  E < a.axisX.dataInfo.viewPortMin ||
                  (E > a.axisX.dataInfo.viewPortMax &&
                    (!k.connectNullData || !s))
                ))
              )
                if ("number" !== typeof r[u].y)
                  0 < u &&
                    !(k.connectNullData || s || C) &&
                    (b.stroke(), v && c.stroke()),
                    (s = !0);
                else {
                  var t = G;
                  E = a.axisX.convertValueToPixel(E);
                  G = a.axisY.convertValueToPixel(r[u].y);
                  var A = k.dataPointIds[u];
                  this._eventManager.objectMap[A] = {
                    id: A,
                    objectType: "dataPoint",
                    dataSeriesIndex: n,
                    dataPointIndex: u,
                    x1: E,
                    y1: G,
                  };
                  C || s
                    ? (!C && k.connectNullData
                        ? (b.setLineDash &&
                            (k.options.nullDataLineDashType ||
                              (q === k.lineDashType &&
                                k.lineDashType !== k.nullDataLineDashType)) &&
                            (b.stroke(),
                            b.beginPath(),
                            b.moveTo(h.x, h.y),
                            (q = k.nullDataLineDashType),
                            b.setLineDash(m)),
                          b.lineTo(E, t),
                          b.lineTo(E, G),
                          v && (c.lineTo(E, t), c.lineTo(E, G)))
                        : (b.beginPath(),
                          b.moveTo(E, G),
                          v && (c.beginPath(), c.moveTo(E, G))),
                      (s = C = !1))
                    : (b.lineTo(E, t),
                      v && c.lineTo(E, t),
                      b.lineTo(E, G),
                      v && c.lineTo(E, G),
                      0 == u % 500 &&
                        (b.stroke(),
                        b.beginPath(),
                        b.moveTo(E, G),
                        v && (c.stroke(), c.beginPath(), c.moveTo(E, G))));
                  h = { x: E, y: G };
                  u < r.length - 1 &&
                    (p !== (r[u].lineColor || w) ||
                      q !== (r[u].lineDashType || k.lineDashType)) &&
                    (b.stroke(),
                    b.beginPath(),
                    b.moveTo(E, G),
                    (p = r[u].lineColor || w),
                    (b.strokeStyle = p),
                    b.setLineDash &&
                      (r[u].lineDashType
                        ? ((q = r[u].lineDashType),
                          b.setLineDash(F(q, k.lineThickness)))
                        : ((q = k.lineDashType), b.setLineDash(d))));
                  if (0 < r[u].markerSize || 0 < k.markerSize)
                    (t = k.getMarkerProperties(u, E, G, b)),
                      g.push(t),
                      (A = R(A)),
                      v &&
                        g.push({
                          x: E,
                          y: G,
                          ctx: c,
                          type: t.type,
                          size: t.size,
                          color: A,
                          borderColor: A,
                          borderThickness: t.borderThickness,
                        });
                  (r[u].indexLabel ||
                    k.indexLabel ||
                    r[u].indexLabelFormatter ||
                    k.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "stepLine",
                      dataPoint: r[u],
                      dataSeries: k,
                      point: { x: E, y: G },
                      direction: 0 > r[u].y === a.axisY.reversed ? 1 : -1,
                      color: w,
                    });
                }
            b.stroke();
            v && c.stroke();
          }
        }
        fa.drawMarkers(g);
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          c.beginPath());
        b.restore();
        b.beginPath();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderSpline = function (a) {
      function f(a) {
        a = x(a, 2);
        if (0 < a.length) {
          c.beginPath();
          v && e.beginPath();
          c.moveTo(a[0].x, a[0].y);
          a[0].newStrokeStyle && (c.strokeStyle = a[0].newStrokeStyle);
          a[0].newLineDashArray && c.setLineDash(a[0].newLineDashArray);
          v && e.moveTo(a[0].x, a[0].y);
          for (var b = 0; b < a.length - 3; b += 3)
            if (
              (c.bezierCurveTo(
                a[b + 1].x,
                a[b + 1].y,
                a[b + 2].x,
                a[b + 2].y,
                a[b + 3].x,
                a[b + 3].y
              ),
              v &&
                e.bezierCurveTo(
                  a[b + 1].x,
                  a[b + 1].y,
                  a[b + 2].x,
                  a[b + 2].y,
                  a[b + 3].x,
                  a[b + 3].y
                ),
              (0 < b && 0 === b % 3e3) ||
                a[b + 3].newStrokeStyle ||
                a[b + 3].newLineDashArray)
            )
              c.stroke(),
                c.beginPath(),
                c.moveTo(a[b + 3].x, a[b + 3].y),
                a[b + 3].newStrokeStyle &&
                  (c.strokeStyle = a[b + 3].newStrokeStyle),
                a[b + 3].newLineDashArray &&
                  c.setLineDash(a[b + 3].newLineDashArray),
                v &&
                  (e.stroke(), e.beginPath(), e.moveTo(a[b + 3].x, a[b + 3].y));
          c.stroke();
          v && e.stroke();
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = this._eventManager.ghostCtx;
        c.save();
        var g = this.plotArea;
        c.beginPath();
        c.rect(g.x1, g.y1, g.width, g.height);
        c.clip();
        for (var h = [], l = 0; l < a.dataSeriesIndexes.length; l++) {
          var n = a.dataSeriesIndexes[l],
            k = this.data[n];
          c.lineWidth = k.lineThickness;
          var r = k.dataPoints,
            q = "solid";
          if (c.setLineDash) {
            var m = F(k.nullDataLineDashType, k.lineThickness),
              q = k.lineDashType,
              d = F(q, k.lineThickness);
            c.setLineDash(d);
          }
          var w = k.id;
          this._eventManager.objectMap[w] = {
            objectType: "dataSeries",
            dataSeriesIndex: n,
          };
          w = R(w);
          e.strokeStyle = w;
          e.lineWidth = 0 < k.lineThickness ? Math.max(k.lineThickness, 4) : 0;
          var w = k._colorSet,
            p =
              (w =
              k.lineColor =
                k.options.lineColor ? k.options.lineColor : w[0]);
          c.strokeStyle = w;
          var C = 0,
            u,
            E,
            G = [];
          c.beginPath();
          if (0 < r.length)
            for (E = !1, C = 0; C < r.length; C++)
              if (
                ((u = r[C].getTime ? r[C].x.getTime() : r[C].x),
                !(
                  u < a.axisX.dataInfo.viewPortMin ||
                  (u > a.axisX.dataInfo.viewPortMax &&
                    (!k.connectNullData || !E))
                ))
              )
                if ("number" !== typeof r[C].y)
                  0 < C &&
                    !E &&
                    (k.connectNullData
                      ? c.setLineDash &&
                        0 < G.length &&
                        (k.options.nullDataLineDashType ||
                          !r[C - 1].lineDashType) &&
                        ((G[G.length - 1].newLineDashArray = m),
                        (q = k.nullDataLineDashType))
                      : (f(G), (G = []))),
                    (E = !0);
                else {
                  u = a.axisX.convertValueToPixel(u);
                  E = a.axisY.convertValueToPixel(r[C].y);
                  var s = k.dataPointIds[C];
                  this._eventManager.objectMap[s] = {
                    id: s,
                    objectType: "dataPoint",
                    dataSeriesIndex: n,
                    dataPointIndex: C,
                    x1: u,
                    y1: E,
                  };
                  G[G.length] = { x: u, y: E };
                  C < r.length - 1 &&
                    (p !== (r[C].lineColor || w) ||
                      q !== (r[C].lineDashType || k.lineDashType)) &&
                    ((p = r[C].lineColor || w),
                    (G[G.length - 1].newStrokeStyle = p),
                    c.setLineDash &&
                      (r[C].lineDashType
                        ? ((q = r[C].lineDashType),
                          (G[G.length - 1].newLineDashArray = F(
                            q,
                            k.lineThickness
                          )))
                        : ((q = k.lineDashType),
                          (G[G.length - 1].newLineDashArray = d))));
                  if (0 < r[C].markerSize || 0 < k.markerSize) {
                    var t = k.getMarkerProperties(C, u, E, c);
                    h.push(t);
                    s = R(s);
                    v &&
                      h.push({
                        x: u,
                        y: E,
                        ctx: e,
                        type: t.type,
                        size: t.size,
                        color: s,
                        borderColor: s,
                        borderThickness: t.borderThickness,
                      });
                  }
                  (r[C].indexLabel ||
                    k.indexLabel ||
                    r[C].indexLabelFormatter ||
                    k.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "spline",
                      dataPoint: r[C],
                      dataSeries: k,
                      point: { x: u, y: E },
                      direction: 0 > r[C].y === a.axisY.reversed ? 1 : -1,
                      color: w,
                    });
                  E = !1;
                }
          f(G);
        }
        fa.drawMarkers(h);
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(g.x1, g.y1, g.width, g.height),
          e.beginPath());
        c.restore();
        c.beginPath();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    var W = function (a, f, b, c, e, g, h, l, n, k, r, q, m) {
      "undefined" === typeof m && (m = 1);
      h = h || 0;
      l = l || "black";
      var d = 15 < c - f && 15 < e - b ? 8 : 0.35 * Math.min(c - f, e - b);
      a.beginPath();
      a.moveTo(f, b);
      a.save();
      a.fillStyle = g;
      a.globalAlpha = m;
      a.fillRect(f, b, c - f, e - b);
      a.globalAlpha = 1;
      0 < h &&
        ((m = 0 === h % 2 ? 0 : 0.5),
        a.beginPath(),
        (a.lineWidth = h),
        (a.strokeStyle = l),
        a.moveTo(f, b),
        a.rect(f - m, b - m, c - f + 2 * m, e - b + 2 * m),
        a.stroke());
      a.restore();
      !0 === n &&
        (a.save(),
        a.beginPath(),
        a.moveTo(f, b),
        a.lineTo(f + d, b + d),
        a.lineTo(c - d, b + d),
        a.lineTo(c, b),
        a.closePath(),
        (h = a.createLinearGradient((c + f) / 2, b + d, (c + f) / 2, b)),
        h.addColorStop(0, g),
        h.addColorStop(1, "rgba(255, 255, 255, .4)"),
        (a.fillStyle = h),
        a.fill(),
        a.restore());
      !0 === k &&
        (a.save(),
        a.beginPath(),
        a.moveTo(f, e),
        a.lineTo(f + d, e - d),
        a.lineTo(c - d, e - d),
        a.lineTo(c, e),
        a.closePath(),
        (h = a.createLinearGradient((c + f) / 2, e - d, (c + f) / 2, e)),
        h.addColorStop(0, g),
        h.addColorStop(1, "rgba(255, 255, 255, .4)"),
        (a.fillStyle = h),
        a.fill(),
        a.restore());
      !0 === r &&
        (a.save(),
        a.beginPath(),
        a.moveTo(f, b),
        a.lineTo(f + d, b + d),
        a.lineTo(f + d, e - d),
        a.lineTo(f, e),
        a.closePath(),
        (h = a.createLinearGradient(f + d, (e + b) / 2, f, (e + b) / 2)),
        h.addColorStop(0, g),
        h.addColorStop(1, "rgba(255, 255, 255, 0.1)"),
        (a.fillStyle = h),
        a.fill(),
        a.restore());
      !0 === q &&
        (a.save(),
        a.beginPath(),
        a.moveTo(c, b),
        a.lineTo(c - d, b + d),
        a.lineTo(c - d, e - d),
        a.lineTo(c, e),
        (h = a.createLinearGradient(c - d, (e + b) / 2, c, (e + b) / 2)),
        h.addColorStop(0, g),
        h.addColorStop(1, "rgba(255, 255, 255, 0.1)"),
        (a.fillStyle = h),
        h.addColorStop(0, g),
        h.addColorStop(1, "rgba(255, 255, 255, 0.1)"),
        (a.fillStyle = h),
        a.fill(),
        a.closePath(),
        a.restore());
    };
    s.prototype.renderColumn = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = 0,
          h,
          l,
          n,
          k = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          g = (this.dataPointMinWidth = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1),
          r = (this.dataPointMaxWidth = this.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : Math.min(
                0.15 * this.width,
                0.9 * (this.plotArea.width / a.plotType.totalDataSeries)
              ) << 0),
          q = a.axisX.dataInfo.minDiff;
        isFinite(q) || (q = 0.3 * Math.abs(a.axisX.range));
        q = this.dataPointWidth = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.width *
                (a.axisX.logarithmic
                  ? Math.log(q) / Math.log(a.axisX.range)
                  : Math.abs(q) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          g > r &&
          (g = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            r
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          r < g &&
          (r = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            g
          ));
        q < g && (q = g);
        q > r && (q = r);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (r = 0; r < a.dataSeriesIndexes.length; r++) {
          var m = a.dataSeriesIndexes[r],
            d = this.data[m],
            w = d.dataPoints;
          if (0 < w.length)
            for (
              var p = 5 < q && d.bevelEnabled ? !0 : !1, g = 0;
              g < w.length;
              g++
            )
              if (
                (w[g].getTime ? (n = w[g].x.getTime()) : (n = w[g].x),
                !(
                  n < a.axisX.dataInfo.viewPortMin ||
                  n > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof w[g].y)
              ) {
                h = a.axisX.convertValueToPixel(n);
                l = a.axisY.convertValueToPixel(w[g].y);
                h = a.axisX.reversed
                  ? (h +
                      (a.plotType.totalDataSeries * q) / 2 -
                      (a.previousDataSeriesCount + r) * q) <<
                    0
                  : (h -
                      (a.plotType.totalDataSeries * q) / 2 +
                      (a.previousDataSeriesCount + r) * q) <<
                    0;
                var C = a.axisX.reversed ? (h - q) << 0 : (h + q) << 0,
                  u;
                0 <= w[g].y ? (u = k) : ((u = l), (l = k));
                l > u && ((c = l), (l = u), (u = c));
                c = w[g].color
                  ? w[g].color
                  : d._colorSet[g % d._colorSet.length];
                W(
                  b,
                  h,
                  l,
                  C,
                  u,
                  c,
                  0,
                  null,
                  p && 0 <= w[g].y,
                  0 > w[g].y && p,
                  !1,
                  !1,
                  d.fillOpacity
                );
                c = d.dataPointIds[g];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: m,
                  dataPointIndex: g,
                  x1: h,
                  y1: l,
                  x2: C,
                  y2: u,
                };
                c = R(c);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    h,
                    l,
                    C,
                    u,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (w[g].indexLabel ||
                  d.indexLabel ||
                  w[g].indexLabelFormatter ||
                  d.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "column",
                    dataPoint: w[g],
                    dataSeries: d,
                    point: {
                      x: h + (C - h) / 2,
                      y: 0 > w[g].y === a.axisY.reversed ? l : u,
                    },
                    direction: 0 > w[g].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: h,
                      y1: Math.min(l, u),
                      x2: C,
                      y2: Math.max(l, u),
                    },
                    color: c,
                  });
              }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.yScaleAnimation,
          easingFunction: L.easing.easeOutQuart,
          animationBase:
            k < a.axisY.bounds.y1
              ? a.axisY.bounds.y1
              : k > a.axisY.bounds.y2
              ? a.axisY.bounds.y2
              : k,
        };
      }
    };
    s.prototype.renderStackedColumn = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = [],
          h = [],
          l = [],
          n = [],
          k = 0,
          r,
          q,
          m = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          k = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
        r = this.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.width) << 0;
        var d = a.axisX.dataInfo.minDiff;
        isFinite(d) || (d = 0.3 * Math.abs(a.axisX.range));
        d = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.width *
                (a.axisX.logarithmic
                  ? Math.log(d) / Math.log(a.axisX.range)
                  : Math.abs(d) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          k > r &&
          (k = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            r
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          r < k &&
          (r = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            k
          ));
        d < k && (d = k);
        d > r && (d = r);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (var w = 0; w < a.dataSeriesIndexes.length; w++) {
          var p = a.dataSeriesIndexes[w],
            C = this.data[p],
            u = C.dataPoints;
          if (0 < u.length) {
            var E = 5 < d && C.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (k = 0; k < u.length; k++)
              if (
                ((c = u[k].x.getTime ? u[k].x.getTime() : u[k].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof u[k].y)
              ) {
                r = a.axisX.convertValueToPixel(c);
                var G =
                    (r - (a.plotType.plotUnits.length * d) / 2 + a.index * d) <<
                    0,
                  s = (G + d) << 0,
                  t;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < u[k].y)
                )
                  (l[c] = u[k].y + (l[c] ? l[c] : 0)),
                    0 < l[c] &&
                      ((q = a.axisY.convertValueToPixel(l[c])),
                      (t = "undefined" !== typeof g[c] ? g[c] : m),
                      (g[c] = q));
                else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= u[k].y
                )
                  (n[c] = u[k].y + (n[c] ? n[c] : 0)),
                    (t = a.axisY.convertValueToPixel(n[c])),
                    (q = "undefined" !== typeof h[c] ? h[c] : m),
                    (h[c] = t);
                else if (
                  ((q = a.axisY.convertValueToPixel(u[k].y)), 0 <= u[k].y)
                ) {
                  var A = "undefined" !== typeof g[c] ? g[c] : 0;
                  q -= A;
                  t = m - A;
                  g[c] = A + (t - q);
                } else
                  (A = h[c] ? h[c] : 0),
                    (t = q + A),
                    (q = m + A),
                    (h[c] = A + (t - q));
                c = u[k].color
                  ? u[k].color
                  : C._colorSet[k % C._colorSet.length];
                W(
                  b,
                  G,
                  q,
                  s,
                  t,
                  c,
                  0,
                  null,
                  E && 0 <= u[k].y,
                  0 > u[k].y && E,
                  !1,
                  !1,
                  C.fillOpacity
                );
                c = C.dataPointIds[k];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: p,
                  dataPointIndex: k,
                  x1: G,
                  y1: q,
                  x2: s,
                  y2: t,
                };
                c = R(c);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    G,
                    q,
                    s,
                    t,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (u[k].indexLabel ||
                  C.indexLabel ||
                  u[k].indexLabelFormatter ||
                  C.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedColumn",
                    dataPoint: u[k],
                    dataSeries: C,
                    point: { x: r, y: 0 <= u[k].y ? q : t },
                    direction: 0 > u[k].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: G,
                      y1: Math.min(q, t),
                      x2: s,
                      y2: Math.max(q, t),
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.yScaleAnimation,
          easingFunction: L.easing.easeOutQuart,
          animationBase:
            m < a.axisY.bounds.y1
              ? a.axisY.bounds.y1
              : m > a.axisY.bounds.y2
              ? a.axisY.bounds.y2
              : m,
        };
      }
    };
    s.prototype.renderStackedColumn100 = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = [],
          h = [],
          l = [],
          n = [],
          k = 0,
          r,
          q,
          m = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          k = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
        r = this.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.width) << 0;
        var d = a.axisX.dataInfo.minDiff;
        isFinite(d) || (d = 0.3 * Math.abs(a.axisX.range));
        d = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.width *
                (a.axisX.logarithmic
                  ? Math.log(d) / Math.log(a.axisX.range)
                  : Math.abs(d) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          k > r &&
          (k = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            r
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          r < k &&
          (r = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            k
          ));
        d < k && (d = k);
        d > r && (d = r);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (var w = 0; w < a.dataSeriesIndexes.length; w++) {
          var p = a.dataSeriesIndexes[w],
            C = this.data[p],
            u = C.dataPoints;
          if (0 < u.length)
            for (
              var E = 5 < d && C.bevelEnabled ? !0 : !1, k = 0;
              k < u.length;
              k++
            )
              if (
                ((c = u[k].x.getTime ? u[k].x.getTime() : u[k].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof u[k].y)
              ) {
                r = a.axisX.convertValueToPixel(c);
                q =
                  0 !== a.dataPointYSums[c]
                    ? 100 * (u[k].y / a.dataPointYSums[c])
                    : 0;
                var G =
                    (r - (a.plotType.plotUnits.length * d) / 2 + a.index * d) <<
                    0,
                  s = (G + d) << 0,
                  t;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < u[k].y)
                ) {
                  l[c] = q + ("undefined" !== typeof l[c] ? l[c] : 0);
                  if (0 >= l[c]) continue;
                  q = a.axisY.convertValueToPixel(l[c]);
                  t = g[c] ? g[c] : m;
                  g[c] = q;
                } else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= u[k].y
                )
                  (n[c] = q + ("undefined" !== typeof n[c] ? n[c] : 0)),
                    (t = a.axisY.convertValueToPixel(n[c])),
                    (q = h[c] ? h[c] : m),
                    (h[c] = t);
                else if (((q = a.axisY.convertValueToPixel(q)), 0 <= u[k].y)) {
                  var A = "undefined" !== typeof g[c] ? g[c] : 0;
                  q -= A;
                  t = m - A;
                  g[c] = A + (t - q);
                } else
                  (A = "undefined" !== typeof h[c] ? h[c] : 0),
                    (t = q + A),
                    (q = m + A),
                    (h[c] = A + (t - q));
                c = u[k].color
                  ? u[k].color
                  : C._colorSet[k % C._colorSet.length];
                W(
                  b,
                  G,
                  q,
                  s,
                  t,
                  c,
                  0,
                  null,
                  E && 0 <= u[k].y,
                  0 > u[k].y && E,
                  !1,
                  !1,
                  C.fillOpacity
                );
                c = C.dataPointIds[k];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: p,
                  dataPointIndex: k,
                  x1: G,
                  y1: q,
                  x2: s,
                  y2: t,
                };
                c = R(c);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    G,
                    q,
                    s,
                    t,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (u[k].indexLabel ||
                  C.indexLabel ||
                  u[k].indexLabelFormatter ||
                  C.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedColumn100",
                    dataPoint: u[k],
                    dataSeries: C,
                    point: { x: r, y: 0 <= u[k].y ? q : t },
                    direction: 0 > u[k].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: G,
                      y1: Math.min(q, t),
                      x2: s,
                      y2: Math.max(q, t),
                    },
                    color: c,
                  });
              }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.yScaleAnimation,
          easingFunction: L.easing.easeOutQuart,
          animationBase:
            m < a.axisY.bounds.y1
              ? a.axisY.bounds.y1
              : m > a.axisY.bounds.y2
              ? a.axisY.bounds.y2
              : m,
        };
      }
    };
    s.prototype.renderBar = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = 0,
          h,
          l,
          n,
          k = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          g = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1,
          r = this.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : Math.min(
                0.15 * this.height,
                0.9 * (this.plotArea.height / a.plotType.totalDataSeries)
              ) << 0,
          q = a.axisX.dataInfo.minDiff;
        isFinite(q) || (q = 0.3 * Math.abs(a.axisX.range));
        q = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.height *
                (a.axisX.logarithmic
                  ? Math.log(q) / Math.log(a.axisX.range)
                  : Math.abs(q) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          g > r &&
          (g = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            r
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          r < g &&
          (r = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            g
          ));
        q < g && (q = g);
        q > r && (q = r);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (r = 0; r < a.dataSeriesIndexes.length; r++) {
          var m = a.dataSeriesIndexes[r],
            d = this.data[m],
            w = d.dataPoints;
          if (0 < w.length) {
            var p = 5 < q && d.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (g = 0; g < w.length; g++)
              if (
                (w[g].getTime ? (n = w[g].x.getTime()) : (n = w[g].x),
                !(
                  n < a.axisX.dataInfo.viewPortMin ||
                  n > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof w[g].y)
              ) {
                l = a.axisX.convertValueToPixel(n);
                h = a.axisY.convertValueToPixel(w[g].y);
                l = a.axisX.reversed
                  ? (l +
                      (a.plotType.totalDataSeries * q) / 2 -
                      (a.previousDataSeriesCount + r) * q) <<
                    0
                  : (l -
                      (a.plotType.totalDataSeries * q) / 2 +
                      (a.previousDataSeriesCount + r) * q) <<
                    0;
                var C = a.axisX.reversed ? (l - q) << 0 : (l + q) << 0,
                  u;
                0 <= w[g].y ? (u = k) : ((u = h), (h = k));
                c = w[g].color
                  ? w[g].color
                  : d._colorSet[g % d._colorSet.length];
                W(b, u, l, h, C, c, 0, null, p, !1, !1, !1, d.fillOpacity);
                c = d.dataPointIds[g];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: m,
                  dataPointIndex: g,
                  x1: u,
                  y1: l,
                  x2: h,
                  y2: C,
                };
                c = R(c);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    u,
                    l,
                    h,
                    C,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (w[g].indexLabel ||
                  d.indexLabel ||
                  w[g].indexLabelFormatter ||
                  d.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "bar",
                    dataPoint: w[g],
                    dataSeries: d,
                    point: { x: 0 <= w[g].y ? h : u, y: l + (C - l) / 2 },
                    direction: 0 > w[g].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: Math.min(u, h),
                      y1: l,
                      x2: Math.max(u, h),
                      y2: C,
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.xScaleAnimation,
          easingFunction: L.easing.easeOutQuart,
          animationBase:
            k < a.axisY.bounds.x1
              ? a.axisY.bounds.x1
              : k > a.axisY.bounds.x2
              ? a.axisY.bounds.x2
              : k,
        };
      }
    };
    s.prototype.renderStackedBar = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = [],
          h = [],
          l = [],
          n = [],
          k = 0,
          r,
          q,
          m = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          k = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
        q = this.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.height) << 0;
        var d = a.axisX.dataInfo.minDiff;
        isFinite(d) || (d = 0.3 * Math.abs(a.axisX.range));
        d = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.height *
                (a.axisX.logarithmic
                  ? Math.log(d) / Math.log(a.axisX.range)
                  : Math.abs(d) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          k > q &&
          (k = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            q
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          q < k &&
          (q = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            k
          ));
        d < k && (d = k);
        d > q && (d = q);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (var w = 0; w < a.dataSeriesIndexes.length; w++) {
          var p = a.dataSeriesIndexes[w],
            C = this.data[p],
            u = C.dataPoints;
          if (0 < u.length) {
            var E = 5 < d && C.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (k = 0; k < u.length; k++)
              if (
                ((c = u[k].x.getTime ? u[k].x.getTime() : u[k].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof u[k].y)
              ) {
                q = a.axisX.convertValueToPixel(c);
                var t =
                    (q - (a.plotType.plotUnits.length * d) / 2 + a.index * d) <<
                    0,
                  s = (t + d) << 0,
                  y;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < u[k].y)
                )
                  (l[c] = u[k].y + (l[c] ? l[c] : 0)),
                    0 < l[c] &&
                      ((y = g[c] ? g[c] : m),
                      (g[c] = r = a.axisY.convertValueToPixel(l[c])));
                else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= u[k].y
                )
                  (n[c] = u[k].y + (n[c] ? n[c] : 0)),
                    (r = h[c] ? h[c] : m),
                    (h[c] = y = a.axisY.convertValueToPixel(n[c]));
                else if (
                  ((r = a.axisY.convertValueToPixel(u[k].y)), 0 <= u[k].y)
                ) {
                  var A = g[c] ? g[c] : 0;
                  y = m + A;
                  r += A;
                  g[c] = A + (r - y);
                } else
                  (A = h[c] ? h[c] : 0),
                    (y = r - A),
                    (r = m - A),
                    (h[c] = A + (r - y));
                c = u[k].color
                  ? u[k].color
                  : C._colorSet[k % C._colorSet.length];
                W(b, y, t, r, s, c, 0, null, E, !1, !1, !1, C.fillOpacity);
                c = C.dataPointIds[k];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: p,
                  dataPointIndex: k,
                  x1: y,
                  y1: t,
                  x2: r,
                  y2: s,
                };
                c = R(c);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    y,
                    t,
                    r,
                    s,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (u[k].indexLabel ||
                  C.indexLabel ||
                  u[k].indexLabelFormatter ||
                  C.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedBar",
                    dataPoint: u[k],
                    dataSeries: C,
                    point: { x: 0 <= u[k].y ? r : y, y: q },
                    direction: 0 > u[k].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: Math.min(y, r),
                      y1: t,
                      x2: Math.max(y, r),
                      y2: s,
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.xScaleAnimation,
          easingFunction: L.easing.easeOutQuart,
          animationBase:
            m < a.axisY.bounds.x1
              ? a.axisY.bounds.x1
              : m > a.axisY.bounds.x2
              ? a.axisY.bounds.x2
              : m,
        };
      }
    };
    s.prototype.renderStackedBar100 = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = [],
          h = [],
          l = [],
          n = [],
          k = 0,
          r,
          q,
          m = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          k = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
        q = this.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.height) << 0;
        var d = a.axisX.dataInfo.minDiff;
        isFinite(d) || (d = 0.3 * Math.abs(a.axisX.range));
        d = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.height *
                (a.axisX.logarithmic
                  ? Math.log(d) / Math.log(a.axisX.range)
                  : Math.abs(d) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          k > q &&
          (k = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            q
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          q < k &&
          (q = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            k
          ));
        d < k && (d = k);
        d > q && (d = q);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (var w = 0; w < a.dataSeriesIndexes.length; w++) {
          var p = a.dataSeriesIndexes[w],
            C = this.data[p],
            u = C.dataPoints;
          if (0 < u.length) {
            var E = 5 < d && C.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (k = 0; k < u.length; k++)
              if (
                ((c = u[k].x.getTime ? u[k].x.getTime() : u[k].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof u[k].y)
              ) {
                q = a.axisX.convertValueToPixel(c);
                var t;
                t =
                  0 !== a.dataPointYSums[c]
                    ? 100 * (u[k].y / a.dataPointYSums[c])
                    : 0;
                var s =
                    (q - (a.plotType.plotUnits.length * d) / 2 + a.index * d) <<
                    0,
                  y = (s + d) << 0;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < u[k].y)
                ) {
                  l[c] = t + (l[c] ? l[c] : 0);
                  if (0 >= l[c]) continue;
                  t = g[c] ? g[c] : m;
                  g[c] = r = a.axisY.convertValueToPixel(l[c]);
                } else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= u[k].y
                )
                  (n[c] = t + (n[c] ? n[c] : 0)),
                    (r = h[c] ? h[c] : m),
                    (h[c] = t = a.axisY.convertValueToPixel(n[c]));
                else if (((r = a.axisY.convertValueToPixel(t)), 0 <= u[k].y)) {
                  var A = g[c] ? g[c] : 0;
                  t = m + A;
                  r += A;
                  g[c] = A + (r - t);
                } else
                  (A = h[c] ? h[c] : 0),
                    (t = r - A),
                    (r = m - A),
                    (h[c] = A + (r - t));
                c = u[k].color
                  ? u[k].color
                  : C._colorSet[k % C._colorSet.length];
                W(b, t, s, r, y, c, 0, null, E, !1, !1, !1, C.fillOpacity);
                c = C.dataPointIds[k];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: p,
                  dataPointIndex: k,
                  x1: t,
                  y1: s,
                  x2: r,
                  y2: y,
                };
                c = R(c);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    t,
                    s,
                    r,
                    y,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (u[k].indexLabel ||
                  C.indexLabel ||
                  u[k].indexLabelFormatter ||
                  C.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedBar100",
                    dataPoint: u[k],
                    dataSeries: C,
                    point: { x: 0 <= u[k].y ? r : t, y: q },
                    direction: 0 > u[k].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: Math.min(t, r),
                      y1: s,
                      x2: Math.max(t, r),
                      y2: y,
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.xScaleAnimation,
          easingFunction: L.easing.easeOutQuart,
          animationBase:
            m < a.axisY.bounds.x1
              ? a.axisY.bounds.x1
              : m > a.axisY.bounds.x2
              ? a.axisY.bounds.x2
              : m,
        };
      }
    };
    s.prototype.renderArea = function (a) {
      var f, b;
      function c() {
        A &&
          (0 < w.lineThickness && g.stroke(),
          a.axisY.logarithmic ||
          (0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum)
            ? (y = s)
            : 0 > a.axisY.viewportMaximum
            ? (y = n.y1)
            : 0 < a.axisY.viewportMinimum && (y = l.y2),
          g.lineTo(u, y),
          g.lineTo(A.x, y),
          g.closePath(),
          (g.globalAlpha = w.fillOpacity),
          g.fill(),
          (g.globalAlpha = 1),
          v && (h.lineTo(u, y), h.lineTo(A.x, y), h.closePath(), h.fill()),
          g.beginPath(),
          g.moveTo(u, E),
          h.beginPath(),
          h.moveTo(u, E),
          (A = { x: u, y: E }));
      }
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        g = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var h = this._eventManager.ghostCtx,
          l = a.axisX.lineCoordinates,
          n = a.axisY.lineCoordinates,
          k = [],
          r = this.plotArea,
          q;
        g.save();
        v && h.save();
        g.beginPath();
        g.rect(r.x1, r.y1, r.width, r.height);
        g.clip();
        v && (h.beginPath(), h.rect(r.x1, r.y1, r.width, r.height), h.clip());
        for (var m = 0; m < a.dataSeriesIndexes.length; m++) {
          var d = a.dataSeriesIndexes[m],
            w = this.data[d],
            p = w.dataPoints,
            k = w.id;
          this._eventManager.objectMap[k] = {
            objectType: "dataSeries",
            dataSeriesIndex: d,
          };
          k = R(k);
          h.fillStyle = k;
          k = [];
          f = !0;
          var C = 0,
            u,
            E,
            t,
            s = a.axisY.convertValueToPixel(
              a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
            ),
            y,
            A = null;
          if (0 < p.length) {
            var x = w._colorSet[C % w._colorSet.length],
              B = (w.lineColor = w.options.lineColor || x),
              M = B;
            g.fillStyle = x;
            g.strokeStyle = B;
            g.lineWidth = w.lineThickness;
            b = "solid";
            if (g.setLineDash) {
              var K = F(w.nullDataLineDashType, w.lineThickness);
              b = w.lineDashType;
              var ca = F(b, w.lineThickness);
              g.setLineDash(ca);
            }
            for (var ba = !0; C < p.length; C++)
              if (
                ((t = p[C].x.getTime ? p[C].x.getTime() : p[C].x),
                !(
                  t < a.axisX.dataInfo.viewPortMin ||
                  (t > a.axisX.dataInfo.viewPortMax &&
                    (!w.connectNullData || !ba))
                ))
              )
                if ("number" !== typeof p[C].y)
                  w.connectNullData || ba || f || c(), (ba = !0);
                else {
                  u = a.axisX.convertValueToPixel(t);
                  E = a.axisY.convertValueToPixel(p[C].y);
                  f || ba
                    ? (!f && w.connectNullData
                        ? (g.setLineDash &&
                            (w.options.nullDataLineDashType ||
                              (b === w.lineDashType &&
                                w.lineDashType !== w.nullDataLineDashType)) &&
                            ((f = u),
                            (b = E),
                            (u = q.x),
                            (E = q.y),
                            c(),
                            g.moveTo(q.x, q.y),
                            (u = f),
                            (E = b),
                            (A = q),
                            (b = w.nullDataLineDashType),
                            g.setLineDash(K)),
                          g.lineTo(u, E),
                          v && h.lineTo(u, E))
                        : (g.beginPath(),
                          g.moveTo(u, E),
                          v && (h.beginPath(), h.moveTo(u, E)),
                          (A = { x: u, y: E })),
                      (ba = f = !1))
                    : (g.lineTo(u, E),
                      v && h.lineTo(u, E),
                      0 == C % 250 && c());
                  q = { x: u, y: E };
                  C < p.length - 1 &&
                    (M !== (p[C].lineColor || B) ||
                      b !== (p[C].lineDashType || w.lineDashType)) &&
                    (c(),
                    (M = p[C].lineColor || B),
                    (g.strokeStyle = M),
                    g.setLineDash &&
                      (p[C].lineDashType
                        ? ((b = p[C].lineDashType),
                          g.setLineDash(F(b, w.lineThickness)))
                        : ((b = w.lineDashType), g.setLineDash(ca))));
                  var Z = w.dataPointIds[C];
                  this._eventManager.objectMap[Z] = {
                    id: Z,
                    objectType: "dataPoint",
                    dataSeriesIndex: d,
                    dataPointIndex: C,
                    x1: u,
                    y1: E,
                  };
                  0 !== p[C].markerSize &&
                    (0 < p[C].markerSize || 0 < w.markerSize) &&
                    ((t = w.getMarkerProperties(C, u, E, g)),
                    k.push(t),
                    (Z = R(Z)),
                    v &&
                      k.push({
                        x: u,
                        y: E,
                        ctx: h,
                        type: t.type,
                        size: t.size,
                        color: Z,
                        borderColor: Z,
                        borderThickness: t.borderThickness,
                      }));
                  (p[C].indexLabel ||
                    w.indexLabel ||
                    p[C].indexLabelFormatter ||
                    w.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "area",
                      dataPoint: p[C],
                      dataSeries: w,
                      point: { x: u, y: E },
                      direction: 0 > p[C].y === a.axisY.reversed ? 1 : -1,
                      color: x,
                    });
                }
            c();
            fa.drawMarkers(k);
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (g.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            g.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            g.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          g.clearRect(r.x1, r.y1, r.width, r.height),
          this._eventManager.ghostCtx.restore());
        g.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderSplineArea = function (a) {
      function f() {
        var b = x(t, 2);
        if (0 < b.length) {
          if (0 < q.lineThickness) {
            c.beginPath();
            c.moveTo(b[0].x, b[0].y);
            b[0].newStrokeStyle && (c.strokeStyle = b[0].newStrokeStyle);
            b[0].newLineDashArray && c.setLineDash(b[0].newLineDashArray);
            for (var d = 0; d < b.length - 3; d += 3)
              if (
                (c.bezierCurveTo(
                  b[d + 1].x,
                  b[d + 1].y,
                  b[d + 2].x,
                  b[d + 2].y,
                  b[d + 3].x,
                  b[d + 3].y
                ),
                v &&
                  e.bezierCurveTo(
                    b[d + 1].x,
                    b[d + 1].y,
                    b[d + 2].x,
                    b[d + 2].y,
                    b[d + 3].x,
                    b[d + 3].y
                  ),
                b[d + 3].newStrokeStyle || b[d + 3].newLineDashArray)
              )
                c.stroke(),
                  c.beginPath(),
                  c.moveTo(b[d + 3].x, b[d + 3].y),
                  b[d + 3].newStrokeStyle &&
                    (c.strokeStyle = b[d + 3].newStrokeStyle),
                  b[d + 3].newLineDashArray &&
                    c.setLineDash(b[d + 3].newLineDashArray);
            c.stroke();
          }
          c.beginPath();
          c.moveTo(b[0].x, b[0].y);
          v && (e.beginPath(), e.moveTo(b[0].x, b[0].y));
          for (d = 0; d < b.length - 3; d += 3)
            c.bezierCurveTo(
              b[d + 1].x,
              b[d + 1].y,
              b[d + 2].x,
              b[d + 2].y,
              b[d + 3].x,
              b[d + 3].y
            ),
              v &&
                e.bezierCurveTo(
                  b[d + 1].x,
                  b[d + 1].y,
                  b[d + 2].x,
                  b[d + 2].y,
                  b[d + 3].x,
                  b[d + 3].y
                );
          a.axisY.logarithmic ||
          (0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum)
            ? (u = C)
            : 0 > a.axisY.viewportMaximum
            ? (u = h.y1)
            : 0 < a.axisY.viewportMinimum && (u = g.y2);
          E = { x: b[0].x, y: b[0].y };
          c.lineTo(b[b.length - 1].x, u);
          c.lineTo(E.x, u);
          c.closePath();
          c.globalAlpha = q.fillOpacity;
          c.fill();
          c.globalAlpha = 1;
          v &&
            (e.lineTo(b[b.length - 1].x, u),
            e.lineTo(E.x, u),
            e.closePath(),
            e.fill());
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = this._eventManager.ghostCtx,
          g = a.axisX.lineCoordinates,
          h = a.axisY.lineCoordinates,
          l = [],
          n = this.plotArea;
        c.save();
        v && e.save();
        c.beginPath();
        c.rect(n.x1, n.y1, n.width, n.height);
        c.clip();
        v && (e.beginPath(), e.rect(n.x1, n.y1, n.width, n.height), e.clip());
        for (var k = 0; k < a.dataSeriesIndexes.length; k++) {
          var r = a.dataSeriesIndexes[k],
            q = this.data[r],
            m = q.dataPoints,
            l = q.id;
          this._eventManager.objectMap[l] = {
            objectType: "dataSeries",
            dataSeriesIndex: r,
          };
          l = R(l);
          e.fillStyle = l;
          var l = [],
            d = 0,
            w,
            p,
            C = a.axisY.convertValueToPixel(
              a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
            ),
            u,
            E = null,
            t = [];
          if (0 < m.length) {
            var s = q._colorSet[d % q._colorSet.length],
              y = (q.lineColor = q.options.lineColor || s),
              A = y;
            c.fillStyle = s;
            c.strokeStyle = y;
            c.lineWidth = q.lineThickness;
            var B = "solid";
            if (c.setLineDash) {
              var I = F(q.nullDataLineDashType, q.lineThickness),
                B = q.lineDashType,
                M = F(B, q.lineThickness);
              c.setLineDash(M);
            }
            for (p = !1; d < m.length; d++)
              if (
                ((w = m[d].x.getTime ? m[d].x.getTime() : m[d].x),
                !(
                  w < a.axisX.dataInfo.viewPortMin ||
                  (w > a.axisX.dataInfo.viewPortMax &&
                    (!q.connectNullData || !p))
                ))
              )
                if ("number" !== typeof m[d].y)
                  0 < d &&
                    !p &&
                    (q.connectNullData
                      ? c.setLineDash &&
                        0 < t.length &&
                        (q.options.nullDataLineDashType ||
                          !m[d - 1].lineDashType) &&
                        ((t[t.length - 1].newLineDashArray = I),
                        (B = q.nullDataLineDashType))
                      : (f(), (t = []))),
                    (p = !0);
                else {
                  w = a.axisX.convertValueToPixel(w);
                  p = a.axisY.convertValueToPixel(m[d].y);
                  var K = q.dataPointIds[d];
                  this._eventManager.objectMap[K] = {
                    id: K,
                    objectType: "dataPoint",
                    dataSeriesIndex: r,
                    dataPointIndex: d,
                    x1: w,
                    y1: p,
                  };
                  t[t.length] = { x: w, y: p };
                  d < m.length - 1 &&
                    (A !== (m[d].lineColor || y) ||
                      B !== (m[d].lineDashType || q.lineDashType)) &&
                    ((A = m[d].lineColor || y),
                    (t[t.length - 1].newStrokeStyle = A),
                    c.setLineDash &&
                      (m[d].lineDashType
                        ? ((B = m[d].lineDashType),
                          (t[t.length - 1].newLineDashArray = F(
                            B,
                            q.lineThickness
                          )))
                        : ((B = q.lineDashType),
                          (t[t.length - 1].newLineDashArray = M))));
                  if (
                    0 !== m[d].markerSize &&
                    (0 < m[d].markerSize || 0 < q.markerSize)
                  ) {
                    var ca = q.getMarkerProperties(d, w, p, c);
                    l.push(ca);
                    K = R(K);
                    v &&
                      l.push({
                        x: w,
                        y: p,
                        ctx: e,
                        type: ca.type,
                        size: ca.size,
                        color: K,
                        borderColor: K,
                        borderThickness: ca.borderThickness,
                      });
                  }
                  (m[d].indexLabel ||
                    q.indexLabel ||
                    m[d].indexLabelFormatter ||
                    q.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "splineArea",
                      dataPoint: m[d],
                      dataSeries: q,
                      point: { x: w, y: p },
                      direction: 0 > m[d].y === a.axisY.reversed ? 1 : -1,
                      color: s,
                    });
                  p = !1;
                }
            f();
            fa.drawMarkers(l);
          }
        }
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(n.x1, n.y1, n.width, n.height),
          this._eventManager.ghostCtx.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStepArea = function (a) {
      var f, b;
      function c() {
        A &&
          (0 < w.lineThickness && g.stroke(),
          a.axisY.logarithmic ||
          (0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum)
            ? (x = y)
            : 0 > a.axisY.viewportMaximum
            ? (x = n.y1)
            : 0 < a.axisY.viewportMinimum && (x = l.y2),
          g.lineTo(u, x),
          g.lineTo(A.x, x),
          g.closePath(),
          (g.globalAlpha = w.fillOpacity),
          g.fill(),
          (g.globalAlpha = 1),
          v && (h.lineTo(u, x), h.lineTo(A.x, x), h.closePath(), h.fill()),
          g.beginPath(),
          g.moveTo(u, t),
          h.beginPath(),
          h.moveTo(u, t),
          (A = { x: u, y: t }));
      }
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        g = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var h = this._eventManager.ghostCtx,
          l = a.axisX.lineCoordinates,
          n = a.axisY.lineCoordinates,
          k = [],
          r = this.plotArea,
          q;
        g.save();
        v && h.save();
        g.beginPath();
        g.rect(r.x1, r.y1, r.width, r.height);
        g.clip();
        v && (h.beginPath(), h.rect(r.x1, r.y1, r.width, r.height), h.clip());
        for (var m = 0; m < a.dataSeriesIndexes.length; m++) {
          var d = a.dataSeriesIndexes[m],
            w = this.data[d],
            p = w.dataPoints,
            k = w.id;
          this._eventManager.objectMap[k] = {
            objectType: "dataSeries",
            dataSeriesIndex: d,
          };
          k = R(k);
          h.fillStyle = k;
          k = [];
          f = !0;
          var C = 0,
            u,
            t,
            s,
            y = a.axisY.convertValueToPixel(
              a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
            ),
            x,
            A = null;
          b = !1;
          if (0 < p.length) {
            var B = w._colorSet[C % w._colorSet.length],
              I = (w.lineColor = w.options.lineColor || B),
              M = I;
            g.fillStyle = B;
            g.strokeStyle = I;
            g.lineWidth = w.lineThickness;
            var K = "solid";
            if (g.setLineDash) {
              var ca = F(w.nullDataLineDashType, w.lineThickness),
                K = w.lineDashType,
                ba = F(K, w.lineThickness);
              g.setLineDash(ba);
            }
            for (; C < p.length; C++)
              if (
                ((s = p[C].x.getTime ? p[C].x.getTime() : p[C].x),
                !(
                  s < a.axisX.dataInfo.viewPortMin ||
                  (s > a.axisX.dataInfo.viewPortMax &&
                    (!w.connectNullData || !b))
                ))
              ) {
                var Z = t;
                "number" !== typeof p[C].y
                  ? (w.connectNullData || b || f || c(), (b = !0))
                  : ((u = a.axisX.convertValueToPixel(s)),
                    (t = a.axisY.convertValueToPixel(p[C].y)),
                    f || b
                      ? (!f && w.connectNullData
                          ? (g.setLineDash &&
                              (w.options.nullDataLineDashType ||
                                (K === w.lineDashType &&
                                  w.lineDashType !== w.nullDataLineDashType)) &&
                              ((f = u),
                              (b = t),
                              (u = q.x),
                              (t = q.y),
                              c(),
                              g.moveTo(q.x, q.y),
                              (u = f),
                              (t = b),
                              (A = q),
                              (K = w.nullDataLineDashType),
                              g.setLineDash(ca)),
                            g.lineTo(u, Z),
                            g.lineTo(u, t),
                            v && (h.lineTo(u, Z), h.lineTo(u, t)))
                          : (g.beginPath(),
                            g.moveTo(u, t),
                            v && (h.beginPath(), h.moveTo(u, t)),
                            (A = { x: u, y: t })),
                        (b = f = !1))
                      : (g.lineTo(u, Z),
                        v && h.lineTo(u, Z),
                        g.lineTo(u, t),
                        v && h.lineTo(u, t),
                        0 == C % 250 && c()),
                    (q = { x: u, y: t }),
                    C < p.length - 1 &&
                      (M !== (p[C].lineColor || I) ||
                        K !== (p[C].lineDashType || w.lineDashType)) &&
                      (c(),
                      (M = p[C].lineColor || I),
                      (g.strokeStyle = M),
                      g.setLineDash &&
                        (p[C].lineDashType
                          ? ((K = p[C].lineDashType),
                            g.setLineDash(F(K, w.lineThickness)))
                          : ((K = w.lineDashType), g.setLineDash(ba)))),
                    (s = w.dataPointIds[C]),
                    (this._eventManager.objectMap[s] = {
                      id: s,
                      objectType: "dataPoint",
                      dataSeriesIndex: d,
                      dataPointIndex: C,
                      x1: u,
                      y1: t,
                    }),
                    0 !== p[C].markerSize &&
                      (0 < p[C].markerSize || 0 < w.markerSize) &&
                      ((Z = w.getMarkerProperties(C, u, t, g)),
                      k.push(Z),
                      (s = R(s)),
                      v &&
                        k.push({
                          x: u,
                          y: t,
                          ctx: h,
                          type: Z.type,
                          size: Z.size,
                          color: s,
                          borderColor: s,
                          borderThickness: Z.borderThickness,
                        })),
                    (p[C].indexLabel ||
                      w.indexLabel ||
                      p[C].indexLabelFormatter ||
                      w.indexLabelFormatter) &&
                      this._indexLabels.push({
                        chartType: "stepArea",
                        dataPoint: p[C],
                        dataSeries: w,
                        point: { x: u, y: t },
                        direction: 0 > p[C].y === a.axisY.reversed ? 1 : -1,
                        color: B,
                      }));
              }
            c();
            fa.drawMarkers(k);
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (g.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            g.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            g.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          g.clearRect(r.x1, r.y1, r.width, r.height),
          this._eventManager.ghostCtx.restore());
        g.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStackedArea = function (a) {
      function f() {
        if (!(1 > n.length)) {
          for (0 < A.lineThickness && c.stroke(); 0 < n.length; ) {
            var a = n.pop();
            c.lineTo(a.x, a.y);
            v && C.lineTo(a.x, a.y);
          }
          c.closePath();
          c.globalAlpha = A.fillOpacity;
          c.fill();
          c.globalAlpha = 1;
          c.beginPath();
          v && (C.closePath(), C.fill(), C.beginPath());
          n = [];
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = null,
          g = [],
          h = this.plotArea,
          l = [],
          n = [],
          k = [],
          r = [],
          q = 0,
          m,
          d,
          w,
          p = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          C = this._eventManager.ghostCtx,
          u,
          t,
          s;
        v && C.beginPath();
        c.save();
        v && C.save();
        c.beginPath();
        c.rect(h.x1, h.y1, h.width, h.height);
        c.clip();
        v && (C.beginPath(), C.rect(h.x1, h.y1, h.width, h.height), C.clip());
        for (var e = [], y = 0; y < a.dataSeriesIndexes.length; y++) {
          var x = a.dataSeriesIndexes[y],
            A = this.data[x],
            B = A.dataPoints;
          A.dataPointIndexes = [];
          for (q = 0; q < B.length; q++)
            (x = B[q].x.getTime ? B[q].x.getTime() : B[q].x),
              (A.dataPointIndexes[x] = q),
              e[x] || (k.push(x), (e[x] = !0));
          k.sort(Oa);
        }
        for (y = 0; y < a.dataSeriesIndexes.length; y++) {
          x = a.dataSeriesIndexes[y];
          A = this.data[x];
          B = A.dataPoints;
          t = !0;
          n = [];
          q = A.id;
          this._eventManager.objectMap[q] = {
            objectType: "dataSeries",
            dataSeriesIndex: x,
          };
          q = R(q);
          C.fillStyle = q;
          if (0 < k.length) {
            var e = A._colorSet[0],
              I = (A.lineColor = A.options.lineColor || e),
              M = I;
            c.fillStyle = e;
            c.strokeStyle = I;
            c.lineWidth = A.lineThickness;
            s = "solid";
            if (c.setLineDash) {
              var K = F(A.nullDataLineDashType, A.lineThickness);
              s = A.lineDashType;
              var ca = F(s, A.lineThickness);
              c.setLineDash(ca);
            }
            for (var ba = !0, q = 0; q < k.length; q++) {
              w = k[q];
              var Z = null,
                Z =
                  0 <= A.dataPointIndexes[w]
                    ? B[A.dataPointIndexes[w]]
                    : { x: w, y: null };
              if (
                !(
                  w < a.axisX.dataInfo.viewPortMin ||
                  (w > a.axisX.dataInfo.viewPortMax &&
                    (!A.connectNullData || !ba))
                )
              )
                if ("number" !== typeof Z.y)
                  A.connectNullData || ba || t || f(), (ba = !0);
                else {
                  m = a.axisX.convertValueToPixel(w);
                  var wa = l[w] ? l[w] : 0;
                  if (
                    a.axisY.logarithmic ||
                    (a.axisY.scaleBreaks &&
                      0 < a.axisY.scaleBreaks._appliedBreaks.length)
                  ) {
                    r[w] = Z.y + (r[w] ? r[w] : 0);
                    if (0 >= r[w] && a.axisY.logarithmic) continue;
                    d = a.axisY.convertValueToPixel(r[w]);
                  } else (d = a.axisY.convertValueToPixel(Z.y)), (d -= wa);
                  n.push({ x: m, y: p - wa });
                  l[w] = p - d;
                  t || ba
                    ? (!t && A.connectNullData
                        ? (c.setLineDash &&
                            (A.options.nullDataLineDashType ||
                              (s === A.lineDashType &&
                                A.lineDashType !== A.nullDataLineDashType)) &&
                            ((t = n.pop()),
                            (s = n[n.length - 1]),
                            f(),
                            c.moveTo(u.x, u.y),
                            n.push(s),
                            n.push(t),
                            (s = A.nullDataLineDashType),
                            c.setLineDash(K)),
                          c.lineTo(m, d),
                          v && C.lineTo(m, d))
                        : (c.beginPath(),
                          c.moveTo(m, d),
                          v && (C.beginPath(), C.moveTo(m, d))),
                      (ba = t = !1))
                    : (c.lineTo(m, d),
                      v && C.lineTo(m, d),
                      0 == q % 250 &&
                        (f(),
                        c.moveTo(m, d),
                        v && C.moveTo(m, d),
                        n.push({ x: m, y: p - wa })));
                  u = { x: m, y: d };
                  q < B.length - 1 &&
                    (M !== (B[q].lineColor || I) ||
                      s !== (B[q].lineDashType || A.lineDashType)) &&
                    (f(),
                    c.beginPath(),
                    c.moveTo(m, d),
                    n.push({ x: m, y: p - wa }),
                    (M = B[q].lineColor || I),
                    (c.strokeStyle = M),
                    c.setLineDash &&
                      (B[q].lineDashType
                        ? ((s = B[q].lineDashType),
                          c.setLineDash(F(s, A.lineThickness)))
                        : ((s = A.lineDashType), c.setLineDash(ca))));
                  if (0 <= A.dataPointIndexes[w]) {
                    var la = A.dataPointIds[A.dataPointIndexes[w]];
                    this._eventManager.objectMap[la] = {
                      id: la,
                      objectType: "dataPoint",
                      dataSeriesIndex: x,
                      dataPointIndex: A.dataPointIndexes[w],
                      x1: m,
                      y1: d,
                    };
                  }
                  0 <= A.dataPointIndexes[w] &&
                    0 !== Z.markerSize &&
                    (0 < Z.markerSize || 0 < A.markerSize) &&
                    ((w = A.getMarkerProperties(
                      A.dataPointIndexes[w],
                      m,
                      d,
                      c
                    )),
                    g.push(w),
                    (markerColor = R(la)),
                    v &&
                      g.push({
                        x: m,
                        y: d,
                        ctx: C,
                        type: w.type,
                        size: w.size,
                        color: markerColor,
                        borderColor: markerColor,
                        borderThickness: w.borderThickness,
                      }));
                  (Z.indexLabel ||
                    A.indexLabel ||
                    Z.indexLabelFormatter ||
                    A.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "stackedArea",
                      dataPoint: Z,
                      dataSeries: A,
                      point: { x: m, y: d },
                      direction: 0 > B[q].y === a.axisY.reversed ? 1 : -1,
                      color: e,
                    });
                }
            }
            f();
            c.moveTo(m, d);
            v && C.moveTo(m, d);
          }
          delete A.dataPointIndexes;
        }
        fa.drawMarkers(g);
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(h.x1, h.y1, h.width, h.height),
          C.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStackedArea100 = function (a) {
      function f() {
        for (0 < A.lineThickness && c.stroke(); 0 < n.length; ) {
          var a = n.pop();
          c.lineTo(a.x, a.y);
          v && y.lineTo(a.x, a.y);
        }
        c.closePath();
        c.globalAlpha = A.fillOpacity;
        c.fill();
        c.globalAlpha = 1;
        c.beginPath();
        v && (y.closePath(), y.fill(), y.beginPath());
        n = [];
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = null,
          g = this.plotArea,
          h = [],
          l = [],
          n = [],
          k = [],
          r = [],
          q = 0,
          m,
          d,
          w,
          p,
          t,
          u,
          s = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          y = this._eventManager.ghostCtx;
        c.save();
        v && y.save();
        c.beginPath();
        c.rect(g.x1, g.y1, g.width, g.height);
        c.clip();
        v && (y.beginPath(), y.rect(g.x1, g.y1, g.width, g.height), y.clip());
        for (var e = [], x = 0; x < a.dataSeriesIndexes.length; x++) {
          var B = a.dataSeriesIndexes[x],
            A = this.data[B],
            z = A.dataPoints;
          A.dataPointIndexes = [];
          for (q = 0; q < z.length; q++)
            (B = z[q].x.getTime ? z[q].x.getTime() : z[q].x),
              (A.dataPointIndexes[B] = q),
              e[B] || (k.push(B), (e[B] = !0));
          k.sort(Oa);
        }
        for (x = 0; x < a.dataSeriesIndexes.length; x++) {
          B = a.dataSeriesIndexes[x];
          A = this.data[B];
          z = A.dataPoints;
          t = !0;
          e = A.id;
          this._eventManager.objectMap[e] = {
            objectType: "dataSeries",
            dataSeriesIndex: B,
          };
          e = R(e);
          y.fillStyle = e;
          n = [];
          if (0 < k.length) {
            var e = A._colorSet[q % A._colorSet.length],
              I = (A.lineColor = A.options.lineColor || e),
              M = I;
            c.fillStyle = e;
            c.strokeStyle = I;
            c.lineWidth = A.lineThickness;
            u = "solid";
            if (c.setLineDash) {
              var K = F(A.nullDataLineDashType, A.lineThickness);
              u = A.lineDashType;
              var ca = F(u, A.lineThickness);
              c.setLineDash(ca);
            }
            for (var ba = !0, q = 0; q < k.length; q++) {
              w = k[q];
              var Z = null,
                Z =
                  0 <= A.dataPointIndexes[w]
                    ? z[A.dataPointIndexes[w]]
                    : { x: w, y: null };
              if (
                !(
                  w < a.axisX.dataInfo.viewPortMin ||
                  (w > a.axisX.dataInfo.viewPortMax &&
                    (!A.connectNullData || !ba))
                )
              )
                if ("number" !== typeof Z.y)
                  A.connectNullData || ba || t || f(), (ba = !0);
                else {
                  var wa;
                  wa =
                    0 !== a.dataPointYSums[w]
                      ? 100 * (Z.y / a.dataPointYSums[w])
                      : 0;
                  m = a.axisX.convertValueToPixel(w);
                  var la = l[w] ? l[w] : 0;
                  if (
                    a.axisY.logarithmic ||
                    (a.axisY.scaleBreaks &&
                      0 < a.axisY.scaleBreaks._appliedBreaks.length)
                  ) {
                    r[w] = wa + (r[w] ? r[w] : 0);
                    if (0 >= r[w] && a.axisY.logarithmic) continue;
                    d = a.axisY.convertValueToPixel(r[w]);
                  } else (d = a.axisY.convertValueToPixel(wa)), (d -= la);
                  n.push({ x: m, y: s - la });
                  l[w] = s - d;
                  t || ba
                    ? (!t && A.connectNullData
                        ? (c.setLineDash &&
                            (A.options.nullDataLineDashType ||
                              (u === A.lineDashType &&
                                A.lineDashType !== A.nullDataLineDashType)) &&
                            ((t = n.pop()),
                            (u = n[n.length - 1]),
                            f(),
                            c.moveTo(p.x, p.y),
                            n.push(u),
                            n.push(t),
                            (u = A.nullDataLineDashType),
                            c.setLineDash(K)),
                          c.lineTo(m, d),
                          v && y.lineTo(m, d))
                        : (c.beginPath(),
                          c.moveTo(m, d),
                          v && (y.beginPath(), y.moveTo(m, d))),
                      (ba = t = !1))
                    : (c.lineTo(m, d),
                      v && y.lineTo(m, d),
                      0 == q % 250 &&
                        (f(),
                        c.moveTo(m, d),
                        v && y.moveTo(m, d),
                        n.push({ x: m, y: s - la })));
                  p = { x: m, y: d };
                  q < z.length - 1 &&
                    (M !== (z[q].lineColor || I) ||
                      u !== (z[q].lineDashType || A.lineDashType)) &&
                    (f(),
                    c.beginPath(),
                    c.moveTo(m, d),
                    n.push({ x: m, y: s - la }),
                    (M = z[q].lineColor || I),
                    (c.strokeStyle = M),
                    c.setLineDash &&
                      (z[q].lineDashType
                        ? ((u = z[q].lineDashType),
                          c.setLineDash(F(u, A.lineThickness)))
                        : ((u = A.lineDashType), c.setLineDash(ca))));
                  if (0 <= A.dataPointIndexes[w]) {
                    var D = A.dataPointIds[A.dataPointIndexes[w]];
                    this._eventManager.objectMap[D] = {
                      id: D,
                      objectType: "dataPoint",
                      dataSeriesIndex: B,
                      dataPointIndex: A.dataPointIndexes[w],
                      x1: m,
                      y1: d,
                    };
                  }
                  0 <= A.dataPointIndexes[w] &&
                    0 !== Z.markerSize &&
                    (0 < Z.markerSize || 0 < A.markerSize) &&
                    ((w = A.getMarkerProperties(q, m, d, c)),
                    h.push(w),
                    (markerColor = R(D)),
                    v &&
                      h.push({
                        x: m,
                        y: d,
                        ctx: y,
                        type: w.type,
                        size: w.size,
                        color: markerColor,
                        borderColor: markerColor,
                        borderThickness: w.borderThickness,
                      }));
                  (Z.indexLabel ||
                    A.indexLabel ||
                    Z.indexLabelFormatter ||
                    A.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "stackedArea100",
                      dataPoint: Z,
                      dataSeries: A,
                      point: { x: m, y: d },
                      direction: 0 > z[q].y === a.axisY.reversed ? 1 : -1,
                      color: e,
                    });
                }
            }
            f();
            c.moveTo(m, d);
            v && y.moveTo(m, d);
          }
          delete A.dataPointIndexes;
        }
        fa.drawMarkers(h);
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(g.x1, g.y1, g.width, g.height),
          y.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderBubble = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this.plotArea,
          e = 0,
          g,
          h;
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(c.x1, c.y1, c.width, c.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.clip());
        for (
          var l = -Infinity, n = Infinity, k = 0;
          k < a.dataSeriesIndexes.length;
          k++
        )
          for (
            var r = a.dataSeriesIndexes[k],
              q = this.data[r],
              m = q.dataPoints,
              d = 0,
              e = 0;
            e < m.length;
            e++
          )
            (g = m[e].getTime ? (g = m[e].x.getTime()) : (g = m[e].x)),
              g < a.axisX.dataInfo.viewPortMin ||
                g > a.axisX.dataInfo.viewPortMax ||
                "undefined" === typeof m[e].z ||
                ((d = m[e].z), d > l && (l = d), d < n && (n = d));
        for (
          var w = 25 * Math.PI,
            p = Math.max(
              Math.pow((0.25 * Math.min(c.height, c.width)) / 2, 2) * Math.PI,
              w
            ),
            k = 0;
          k < a.dataSeriesIndexes.length;
          k++
        )
          if (
            ((r = a.dataSeriesIndexes[k]),
            (q = this.data[r]),
            (m = q.dataPoints),
            0 < m.length)
          )
            for (b.strokeStyle = "#4572A7 ", e = 0; e < m.length; e++)
              if (
                ((g = m[e].getTime ? (g = m[e].x.getTime()) : (g = m[e].x)),
                !(
                  g < a.axisX.dataInfo.viewPortMin ||
                  g > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof m[e].y)
              ) {
                g = a.axisX.convertValueToPixel(g);
                h = a.axisY.convertValueToPixel(m[e].y);
                var d = m[e].z,
                  t =
                    2 *
                    Math.max(
                      Math.sqrt(
                        (l === n ? p / 2 : w + ((p - w) / (l - n)) * (d - n)) /
                          Math.PI
                      ) << 0,
                      1
                    ),
                  d = q.getMarkerProperties(e, b);
                d.size = t;
                b.globalAlpha = q.fillOpacity;
                fa.drawMarker(
                  g,
                  h,
                  b,
                  d.type,
                  d.size,
                  d.color,
                  d.borderColor,
                  d.borderThickness
                );
                b.globalAlpha = 1;
                var u = q.dataPointIds[e];
                this._eventManager.objectMap[u] = {
                  id: u,
                  objectType: "dataPoint",
                  dataSeriesIndex: r,
                  dataPointIndex: e,
                  x1: g,
                  y1: h,
                  size: t,
                };
                t = R(u);
                v &&
                  fa.drawMarker(
                    g,
                    h,
                    this._eventManager.ghostCtx,
                    d.type,
                    d.size,
                    t,
                    t,
                    d.borderThickness
                  );
                (m[e].indexLabel ||
                  q.indexLabel ||
                  m[e].indexLabelFormatter ||
                  q.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "bubble",
                    dataPoint: m[e],
                    dataSeries: q,
                    point: { x: g, y: h },
                    direction: 1,
                    bounds: {
                      x1: g - d.size / 2,
                      y1: h - d.size / 2,
                      x2: g + d.size / 2,
                      y2: h + d.size / 2,
                    },
                    color: null,
                  });
              }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderScatter = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this.plotArea,
          e = 0,
          g,
          h;
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(c.x1, c.y1, c.width, c.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.clip());
        for (var l = 0; l < a.dataSeriesIndexes.length; l++) {
          var n = a.dataSeriesIndexes[l],
            k = this.data[n],
            r = k.dataPoints;
          if (0 < r.length) {
            b.strokeStyle = "#4572A7 ";
            Math.pow((0.3 * Math.min(c.height, c.width)) / 2, 2);
            for (var q = 0, m = 0, e = 0; e < r.length; e++)
              if (
                ((g = r[e].getTime ? (g = r[e].x.getTime()) : (g = r[e].x)),
                !(
                  g < a.axisX.dataInfo.viewPortMin ||
                  g > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof r[e].y)
              ) {
                g = a.axisX.convertValueToPixel(g);
                h = a.axisY.convertValueToPixel(r[e].y);
                var d = k.getMarkerProperties(e, g, h, b);
                b.globalAlpha = k.fillOpacity;
                fa.drawMarker(
                  d.x,
                  d.y,
                  d.ctx,
                  d.type,
                  d.size,
                  d.color,
                  d.borderColor,
                  d.borderThickness
                );
                b.globalAlpha = 1;
                (Math.sqrt((q - g) * (q - g) + (m - h) * (m - h)) <
                  Math.min(d.size, 5) &&
                  r.length >
                    Math.min(this.plotArea.width, this.plotArea.height)) ||
                  ((q = k.dataPointIds[e]),
                  (this._eventManager.objectMap[q] = {
                    id: q,
                    objectType: "dataPoint",
                    dataSeriesIndex: n,
                    dataPointIndex: e,
                    x1: g,
                    y1: h,
                  }),
                  (q = R(q)),
                  v &&
                    fa.drawMarker(
                      d.x,
                      d.y,
                      this._eventManager.ghostCtx,
                      d.type,
                      d.size,
                      q,
                      q,
                      d.borderThickness
                    ),
                  (r[e].indexLabel ||
                    k.indexLabel ||
                    r[e].indexLabelFormatter ||
                    k.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "scatter",
                      dataPoint: r[e],
                      dataSeries: k,
                      point: { x: g, y: h },
                      direction: 1,
                      bounds: {
                        x1: g - d.size / 2,
                        y1: h - d.size / 2,
                        x2: g + d.size / 2,
                        y2: h + d.size / 2,
                      },
                      color: null,
                    }),
                  (q = g),
                  (m = h));
              }
          }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderCandlestick = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f,
        c = this._eventManager.ghostCtx;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = null,
          g = null,
          h = this.plotArea,
          l = 0,
          n,
          k,
          r,
          q,
          m,
          d,
          e = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1,
          g = this.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 0.015 * this.width,
          w = a.axisX.dataInfo.minDiff;
        isFinite(w) || (w = 0.3 * Math.abs(a.axisX.range));
        w = this.dataPointWidth
          ? this.dataPointWidth
          : (0.7 *
              h.width *
              (a.axisX.logarithmic
                ? Math.log(w) / Math.log(a.axisX.range)
                : Math.abs(w) / Math.abs(a.axisX.range))) <<
            0;
        this.dataPointMaxWidth &&
          e > g &&
          (e = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            g
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          g < e &&
          (g = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            e
          ));
        w < e && (w = e);
        w > g && (w = g);
        b.save();
        v && c.save();
        b.beginPath();
        b.rect(h.x1, h.y1, h.width, h.height);
        b.clip();
        v && (c.beginPath(), c.rect(h.x1, h.y1, h.width, h.height), c.clip());
        for (var p = 0; p < a.dataSeriesIndexes.length; p++) {
          var t = a.dataSeriesIndexes[p],
            u = this.data[t],
            s = u.dataPoints;
          if (0 < s.length)
            for (
              var G = 5 < w && u.bevelEnabled ? !0 : !1, l = 0;
              l < s.length;
              l++
            )
              if (
                (s[l].getTime ? (d = s[l].x.getTime()) : (d = s[l].x),
                !(
                  d < a.axisX.dataInfo.viewPortMin ||
                  d > a.axisX.dataInfo.viewPortMax
                ) &&
                  !y(s[l].y) &&
                  s[l].y.length &&
                  "number" === typeof s[l].y[0] &&
                  "number" === typeof s[l].y[1] &&
                  "number" === typeof s[l].y[2] &&
                  "number" === typeof s[l].y[3])
              ) {
                n = a.axisX.convertValueToPixel(d);
                k = a.axisY.convertValueToPixel(s[l].y[0]);
                r = a.axisY.convertValueToPixel(s[l].y[1]);
                q = a.axisY.convertValueToPixel(s[l].y[2]);
                m = a.axisY.convertValueToPixel(s[l].y[3]);
                var x = (n - w / 2) << 0,
                  B = (x + w) << 0,
                  g = u.options.fallingColor ? u.fallingColor : u._colorSet[0],
                  e = s[l].color ? s[l].color : u._colorSet[0],
                  A = Math.round(Math.max(1, 0.15 * w)),
                  z = 0 === A % 2 ? 0 : 0.5,
                  I = u.dataPointIds[l];
                this._eventManager.objectMap[I] = {
                  id: I,
                  objectType: "dataPoint",
                  dataSeriesIndex: t,
                  dataPointIndex: l,
                  x1: x,
                  y1: k,
                  x2: B,
                  y2: r,
                  x3: n,
                  y3: q,
                  x4: n,
                  y4: m,
                  borderThickness: A,
                  color: e,
                };
                b.strokeStyle = e;
                b.beginPath();
                b.lineWidth = A;
                c.lineWidth = Math.max(A, 4);
                "candlestick" === u.type
                  ? (b.moveTo(n - z, r),
                    b.lineTo(n - z, Math.min(k, m)),
                    b.stroke(),
                    b.moveTo(n - z, Math.max(k, m)),
                    b.lineTo(n - z, q),
                    b.stroke(),
                    W(
                      b,
                      x,
                      Math.min(k, m),
                      B,
                      Math.max(k, m),
                      s[l].y[0] <= s[l].y[3] ? u.risingColor : g,
                      A,
                      e,
                      G,
                      G,
                      !1,
                      !1,
                      u.fillOpacity
                    ),
                    v &&
                      ((e = R(I)),
                      (c.strokeStyle = e),
                      c.moveTo(n - z, r),
                      c.lineTo(n - z, Math.min(k, m)),
                      c.stroke(),
                      c.moveTo(n - z, Math.max(k, m)),
                      c.lineTo(n - z, q),
                      c.stroke(),
                      W(
                        c,
                        x,
                        Math.min(k, m),
                        B,
                        Math.max(k, m),
                        e,
                        0,
                        null,
                        !1,
                        !1,
                        !1,
                        !1
                      )))
                  : "ohlc" === u.type &&
                    (b.moveTo(n - z, r),
                    b.lineTo(n - z, q),
                    b.stroke(),
                    b.beginPath(),
                    b.moveTo(n, k),
                    b.lineTo(x, k),
                    b.stroke(),
                    b.beginPath(),
                    b.moveTo(n, m),
                    b.lineTo(B, m),
                    b.stroke(),
                    v &&
                      ((e = R(I)),
                      (c.strokeStyle = e),
                      c.moveTo(n - z, r),
                      c.lineTo(n - z, q),
                      c.stroke(),
                      c.beginPath(),
                      c.moveTo(n, k),
                      c.lineTo(x, k),
                      c.stroke(),
                      c.beginPath(),
                      c.moveTo(n, m),
                      c.lineTo(B, m),
                      c.stroke()));
                (s[l].indexLabel ||
                  u.indexLabel ||
                  s[l].indexLabelFormatter ||
                  u.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: u.type,
                    dataPoint: s[l],
                    dataSeries: u,
                    point: { x: x + (B - x) / 2, y: a.axisY.reversed ? q : r },
                    direction: 1,
                    bounds: {
                      x1: x,
                      y1: Math.min(r, q),
                      x2: B,
                      y2: Math.max(r, q),
                    },
                    color: e,
                  });
              }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(h.x1, h.y1, h.width, h.height),
          c.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderBoxAndWhisker = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f,
        c = this._eventManager.ghostCtx;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = null,
          g = this.plotArea,
          h = 0,
          l,
          n,
          k,
          r,
          q,
          m,
          d,
          e = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1,
          h = this.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 0.015 * this.width,
          w = a.axisX.dataInfo.minDiff;
        isFinite(w) || (w = 0.3 * Math.abs(a.axisX.range));
        w = this.dataPointWidth
          ? this.dataPointWidth
          : (0.7 *
              g.width *
              (a.axisX.logarithmic
                ? Math.log(w) / Math.log(a.axisX.range)
                : Math.abs(w) / Math.abs(a.axisX.range))) <<
            0;
        this.dataPointMaxWidth &&
          e > h &&
          (e = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            h
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          h < e &&
          (h = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            e
          ));
        w < e && (w = e);
        w > h && (w = h);
        b.save();
        v && c.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v && (c.beginPath(), c.rect(g.x1, g.y1, g.width, g.height), c.clip());
        for (
          var p = !1, p = !!a.axisY.reversed, t = 0;
          t < a.dataSeriesIndexes.length;
          t++
        ) {
          var u = a.dataSeriesIndexes[t],
            s = this.data[u],
            G = s.dataPoints;
          if (0 < G.length)
            for (
              var x = 5 < w && s.bevelEnabled ? !0 : !1, h = 0;
              h < G.length;
              h++
            )
              if (
                (G[h].getTime ? (d = G[h].x.getTime()) : (d = G[h].x),
                !(
                  d < a.axisX.dataInfo.viewPortMin ||
                  d > a.axisX.dataInfo.viewPortMax
                ) &&
                  !y(G[h].y) &&
                  G[h].y.length &&
                  "number" === typeof G[h].y[0] &&
                  "number" === typeof G[h].y[1] &&
                  "number" === typeof G[h].y[2] &&
                  "number" === typeof G[h].y[3] &&
                  "number" === typeof G[h].y[4] &&
                  5 === G[h].y.length)
              ) {
                l = a.axisX.convertValueToPixel(d);
                n = a.axisY.convertValueToPixel(G[h].y[0]);
                k = a.axisY.convertValueToPixel(G[h].y[1]);
                r = a.axisY.convertValueToPixel(G[h].y[2]);
                q = a.axisY.convertValueToPixel(G[h].y[3]);
                m = a.axisY.convertValueToPixel(G[h].y[4]);
                var B = (l - w / 2) << 0,
                  A = (l + w / 2) << 0,
                  e = G[h].color ? G[h].color : s._colorSet[0],
                  z = Math.round(Math.max(1, 0.15 * w)),
                  I = 0 === z % 2 ? 0 : 0.5,
                  M = G[h].whiskerColor
                    ? G[h].whiskerColor
                    : G[h].color
                    ? s.whiskerColor
                      ? s.whiskerColor
                      : G[h].color
                    : s.whiskerColor
                    ? s.whiskerColor
                    : e,
                  K =
                    "number" === typeof G[h].whiskerThickness
                      ? G[h].whiskerThickness
                      : "number" === typeof s.options.whiskerThickness
                      ? s.whiskerThickness
                      : z,
                  ca = G[h].whiskerDashType
                    ? G[h].whiskerDashType
                    : s.whiskerDashType,
                  ba = y(G[h].whiskerLength)
                    ? y(s.options.whiskerLength)
                      ? w
                      : s.whiskerLength
                    : G[h].whiskerLength,
                  ba =
                    "number" === typeof ba
                      ? 0 >= ba
                        ? 0
                        : ba >= w
                        ? w
                        : ba
                      : "string" === typeof ba
                      ? (parseInt(ba) * w) / 100 > w
                        ? w
                        : (parseInt(ba) * w) / 100
                      : w,
                  Z = 1 === Math.round(K) % 2 ? 0.5 : 0,
                  wa = G[h].stemColor
                    ? G[h].stemColor
                    : G[h].color
                    ? s.stemColor
                      ? s.stemColor
                      : G[h].color
                    : s.stemColor
                    ? s.stemColor
                    : e,
                  la =
                    "number" === typeof G[h].stemThickness
                      ? G[h].stemThickness
                      : "number" === typeof s.options.stemThickness
                      ? s.stemThickness
                      : z,
                  D = 1 === Math.round(la) % 2 ? 0.5 : 0,
                  db = G[h].stemDashType ? G[h].stemDashType : s.stemDashType,
                  Q = G[h].lineColor
                    ? G[h].lineColor
                    : G[h].color
                    ? s.lineColor
                      ? s.lineColor
                      : G[h].color
                    : s.lineColor
                    ? s.lineColor
                    : e,
                  J =
                    "number" === typeof G[h].lineThickness
                      ? G[h].lineThickness
                      : "number" === typeof s.options.lineThickness
                      ? s.lineThickness
                      : z,
                  S = G[h].lineDashType ? G[h].lineDashType : s.lineDashType,
                  N = 1 === Math.round(J) % 2 ? 0.5 : 0,
                  P = s.upperBoxColor,
                  U = s.lowerBoxColor,
                  qa = y(s.options.fillOpacity) ? 1 : s.fillOpacity,
                  O = s.dataPointIds[h];
                this._eventManager.objectMap[O] = {
                  id: O,
                  objectType: "dataPoint",
                  dataSeriesIndex: u,
                  dataPointIndex: h,
                  x1: B,
                  y1: n,
                  x2: A,
                  y2: k,
                  x3: l,
                  y3: r,
                  x4: l,
                  y4: q,
                  y5: m,
                  borderThickness: z,
                  color: e,
                  stemThickness: la,
                  stemColor: wa,
                  whiskerThickness: K,
                  whiskerLength: ba,
                  whiskerColor: M,
                  lineThickness: J,
                  lineColor: Q,
                };
                b.save();
                0 < la &&
                  (b.beginPath(),
                  (b.strokeStyle = wa),
                  (b.lineWidth = la),
                  b.setLineDash && b.setLineDash(F(db, la)),
                  b.moveTo(l - D, k),
                  b.lineTo(l - D, n),
                  b.stroke(),
                  b.moveTo(l - D, q),
                  b.lineTo(l - D, r),
                  b.stroke());
                b.restore();
                c.lineWidth = Math.max(z, 4);
                b.beginPath();
                W(
                  b,
                  B,
                  Math.min(m, k),
                  A,
                  Math.max(k, m),
                  U,
                  0,
                  e,
                  p ? x : !1,
                  p ? !1 : x,
                  !1,
                  !1,
                  qa
                );
                b.beginPath();
                W(
                  b,
                  B,
                  Math.min(r, m),
                  A,
                  Math.max(m, r),
                  P,
                  0,
                  e,
                  p ? !1 : x,
                  p ? x : !1,
                  !1,
                  !1,
                  qa
                );
                b.beginPath();
                b.lineWidth = z;
                b.strokeStyle = e;
                b.rect(
                  B - I,
                  Math.min(k, r) - I,
                  A - B + 2 * I,
                  Math.max(k, r) - Math.min(k, r) + 2 * I
                );
                b.stroke();
                b.save();
                0 < J &&
                  (b.beginPath(),
                  (b.globalAlpha = 1),
                  b.setLineDash && b.setLineDash(F(S, J)),
                  (b.strokeStyle = Q),
                  (b.lineWidth = J),
                  b.moveTo(B, m - N),
                  b.lineTo(A, m - N),
                  b.stroke());
                b.restore();
                b.save();
                0 < K &&
                  (b.beginPath(),
                  b.setLineDash && b.setLineDash(F(ca, K)),
                  (b.strokeStyle = M),
                  (b.lineWidth = K),
                  b.moveTo((l - ba / 2) << 0, q - Z),
                  b.lineTo((l + ba / 2) << 0, q - Z),
                  b.stroke(),
                  b.moveTo((l - ba / 2) << 0, n + Z),
                  b.lineTo((l + ba / 2) << 0, n + Z),
                  b.stroke());
                b.restore();
                v &&
                  ((e = R(O)),
                  (c.strokeStyle = e),
                  (c.lineWidth = la),
                  0 < la &&
                    (c.moveTo(l - I - D, k),
                    c.lineTo(l - I - D, Math.max(n, q)),
                    c.stroke(),
                    c.moveTo(l - I - D, Math.min(n, q)),
                    c.lineTo(l - I - D, r),
                    c.stroke()),
                  W(
                    c,
                    B,
                    Math.max(k, r),
                    A,
                    Math.min(k, r),
                    e,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  ),
                  0 < K &&
                    (c.beginPath(),
                    (c.lineWidth = K),
                    c.moveTo(l + ba / 2, q - Z),
                    c.lineTo(l - ba / 2, q - Z),
                    c.stroke(),
                    c.moveTo(l + ba / 2, n + Z),
                    c.lineTo(l - ba / 2, n + Z),
                    c.stroke()));
                (G[h].indexLabel ||
                  s.indexLabel ||
                  G[h].indexLabelFormatter ||
                  s.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: s.type,
                    dataPoint: G[h],
                    dataSeries: s,
                    point: { x: B + (A - B) / 2, y: a.axisY.reversed ? n : q },
                    direction: 1,
                    bounds: {
                      x1: B,
                      y1: Math.min(n, q),
                      x2: A,
                      y2: Math.max(n, q),
                    },
                    color: e,
                  });
              }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          c.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeColumn = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = 0,
          h,
          l,
          n,
          g = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
        h = this.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.dataPointWidth
          ? this.dataPointWidth
          : 0.03 * this.width;
        var k = a.axisX.dataInfo.minDiff;
        isFinite(k) || (k = 0.3 * Math.abs(a.axisX.range));
        k = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.width *
                (a.axisX.logarithmic
                  ? Math.log(k) / Math.log(a.axisX.range)
                  : Math.abs(k) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          g > h &&
          (g = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            h
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          h < g &&
          (h = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            g
          ));
        k < g && (k = g);
        k > h && (k = h);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (var r = 0; r < a.dataSeriesIndexes.length; r++) {
          var q = a.dataSeriesIndexes[r],
            m = this.data[q],
            d = m.dataPoints;
          if (0 < d.length)
            for (
              var w = 5 < k && m.bevelEnabled ? !0 : !1, g = 0;
              g < d.length;
              g++
            )
              if (
                (d[g].getTime ? (n = d[g].x.getTime()) : (n = d[g].x),
                !(
                  n < a.axisX.dataInfo.viewPortMin ||
                  n > a.axisX.dataInfo.viewPortMax
                ) &&
                  !y(d[g].y) &&
                  d[g].y.length &&
                  "number" === typeof d[g].y[0] &&
                  "number" === typeof d[g].y[1])
              ) {
                c = a.axisX.convertValueToPixel(n);
                h = a.axisY.convertValueToPixel(d[g].y[0]);
                l = a.axisY.convertValueToPixel(d[g].y[1]);
                var p = a.axisX.reversed
                    ? (c +
                        (a.plotType.totalDataSeries * k) / 2 -
                        (a.previousDataSeriesCount + r) * k) <<
                      0
                    : (c -
                        (a.plotType.totalDataSeries * k) / 2 +
                        (a.previousDataSeriesCount + r) * k) <<
                      0,
                  s = a.axisX.reversed ? (p - k) << 0 : (p + k) << 0,
                  c = d[g].color
                    ? d[g].color
                    : m._colorSet[g % m._colorSet.length];
                if (h > l) {
                  var u = h;
                  h = l;
                  l = u;
                }
                u = m.dataPointIds[g];
                this._eventManager.objectMap[u] = {
                  id: u,
                  objectType: "dataPoint",
                  dataSeriesIndex: q,
                  dataPointIndex: g,
                  x1: p,
                  y1: h,
                  x2: s,
                  y2: l,
                };
                W(b, p, h, s, l, c, 0, c, w, w, !1, !1, m.fillOpacity);
                c = R(u);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    p,
                    h,
                    s,
                    l,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                if (
                  d[g].indexLabel ||
                  m.indexLabel ||
                  d[g].indexLabelFormatter ||
                  m.indexLabelFormatter
                )
                  this._indexLabels.push({
                    chartType: "rangeColumn",
                    dataPoint: d[g],
                    dataSeries: m,
                    indexKeyword: 0,
                    point: {
                      x: p + (s - p) / 2,
                      y: d[g].y[1] >= d[g].y[0] ? l : h,
                    },
                    direction: d[g].y[1] >= d[g].y[0] ? -1 : 1,
                    bounds: {
                      x1: p,
                      y1: Math.min(h, l),
                      x2: s,
                      y2: Math.max(h, l),
                    },
                    color: c,
                  }),
                    this._indexLabels.push({
                      chartType: "rangeColumn",
                      dataPoint: d[g],
                      dataSeries: m,
                      indexKeyword: 1,
                      point: {
                        x: p + (s - p) / 2,
                        y: d[g].y[1] >= d[g].y[0] ? h : l,
                      },
                      direction: d[g].y[1] >= d[g].y[0] ? 1 : -1,
                      bounds: {
                        x1: p,
                        y1: Math.min(h, l),
                        x2: s,
                        y2: Math.max(h, l),
                      },
                      color: c,
                    });
              }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderError = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f,
        c = a.axisY._position
          ? "left" === a.axisY._position || "right" === a.axisY._position
            ? !1
            : !0
          : !1;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = null,
          g = !1,
          h = this.plotArea,
          l = 0,
          n,
          k,
          r,
          q,
          m,
          d,
          w,
          p = a.axisX.dataInfo.minDiff;
        isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(h.x1, h.y1, h.width, h.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(h.x1, h.y1, h.width, h.height),
          this._eventManager.ghostCtx.clip());
        for (var s = 0, u = 0; u < this.data.length; u++)
          !this.data[u].type.match(/(bar|column)/gi) ||
            !this.data[u].visible ||
            (this.data[u].type.match(/(stacked)/gi) && s) ||
            s++;
        for (var t = 0; t < a.dataSeriesIndexes.length; t++) {
          var G = a.dataSeriesIndexes[t],
            x = this.data[G],
            z = x.dataPoints,
            A = y(x._linkedSeries)
              ? !1
              : x._linkedSeries.type.match(/(bar|column)/gi) &&
                x._linkedSeries.visible
              ? !0
              : !1,
            F = 0;
          if (A)
            for (e = x._linkedSeries.id, u = 0; u < e; u++)
              !this.data[u].type.match(/(bar|column)/gi) ||
                !this.data[u].visible ||
                (this.data[u].type.match(/(stacked)/gi) && F) ||
                (this.data[u].type.match(/(range)/gi) && (g = !0), F++);
          e = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
          l = this.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : c
            ? Math.min(
                0.15 * this.height,
                0.9 * (this.plotArea.height / (A ? s : 1))
              ) << 0
            : 0.3 * this.width;
          g &&
            (l = this.dataPointMaxWidth
              ? this.dataPointMaxWidth
              : this.dataPointWidth
              ? this.dataPointWidth
              : c
              ? Math.min(
                  0.15 * this.height,
                  0.9 * (this.plotArea.height / (A ? s : 1))
                ) << 0
              : 0.03 * this.width);
          u = this.options.dataPointWidth
            ? this.dataPointWidth
            : (0.9 *
                (((c ? h.height : h.width) *
                  (a.axisX.logarithmic
                    ? Math.log(p) / Math.log(a.axisX.range)
                    : Math.abs(p) / Math.abs(a.axisX.range))) /
                  (A ? s : 1))) <<
              0;
          this.dataPointMaxWidth &&
            e > l &&
            (e = Math.min(
              this.dataPointWidth ? this.dataPointWidth : Infinity,
              l
            ));
          !this.dataPointMaxWidth &&
            this.dataPointMinWidth &&
            l < e &&
            (l = Math.max(
              this.dataPointWidth ? this.dataPointWidth : -Infinity,
              e
            ));
          u < e && (u = e);
          u > l && (u = l);
          if (0 < z.length)
            for (var I = x._colorSet, l = 0; l < z.length; l++) {
              var e = (x.lineColor = x.options.color ? x.options.color : I[0]),
                M = {
                  color: z[l].whiskerColor
                    ? z[l].whiskerColor
                    : z[l].color
                    ? x.whiskerColor
                      ? x.whiskerColor
                      : z[l].color
                    : x.whiskerColor
                    ? x.whiskerColor
                    : e,
                  thickness: y(z[l].whiskerThickness)
                    ? x.whiskerThickness
                    : z[l].whiskerThickness,
                  dashType: z[l].whiskerDashType
                    ? z[l].whiskerDashType
                    : x.whiskerDashType,
                  length: y(z[l].whiskerLength)
                    ? y(x.options.whiskerLength)
                      ? u
                      : x.options.whiskerLength
                    : z[l].whiskerLength,
                  trimLength: y(z[l].whiskerLength)
                    ? y(x.options.whiskerLength)
                      ? 50
                      : 0
                    : 0,
                };
              M.length =
                "number" === typeof M.length
                  ? 0 >= M.length
                    ? 0
                    : M.length >= u
                    ? u
                    : M.length
                  : "string" === typeof M.length
                  ? (parseInt(M.length) * u) / 100 > u
                    ? u
                    : (parseInt(M.length) * u) / 100 > u
                  : u;
              M.thickness =
                "number" === typeof M.thickness
                  ? 0 > M.thickness
                    ? 0
                    : Math.round(M.thickness)
                  : 2;
              var K = {
                color: z[l].stemColor
                  ? z[l].stemColor
                  : z[l].color
                  ? x.stemColor
                    ? x.stemColor
                    : z[l].color
                  : x.stemColor
                  ? x.stemColor
                  : e,
                thickness: z[l].stemThickness
                  ? z[l].stemThickness
                  : x.stemThickness,
                dashType: z[l].stemDashType
                  ? z[l].stemDashType
                  : x.stemDashType,
              };
              K.thickness =
                "number" === typeof K.thickness
                  ? 0 > K.thickness
                    ? 0
                    : Math.round(K.thickness)
                  : 2;
              z[l].getTime ? (w = z[l].x.getTime()) : (w = z[l].x);
              if (
                !(
                  w < a.axisX.dataInfo.viewPortMin ||
                  w > a.axisX.dataInfo.viewPortMax
                ) &&
                !y(z[l].y) &&
                z[l].y.length &&
                "number" === typeof z[l].y[0] &&
                "number" === typeof z[l].y[1]
              ) {
                var ca = a.axisX.convertValueToPixel(w);
                c ? (k = ca) : (n = ca);
                ca = a.axisY.convertValueToPixel(z[l].y[0]);
                c ? (r = ca) : (m = ca);
                ca = a.axisY.convertValueToPixel(z[l].y[1]);
                c ? (q = ca) : (d = ca);
                c
                  ? ((m = a.axisX.reversed
                      ? (k + ((A ? s : 1) * u) / 2 - (A ? F - 1 : 0) * u) << 0
                      : (k - ((A ? s : 1) * u) / 2 + (A ? F - 1 : 0) * u) << 0),
                    (d = a.axisX.reversed ? (m - u) << 0 : (m + u) << 0))
                  : ((r = a.axisX.reversed
                      ? (n + ((A ? s : 1) * u) / 2 - (A ? F - 1 : 0) * u) << 0
                      : (n - ((A ? s : 1) * u) / 2 + (A ? F - 1 : 0) * u) << 0),
                    (q = a.axisX.reversed ? (r - u) << 0 : (r + u) << 0));
                !c && m > d && ((ca = m), (m = d), (d = ca));
                c && r > q && ((ca = r), (r = q), (q = ca));
                ca = x.dataPointIds[l];
                this._eventManager.objectMap[ca] = {
                  id: ca,
                  objectType: "dataPoint",
                  dataSeriesIndex: G,
                  dataPointIndex: l,
                  x1: Math.min(r, q),
                  y1: Math.min(m, d),
                  x2: Math.max(q, r),
                  y2: Math.max(d, m),
                  isXYSwapped: c,
                  stemProperties: K,
                  whiskerProperties: M,
                };
                B(
                  b,
                  Math.min(r, q),
                  Math.min(m, d),
                  Math.max(q, r),
                  Math.max(d, m),
                  e,
                  M,
                  K,
                  c
                );
                v && B(this._eventManager.ghostCtx, r, m, q, d, e, M, K, c);
                if (
                  z[l].indexLabel ||
                  x.indexLabel ||
                  z[l].indexLabelFormatter ||
                  x.indexLabelFormatter
                )
                  this._indexLabels.push({
                    chartType: "error",
                    dataPoint: z[l],
                    dataSeries: x,
                    indexKeyword: 0,
                    point: {
                      x: c ? (z[l].y[1] >= z[l].y[0] ? r : q) : r + (q - r) / 2,
                      y: c ? m + (d - m) / 2 : z[l].y[1] >= z[l].y[0] ? d : m,
                    },
                    direction: z[l].y[1] >= z[l].y[0] ? -1 : 1,
                    bounds: {
                      x1: c ? Math.min(r, q) : r,
                      y1: c ? m : Math.min(m, d),
                      x2: c ? Math.max(r, q) : q,
                      y2: c ? d : Math.max(m, d),
                    },
                    color: e,
                    axisSwapped: c,
                  }),
                    this._indexLabels.push({
                      chartType: "error",
                      dataPoint: z[l],
                      dataSeries: x,
                      indexKeyword: 1,
                      point: {
                        x: c
                          ? z[l].y[1] >= z[l].y[0]
                            ? q
                            : r
                          : r + (q - r) / 2,
                        y: c ? m + (d - m) / 2 : z[l].y[1] >= z[l].y[0] ? m : d,
                      },
                      direction: z[l].y[1] >= z[l].y[0] ? 1 : -1,
                      bounds: {
                        x1: c ? Math.min(r, q) : r,
                        y1: c ? m : Math.min(m, d),
                        x2: c ? Math.max(r, q) : q,
                        y2: c ? d : Math.max(m, d),
                      },
                      color: e,
                      axisSwapped: c,
                    });
              }
            }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(h.x1, h.y1, h.width, h.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeBar = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          e = this.plotArea,
          g = 0,
          h,
          l,
          n,
          k,
          g = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
        h = this.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.dataPointWidth
          ? this.dataPointWidth
          : Math.min(
              0.15 * this.height,
              0.9 * (this.plotArea.height / a.plotType.totalDataSeries)
            ) << 0;
        var r = a.axisX.dataInfo.minDiff;
        isFinite(r) || (r = 0.3 * Math.abs(a.axisX.range));
        r = this.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((e.height *
                (a.axisX.logarithmic
                  ? Math.log(r) / Math.log(a.axisX.range)
                  : Math.abs(r) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          g > h &&
          (g = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            h
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          h < g &&
          (h = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            g
          ));
        r < g && (r = g);
        r > h && (r = h);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(e.x1, e.y1, e.width, e.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.clip());
        for (var q = 0; q < a.dataSeriesIndexes.length; q++) {
          var m = a.dataSeriesIndexes[q],
            d = this.data[m],
            w = d.dataPoints;
          if (0 < w.length) {
            var p = 5 < r && d.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (g = 0; g < w.length; g++)
              if (
                (w[g].getTime ? (k = w[g].x.getTime()) : (k = w[g].x),
                !(
                  k < a.axisX.dataInfo.viewPortMin ||
                  k > a.axisX.dataInfo.viewPortMax
                ) &&
                  !y(w[g].y) &&
                  w[g].y.length &&
                  "number" === typeof w[g].y[0] &&
                  "number" === typeof w[g].y[1])
              ) {
                h = a.axisY.convertValueToPixel(w[g].y[0]);
                l = a.axisY.convertValueToPixel(w[g].y[1]);
                n = a.axisX.convertValueToPixel(k);
                n = a.axisX.reversed
                  ? (n +
                      (a.plotType.totalDataSeries * r) / 2 -
                      (a.previousDataSeriesCount + q) * r) <<
                    0
                  : (n -
                      (a.plotType.totalDataSeries * r) / 2 +
                      (a.previousDataSeriesCount + q) * r) <<
                    0;
                var s = a.axisX.reversed ? (n - r) << 0 : (n + r) << 0;
                h > l && ((c = h), (h = l), (l = c));
                c = w[g].color
                  ? w[g].color
                  : d._colorSet[g % d._colorSet.length];
                W(b, h, n, l, s, c, 0, null, p, !1, !1, !1, d.fillOpacity);
                c = d.dataPointIds[g];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: m,
                  dataPointIndex: g,
                  x1: h,
                  y1: n,
                  x2: l,
                  y2: s,
                };
                c = R(c);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    h,
                    n,
                    l,
                    s,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                if (
                  w[g].indexLabel ||
                  d.indexLabel ||
                  w[g].indexLabelFormatter ||
                  d.indexLabelFormatter
                )
                  this._indexLabels.push({
                    chartType: "rangeBar",
                    dataPoint: w[g],
                    dataSeries: d,
                    indexKeyword: 0,
                    point: {
                      x: w[g].y[1] >= w[g].y[0] ? h : l,
                      y: n + (s - n) / 2,
                    },
                    direction: w[g].y[1] >= w[g].y[0] ? -1 : 1,
                    bounds: {
                      x1: Math.min(h, l),
                      y1: n,
                      x2: Math.max(h, l),
                      y2: s,
                    },
                    color: c,
                  }),
                    this._indexLabels.push({
                      chartType: "rangeBar",
                      dataPoint: w[g],
                      dataSeries: d,
                      indexKeyword: 1,
                      point: {
                        x: w[g].y[1] >= w[g].y[0] ? l : h,
                        y: n + (s - n) / 2,
                      },
                      direction: w[g].y[1] >= w[g].y[0] ? 1 : -1,
                      bounds: {
                        x1: Math.min(h, l),
                        y1: n,
                        x2: Math.max(h, l),
                        y2: s,
                      },
                      color: c,
                    });
              }
          }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(e.x1, e.y1, e.width, e.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeArea = function (a) {
      function f() {
        if (t) {
          var a = null;
          0 < r.lineThickness && c.stroke();
          for (var b = n.length - 1; 0 <= b; b--)
            (a = n[b]), c.lineTo(a.x, a.y), e.lineTo(a.x, a.y);
          c.closePath();
          c.globalAlpha = r.fillOpacity;
          c.fill();
          c.globalAlpha = 1;
          e.fill();
          if (0 < r.lineThickness) {
            c.beginPath();
            c.moveTo(a.x, a.y);
            for (b = 0; b < n.length; b++) (a = n[b]), c.lineTo(a.x, a.y);
            c.stroke();
          }
          c.beginPath();
          c.moveTo(w, p);
          e.beginPath();
          e.moveTo(w, p);
          t = { x: w, y: p };
          n = [];
          n.push({ x: w, y: s });
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = this._eventManager.ghostCtx,
          g = [],
          h = this.plotArea;
        c.save();
        v && e.save();
        c.beginPath();
        c.rect(h.x1, h.y1, h.width, h.height);
        c.clip();
        v && (e.beginPath(), e.rect(h.x1, h.y1, h.width, h.height), e.clip());
        for (var l = 0; l < a.dataSeriesIndexes.length; l++) {
          var n = [],
            k = a.dataSeriesIndexes[l],
            r = this.data[k],
            q = r.dataPoints,
            g = r.id;
          this._eventManager.objectMap[g] = {
            objectType: "dataSeries",
            dataSeriesIndex: k,
          };
          g = R(g);
          e.fillStyle = g;
          var g = [],
            m = !0,
            d = 0,
            w,
            p,
            s,
            u,
            t = null;
          if (0 < q.length) {
            var y = r._colorSet[d % r._colorSet.length],
              x = (r.lineColor = r.options.lineColor || y),
              B = x;
            c.fillStyle = y;
            c.strokeStyle = x;
            c.lineWidth = r.lineThickness;
            var A = "solid";
            if (c.setLineDash) {
              var z = F(r.nullDataLineDashType, r.lineThickness),
                A = r.lineDashType,
                I = F(A, r.lineThickness);
              c.setLineDash(I);
            }
            for (var M = !0; d < q.length; d++)
              if (
                ((u = q[d].x.getTime ? q[d].x.getTime() : q[d].x),
                !(
                  u < a.axisX.dataInfo.viewPortMin ||
                  (u > a.axisX.dataInfo.viewPortMax &&
                    (!r.connectNullData || !M))
                ))
              )
                if (
                  null !== q[d].y &&
                  q[d].y.length &&
                  "number" === typeof q[d].y[0] &&
                  "number" === typeof q[d].y[1]
                ) {
                  w = a.axisX.convertValueToPixel(u);
                  p = a.axisY.convertValueToPixel(q[d].y[0]);
                  s = a.axisY.convertValueToPixel(q[d].y[1]);
                  m || M
                    ? (r.connectNullData && !m
                        ? (c.setLineDash &&
                            (r.options.nullDataLineDashType ||
                              (A === r.lineDashType &&
                                r.lineDashType !== r.nullDataLineDashType)) &&
                            ((n[n.length - 1].newLineDashArray = I),
                            (A = r.nullDataLineDashType),
                            c.setLineDash(z)),
                          c.lineTo(w, p),
                          v && e.lineTo(w, p),
                          n.push({ x: w, y: s }))
                        : (c.beginPath(),
                          c.moveTo(w, p),
                          (t = { x: w, y: p }),
                          (n = []),
                          n.push({ x: w, y: s }),
                          v && (e.beginPath(), e.moveTo(w, p))),
                      (M = m = !1))
                    : (c.lineTo(w, p),
                      n.push({ x: w, y: s }),
                      v && e.lineTo(w, p),
                      0 == d % 250 && f());
                  u = r.dataPointIds[d];
                  this._eventManager.objectMap[u] = {
                    id: u,
                    objectType: "dataPoint",
                    dataSeriesIndex: k,
                    dataPointIndex: d,
                    x1: w,
                    y1: p,
                    y2: s,
                  };
                  d < q.length - 1 &&
                    (B !== (q[d].lineColor || x) ||
                      A !== (q[d].lineDashType || r.lineDashType)) &&
                    (f(),
                    (B = q[d].lineColor || x),
                    (n[n.length - 1].newStrokeStyle = B),
                    (c.strokeStyle = B),
                    c.setLineDash &&
                      (q[d].lineDashType
                        ? ((A = q[d].lineDashType),
                          (n[n.length - 1].newLineDashArray = F(
                            A,
                            r.lineThickness
                          )),
                          c.setLineDash(n[n.length - 1].newLineDashArray))
                        : ((A = r.lineDashType),
                          (n[n.length - 1].newLineDashArray = I),
                          c.setLineDash(I))));
                  if (
                    0 !== q[d].markerSize &&
                    (0 < q[d].markerSize || 0 < r.markerSize)
                  ) {
                    var K = r.getMarkerProperties(d, w, s, c);
                    g.push(K);
                    var ca = R(u);
                    v &&
                      g.push({
                        x: w,
                        y: s,
                        ctx: e,
                        type: K.type,
                        size: K.size,
                        color: ca,
                        borderColor: ca,
                        borderThickness: K.borderThickness,
                      });
                    K = r.getMarkerProperties(d, w, p, c);
                    g.push(K);
                    ca = R(u);
                    v &&
                      g.push({
                        x: w,
                        y: p,
                        ctx: e,
                        type: K.type,
                        size: K.size,
                        color: ca,
                        borderColor: ca,
                        borderThickness: K.borderThickness,
                      });
                  }
                  if (
                    q[d].indexLabel ||
                    r.indexLabel ||
                    q[d].indexLabelFormatter ||
                    r.indexLabelFormatter
                  )
                    this._indexLabels.push({
                      chartType: "rangeArea",
                      dataPoint: q[d],
                      dataSeries: r,
                      indexKeyword: 0,
                      point: { x: w, y: p },
                      direction:
                        q[d].y[0] > q[d].y[1] === a.axisY.reversed ? -1 : 1,
                      color: y,
                    }),
                      this._indexLabels.push({
                        chartType: "rangeArea",
                        dataPoint: q[d],
                        dataSeries: r,
                        indexKeyword: 1,
                        point: { x: w, y: s },
                        direction:
                          q[d].y[0] > q[d].y[1] === a.axisY.reversed ? 1 : -1,
                        color: y,
                      });
                } else M || m || f(), (M = !0);
            f();
            fa.drawMarkers(g);
          }
        }
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(h.x1, h.y1, h.width, h.height),
          this._eventManager.ghostCtx.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeSplineArea = function (a) {
      function f(a, b) {
        var d = x(p, 2);
        if (0 < d.length) {
          if (0 < k.lineThickness) {
            c.strokeStyle = b;
            c.setLineDash && c.setLineDash(a);
            c.beginPath();
            c.moveTo(d[0].x, d[0].y);
            for (var f = 0; f < d.length - 3; f += 3) {
              if (d[f].newStrokeStyle || d[f].newLineDashArray)
                c.stroke(),
                  c.beginPath(),
                  c.moveTo(d[f].x, d[f].y),
                  d[f].newStrokeStyle && (c.strokeStyle = d[f].newStrokeStyle),
                  d[f].newLineDashArray && c.setLineDash(d[f].newLineDashArray);
              c.bezierCurveTo(
                d[f + 1].x,
                d[f + 1].y,
                d[f + 2].x,
                d[f + 2].y,
                d[f + 3].x,
                d[f + 3].y
              );
            }
            c.stroke();
          }
          c.beginPath();
          c.moveTo(d[0].x, d[0].y);
          v && (e.beginPath(), e.moveTo(d[0].x, d[0].y));
          for (f = 0; f < d.length - 3; f += 3)
            c.bezierCurveTo(
              d[f + 1].x,
              d[f + 1].y,
              d[f + 2].x,
              d[f + 2].y,
              d[f + 3].x,
              d[f + 3].y
            ),
              v &&
                e.bezierCurveTo(
                  d[f + 1].x,
                  d[f + 1].y,
                  d[f + 2].x,
                  d[f + 2].y,
                  d[f + 3].x,
                  d[f + 3].y
                );
          d = x(s, 2);
          c.lineTo(s[s.length - 1].x, s[s.length - 1].y);
          for (f = d.length - 1; 2 < f; f -= 3)
            c.bezierCurveTo(
              d[f - 1].x,
              d[f - 1].y,
              d[f - 2].x,
              d[f - 2].y,
              d[f - 3].x,
              d[f - 3].y
            ),
              v &&
                e.bezierCurveTo(
                  d[f - 1].x,
                  d[f - 1].y,
                  d[f - 2].x,
                  d[f - 2].y,
                  d[f - 3].x,
                  d[f - 3].y
                );
          c.closePath();
          c.globalAlpha = k.fillOpacity;
          c.fill();
          v && (e.closePath(), e.fill());
          c.globalAlpha = 1;
          if (0 < k.lineThickness) {
            c.strokeStyle = b;
            c.setLineDash && c.setLineDash(a);
            c.beginPath();
            c.moveTo(d[0].x, d[0].y);
            for (var g = (f = 0); f < d.length - 3; f += 3, g++) {
              if (p[g].newStrokeStyle || p[g].newLineDashArray)
                c.stroke(),
                  c.beginPath(),
                  c.moveTo(d[f].x, d[f].y),
                  p[g].newStrokeStyle && (c.strokeStyle = p[g].newStrokeStyle),
                  p[g].newLineDashArray && c.setLineDash(p[g].newLineDashArray);
              c.bezierCurveTo(
                d[f + 1].x,
                d[f + 1].y,
                d[f + 2].x,
                d[f + 2].y,
                d[f + 3].x,
                d[f + 3].y
              );
            }
            c.stroke();
          }
          c.beginPath();
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var e = this._eventManager.ghostCtx,
          g = [],
          h = this.plotArea;
        c.save();
        v && e.save();
        c.beginPath();
        c.rect(h.x1, h.y1, h.width, h.height);
        c.clip();
        v && (e.beginPath(), e.rect(h.x1, h.y1, h.width, h.height), e.clip());
        for (var l = 0; l < a.dataSeriesIndexes.length; l++) {
          var n = a.dataSeriesIndexes[l],
            k = this.data[n],
            r = k.dataPoints,
            g = k.id;
          this._eventManager.objectMap[g] = {
            objectType: "dataSeries",
            dataSeriesIndex: n,
          };
          g = R(g);
          e.fillStyle = g;
          var g = [],
            q = 0,
            m,
            d,
            w,
            p = [],
            s = [];
          if (0 < r.length) {
            var u = k._colorSet[q % k._colorSet.length],
              t = (k.lineColor = k.options.lineColor || u),
              y = t;
            c.fillStyle = u;
            c.lineWidth = k.lineThickness;
            var B = "solid",
              z;
            if (c.setLineDash) {
              var A = F(k.nullDataLineDashType, k.lineThickness),
                B = k.lineDashType;
              z = F(B, k.lineThickness);
            }
            for (d = !1; q < r.length; q++)
              if (
                ((m = r[q].x.getTime ? r[q].x.getTime() : r[q].x),
                !(
                  m < a.axisX.dataInfo.viewPortMin ||
                  (m > a.axisX.dataInfo.viewPortMax &&
                    (!k.connectNullData || !d))
                ))
              )
                if (
                  null !== r[q].y &&
                  r[q].y.length &&
                  "number" === typeof r[q].y[0] &&
                  "number" === typeof r[q].y[1]
                ) {
                  m = a.axisX.convertValueToPixel(m);
                  d = a.axisY.convertValueToPixel(r[q].y[0]);
                  w = a.axisY.convertValueToPixel(r[q].y[1]);
                  var J = k.dataPointIds[q];
                  this._eventManager.objectMap[J] = {
                    id: J,
                    objectType: "dataPoint",
                    dataSeriesIndex: n,
                    dataPointIndex: q,
                    x1: m,
                    y1: d,
                    y2: w,
                  };
                  p[p.length] = { x: m, y: d };
                  s[s.length] = { x: m, y: w };
                  q < r.length - 1 &&
                    (y !== (r[q].lineColor || t) ||
                      B !== (r[q].lineDashType || k.lineDashType)) &&
                    ((y = r[q].lineColor || t),
                    (p[p.length - 1].newStrokeStyle = y),
                    c.setLineDash &&
                      (r[q].lineDashType
                        ? ((B = r[q].lineDashType),
                          (p[p.length - 1].newLineDashArray = F(
                            B,
                            k.lineThickness
                          )))
                        : ((B = k.lineDashType),
                          (p[p.length - 1].newLineDashArray = z))));
                  if (
                    0 !== r[q].markerSize &&
                    (0 < r[q].markerSize || 0 < k.markerSize)
                  ) {
                    var I = k.getMarkerProperties(q, m, d, c);
                    g.push(I);
                    var M = R(J);
                    v &&
                      g.push({
                        x: m,
                        y: d,
                        ctx: e,
                        type: I.type,
                        size: I.size,
                        color: M,
                        borderColor: M,
                        borderThickness: I.borderThickness,
                      });
                    I = k.getMarkerProperties(q, m, w, c);
                    g.push(I);
                    M = R(J);
                    v &&
                      g.push({
                        x: m,
                        y: w,
                        ctx: e,
                        type: I.type,
                        size: I.size,
                        color: M,
                        borderColor: M,
                        borderThickness: I.borderThickness,
                      });
                  }
                  if (
                    r[q].indexLabel ||
                    k.indexLabel ||
                    r[q].indexLabelFormatter ||
                    k.indexLabelFormatter
                  )
                    this._indexLabels.push({
                      chartType: "rangeSplineArea",
                      dataPoint: r[q],
                      dataSeries: k,
                      indexKeyword: 0,
                      point: { x: m, y: d },
                      direction: r[q].y[0] <= r[q].y[1] ? -1 : 1,
                      color: u,
                    }),
                      this._indexLabels.push({
                        chartType: "rangeSplineArea",
                        dataPoint: r[q],
                        dataSeries: k,
                        indexKeyword: 1,
                        point: { x: m, y: w },
                        direction: r[q].y[0] <= r[q].y[1] ? 1 : -1,
                        color: u,
                      });
                  d = !1;
                } else
                  0 < q &&
                    !d &&
                    (k.connectNullData
                      ? c.setLineDash &&
                        0 < p.length &&
                        (k.options.nullDataLineDashType ||
                          !r[q - 1].lineDashType) &&
                        ((p[p.length - 1].newLineDashArray = A),
                        (B = k.nullDataLineDashType))
                      : (f(z, t), (p = []), (s = []))),
                    (d = !0);
            f(z, t);
            fa.drawMarkers(g);
          }
        }
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(h.x1, h.y1, h.width, h.height),
          this._eventManager.ghostCtx.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: L.xClipAnimation,
          easingFunction: L.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderWaterfall = function (a) {
      var f = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : f;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this._eventManager.ghostCtx,
          e = null,
          g = this.plotArea,
          h = 0,
          l,
          n,
          k,
          r,
          q = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          h = this.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.dataPointWidth
            ? this.dataPointWidth
            : 1;
        n = this.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.dataPointWidth
          ? this.dataPointWidth
          : Math.min(
              0.15 * this.width,
              0.9 * (this.plotArea.width / a.plotType.totalDataSeries)
            ) << 0;
        var m = a.axisX.dataInfo.minDiff;
        isFinite(m) || (m = 0.3 * Math.abs(a.axisX.range));
        m = this.dataPointWidth
          ? this.dataPointWidth
          : (0.6 *
              ((g.width *
                (a.axisX.logarithmic
                  ? Math.log(m) / Math.log(a.axisX.range)
                  : Math.abs(m) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          h > n &&
          (h = Math.min(
            this.dataPointWidth ? this.dataPointWidth : Infinity,
            n
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          n < h &&
          (n = Math.max(
            this.dataPointWidth ? this.dataPointWidth : -Infinity,
            h
          ));
        m < h && (m = h);
        m > n && (m = n);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (var d = 0; d < a.dataSeriesIndexes.length; d++) {
          var w = a.dataSeriesIndexes[d],
            p = this.data[w],
            s = p.dataPoints,
            e = p._colorSet[0];
          p.risingColor = p.options.risingColor ? p.options.risingColor : e;
          p.fallingColor = p.options.fallingColor
            ? p.options.fallingColor
            : "#e40a0a";
          var u =
              "number" === typeof p.options.lineThickness
                ? Math.round(p.lineThickness)
                : 1,
            t = 1 === Math.round(u) % 2 ? -0.5 : 0;
          if (0 < s.length)
            for (
              var y = 5 < m && p.bevelEnabled ? !0 : !1,
                x = !1,
                B = null,
                A = null,
                h = 0;
              h < s.length;
              h++
            )
              if (
                (s[h].getTime ? (r = s[h].x.getTime()) : (r = s[h].x),
                "number" !== typeof s[h].y)
              ) {
                if (0 < h && !x && p.connectNullData)
                  var z =
                    p.options.nullDataLineDashType || !s[h - 1].lineDashType
                      ? p.nullDataLineDashType
                      : s[h - 1].lineDashType;
                x = !0;
              } else {
                l = a.axisX.convertValueToPixel(r);
                n =
                  0 === p.dataPointEOs[h].cumulativeSum
                    ? q
                    : a.axisY.convertValueToPixel(
                        p.dataPointEOs[h].cumulativeSum
                      );
                k =
                  0 === p.dataPointEOs[h].cumulativeSumYStartValue
                    ? q
                    : a.axisY.convertValueToPixel(
                        p.dataPointEOs[h].cumulativeSumYStartValue
                      );
                l = a.axisX.reversed
                  ? (l +
                      (a.plotType.totalDataSeries * m) / 2 -
                      (a.previousDataSeriesCount + d) * m) <<
                    0
                  : (l -
                      (a.plotType.totalDataSeries * m) / 2 +
                      (a.previousDataSeriesCount + d) * m) <<
                    0;
                var I = a.axisX.reversed ? (l - m) << 0 : (l + m) << 0;
                n > k && ((e = n), (n = k), (k = e));
                a.axisY.reversed && ((e = n), (n = k), (k = e));
                e = p.dataPointIds[h];
                this._eventManager.objectMap[e] = {
                  id: e,
                  objectType: "dataPoint",
                  dataSeriesIndex: w,
                  dataPointIndex: h,
                  x1: l,
                  y1: n,
                  x2: I,
                  y2: k,
                };
                var M = s[h].color
                  ? s[h].color
                  : -1 < s[h].y
                  ? p.risingColor
                  : p.fallingColor;
                W(b, l, n, I, k, M, 0, M, y, y, !1, !1, p.fillOpacity);
                e = R(e);
                v &&
                  W(
                    this._eventManager.ghostCtx,
                    l,
                    n,
                    I,
                    k,
                    e,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                var K,
                  M = l;
                K =
                  ("undefined" !== typeof s[h].isIntermediateSum &&
                    !0 === s[h].isIntermediateSum) ||
                  ("undefined" !== typeof s[h].isCumulativeSum &&
                    !0 === s[h].isCumulativeSum)
                    ? -1 < s[h].y
                      ? n
                      : k
                    : -1 < s[h].y
                    ? k
                    : n;
                0 < h &&
                  B &&
                  (!x || p.connectNullData) &&
                  (x && b.setLineDash && b.setLineDash(F(z, u)),
                  b.beginPath(),
                  b.moveTo(B, A - t),
                  b.lineTo(M, K - t),
                  0 < u && b.stroke(),
                  v &&
                    (c.beginPath(),
                    c.moveTo(B, A - t),
                    c.lineTo(M, K - t),
                    0 < u && c.stroke()));
                x = !1;
                B = I;
                A = -1 < s[h].y ? n : k;
                M = s[h].lineDashType
                  ? s[h].lineDashType
                  : p.options.lineDashType
                  ? p.options.lineDashType
                  : "shortDash";
                b.strokeStyle = s[h].lineColor
                  ? s[h].lineColor
                  : p.options.lineColor
                  ? p.options.lineColor
                  : "#9e9e9e";
                b.lineWidth = u;
                b.setLineDash && ((M = F(M, u)), b.setLineDash(M));
                (s[h].indexLabel ||
                  p.indexLabel ||
                  s[h].indexLabelFormatter ||
                  p.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "waterfall",
                    dataPoint: s[h],
                    dataSeries: p,
                    point: { x: l + (I - l) / 2, y: 0 <= s[h].y ? n : k },
                    direction: 0 > s[h].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: l,
                      y1: Math.min(n, k),
                      x2: I,
                      y2: Math.max(n, k),
                    },
                    color: e,
                  });
              }
        }
        v &&
          (f.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: f,
          dest: this.plotArea.ctx,
          animationCallback: L.fadeInAnimation,
          easingFunction: L.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    var oa = function (a, f, b, c, e, g, h, l, n) {
      if (!(0 > b)) {
        "undefined" === typeof l && (l = 1);
        if (!v) {
          var k = Number((h % (2 * Math.PI)).toFixed(8));
          Number((g % (2 * Math.PI)).toFixed(8)) === k && (h -= 1e-4);
        }
        a.save();
        a.globalAlpha = l;
        "pie" === e
          ? (a.beginPath(),
            a.moveTo(f.x, f.y),
            a.arc(f.x, f.y, b, g, h, !1),
            (a.fillStyle = c),
            (a.strokeStyle = "white"),
            (a.lineWidth = 2),
            a.closePath(),
            a.fill())
          : "doughnut" === e &&
            (a.beginPath(),
            a.arc(f.x, f.y, b, g, h, !1),
            0 <= n && a.arc(f.x, f.y, n * b, h, g, !0),
            a.closePath(),
            (a.fillStyle = c),
            (a.strokeStyle = "white"),
            (a.lineWidth = 2),
            a.fill());
        a.globalAlpha = 1;
        a.restore();
      }
    };
    s.prototype.renderPie = function (a) {
      function f() {
        if (k && r) {
          for (var a = 0, b = 0, c = 0, e = 0, f = 0; f < r.length; f++) {
            var g = r[f],
              h = k.dataPointIds[f];
            d[f].id = h;
            d[f].objectType = "dataPoint";
            d[f].dataPointIndex = f;
            d[f].dataSeriesIndex = 0;
            var l = d[f],
              q = { percent: null, total: null },
              p = null,
              q = n.getPercentAndTotal(k, g);
            if (k.indexLabelFormatter || g.indexLabelFormatter)
              p = {
                chart: n.options,
                dataSeries: k,
                dataPoint: g,
                total: q.total,
                percent: q.percent,
              };
            q = g.indexLabelFormatter
              ? g.indexLabelFormatter(p)
              : g.indexLabel
              ? n.replaceKeywordsWithValue(g.indexLabel, g, k, f)
              : k.indexLabelFormatter
              ? k.indexLabelFormatter(p)
              : k.indexLabel
              ? n.replaceKeywordsWithValue(k.indexLabel, g, k, f)
              : g.label
              ? g.label
              : "";
            n._eventManager.objectMap[h] = l;
            l.center = { x: v.x, y: v.y };
            l.y = g.y;
            l.radius = A;
            l.percentInnerRadius = I;
            l.indexLabelText = q;
            l.indexLabelPlacement = k.indexLabelPlacement;
            l.indexLabelLineColor = g.indexLabelLineColor
              ? g.indexLabelLineColor
              : k.options.indexLabelLineColor
              ? k.options.indexLabelLineColor
              : g.color
              ? g.color
              : k._colorSet[f % k._colorSet.length];
            l.indexLabelLineThickness = y(g.indexLabelLineThickness)
              ? k.indexLabelLineThickness
              : g.indexLabelLineThickness;
            l.indexLabelLineDashType = g.indexLabelLineDashType
              ? g.indexLabelLineDashType
              : k.indexLabelLineDashType;
            l.indexLabelFontColor = g.indexLabelFontColor
              ? g.indexLabelFontColor
              : k.indexLabelFontColor;
            l.indexLabelFontStyle = g.indexLabelFontStyle
              ? g.indexLabelFontStyle
              : k.indexLabelFontStyle;
            l.indexLabelFontWeight = g.indexLabelFontWeight
              ? g.indexLabelFontWeight
              : k.indexLabelFontWeight;
            l.indexLabelFontSize = y(g.indexLabelFontSize)
              ? k.indexLabelFontSize
              : g.indexLabelFontSize;
            l.indexLabelFontFamily = g.indexLabelFontFamily
              ? g.indexLabelFontFamily
              : k.indexLabelFontFamily;
            l.indexLabelBackgroundColor = g.indexLabelBackgroundColor
              ? g.indexLabelBackgroundColor
              : k.options.indexLabelBackgroundColor
              ? k.options.indexLabelBackgroundColor
              : k.indexLabelBackgroundColor;
            l.indexLabelMaxWidth = g.indexLabelMaxWidth
              ? g.indexLabelMaxWidth
              : k.indexLabelMaxWidth
              ? k.indexLabelMaxWidth
              : 0.33 * m.width;
            l.indexLabelWrap =
              "undefined" !== typeof g.indexLabelWrap
                ? g.indexLabelWrap
                : k.indexLabelWrap;
            l.startAngle =
              0 === f
                ? k.startAngle
                  ? (k.startAngle / 180) * Math.PI
                  : 0
                : d[f - 1].endAngle;
            l.startAngle = (l.startAngle + 2 * Math.PI) % (2 * Math.PI);
            l.endAngle = l.startAngle + ((2 * Math.PI) / x) * Math.abs(g.y);
            g = (l.endAngle + l.startAngle) / 2;
            g = (g + 2 * Math.PI) % (2 * Math.PI);
            l.midAngle = g;
            if (l.midAngle > Math.PI / 2 - u && l.midAngle < Math.PI / 2 + u) {
              if (0 === a || d[c].midAngle > l.midAngle) c = f;
              a++;
            } else if (
              l.midAngle > (3 * Math.PI) / 2 - u &&
              l.midAngle < (3 * Math.PI) / 2 + u
            ) {
              if (0 === b || d[e].midAngle > l.midAngle) e = f;
              b++;
            }
            l.hemisphere =
              g > Math.PI / 2 && g <= (3 * Math.PI) / 2 ? "left" : "right";
            l.indexLabelTextBlock = new ia(n.plotArea.ctx, {
              fontSize: l.indexLabelFontSize,
              fontFamily: l.indexLabelFontFamily,
              fontColor: l.indexLabelFontColor,
              fontStyle: l.indexLabelFontStyle,
              fontWeight: l.indexLabelFontWeight,
              horizontalAlign: "left",
              backgroundColor: l.indexLabelBackgroundColor,
              maxWidth: l.indexLabelMaxWidth,
              maxHeight: l.indexLabelWrap
                ? 5 * l.indexLabelFontSize
                : 1.5 * l.indexLabelFontSize,
              text: l.indexLabelText,
              padding: 0,
              textBaseline: "top",
            });
            l.indexLabelTextBlock.measureText();
          }
          h = g = 0;
          q = !1;
          for (f = 0; f < r.length; f++)
            (l = d[(c + f) % r.length]),
              1 < a &&
                l.midAngle > Math.PI / 2 - u &&
                l.midAngle < Math.PI / 2 + u &&
                (g <= a / 2 && !q
                  ? ((l.hemisphere = "right"), g++)
                  : ((l.hemisphere = "left"), (q = !0)));
          q = !1;
          for (f = 0; f < r.length; f++)
            (l = d[(e + f) % r.length]),
              1 < b &&
                l.midAngle > (3 * Math.PI) / 2 - u &&
                l.midAngle < (3 * Math.PI) / 2 + u &&
                (h <= b / 2 && !q
                  ? ((l.hemisphere = "left"), h++)
                  : ((l.hemisphere = "right"), (q = !0)));
        }
      }
      function b(a) {
        var b = n.plotArea.ctx;
        b.clearRect(m.x1, m.y1, m.width, m.height);
        b.fillStyle = n.backgroundColor;
        b.fillRect(m.x1, m.y1, m.width, m.height);
        for (b = 0; b < r.length; b++) {
          var c = d[b].startAngle,
            e = d[b].endAngle;
          if (e > c) {
            var f = 0.07 * A * Math.cos(d[b].midAngle),
              g = 0.07 * A * Math.sin(d[b].midAngle),
              h = !1;
            if (r[b].exploded) {
              if (
                1e-9 < Math.abs(d[b].center.x - (v.x + f)) ||
                1e-9 < Math.abs(d[b].center.y - (v.y + g))
              )
                (d[b].center.x = v.x + f * a),
                  (d[b].center.y = v.y + g * a),
                  (h = !0);
            } else if (
              0 < Math.abs(d[b].center.x - v.x) ||
              0 < Math.abs(d[b].center.y - v.y)
            )
              (d[b].center.x = v.x + f * (1 - a)),
                (d[b].center.y = v.y + g * (1 - a)),
                (h = !0);
            h &&
              ((f = {}),
              (f.dataSeries = k),
              (f.dataPoint = k.dataPoints[b]),
              (f.index = b),
              n.toolTip.highlightObjects([f]));
            oa(
              n.plotArea.ctx,
              d[b].center,
              d[b].radius,
              r[b].color ? r[b].color : k._colorSet[b % k._colorSet.length],
              k.type,
              c,
              e,
              k.fillOpacity,
              d[b].percentInnerRadius
            );
          }
        }
        a = n.plotArea.ctx;
        a.save();
        a.fillStyle = "black";
        a.strokeStyle = "grey";
        a.textBaseline = "middle";
        a.lineJoin = "round";
        for (b = b = 0; b < r.length; b++)
          (c = d[b]),
            c.indexLabelText &&
              ((c.indexLabelTextBlock.y -= c.indexLabelTextBlock.height / 2),
              (e = 0),
              (e =
                "left" === c.hemisphere
                  ? "inside" !== k.indexLabelPlacement
                    ? -(c.indexLabelTextBlock.width + q)
                    : -c.indexLabelTextBlock.width / 2
                  : "inside" !== k.indexLabelPlacement
                  ? q
                  : -c.indexLabelTextBlock.width / 2),
              (c.indexLabelTextBlock.x += e),
              c.indexLabelTextBlock.render(!0),
              (c.indexLabelTextBlock.x -= e),
              (c.indexLabelTextBlock.y += c.indexLabelTextBlock.height / 2),
              "inside" !== c.indexLabelPlacement &&
                0 < c.indexLabelLineThickness &&
                ((e = c.center.x + A * Math.cos(c.midAngle)),
                (f = c.center.y + A * Math.sin(c.midAngle)),
                (a.strokeStyle = c.indexLabelLineColor),
                (a.lineWidth = c.indexLabelLineThickness),
                a.setLineDash &&
                  a.setLineDash(
                    F(c.indexLabelLineDashType, c.indexLabelLineThickness)
                  ),
                a.beginPath(),
                a.moveTo(e, f),
                a.lineTo(c.indexLabelTextBlock.x, c.indexLabelTextBlock.y),
                a.lineTo(
                  c.indexLabelTextBlock.x + ("left" === c.hemisphere ? -q : q),
                  c.indexLabelTextBlock.y
                ),
                a.stroke()),
              (a.lineJoin = "miter"));
        a.save();
      }
      function c(a, b) {
        var c = 0,
          c = a.indexLabelTextBlock.y - a.indexLabelTextBlock.height / 2,
          d = a.indexLabelTextBlock.y + a.indexLabelTextBlock.height / 2,
          e = b.indexLabelTextBlock.y - b.indexLabelTextBlock.height / 2,
          f = b.indexLabelTextBlock.y + b.indexLabelTextBlock.height / 2;
        return (c =
          b.indexLabelTextBlock.y > a.indexLabelTextBlock.y ? e - d : c - f);
      }
      function e(a) {
        for (var b = null, e = 1; e < r.length; e++)
          if (
            ((b = (a + e + d.length) % d.length),
            d[b].hemisphere !== d[a].hemisphere)
          ) {
            b = null;
            break;
          } else if (
            d[b].indexLabelText &&
            b !== a &&
            (0 > c(d[b], d[a]) ||
              ("right" === d[a].hemisphere
                ? d[b].indexLabelTextBlock.y >= d[a].indexLabelTextBlock.y
                : d[b].indexLabelTextBlock.y <= d[a].indexLabelTextBlock.y))
          )
            break;
          else b = null;
        return b;
      }
      function g(a, b, f) {
        f = (f || 0) + 1;
        if (1e3 < f) return 0;
        b = b || 0;
        var k = 0,
          h = v.y - 1 * p,
          m = v.y + 1 * p;
        if (0 <= a && a < r.length) {
          var l = d[a];
          if (
            (0 > b && l.indexLabelTextBlock.y < h) ||
            (0 < b && l.indexLabelTextBlock.y > m)
          )
            return 0;
          var n = 0,
            q = 0,
            q = (n = n = 0);
          0 > b
            ? l.indexLabelTextBlock.y - l.indexLabelTextBlock.height / 2 > h &&
              l.indexLabelTextBlock.y - l.indexLabelTextBlock.height / 2 + b <
                h &&
              (b = -(
                h -
                (l.indexLabelTextBlock.y - l.indexLabelTextBlock.height / 2 + b)
              ))
            : l.indexLabelTextBlock.y + l.indexLabelTextBlock.height / 2 < h &&
              l.indexLabelTextBlock.y + l.indexLabelTextBlock.height / 2 + b >
                m &&
              (b =
                l.indexLabelTextBlock.y +
                l.indexLabelTextBlock.height / 2 +
                b -
                m);
          b = l.indexLabelTextBlock.y + b;
          h = 0;
          h =
            "right" === l.hemisphere
              ? v.x + Math.sqrt(Math.pow(p, 2) - Math.pow(b - v.y, 2))
              : v.x - Math.sqrt(Math.pow(p, 2) - Math.pow(b - v.y, 2));
          q = v.x + A * Math.cos(l.midAngle);
          n = v.y + A * Math.sin(l.midAngle);
          n = Math.sqrt(Math.pow(h - q, 2) + Math.pow(b - n, 2));
          q = Math.acos(A / p);
          n = Math.acos((p * p + A * A - n * n) / (2 * A * p));
          b = n < q ? b - l.indexLabelTextBlock.y : 0;
          h = null;
          for (m = 1; m < r.length; m++)
            if (
              ((h = (a - m + d.length) % d.length),
              d[h].hemisphere !== d[a].hemisphere)
            ) {
              h = null;
              break;
            } else if (
              d[h].indexLabelText &&
              d[h].hemisphere === d[a].hemisphere &&
              h !== a &&
              (0 > c(d[h], d[a]) ||
                ("right" === d[a].hemisphere
                  ? d[h].indexLabelTextBlock.y <= d[a].indexLabelTextBlock.y
                  : d[h].indexLabelTextBlock.y >= d[a].indexLabelTextBlock.y))
            )
              break;
            else h = null;
          q = h;
          n = e(a);
          m = h = 0;
          0 > b
            ? ((m = "right" === l.hemisphere ? q : n),
              (k = b),
              null !== m &&
                ((q = -b),
                (b =
                  l.indexLabelTextBlock.y -
                  l.indexLabelTextBlock.height / 2 -
                  (d[m].indexLabelTextBlock.y +
                    d[m].indexLabelTextBlock.height / 2)),
                b - q < w &&
                  ((h = -q),
                  (m = g(m, h, f + 1)),
                  +m.toFixed(t) > +h.toFixed(t) &&
                    (k = b > w ? -(b - w) : -(q - (m - h))))))
            : 0 < b &&
              ((m = "right" === l.hemisphere ? n : q),
              (k = b),
              null !== m &&
                ((q = b),
                (b =
                  d[m].indexLabelTextBlock.y -
                  d[m].indexLabelTextBlock.height / 2 -
                  (l.indexLabelTextBlock.y + l.indexLabelTextBlock.height / 2)),
                b - q < w &&
                  ((h = q),
                  (m = g(m, h, f + 1)),
                  +m.toFixed(t) < +h.toFixed(t) &&
                    (k = b > w ? b - w : q - (h - m)))));
          k &&
            ((f = l.indexLabelTextBlock.y + k),
            (b = 0),
            (b =
              "right" === l.hemisphere
                ? v.x + Math.sqrt(Math.pow(p, 2) - Math.pow(f - v.y, 2))
                : v.x - Math.sqrt(Math.pow(p, 2) - Math.pow(f - v.y, 2))),
            l.midAngle > Math.PI / 2 - u && l.midAngle < Math.PI / 2 + u
              ? ((h = (a - 1 + d.length) % d.length),
                (h = d[h]),
                (a = d[(a + 1 + d.length) % d.length]),
                "left" === l.hemisphere &&
                "right" === h.hemisphere &&
                b > h.indexLabelTextBlock.x
                  ? (b = h.indexLabelTextBlock.x - 15)
                  : "right" === l.hemisphere &&
                    "left" === a.hemisphere &&
                    b < a.indexLabelTextBlock.x &&
                    (b = a.indexLabelTextBlock.x + 15))
              : l.midAngle > (3 * Math.PI) / 2 - u &&
                l.midAngle < (3 * Math.PI) / 2 + u &&
                ((h = (a - 1 + d.length) % d.length),
                (h = d[h]),
                (a = d[(a + 1 + d.length) % d.length]),
                "right" === l.hemisphere &&
                "left" === h.hemisphere &&
                b < h.indexLabelTextBlock.x
                  ? (b = h.indexLabelTextBlock.x + 15)
                  : "left" === l.hemisphere &&
                    "right" === a.hemisphere &&
                    b > a.indexLabelTextBlock.x &&
                    (b = a.indexLabelTextBlock.x - 15)),
            (l.indexLabelTextBlock.y = f),
            (l.indexLabelTextBlock.x = b),
            (l.indexLabelAngle = Math.atan2(
              l.indexLabelTextBlock.y - v.y,
              l.indexLabelTextBlock.x - v.x
            )));
        }
        return k;
      }
      function h() {
        var a = n.plotArea.ctx;
        a.fillStyle = "grey";
        a.strokeStyle = "grey";
        a.font = "16px Arial";
        a.textBaseline = "middle";
        for (
          var b = (a = 0), f = 0, h = !0, b = 0;
          10 > b && (1 > b || 0 < f);
          b++
        ) {
          if (
            k.radius ||
            (!k.radius &&
              "undefined" !== typeof k.innerRadius &&
              null !== k.innerRadius &&
              A - f <= z)
          )
            h = !1;
          h && (A -= f);
          f = 0;
          if ("inside" !== k.indexLabelPlacement) {
            p = A * s;
            for (a = 0; a < r.length; a++) {
              var l = d[a];
              l.indexLabelTextBlock.x = v.x + p * Math.cos(l.midAngle);
              l.indexLabelTextBlock.y = v.y + p * Math.sin(l.midAngle);
              l.indexLabelAngle = l.midAngle;
              l.radius = A;
              l.percentInnerRadius = I;
            }
            for (var u, y, a = 0; a < r.length; a++) {
              var l = d[a],
                x = e(a);
              if (null !== x) {
                u = d[a];
                y = d[x];
                var B = 0,
                  B = c(u, y) - w;
                if (0 > B) {
                  for (var F = (y = 0), ra = 0; ra < r.length; ra++)
                    ra !== a &&
                      d[ra].hemisphere === l.hemisphere &&
                      (d[ra].indexLabelTextBlock.y < l.indexLabelTextBlock.y
                        ? y++
                        : F++);
                  y = (B / (y + F || 1)) * F;
                  var F = -1 * (B - y),
                    L = (ra = 0);
                  "right" === l.hemisphere
                    ? ((ra = g(a, y)),
                      (F = -1 * (B - ra)),
                      (L = g(x, F)),
                      +L.toFixed(t) < +F.toFixed(t) &&
                        +ra.toFixed(t) <= +y.toFixed(t) &&
                        g(a, -(F - L)))
                    : ((ra = g(x, y)),
                      (F = -1 * (B - ra)),
                      (L = g(a, F)),
                      +L.toFixed(t) < +F.toFixed(t) &&
                        +ra.toFixed(t) <= +y.toFixed(t) &&
                        g(x, -(F - L)));
                }
              }
            }
          } else
            for (a = 0; a < r.length; a++)
              (l = d[a]),
                (p = "pie" === k.type ? 0.7 * A : 0.8 * A),
                (x = v.x + p * Math.cos(l.midAngle)),
                (y = v.y + p * Math.sin(l.midAngle)),
                (l.indexLabelTextBlock.x = x),
                (l.indexLabelTextBlock.y = y);
          for (a = 0; a < r.length; a++)
            if (
              ((l = d[a]),
              (x = l.indexLabelTextBlock.measureText()),
              0 !== x.height && 0 !== x.width)
            )
              (x = x = 0),
                "right" === l.hemisphere
                  ? ((x =
                      m.x2 -
                      (l.indexLabelTextBlock.x +
                        l.indexLabelTextBlock.width +
                        q)),
                    (x *= -1))
                  : (x =
                      m.x1 -
                      (l.indexLabelTextBlock.x -
                        l.indexLabelTextBlock.width -
                        q)),
                0 < x &&
                  (!h &&
                    l.indexLabelText &&
                    ((y =
                      "right" === l.hemisphere
                        ? m.x2 - l.indexLabelTextBlock.x
                        : l.indexLabelTextBlock.x - m.x1),
                    0.3 * l.indexLabelTextBlock.maxWidth > y
                      ? (l.indexLabelText = "")
                      : (l.indexLabelTextBlock.maxWidth = 0.85 * y),
                    0.3 * l.indexLabelTextBlock.maxWidth < y &&
                      (l.indexLabelTextBlock.x -=
                        "right" === l.hemisphere ? 2 : -2)),
                  Math.abs(
                    l.indexLabelTextBlock.y -
                      l.indexLabelTextBlock.height / 2 -
                      v.y
                  ) < A ||
                    Math.abs(
                      l.indexLabelTextBlock.y +
                        l.indexLabelTextBlock.height / 2 -
                        v.y
                    ) < A) &&
                  ((x /= Math.abs(Math.cos(l.indexLabelAngle))),
                  9 < x && (x *= 0.3),
                  x > f && (f = x)),
                (x = x = 0),
                0 < l.indexLabelAngle && l.indexLabelAngle < Math.PI
                  ? ((x =
                      m.y2 -
                      (l.indexLabelTextBlock.y +
                        l.indexLabelTextBlock.height / 2 +
                        5)),
                    (x *= -1))
                  : (x =
                      m.y1 -
                      (l.indexLabelTextBlock.y -
                        l.indexLabelTextBlock.height / 2 -
                        5)),
                0 < x &&
                  (!h &&
                    l.indexLabelText &&
                    ((y =
                      0 < l.indexLabelAngle && l.indexLabelAngle < Math.PI
                        ? -1
                        : 1),
                    0 === g(a, x * y) && g(a, 2 * y)),
                  Math.abs(l.indexLabelTextBlock.x - v.x) < A &&
                    ((x /= Math.abs(Math.sin(l.indexLabelAngle))),
                    9 < x && (x *= 0.3),
                    x > f && (f = x)));
          var N = function (a, b, c) {
            for (
              var e = [], f = 0;
              e.push(d[b]), b !== c;
              b = (b + 1 + r.length) % r.length
            );
            e.sort(function (a, b) {
              return a.y - b.y;
            });
            for (b = 0; b < e.length; b++)
              if (((c = e[b]), f < 0.7 * a))
                (f += c.indexLabelTextBlock.height),
                  (c.indexLabelTextBlock.text = ""),
                  (c.indexLabelText = ""),
                  c.indexLabelTextBlock.measureText();
              else break;
          };
          (function () {
            for (var a = -1, b = -1, f = 0, g = !1, h = 0; h < r.length; h++)
              if (((g = !1), (u = d[h]), u.indexLabelText)) {
                var k = e(h);
                if (null !== k) {
                  var l = d[k];
                  B = 0;
                  B = c(u, l);
                  var m;
                  if ((m = 0 > B)) {
                    m = u.indexLabelTextBlock.x;
                    var n =
                        u.indexLabelTextBlock.y -
                        u.indexLabelTextBlock.height / 2,
                      p =
                        u.indexLabelTextBlock.y +
                        u.indexLabelTextBlock.height / 2,
                      w =
                        l.indexLabelTextBlock.y -
                        l.indexLabelTextBlock.height / 2,
                      s = l.indexLabelTextBlock.x + l.indexLabelTextBlock.width,
                      t =
                        l.indexLabelTextBlock.y +
                        l.indexLabelTextBlock.height / 2;
                    m =
                      u.indexLabelTextBlock.x + u.indexLabelTextBlock.width <
                        l.indexLabelTextBlock.x - q ||
                      m > s + q ||
                      n > t + q ||
                      p < w - q
                        ? !1
                        : !0;
                  }
                  m
                    ? (0 > a && (a = h),
                      k !== a && ((b = k), (f += -B)),
                      0 === h % Math.max(r.length / 10, 3) && (g = !0))
                    : (g = !0);
                  g &&
                    0 < f &&
                    0 <= a &&
                    0 <= b &&
                    (N(f, a, b), (b = a = -1), (f = 0));
                }
              }
            0 < f && N(f, a, b);
          })();
        }
      }
      function l() {
        n.plotArea.layoutManager.reset();
        n.title &&
          (n.title.dockInsidePlotArea ||
            ("center" === n.title.horizontalAlign &&
              "center" === n.title.verticalAlign)) &&
          n.title.render();
        if (n.subtitles)
          for (var a = 0; a < n.subtitles.length; a++) {
            var b = n.subtitles[a];
            (b.dockInsidePlotArea ||
              ("center" === b.horizontalAlign &&
                "center" === b.verticalAlign)) &&
              b.render();
          }
        n.legend &&
          (n.legend.dockInsidePlotArea ||
            ("center" === n.legend.horizontalAlign &&
              "center" === n.legend.verticalAlign)) &&
          n.legend.render();
      }
      var n = this;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var k = this.data[a.dataSeriesIndexes[0]],
          r = k.dataPoints,
          q = 10,
          m = this.plotArea,
          d = k.dataPointEOs,
          w = 2,
          p,
          s = 1.3,
          u = (20 / 180) * Math.PI,
          t = 6,
          v = { x: (m.x2 + m.x1) / 2, y: (m.y2 + m.y1) / 2 },
          x = 0;
        a = !1;
        for (var B = 0; B < r.length; B++)
          (x += Math.abs(r[B].y)),
            !a &&
              "undefined" !== typeof r[B].indexLabel &&
              null !== r[B].indexLabel &&
              0 < r[B].indexLabel.toString().length &&
              (a = !0),
            !a &&
              "undefined" !== typeof r[B].label &&
              null !== r[B].label &&
              0 < r[B].label.toString().length &&
              (a = !0);
        if (0 !== x) {
          a =
            a ||
            ("undefined" !== typeof k.indexLabel &&
              null !== k.indexLabel &&
              0 < k.indexLabel.toString().length);
          var A =
            "inside" !== k.indexLabelPlacement && a
              ? (0.75 * Math.min(m.width, m.height)) / 2
              : (0.92 * Math.min(m.width, m.height)) / 2;
          k.radius && (A = J(k.radius, A));
          var z =
            "undefined" !== typeof k.innerRadius && null !== k.innerRadius
              ? J(k.innerRadius, A)
              : 0.7 * A;
          k.radius = A;
          "doughnut" === k.type && (k.innerRadius = z);
          var I = Math.min(z / A, (A - 1) / A);
          this.pieDoughnutClickHandler = function (a) {
            n.isAnimating ||
              (!y(a.dataSeries.explodeOnClick) &&
                !a.dataSeries.explodeOnClick) ||
              ((a = a.dataPoint),
              (a.exploded = a.exploded ? !1 : !0),
              1 < this.dataPoints.length &&
                n._animator.animate(0, 500, function (a) {
                  b(a);
                  l();
                }));
          };
          f();
          h();
          h();
          h();
          h();
          this.disableToolTip = !0;
          this._animator.animate(
            0,
            this.animatedRender ? this.animationDuration : 0,
            function (a) {
              var b = n.plotArea.ctx;
              b.clearRect(m.x1, m.y1, m.width, m.height);
              b.fillStyle = n.backgroundColor;
              b.fillRect(m.x1, m.y1, m.width, m.height);
              a = d[0].startAngle + 2 * Math.PI * a;
              for (b = 0; b < r.length; b++) {
                var c = 0 === b ? d[b].startAngle : e,
                  e = c + (d[b].endAngle - d[b].startAngle),
                  f = !1;
                e > a && ((e = a), (f = !0));
                var g = r[b].color
                  ? r[b].color
                  : k._colorSet[b % k._colorSet.length];
                e > c &&
                  oa(
                    n.plotArea.ctx,
                    d[b].center,
                    d[b].radius,
                    g,
                    k.type,
                    c,
                    e,
                    k.fillOpacity,
                    d[b].percentInnerRadius
                  );
                if (f) break;
              }
              l();
            },
            function () {
              n.disableToolTip = !1;
              n._animator.animate(0, n.animatedRender ? 500 : 0, function (a) {
                b(a);
                l();
              });
            }
          );
        }
      }
    };
    var sa = function (a, f, b, c) {
      "undefined" === typeof b && (b = 1);
      0 >= Math.round(f.y4 - f.y1) ||
        (a.save(),
        (a.globalAlpha = b),
        a.beginPath(),
        a.moveTo(Math.round(f.x1), Math.round(f.y1)),
        a.lineTo(Math.round(f.x2), Math.round(f.y2)),
        a.lineTo(Math.round(f.x3), Math.round(f.y3)),
        a.lineTo(Math.round(f.x4), Math.round(f.y4)),
        "undefined" !== f.x5 &&
          (a.lineTo(Math.round(f.x5), Math.round(f.y5)),
          a.lineTo(Math.round(f.x6), Math.round(f.y6))),
        a.closePath(),
        (a.fillStyle = c ? c : f.color),
        a.fill(),
        (a.globalAplha = 1),
        a.restore());
    };
    s.prototype.renderFunnel = function (a) {
      function f() {
        for (var a = 0, b = [], c = 0; c < x.length; c++) {
          if ("undefined" === typeof x[c].y) return -1;
          x[c].y = "number" === typeof x[c].y ? x[c].y : 0;
          a += Math.abs(x[c].y);
        }
        if (0 === a) return -1;
        for (c = b[0] = 0; c < x.length; c++)
          b.push((Math.abs(x[c].y) * Q) / a);
        return b;
      }
      function b() {
        var a = V,
          b = W,
          c = N,
          d = $,
          e,
          f;
        e = ba;
        f = Z - P;
        headArea = ((f - e) * (b - a + (d - c))) / 2;
        headArea = Math.abs(headArea);
        c = $ - N;
        e = f - e;
        f = c * (f - Z);
        f = Math.abs(f);
        f = headArea + f;
        for (var d = [], g = 0, h = 0; h < x.length; h++) {
          if ("undefined" === typeof x[h].y) return -1;
          x[h].y = "number" === typeof x[h].y ? x[h].y : 0;
          g += Math.abs(x[h].y);
        }
        if (0 === g) return -1;
        for (
          var k = (d[0] = 0), l = 0, m, b = b - a, n = !1, h = 0;
          h < x.length;
          h++
        )
          (a = (Math.abs(x[h].y) * f) / g),
            n
              ? (k = 0 == Number(c.toFixed(3)) ? 0 : a / c)
              : ((sqrt = aa * aa * b * b - 4 * Math.abs(aa) * a),
                0 > sqrt
                  ? ((m = c),
                    (k = ((b + m) * (e - l)) / 2),
                    (a -= k),
                    (k = e - l),
                    (l += e - l),
                    (k += 0 == m ? 0 : a / m),
                    (l += a / m),
                    (n = !0))
                  : ((k = (Math.abs(aa) * b - Math.sqrt(sqrt)) / 2),
                    (m = b - (2 * k) / Math.abs(aa)),
                    (l += k),
                    l > e &&
                      ((l -= k),
                      (m = c),
                      (k = ((b + m) * (e - l)) / 2),
                      (a -= k),
                      (k = e - l),
                      (l += e - l),
                      (k += a / m),
                      (l += a / m),
                      (n = !0)),
                    (b = m))),
            d.push(k);
        return d;
      }
      function c() {
        if (u && x) {
          for (
            var a,
              b,
              c,
              e,
              f,
              g,
              h,
              k,
              l,
              m,
              n,
              q,
              r,
              p,
              w = [],
              s = [],
              A = { percent: null, total: null },
              B = null,
              z = 0;
            z < x.length;
            z++
          )
            (p = O[z]),
              (p =
                "undefined" !== typeof p.x5
                  ? (p.y2 + p.y4) / 2
                  : (p.y2 + p.y3) / 2),
              (p = d(p).x2 + 1),
              (w[z] = S - p - U);
          p = 0.5 * U;
          for (
            var z = 0, pa = x.length - 1;
            z < x.length || 0 <= pa;
            z++, pa--
          ) {
            b = u.reversed ? x[pa] : x[z];
            a = b.color
              ? b.color
              : u.reversed
              ? u._colorSet[(x.length - 1 - z) % u._colorSet.length]
              : u._colorSet[z % u._colorSet.length];
            c = b.indexLabelPlacement || u.indexLabelPlacement || "outside";
            e =
              b.indexLabelBackgroundColor ||
              u.indexLabelBackgroundColor ||
              (v ? "transparent" : null);
            f = b.indexLabelFontColor || u.indexLabelFontColor || "#979797";
            g = y(b.indexLabelFontSize)
              ? u.indexLabelFontSize
              : b.indexLabelFontSize;
            h = b.indexLabelFontStyle || u.indexLabelFontStyle || "normal";
            k = b.indexLabelFontFamily || u.indexLabelFontFamily || "arial";
            l = b.indexLabelFontWeight || u.indexLabelFontWeight || "normal";
            a = b.indexLabelLineColor || u.options.indexLabelLineColor || a;
            m =
              "number" === typeof b.indexLabelLineThickness
                ? b.indexLabelLineThickness
                : "number" === typeof u.indexLabelLineThickness
                ? u.indexLabelLineThickness
                : 2;
            n = b.indexLabelLineDashType || u.indexLabelLineDashType || "solid";
            q =
              "undefined" !== typeof b.indexLabelWrap
                ? b.indexLabelWrap
                : "undefined" !== typeof u.indexLabelWrap
                ? u.indexLabelWrap
                : !0;
            r = u.dataPointIds[z];
            t._eventManager.objectMap[r] = {
              id: r,
              objectType: "dataPoint",
              dataPointIndex: z,
              dataSeriesIndex: 0,
              funnelSection: O[u.reversed ? x.length - 1 - z : z],
            };
            "inside" === u.indexLabelPlacement &&
              ((w[z] =
                z !== da
                  ? u.reversed
                    ? O[z].x2 - O[z].x1
                    : O[z].x3 - O[z].x4
                  : O[z].x3 - O[z].x6),
              20 > w[z] &&
                ((w[z] =
                  z !== da
                    ? u.reversed
                      ? O[z].x3 - O[z].x4
                      : O[z].x2 - O[z].x1
                    : O[z].x2 - O[z].x1),
                (w[z] /= 2)));
            r = b.indexLabelMaxWidth
              ? b.indexLabelMaxWidth
              : u.options.indexLabelMaxWidth
              ? u.indexLabelMaxWidth
              : w[z];
            if (r > w[z] || 0 > r) r = w[z];
            s[z] = "inside" === u.indexLabelPlacement ? O[z].height : !1;
            A = t.getPercentAndTotal(u, b);
            if (u.indexLabelFormatter || b.indexLabelFormatter)
              B = {
                chart: t.options,
                dataSeries: u,
                dataPoint: b,
                total: A.total,
                percent: A.percent,
              };
            b = b.indexLabelFormatter
              ? b.indexLabelFormatter(B)
              : b.indexLabel
              ? t.replaceKeywordsWithValue(b.indexLabel, b, u, z)
              : u.indexLabelFormatter
              ? u.indexLabelFormatter(B)
              : u.indexLabel
              ? t.replaceKeywordsWithValue(u.indexLabel, b, u, z)
              : b.label
              ? b.label
              : "";
            0 >= m && (m = 0);
            1e3 > r && 1e3 - r < p && (r += 1e3 - r);
            R.roundRect || Aa(R);
            c = new ia(R, {
              fontSize: g,
              fontFamily: k,
              fontColor: f,
              fontStyle: h,
              fontWeight: l,
              horizontalAlign: c,
              backgroundColor: e,
              maxWidth: r,
              maxHeight: !1 === s[z] ? (q ? 4.28571429 * g : 1.5 * g) : s[z],
              text: b,
              padding: ea,
            });
            c.measureText();
            H.push({
              textBlock: c,
              id: u.reversed ? pa : z,
              isDirty: !1,
              lineColor: a,
              lineThickness: m,
              lineDashType: n,
              height: c.height < c.maxHeight ? c.height : c.maxHeight,
              width: c.width < c.maxWidth ? c.width : c.maxWidth,
            });
          }
        }
      }
      function e() {
        var a,
          b,
          c,
          d,
          e,
          f = [];
        e = !1;
        c = 0;
        for (
          var g = S - W - U / 2,
            g = u.options.indexLabelMaxWidth
              ? u.indexLabelMaxWidth > g
                ? g
                : u.indexLabelMaxWidth
              : g,
            h = H.length - 1;
          0 <= h;
          h--
        ) {
          dataPoint = x[H[h].id];
          c = H[h];
          d = c.textBlock;
          b = (a = m(h) < O.length ? H[m(h)] : null) ? a.textBlock : null;
          c = c.height;
          a && d.y + c + ea > b.y && (e = !0);
          c = dataPoint.indexLabelMaxWidth || g;
          if (c > g || 0 > c) c = g;
          f.push(c);
        }
        if (e)
          for (h = H.length - 1; 0 <= h; h--)
            (a = O[h]),
              (H[h].textBlock.maxWidth = f[f.length - (h + 1)]),
              H[h].textBlock.measureText(),
              (H[h].textBlock.x = S - g),
              (c =
                H[h].textBlock.height < H[h].textBlock.maxHeight
                  ? H[h].textBlock.height
                  : H[h].textBlock.maxHeight),
              (e =
                H[h].textBlock.width < H[h].textBlock.maxWidth
                  ? H[h].textBlock.width
                  : H[h].textBlock.maxWidth),
              (H[h].height = c),
              (H[h].width = e),
              (c =
                "undefined" !== typeof a.x5
                  ? (a.y2 + a.y4) / 2
                  : (a.y2 + a.y3) / 2),
              (H[h].textBlock.y = c - H[h].height / 2),
              u.reversed
                ? (H[h].textBlock.y + H[h].height > T + z &&
                    (H[h].textBlock.y = T + z - H[h].height),
                  H[h].textBlock.y < qa - z && (H[h].textBlock.y = qa - z))
                : (H[h].textBlock.y < T - z && (H[h].textBlock.y = T - z),
                  H[h].textBlock.y + H[h].height > qa + z &&
                    (H[h].textBlock.y = qa + z - H[h].height));
      }
      function g() {
        var a, b, c, e;
        if ("inside" !== u.indexLabelPlacement)
          for (var f = 0; f < O.length; f++)
            0 == H[f].textBlock.text.length
              ? (H[f].isDirty = !0)
              : ((a = O[f]),
                (c =
                  "undefined" !== typeof a.x5
                    ? (a.y2 + a.y4) / 2
                    : (a.y2 + a.y3) / 2),
                (b = u.reversed
                  ? "undefined" !== typeof a.x5
                    ? c > X
                      ? d(c).x2 + 1
                      : (a.x2 + a.x3) / 2 + 1
                    : (a.x2 + a.x3) / 2 + 1
                  : "undefined" !== typeof a.x5
                  ? c < X
                    ? d(c).x2 + 1
                    : (a.x4 + a.x3) / 2 + 1
                  : (a.x2 + a.x3) / 2 + 1),
                (H[f].textBlock.x = b + U),
                (H[f].textBlock.y = c - H[f].height / 2),
                u.reversed
                  ? (H[f].textBlock.y + H[f].height > T + z &&
                      (H[f].textBlock.y = T + z - H[f].height),
                    H[f].textBlock.y < qa - z && (H[f].textBlock.y = qa - z))
                  : (H[f].textBlock.y < T - z && (H[f].textBlock.y = T - z),
                    H[f].textBlock.y + H[f].height > qa + z &&
                      (H[f].textBlock.y = qa + z - H[f].height)));
        else
          for (f = 0; f < O.length; f++)
            0 == H[f].textBlock.text.length
              ? (H[f].isDirty = !0)
              : ((a = O[f]),
                (b = a.height),
                (c = H[f].height),
                (e = H[f].width),
                b >= c
                  ? ((b =
                      f != da
                        ? (a.x4 + a.x3) / 2 - e / 2
                        : (a.x5 + a.x4) / 2 - e / 2),
                    (c =
                      f != da
                        ? (a.y1 + a.y3) / 2 - c / 2
                        : (a.y1 + a.y4) / 2 - c / 2),
                    (H[f].textBlock.x = b),
                    (H[f].textBlock.y = c))
                  : (H[f].isDirty = !0));
      }
      function h() {
        function a(b, c) {
          var d;
          if (0 > b || b >= H.length) return 0;
          var e,
            f = H[b].textBlock;
          if (0 > c) {
            c *= -1;
            e = q(b);
            d = l(e, b);
            if (d >= c) return (f.y -= c), c;
            if (0 == b) return 0 < d && (f.y -= d), d;
            d += a(e, -(c - d));
            0 < d && (f.y -= d);
            return d;
          }
          e = m(b);
          d = l(b, e);
          if (d >= c) return (f.y += c), c;
          if (b == O.length - 1) return 0 < d && (f.y += d), d;
          d += a(e, c - d);
          0 < d && (f.y += d);
          return d;
        }
        function b() {
          var a,
            d,
            e,
            f,
            g = 0,
            h;
          f = (Z - ba + 2 * z) / n;
          h = n;
          for (var k, l = 1; l < h; l++) {
            e = l * f;
            for (var r = H.length - 1; 0 <= r; r--)
              !H[r].isDirty &&
                H[r].textBlock.y < e &&
                H[r].textBlock.y + H[r].height > e &&
                ((k = m(r)),
                !(k >= H.length - 1) &&
                  H[r].textBlock.y + H[r].height + ea > H[k].textBlock.y &&
                  (H[r].textBlock.y =
                    H[r].textBlock.y + H[r].height - e > e - H[r].textBlock.y
                      ? e + 1
                      : e - H[r].height - 1));
          }
          for (k = O.length - 1; 0 < k; k--)
            if (!H[k].isDirty) {
              e = q(k);
              if (0 > e && ((e = 0), H[e].isDirty)) break;
              if (H[k].textBlock.y < H[e].textBlock.y + H[e].height) {
                d = d || k;
                f = k;
                for (
                  h = 0;
                  H[f].textBlock.y < H[e].textBlock.y + H[e].height + ea;

                ) {
                  a = a || H[f].textBlock.y + H[f].height;
                  h += H[f].height;
                  h += ea;
                  f = e;
                  if (0 >= f) {
                    f = 0;
                    h += H[f].height;
                    break;
                  }
                  e = q(f);
                  if (0 > e) {
                    f = 0;
                    h += H[f].height;
                    break;
                  }
                }
                if (f != k) {
                  g = H[f].textBlock.y;
                  a -= g;
                  a = h - a;
                  g = c(a, d, f);
                  break;
                }
              }
            }
          return g;
        }
        function c(a, b, d) {
          var e = [],
            f = 0,
            g = 0;
          for (a = Math.abs(a); d <= b; d++) e.push(O[d]);
          e.sort(function (a, b) {
            return a.height - b.height;
          });
          for (d = 0; d < e.length; d++)
            if (((b = e[d]), f < a))
              g++,
                (f += H[b.id].height + ea),
                (H[b.id].textBlock.text = ""),
                (H[b.id].indexLabelText = ""),
                (H[b.id].isDirty = !0),
                H[b.id].textBlock.measureText();
            else break;
          return g;
        }
        for (var d, e, f, g, h, k, n = 1, r = 0; r < 2 * n; r++) {
          for (
            var p = H.length - 1;
            0 <= p &&
            !((previousTextBlock = (previousLabel = 0 <= q(p) ? H[q(p)] : null)
              ? previousLabel.textBlock
              : null),
            (f = H[p]),
            (g = f.textBlock),
            (k = (h = m(p) < O.length ? H[m(p)] : null) ? h.textBlock : null),
            (d = +f.height.toFixed(6)),
            (e = +g.y.toFixed(6)),
            !f.isDirty &&
              h &&
              e + d + ea > +k.y.toFixed(6) &&
              ((d = g.y + d + ea - k.y),
              (e = a(p, -d)),
              e < d && (0 < e && (d -= e), (e = a(m(p), d)), e != d)));
            p--
          );
          b();
        }
      }
      function l(a, b) {
        return (
          (b < O.length ? H[b].textBlock.y : u.reversed ? T + z : qa + z) -
          (0 > a
            ? u.reversed
              ? qa - z
              : T - z
            : H[a].textBlock.y + H[a].height + ea)
        );
      }
      function n(a, b, c) {
        var d,
          e,
          f,
          h = [],
          l = z,
          m = [];
        -1 !== b &&
          (0 <= ja.indexOf(b)
            ? ((e = ja.indexOf(b)), ja.splice(e, 1))
            : (ja.push(b),
              (ja = ja.sort(function (a, b) {
                return a - b;
              }))));
        if (0 === ja.length) h = ha;
        else {
          e =
            (z *
              (1 != ja.length || (0 != ja[0] && ja[0] != O.length - 1)
                ? 2
                : 1)) /
            k();
          for (var n = 0; n < O.length; n++) {
            if (1 == ja.length && 0 == ja[0]) {
              if (0 === n) {
                h.push(ha[n]);
                d = l;
                continue;
              }
            } else 0 === n && (d = -1 * l);
            h.push(ha[n] + d);
            if (0 <= ja.indexOf(n) || (n < O.length && 0 <= ja.indexOf(n + 1)))
              d += e;
          }
        }
        f = (function () {
          for (var a = [], b = 0; b < O.length; b++) a.push(h[b] - O[b].y1);
          return a;
        })();
        var q = {
          startTime: new Date().getTime(),
          duration: c || 500,
          easingFunction: function (a, b, c, d) {
            return L.easing.easeOutQuart(a, b, c, d);
          },
          changeSection: function (a) {
            for (var b, c, d = 0; d < O.length; d++)
              (b = f[d]),
                (c = O[d]),
                (newY = b * a),
                "undefined" === typeof m[d] && (m[d] = 0),
                0 > m && (m *= -1),
                (c.y1 += newY - m[d]),
                (c.y2 += newY - m[d]),
                (c.y3 += newY - m[d]),
                (c.y4 += newY - m[d]),
                c.y5 && ((c.y5 += newY - m[d]), (c.y6 += newY - m[d])),
                (m[d] = newY);
          },
        };
        a._animator.animate(
          0,
          c,
          function (c) {
            var d = a.plotArea.ctx || a.ctx;
            ga = !0;
            d.clearRect(B.x1, B.y1, B.x2 - B.x1, B.y2 - B.y1);
            d.fillStyle = a.backgroundColor;
            d.fillRect(B.x1, B.y1, B.width, B.height);
            q.changeSection(c, b);
            var e = {};
            e.dataSeries = u;
            e.dataPoint = u.reversed
              ? u.dataPoints[x.length - 1 - b]
              : u.dataPoints[b];
            e.index = u.reversed ? x.length - 1 - b : b;
            a.toolTip.highlightObjects([e]);
            for (e = 0; e < O.length; e++) sa(d, O[e], u.fillOpacity);
            s(d);
            M && ("inside" !== u.indexLabelPlacement ? r(d) : g(), p(d));
            1 <= c && (ga = !1);
          },
          null,
          L.easing.easeOutQuart
        );
      }
      function k() {
        for (var a = 0, b = 0; b < O.length - 1; b++)
          (0 <= ja.indexOf(b) || 0 <= ja.indexOf(b + 1)) && a++;
        return a;
      }
      function r(a) {
        for (var b, c, e, f, g = 0; g < O.length; g++)
          (f = 1 === H[g].lineThickness % 2 ? 0.5 : 0),
            (c = (((O[g].y2 + O[g].y4) / 2) << 0) + f),
            (b = d(c).x2 - 1),
            (e = H[g].textBlock.x),
            (f = ((H[g].textBlock.y + H[g].height / 2) << 0) + f),
            H[g].isDirty ||
              0 == H[g].lineThickness ||
              ((a.strokeStyle = H[g].lineColor),
              (a.lineWidth = H[g].lineThickness),
              a.setLineDash &&
                a.setLineDash(F(H[g].lineDashType, H[g].lineThickness)),
              a.beginPath(),
              a.moveTo(b, c),
              a.lineTo(e, f),
              a.stroke());
      }
      function q(a) {
        for (a -= 1; -1 <= a && -1 != a && H[a].isDirty; a--);
        return a;
      }
      function m(a) {
        for (a += 1; a <= O.length && a != O.length && H[a].isDirty; a++);
        return a;
      }
      function d(a) {
        for (var b, c = 0; c < x.length; c++)
          if (O[c].y1 < a && O[c].y4 > a) {
            b = O[c];
            break;
          }
        return b
          ? ((a = b.y6
              ? a > b.y6
                ? b.x3 + ((b.x4 - b.x3) / (b.y4 - b.y3)) * (a - b.y3)
                : b.x2 + ((b.x3 - b.x2) / (b.y3 - b.y2)) * (a - b.y2)
              : b.x2 + ((b.x3 - b.x2) / (b.y3 - b.y2)) * (a - b.y2)),
            { x1: a, x2: a })
          : -1;
      }
      function p(a) {
        for (var b = 0; b < O.length; b++)
          H[b].isDirty ||
            (a && (H[b].textBlock.ctx = a), H[b].textBlock.render(!0));
      }
      function s(a) {
        t.plotArea.layoutManager.reset();
        a.roundRect || Aa(a);
        t.title &&
          (t.title.dockInsidePlotArea ||
            ("center" === t.title.horizontalAlign &&
              "center" === t.title.verticalAlign)) &&
          ((t.title.ctx = a), t.title.render());
        if (t.subtitles)
          for (var b = 0; b < t.subtitles.length; b++) {
            var c = t.subtitles[b];
            if (
              c.dockInsidePlotArea ||
              ("center" === c.horizontalAlign && "center" === c.verticalAlign)
            )
              (t.subtitles.ctx = a), c.render();
          }
        t.legend &&
          (t.legend.dockInsidePlotArea ||
            ("center" === t.legend.horizontalAlign &&
              "center" === t.legend.verticalAlign)) &&
          ((t.legend.ctx = a), t.legend.render());
        Fa.fNg && Fa.fNg(t);
      }
      var t = this;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        for (
          var u = this.data[a.dataSeriesIndexes[0]],
            x = u.dataPoints,
            B = this.plotArea,
            z = 0.025 * B.width,
            J = 0.01 * B.width,
            A = 0,
            Q = B.height - 2 * z,
            I = Math.min(B.width - 2 * J, 2.8 * B.height),
            M = !1,
            K = 0;
          K < x.length;
          K++
        )
          if (
            (!M &&
              "undefined" !== typeof x[K].indexLabel &&
              null !== x[K].indexLabel &&
              0 < x[K].indexLabel.toString().length &&
              (M = !0),
            !M &&
              "undefined" !== typeof x[K].label &&
              null !== x[K].label &&
              0 < x[K].label.toString().length &&
              (M = !0),
            (!M && "function" === typeof u.indexLabelFormatter) ||
              "function" === typeof x[K].indexLabelFormatter)
          )
            M = !0;
        M =
          M ||
          ("undefined" !== typeof u.indexLabel &&
            null !== u.indexLabel &&
            0 < u.indexLabel.toString().length);
        ("inside" !== u.indexLabelPlacement && M) ||
          (J = (B.width - 0.75 * I) / 2);
        var K = B.x1 + J,
          S = B.x2 - J,
          ba = B.y1 + z,
          Z = B.y2 - z,
          R = a.targetCanvasCtx || this.plotArea.ctx || this.ctx;
        if (0 != u.length && u.dataPoints && u.visible && 0 !== x.length) {
          var P, D;
          a = (75 * I) / 100;
          var U = (30 * (S - a)) / 100;
          "funnel" === u.type
            ? ((P = y(u.options.neckHeight) ? 0.35 * Q : u.neckHeight),
              (D = y(u.options.neckWidth) ? 0.25 * a : u.neckWidth),
              "string" === typeof P && P.match(/%$/)
                ? ((P = parseInt(P)), (P = (P * Q) / 100))
                : (P = parseInt(P)),
              "string" === typeof D && D.match(/%$/)
                ? ((D = parseInt(D)), (D = (D * a) / 100))
                : (D = parseInt(D)),
              P > Q ? (P = Q) : 0 >= P && (P = 0),
              D > a ? (D = a - 0.5) : 0 >= D && (D = 0))
            : "pyramid" === u.type &&
              ((D = P = 0), (u.reversed = u.reversed ? !1 : !0));
          var J = K + a / 2,
            V = K,
            W = K + a,
            T = u.reversed ? Z : ba,
            N = J - D / 2,
            $ = J + D / 2,
            X = u.reversed ? ba + P : Z - P,
            qa = u.reversed ? ba : Z;
          a = [];
          var J = [],
            O = [],
            I = [],
            Y = ba,
            da,
            aa = (X - T) / (N - V),
            fa = -aa,
            K =
              "area" === (u.valueRepresents ? u.valueRepresents : "height")
                ? b()
                : f();
          if (-1 !== K) {
            if (u.reversed)
              for (I.push(Y), D = K.length - 1; 0 < D; D--)
                (Y += K[D]), I.push(Y);
            else for (D = 0; D < K.length; D++) (Y += K[D]), I.push(Y);
            if (u.reversed)
              for (D = 0; D < K.length; D++)
                I[D] < X
                  ? (a.push(N), J.push($), (da = D))
                  : (a.push((I[D] - T + aa * V) / aa),
                    J.push((I[D] - T + fa * W) / fa));
            else
              for (D = 0; D < K.length; D++)
                I[D] < X
                  ? (a.push((I[D] - T + aa * V) / aa),
                    J.push((I[D] - T + fa * W) / fa),
                    (da = D))
                  : (a.push(N), J.push($));
            for (D = 0; D < K.length - 1; D++)
              (Y = u.reversed
                ? x[x.length - 1 - D].color
                  ? x[x.length - 1 - D].color
                  : u._colorSet[(x.length - 1 - D) % u._colorSet.length]
                : x[D].color
                ? x[D].color
                : u._colorSet[D % u._colorSet.length]),
                D === da
                  ? O.push({
                      x1: a[D],
                      y1: I[D],
                      x2: J[D],
                      y2: I[D],
                      x3: $,
                      y3: X,
                      x4: J[D + 1],
                      y4: I[D + 1],
                      x5: a[D + 1],
                      y5: I[D + 1],
                      x6: N,
                      y6: X,
                      id: D,
                      height: I[D + 1] - I[D],
                      color: Y,
                    })
                  : O.push({
                      x1: a[D],
                      y1: I[D],
                      x2: J[D],
                      y2: I[D],
                      x3: J[D + 1],
                      y3: I[D + 1],
                      x4: a[D + 1],
                      y4: I[D + 1],
                      id: D,
                      height: I[D + 1] - I[D],
                      color: Y,
                    });
            var ea = 2,
              H = [],
              ga = !1,
              ja = [],
              ha = [],
              K = !1;
            a = a = 0;
            Ba(ja);
            for (D = 0; D < x.length; D++)
              x[D].exploded &&
                ((K = !0), u.reversed ? ja.push(x.length - 1 - D) : ja.push(D));
            R.clearRect(B.x1, B.y1, B.width, B.height);
            R.fillStyle = t.backgroundColor;
            R.fillRect(B.x1, B.y1, B.width, B.height);
            if (
              M &&
              u.visible &&
              (c(), g(), e(), "inside" !== u.indexLabelPlacement)
            ) {
              h();
              for (D = 0; D < x.length; D++)
                H[D].isDirty ||
                  ((a = H[D].textBlock.x + H[D].width),
                  (a = (S - a) / 2),
                  0 == D && (A = a),
                  A > a && (A = a));
              for (D = 0; D < O.length; D++)
                (O[D].x1 += A),
                  (O[D].x2 += A),
                  (O[D].x3 += A),
                  (O[D].x4 += A),
                  O[D].x5 && ((O[D].x5 += A), (O[D].x6 += A)),
                  (H[D].textBlock.x += A);
            }
            for (D = 0; D < O.length; D++)
              (A = O[D]), sa(R, A, u.fillOpacity), ha.push(A.y1);
            s(R);
            M &&
              u.visible &&
              ("inside" === u.indexLabelPlacement || t.animationEnabled || r(R),
              t.animationEnabled || p());
            if (!M)
              for (D = 0; D < x.length; D++)
                (A = u.dataPointIds[D]),
                  (a = {
                    id: A,
                    objectType: "dataPoint",
                    dataPointIndex: D,
                    dataSeriesIndex: 0,
                    funnelSection: O[u.reversed ? x.length - 1 - D : D],
                  }),
                  (t._eventManager.objectMap[A] = a);
            !t.animationEnabled && K
              ? n(t, -1, 0)
              : t.animationEnabled && !t.animatedRender && n(t, -1, 0);
            this.funnelPyramidClickHandler = function (a) {
              var b = -1;
              if (
                !ga &&
                !t.isAnimating &&
                (y(a.dataSeries.explodeOnClick) ||
                  a.dataSeries.explodeOnClick) &&
                ((b = u.reversed
                  ? x.length - 1 - a.dataPointIndex
                  : a.dataPointIndex),
                0 <= b)
              ) {
                a = b;
                if ("funnel" === u.type || "pyramid" === u.type)
                  u.reversed
                    ? (x[x.length - 1 - a].exploded = x[x.length - 1 - a]
                        .exploded
                        ? !1
                        : !0)
                    : (x[a].exploded = x[a].exploded ? !1 : !0);
                n(t, b, 500);
              }
            };
            return {
              source: R,
              dest: this.plotArea.ctx,
              animationCallback: function (a, b) {
                L.fadeInAnimation(a, b);
                1 <= a && (n(t, -1, 500), s(t.plotArea.ctx || t.ctx));
              },
              easingFunction: L.easing.easeInQuad,
              animationBase: 0,
            };
          }
        }
      }
    };
    s.prototype.animationRequestId = null;
    s.prototype.requestAnimFrame = (function () {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (a) {
          window.setTimeout(a, 1e3 / 60);
        }
      );
    })();
    s.prototype.cancelRequestAnimFrame =
      window.cancelAnimationFrame ||
      window.webkitCancelRequestAnimationFrame ||
      window.mozCancelRequestAnimationFrame ||
      window.oCancelRequestAnimationFrame ||
      window.msCancelRequestAnimationFrame ||
      clearTimeout;
    s.prototype.set = function (a, f, b) {
      b = "undefined" === typeof b ? !0 : b;
      "options" === a
        ? ((this.options = f), b && this.render())
        : s.base.set.call(this, a, f, b);
    };
    s.prototype.exportChart = function (a) {
      a = "undefined" === typeof a ? {} : a;
      var f = a.format ? a.format : "png",
        b = a.fileName ? a.fileName : this.exportFileName;
      if (a.toDataURL) return this.canvas.toDataURL("image/" + f);
      t(this.canvas, f, b);
    };
    s.prototype.print = function () {
      var a = this.exportChart({ toDataURL: !0 }),
        f = document.createElement("iframe");
      f.setAttribute("class", "canvasjs-chart-print-frame");
      f.setAttribute(
        "style",
        "position:absolute; width:100%; border: 0px; margin: 0px 0px 0px 0px; padding 0px 0px 0px 0px;"
      );
      f.style.height = this.height + "px";
      this._canvasJSContainer.appendChild(f);
      var b = this,
        c = f.contentWindow || f.contentDocument.document || f.contentDocument;
      c.document.open();
      c.document.write(
        '<!DOCTYPE HTML>\n<html><body style="margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"><img src="' +
          a +
          '"/><body/></html>'
      );
      c.document.close();
      setTimeout(function () {
        c.focus();
        c.print();
        setTimeout(function () {
          b._canvasJSContainer.removeChild(f);
        }, 1e3);
      }, 500);
    };
    s.prototype.getPercentAndTotal = function (a, f) {
      var b = null,
        c = null,
        e = null;
      if (0 <= a.type.indexOf("stacked"))
        (c = 0),
          (b = f.x.getTime ? f.x.getTime() : f.x),
          b in a.plotUnit.yTotals &&
            ((c = a.plotUnit.yTotals[b]),
            (e = isNaN(f.y) ? 0 : 100 * (f.y / c)));
      else if (
        "pie" === a.type ||
        "doughnut" === a.type ||
        "funnel" === a.type ||
        "pyramid" === a.type
      ) {
        for (i = c = 0; i < a.dataPoints.length; i++)
          isNaN(a.dataPoints[i].y) || (c += a.dataPoints[i].y);
        e = isNaN(f.y) ? 0 : 100 * (f.y / c);
      }
      return { percent: e, total: c };
    };
    s.prototype.replaceKeywordsWithValue = function (a, f, b, c, e) {
      var g = this;
      e = "undefined" === typeof e ? 0 : e;
      if (
        (0 <= b.type.indexOf("stacked") ||
          "pie" === b.type ||
          "doughnut" === b.type ||
          "funnel" === b.type ||
          "pyramid" === b.type) &&
        (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"))
      ) {
        var h = "#percent",
          l = "#total",
          n = this.getPercentAndTotal(b, f),
          l = isNaN(n.total) ? l : n.total,
          h = isNaN(n.percent) ? h : n.percent;
        do {
          n = "";
          if (b.percentFormatString) n = b.percentFormatString;
          else {
            var n = "#,##0.",
              k = Math.max(Math.ceil(Math.log(1 / Math.abs(h)) / Math.LN10), 2);
            if (isNaN(k) || !isFinite(k)) k = 2;
            for (var r = 0; r < k; r++) n += "#";
            b.percentFormatString = n;
          }
          a = a.replace("#percent", X(h, n, g._cultureInfo));
          a = a.replace(
            "#total",
            X(
              l,
              b.yValueFormatString ? b.yValueFormatString : "#,##0.########",
              g._cultureInfo
            )
          );
        } while (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"));
      }
      return a.replace(/\{.*?\}|"[^"]*"|'[^']*'/g, function (a) {
        if (
          ('"' === a[0] && '"' === a[a.length - 1]) ||
          ("'" === a[0] && "'" === a[a.length - 1])
        )
          return a.slice(1, a.length - 1);
        a = Ea(a.slice(1, a.length - 1));
        a = a.replace("#index", e);
        var h = null;
        try {
          var d = a.match(/(.*?)\s*\[\s*(.*?)\s*\]/);
          d && 0 < d.length && ((h = Ea(d[2])), (a = Ea(d[1])));
        } catch (k) {}
        d = null;
        if ("color" === a)
          return "waterfall" === b.type
            ? f.color
              ? f.color
              : -1 < f.y
              ? b.risingColor
              : b.fallingColor
            : "error" === b.type
            ? b.color
              ? b.color
              : b._colorSet[h % b._colorSet.length]
            : f.color
            ? f.color
            : b.color
            ? b.color
            : b._colorSet[c % b._colorSet.length];
        if (f.hasOwnProperty(a)) d = f;
        else if (b.hasOwnProperty(a)) d = b;
        else return "";
        d = d[a];
        null !== h && (d = d[h]);
        if ("x" === a)
          if (
            "dateTime" === b.axisX.valueType ||
            "dateTime" === b.xValueType ||
            (f.x && f.x.getTime)
          ) {
            if (
              g.plotInfo.plotTypes[0].plotUnits[0].axisX &&
              !g.plotInfo.plotTypes[0].plotUnits[0].axisX.logarithmic
            )
              return za(
                d,
                f.xValueFormatString
                  ? f.xValueFormatString
                  : b.xValueFormatString
                  ? b.xValueFormatString
                  : (b.xValueFormatString =
                      g.axisX && g.axisX.autoValueFormatString
                        ? g.axisX.autoValueFormatString
                        : "DD MMM YY"),
                g._cultureInfo
              );
          } else
            return X(
              d,
              f.xValueFormatString
                ? f.xValueFormatString
                : b.xValueFormatString
                ? b.xValueFormatString
                : (b.xValueFormatString = "#,##0.########"),
              g._cultureInfo
            );
        else
          return "y" === a
            ? X(
                d,
                f.yValueFormatString
                  ? f.yValueFormatString
                  : b.yValueFormatString
                  ? b.yValueFormatString
                  : (b.yValueFormatString = "#,##0.########"),
                g._cultureInfo
              )
            : "z" === a
            ? X(
                d,
                f.zValueFormatString
                  ? f.zValueFormatString
                  : b.zValueFormatString
                  ? b.zValueFormatString
                  : (b.zValueFormatString = "#,##0.########"),
                g._cultureInfo
              )
            : d;
      });
    };
    ma(U, T);
    U.prototype.render = function () {
      var a = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
        f = a.layoutManager.getFreeSpace(),
        b = null,
        c = 0,
        e = 0,
        g = 0,
        h = 0,
        l = (this.markerMargin =
          this.chart.options.legend &&
          !y(this.chart.options.legend.markerMargin)
            ? this.chart.options.legend.markerMargin
            : 0.3 * this.fontSize);
      this.height = 0;
      var n = [],
        k = [];
      "top" === this.verticalAlign || "bottom" === this.verticalAlign
        ? ((this.orientation = "horizontal"),
          (b = this.verticalAlign),
          (g = this.maxWidth =
            null !== this.maxWidth ? this.maxWidth : f.width),
          (h = this.maxHeight =
            null !== this.maxHeight ? this.maxHeight : 0.5 * f.height))
        : "center" === this.verticalAlign &&
          ((this.orientation = "vertical"),
          (b = this.horizontalAlign),
          (g = this.maxWidth =
            null !== this.maxWidth ? this.maxWidth : 0.5 * f.width),
          (h = this.maxHeight =
            null !== this.maxHeight ? this.maxHeight : f.height));
      for (var r = [], q = 0; q < this.dataSeries.length; q++) {
        var m = this.dataSeries[q];
        if (m.dataPoints && m.dataPoints.length)
          if (
            "pie" !== m.type &&
            "doughnut" !== m.type &&
            "funnel" !== m.type &&
            "pyramid" !== m.type
          ) {
            var d = (m.legendMarkerType = m.legendMarkerType
                ? m.legendMarkerType
                : ("line" !== m.type &&
                    "stepLine" !== m.type &&
                    "spline" !== m.type &&
                    "scatter" !== m.type &&
                    "bubble" !== m.type) ||
                  !m.markerType
                ? "error" === m.type && m._linkedSeries
                  ? m._linkedSeries.legendMarkerType
                    ? m._linkedSeries.legendMarkerType
                    : S.getDefaultLegendMarker(m._linkedSeries.type)
                  : S.getDefaultLegendMarker(m.type)
                : m.markerType),
              p = m.legendText
                ? m.legendText
                : this.itemTextFormatter
                ? this.itemTextFormatter({
                    chart: this.chart,
                    legend: this.options,
                    dataSeries: m,
                    dataPoint: null,
                  })
                : m.name,
              s = (m.legendMarkerColor = m.legendMarkerColor
                ? m.legendMarkerColor
                : m.markerColor
                ? m.markerColor
                : "error" === m.type
                ? y(m.whiskerColor)
                  ? m._colorSet[0]
                  : m.whiskerColor
                : m._colorSet[0]),
              t =
                m.markerSize ||
                ("line" !== m.type &&
                  "stepLine" !== m.type &&
                  "spline" !== m.type)
                  ? 0.75 * this.lineHeight
                  : 0,
              u = m.legendMarkerBorderColor
                ? m.legendMarkerBorderColor
                : m.markerBorderColor,
              v = m.legendMarkerBorderThickness
                ? m.legendMarkerBorderThickness
                : m.markerBorderThickness
                ? Math.max(1, Math.round(0.2 * t))
                : 0;
            "error" === m.type && r.push(s);
            p = this.chart.replaceKeywordsWithValue(p, m.dataPoints[0], m, q);
            d = {
              markerType: d,
              markerColor: s,
              text: p,
              textBlock: null,
              chartType: m.type,
              markerSize: t,
              lineColor: m._colorSet[0],
              dataSeriesIndex: m.index,
              dataPointIndex: null,
              markerBorderColor: u,
              markerBorderThickness: v,
            };
            n.push(d);
          } else
            for (var x = 0; x < m.dataPoints.length; x++) {
              var z = m.dataPoints[x],
                d = z.legendMarkerType
                  ? z.legendMarkerType
                  : m.legendMarkerType
                  ? m.legendMarkerType
                  : S.getDefaultLegendMarker(m.type),
                p = z.legendText
                  ? z.legendText
                  : m.legendText
                  ? m.legendText
                  : this.itemTextFormatter
                  ? this.itemTextFormatter({
                      chart: this.chart,
                      legend: this.options,
                      dataSeries: m,
                      dataPoint: z,
                    })
                  : z.name
                  ? z.name
                  : "DataPoint: " + (x + 1),
                s = z.legendMarkerColor
                  ? z.legendMarkerColor
                  : m.legendMarkerColor
                  ? m.legendMarkerColor
                  : z.color
                  ? z.color
                  : m.color
                  ? m.color
                  : m._colorSet[x % m._colorSet.length],
                t = 0.75 * this.lineHeight,
                u = z.legendMarkerBorderColor
                  ? z.legendMarkerBorderColor
                  : m.legendMarkerBorderColor
                  ? m.legendMarkerBorderColor
                  : z.markerBorderColor
                  ? z.markerBorderColor
                  : m.markerBorderColor,
                v = z.legendMarkerBorderThickness
                  ? z.legendMarkerBorderThickness
                  : m.legendMarkerBorderThickness
                  ? m.legendMarkerBorderThickness
                  : z.markerBorderThickness || m.markerBorderThickness
                  ? Math.max(1, Math.round(0.2 * t))
                  : 0,
                p = this.chart.replaceKeywordsWithValue(p, z, m, x),
                d = {
                  markerType: d,
                  markerColor: s,
                  text: p,
                  textBlock: null,
                  chartType: m.type,
                  markerSize: t,
                  dataSeriesIndex: q,
                  dataPointIndex: x,
                  markerBorderColor: u,
                  markerBorderThickness: v,
                };
              (z.showInLegend || (m.showInLegend && !1 !== z.showInLegend)) &&
                n.push(d);
            }
      }
      !0 === this.reversed && n.reverse();
      if (0 < n.length) {
        m = null;
        p = x = z = v = 0;
        z =
          null !== this.itemWidth
            ? null !== this.itemMaxWidth
              ? Math.min(this.itemWidth, this.itemMaxWidth, g)
              : (this.itemMaxWidth = Math.min(this.itemWidth, g))
            : null !== this.itemMaxWidth
            ? Math.min(this.itemMaxWidth, g)
            : (this.itemMaxWidth = g);
        t = 0 === t ? 0.75 * this.lineHeight : t;
        z -= t + l;
        for (q = 0; q < n.length; q++) {
          d = n[q];
          s = z;
          if (
            "line" === d.chartType ||
            "spline" === d.chartType ||
            "stepLine" === d.chartType
          )
            s -= 2 * 0.1 * this.lineHeight;
          if (
            !(
              0 >= h ||
              "undefined" === typeof h ||
              0 >= s ||
              "undefined" === typeof s
            )
          ) {
            if ("horizontal" === this.orientation) {
              d.textBlock = new ia(this.ctx, {
                x: 0,
                y: 0,
                maxWidth: s,
                maxHeight: this.itemWrap ? h : this.lineHeight,
                angle: 0,
                text: d.text,
                horizontalAlign: "left",
                fontSize: this.fontSize,
                fontFamily: this.fontFamily,
                fontWeight: this.fontWeight,
                fontColor: this.fontColor,
                fontStyle: this.fontStyle,
                textBaseline: "middle",
              });
              d.textBlock.measureText();
              null !== this.itemWidth &&
                (d.textBlock.width =
                  this.itemWidth -
                  (t +
                    l +
                    ("line" === d.chartType ||
                    "spline" === d.chartType ||
                    "stepLine" === d.chartType
                      ? 2 * 0.1 * this.lineHeight
                      : 0)));
              if (
                !m ||
                m.width +
                  Math.round(
                    d.textBlock.width +
                      t +
                      l +
                      (0 === m.width ? 0 : this.horizontalSpacing) +
                      ("line" === d.chartType ||
                      "spline" === d.chartType ||
                      "stepLine" === d.chartType
                        ? 2 * 0.1 * this.lineHeight
                        : 0)
                  ) >
                  g
              )
                (m = { items: [], width: 0 }),
                  k.push(m),
                  (this.height += x),
                  (x = 0);
              x = Math.max(x, d.textBlock.height);
            } else
              (d.textBlock = new ia(this.ctx, {
                x: 0,
                y: 0,
                maxWidth: z,
                maxHeight: !0 === this.itemWrap ? h : 1.5 * this.fontSize,
                angle: 0,
                text: d.text,
                horizontalAlign: "left",
                fontSize: this.fontSize,
                fontFamily: this.fontFamily,
                fontWeight: this.fontWeight,
                fontColor: this.fontColor,
                fontStyle: this.fontStyle,
                textBaseline: "middle",
              })),
                d.textBlock.measureText(),
                null !== this.itemWidth &&
                  (d.textBlock.width =
                    this.itemWidth -
                    (t +
                      l +
                      ("line" === d.chartType ||
                      "spline" === d.chartType ||
                      "stepLine" === d.chartType
                        ? 2 * 0.1 * this.lineHeight
                        : 0))),
                this.height < h - this.lineHeight
                  ? ((m = { items: [], width: 0 }), k.push(m))
                  : ((m = k[v]), (v = (v + 1) % k.length)),
                (this.height += d.textBlock.height);
            d.textBlock.x = m.width;
            d.textBlock.y = 0;
            m.width += Math.round(
              d.textBlock.width +
                t +
                l +
                (0 === m.width ? 0 : this.horizontalSpacing) +
                ("line" === d.chartType ||
                "spline" === d.chartType ||
                "stepLine" === d.chartType
                  ? 2 * 0.1 * this.lineHeight
                  : 0)
            );
            m.items.push(d);
            this.width = Math.max(m.width, this.width);
            p =
              d.textBlock.width +
              (t +
                l +
                ("line" === d.chartType ||
                "spline" === d.chartType ||
                "stepLine" === d.chartType
                  ? 2 * 0.1 * this.lineHeight
                  : 0));
          }
        }
        this.itemWidth = p;
        this.height =
          !1 === this.itemWrap ? k.length * this.lineHeight : this.height + x;
        this.height = Math.min(h, this.height);
        this.width = Math.min(g, this.width);
      }
      "top" === this.verticalAlign
        ? ((e =
            "left" === this.horizontalAlign
              ? f.x1
              : "right" === this.horizontalAlign
              ? f.x2 - this.width
              : f.x1 + f.width / 2 - this.width / 2),
          (c = f.y1))
        : "center" === this.verticalAlign
        ? ((e =
            "left" === this.horizontalAlign
              ? f.x1
              : "right" === this.horizontalAlign
              ? f.x2 - this.width
              : f.x1 + f.width / 2 - this.width / 2),
          (c = f.y1 + f.height / 2 - this.height / 2))
        : "bottom" === this.verticalAlign &&
          ((e =
            "left" === this.horizontalAlign
              ? f.x1
              : "right" === this.horizontalAlign
              ? f.x2 - this.width
              : f.x1 + f.width / 2 - this.width / 2),
          (c = f.y2 - this.height));
      this.items = n;
      for (q = 0; q < this.items.length; q++)
        (d = n[q]),
          (d.id = ++this.chart._eventManager.lastObjectId),
          (this.chart._eventManager.objectMap[d.id] = {
            id: d.id,
            objectType: "legendItem",
            legendItemIndex: q,
            dataSeriesIndex: d.dataSeriesIndex,
            dataPointIndex: d.dataPointIndex,
          });
      ((0 < this.borderThickness && this.borderColor) ||
        this.backgroundColor) &&
        this.ctx.roundRect(
          e,
          c,
          this.width,
          this.height,
          this.cornerRadius,
          this.borderThickness,
          this.backgroundColor,
          this.borderColor
        );
      for (q = f = 0; q < k.length; q++) {
        m = k[q];
        for (z = x = 0; z < m.items.length; z++) {
          d = m.items[z];
          s = d.textBlock.x + e + (0 === z ? 0.2 * t : this.horizontalSpacing);
          u = c + f;
          p = s;
          this.chart.data[d.dataSeriesIndex].visible ||
            (this.ctx.globalAlpha = 0.5);
          this.ctx.save();
          this.ctx.beginPath();
          this.ctx.rect(e, c, g, Math.max(h - (h % this.lineHeight), 0));
          this.ctx.clip();
          if (
            "line" === d.chartType ||
            "stepLine" === d.chartType ||
            "spline" === d.chartType
          )
            (this.ctx.strokeStyle = d.lineColor),
              (this.ctx.lineWidth = Math.ceil(this.lineHeight / 8)),
              this.ctx.beginPath(),
              this.ctx.moveTo(
                s - 0.1 * this.lineHeight,
                u + this.lineHeight / 2
              ),
              this.ctx.lineTo(
                s + 0.85 * this.lineHeight,
                u + this.lineHeight / 2
              ),
              this.ctx.stroke(),
              (p -= 0.1 * this.lineHeight);
          if ("error" === d.chartType) {
            this.ctx.strokeStyle = r[0];
            v = t / 8;
            this.ctx.lineWidth = v;
            this.ctx.beginPath();
            var v = s - 0.08 * this.lineHeight + 0.1 * this.lineHeight,
              B = u + 0.15 * this.lineHeight,
              A = 0.7 * this.lineHeight,
              F = A + 0.02 * this.lineHeight;
            this.ctx.moveTo(v, B);
            this.ctx.lineTo(v + A, B);
            this.ctx.stroke();
            this.ctx.beginPath();
            this.ctx.moveTo(v + A / 2, B);
            this.ctx.lineTo(v + A / 2, B + F);
            this.ctx.stroke();
            this.ctx.beginPath();
            this.ctx.moveTo(v, B + F);
            this.ctx.lineTo(v + A, B + F);
            this.ctx.stroke();
            r.shift();
          }
          fa.drawMarker(
            s + t / 2,
            u + this.lineHeight / 2,
            this.ctx,
            d.markerType,
            "error" === d.chartType ||
              "line" === d.chartType ||
              "spline" === d.chartType
              ? d.markerSize / 2
              : d.markerSize,
            d.markerColor,
            d.markerBorderColor,
            d.markerBorderThickness
          );
          d.textBlock.x = s + l + t;
          if (
            "line" === d.chartType ||
            "stepLine" === d.chartType ||
            "spline" === d.chartType
          )
            d.textBlock.x += 0.1 * this.lineHeight;
          d.textBlock.y = Math.round(u + this.lineHeight / 2);
          d.textBlock.render(!0);
          this.ctx.restore();
          x = 0 < z ? Math.max(x, d.textBlock.height) : d.textBlock.height;
          this.chart.data[d.dataSeriesIndex].visible ||
            (this.ctx.globalAlpha = 1);
          v = R(d.id);
          this.ghostCtx.fillStyle = v;
          this.ghostCtx.beginPath();
          this.ghostCtx.fillRect(
            p,
            d.textBlock.y - this.lineHeight / 2,
            d.textBlock.x + d.textBlock.width - p,
            d.textBlock.height
          );
          d.x1 = this.chart._eventManager.objectMap[d.id].x1 = p;
          d.y1 = this.chart._eventManager.objectMap[d.id].y1 =
            d.textBlock.y - this.lineHeight / 2;
          d.x2 = this.chart._eventManager.objectMap[d.id].x2 =
            d.textBlock.x + d.textBlock.width;
          d.y2 = this.chart._eventManager.objectMap[d.id].y2 =
            d.textBlock.y + d.textBlock.height - this.lineHeight / 2;
        }
        f += x;
      }
      0 < n.length &&
        a.layoutManager.registerSpace(b, {
          width: this.width + 2 + 2,
          height: this.height + 5 + 5,
        });
      this.bounds = { x1: e, y1: c, x2: e + this.width, y2: c + this.height };
    };
    ma(S, T);
    S.prototype.getDefaultAxisPlacement = function () {
      var a = this.type;
      if (
        "column" === a ||
        "line" === a ||
        "stepLine" === a ||
        "spline" === a ||
        "area" === a ||
        "stepArea" === a ||
        "splineArea" === a ||
        "stackedColumn" === a ||
        "stackedLine" === a ||
        "bubble" === a ||
        "scatter" === a ||
        "stackedArea" === a ||
        "stackedColumn100" === a ||
        "stackedLine100" === a ||
        "stackedArea100" === a ||
        "candlestick" === a ||
        "ohlc" === a ||
        "rangeColumn" === a ||
        "rangeArea" === a ||
        "rangeSplineArea" === a ||
        "boxAndWhisker" === a ||
        "waterfall" === a
      )
        return "normal";
      if (
        "bar" === a ||
        "stackedBar" === a ||
        "stackedBar100" === a ||
        "rangeBar" === a
      )
        return "xySwapped";
      if ("pie" === a || "doughnut" === a || "funnel" === a || "pyramid" === a)
        return "none";
      "error" !== a && window.console.log("Unknown Chart Type: " + a);
      return null;
    };
    S.getDefaultLegendMarker = function (a) {
      if (
        "column" === a ||
        "stackedColumn" === a ||
        "stackedLine" === a ||
        "bar" === a ||
        "stackedBar" === a ||
        "stackedBar100" === a ||
        "bubble" === a ||
        "scatter" === a ||
        "stackedColumn100" === a ||
        "stackedLine100" === a ||
        "stepArea" === a ||
        "candlestick" === a ||
        "ohlc" === a ||
        "rangeColumn" === a ||
        "rangeBar" === a ||
        "rangeArea" === a ||
        "rangeSplineArea" === a ||
        "boxAndWhisker" === a ||
        "waterfall" === a
      )
        return "square";
      if (
        "line" === a ||
        "stepLine" === a ||
        "spline" === a ||
        "pie" === a ||
        "doughnut" === a
      )
        return "circle";
      if (
        "area" === a ||
        "splineArea" === a ||
        "stackedArea" === a ||
        "stackedArea100" === a ||
        "funnel" === a ||
        "pyramid" === a
      )
        return "triangle";
      if ("error" === a) return "none";
      window.console.log("Unknown Chart Type: " + a);
      return null;
    };
    S.prototype.getDataPointAtX = function (a, f) {
      if (!this.dataPoints || 0 === this.dataPoints.length) return null;
      var b = { dataPoint: null, distance: Infinity, index: NaN },
        c = null,
        e = 0,
        g = 0,
        h = 1,
        l = Infinity,
        n = 0,
        k = 0,
        r = 0;
      "none" !== this.chart.plotInfo.axisPlacement &&
        (this.axisX.logarithmic
          ? ((r = Math.log(
              this.dataPoints[this.dataPoints.length - 1].x /
                this.dataPoints[0].x
            )),
            (r =
              1 < r
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / r) *
                        Math.log(a / this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0))
          : ((r =
              this.dataPoints[this.dataPoints.length - 1].x -
              this.dataPoints[0].x),
            (r =
              0 < r
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / r) *
                        (a - this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0)));
      for (;;) {
        g = 0 < h ? r + e : r - e;
        if (0 <= g && g < this.dataPoints.length) {
          var c = this.dataPoints[g],
            q = this.axisX.logarithmic
              ? c.x > a
                ? c.x / a
                : a / c.x
              : Math.abs(c.x - a);
          q < b.distance &&
            ((b.dataPoint = c), (b.distance = q), (b.index = g));
          c = q;
          c <= l ? (l = c) : 0 < h ? n++ : k++;
          if (1e3 < n && 1e3 < k) break;
        } else if (0 > r - e && r + e >= this.dataPoints.length) break;
        -1 === h ? (e++, (h = 1)) : (h = -1);
      }
      return f || b.dataPoint.x !== a
        ? f && null !== b.dataPoint
          ? b
          : null
        : b;
    };
    S.prototype.getDataPointAtXY = function (a, f, b) {
      if (
        !this.dataPoints ||
        0 === this.dataPoints.length ||
        a < this.chart.plotArea.x1 ||
        a > this.chart.plotArea.x2 ||
        f < this.chart.plotArea.y1 ||
        f > this.chart.plotArea.y2
      )
        return null;
      b = b || !1;
      var c = [],
        e = 0,
        g = 0,
        h = 1,
        l = !1,
        n = Infinity,
        k = 0,
        r = 0,
        q = 0;
      if ("none" !== this.chart.plotInfo.axisPlacement)
        if (
          ((q = (
            this.chart.axisX[0] ? this.chart.axisX[0] : this.chart.axisX2[0]
          ).getXValueAt({
            x: a,
            y: f,
          })),
          this.axisX.logarithmic)
        )
          var m = Math.log(
              this.dataPoints[this.dataPoints.length - 1].x /
                this.dataPoints[0].x
            ),
            q =
              1 < m
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / m) *
                        Math.log(q / this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0;
        else
          (m =
            this.dataPoints[this.dataPoints.length - 1].x -
            this.dataPoints[0].x),
            (q =
              0 < m
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / m) *
                        (q - this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0);
      for (;;) {
        g = 0 < h ? q + e : q - e;
        if (0 <= g && g < this.dataPoints.length) {
          var m = this.chart._eventManager.objectMap[this.dataPointIds[g]],
            d = this.dataPoints[g],
            p = null;
          if (m) {
            switch (this.type) {
              case "column":
              case "stackedColumn":
              case "stackedColumn100":
              case "bar":
              case "stackedBar":
              case "stackedBar100":
              case "rangeColumn":
              case "rangeBar":
              case "waterfall":
              case "error":
                a >= m.x1 &&
                  a <= m.x2 &&
                  f >= m.y1 &&
                  f <= m.y2 &&
                  (c.push({
                    dataPoint: d,
                    dataPointIndex: g,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(m.x1 - a),
                      Math.abs(m.x2 - a),
                      Math.abs(m.y1 - f),
                      Math.abs(m.y2 - f)
                    ),
                  }),
                  (l = !0));
                break;
              case "line":
              case "stepLine":
              case "spline":
              case "area":
              case "stepArea":
              case "stackedArea":
              case "stackedArea100":
              case "splineArea":
              case "scatter":
                var s = ka("markerSize", d, this) || 4,
                  t = b ? 20 : s,
                  p = Math.sqrt(Math.pow(m.x1 - a, 2) + Math.pow(m.y1 - f, 2));
                p <= t &&
                  c.push({
                    dataPoint: d,
                    dataPointIndex: g,
                    dataSeries: this,
                    distance: p,
                  });
                m = Math.abs(m.x1 - a);
                m <= n ? (n = m) : 0 < h ? k++ : r++;
                p <= s / 2 && (l = !0);
                break;
              case "rangeArea":
              case "rangeSplineArea":
                s = ka("markerSize", d, this) || 4;
                t = b ? 20 : s;
                p = Math.min(
                  Math.sqrt(Math.pow(m.x1 - a, 2) + Math.pow(m.y1 - f, 2)),
                  Math.sqrt(Math.pow(m.x1 - a, 2) + Math.pow(m.y2 - f, 2))
                );
                p <= t &&
                  c.push({
                    dataPoint: d,
                    dataPointIndex: g,
                    dataSeries: this,
                    distance: p,
                  });
                m = Math.abs(m.x1 - a);
                m <= n ? (n = m) : 0 < h ? k++ : r++;
                p <= s / 2 && (l = !0);
                break;
              case "bubble":
                s = m.size;
                p = Math.sqrt(Math.pow(m.x1 - a, 2) + Math.pow(m.y1 - f, 2));
                p <= s / 2 &&
                  (c.push({
                    dataPoint: d,
                    dataPointIndex: g,
                    dataSeries: this,
                    distance: p,
                  }),
                  (l = !0));
                break;
              case "pie":
              case "doughnut":
                s = m.center;
                t =
                  "doughnut" === this.type
                    ? m.percentInnerRadius * m.radius
                    : 0;
                p = Math.sqrt(Math.pow(s.x - a, 2) + Math.pow(s.y - f, 2));
                p < m.radius &&
                  p > t &&
                  ((p = Math.atan2(f - s.y, a - s.x)),
                  0 > p && (p += 2 * Math.PI),
                  (p = Number(
                    ((((180 * (p / Math.PI)) % 360) + 360) % 360).toFixed(12)
                  )),
                  (s = Number(
                    (
                      (((180 * (m.startAngle / Math.PI)) % 360) + 360) %
                      360
                    ).toFixed(12)
                  )),
                  (t = Number(
                    (
                      (((180 * (m.endAngle / Math.PI)) % 360) + 360) %
                      360
                    ).toFixed(12)
                  )),
                  0 === t && 1 < m.endAngle && (t = 360),
                  s >= t && 0 !== d.y && ((t += 360), p < s && (p += 360)),
                  p > s &&
                    p < t &&
                    (c.push({
                      dataPoint: d,
                      dataPointIndex: g,
                      dataSeries: this,
                      distance: 0,
                    }),
                    (l = !0)));
                break;
              case "funnel":
              case "pyramid":
                p = m.funnelSection;
                f > p.y1 &&
                  f < p.y4 &&
                  (p.y6
                    ? f > p.y6
                      ? ((g =
                          p.x6 + ((p.x5 - p.x6) / (p.y5 - p.y6)) * (f - p.y6)),
                        (p =
                          p.x3 + ((p.x4 - p.x3) / (p.y4 - p.y3)) * (f - p.y3)))
                      : ((g =
                          p.x1 + ((p.x6 - p.x1) / (p.y6 - p.y1)) * (f - p.y1)),
                        (p =
                          p.x2 + ((p.x3 - p.x2) / (p.y3 - p.y2)) * (f - p.y2)))
                    : ((g =
                        p.x1 + ((p.x4 - p.x1) / (p.y4 - p.y1)) * (f - p.y1)),
                      (p =
                        p.x2 + ((p.x3 - p.x2) / (p.y3 - p.y2)) * (f - p.y2))),
                  a > g &&
                    a < p &&
                    (c.push({
                      dataPoint: d,
                      dataPointIndex: m.dataPointIndex,
                      dataSeries: this,
                      distance: 0,
                    }),
                    (l = !0)));
                break;
              case "boxAndWhisker":
                if (
                  (a >= m.x1 - m.borderThickness / 2 &&
                    a <= m.x2 + m.borderThickness / 2 &&
                    f >= m.y4 - m.borderThickness / 2 &&
                    f <= m.y1 + m.borderThickness / 2) ||
                  (Math.abs(m.x2 - a + m.x1 - a) < m.borderThickness &&
                    f >= m.y1 &&
                    f <= m.y4)
                )
                  c.push({
                    dataPoint: d,
                    dataPointIndex: g,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(m.x1 - a),
                      Math.abs(m.x2 - a),
                      Math.abs(m.y2 - f),
                      Math.abs(m.y3 - f)
                    ),
                  }),
                    (l = !0);
                break;
              case "candlestick":
                if (
                  (a >= m.x1 - m.borderThickness / 2 &&
                    a <= m.x2 + m.borderThickness / 2 &&
                    f >= m.y2 - m.borderThickness / 2 &&
                    f <= m.y3 + m.borderThickness / 2) ||
                  (Math.abs(m.x2 - a + m.x1 - a) < m.borderThickness &&
                    f >= m.y1 &&
                    f <= m.y4)
                )
                  c.push({
                    dataPoint: d,
                    dataPointIndex: g,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(m.x1 - a),
                      Math.abs(m.x2 - a),
                      Math.abs(m.y2 - f),
                      Math.abs(m.y3 - f)
                    ),
                  }),
                    (l = !0);
                break;
              case "ohlc":
                if (
                  (Math.abs(m.x2 - a + m.x1 - a) < m.borderThickness &&
                    f >= m.y2 &&
                    f <= m.y3) ||
                  (a >= m.x1 &&
                    a <= (m.x2 + m.x1) / 2 &&
                    f >= m.y1 - m.borderThickness / 2 &&
                    f <= m.y1 + m.borderThickness / 2) ||
                  (a >= (m.x1 + m.x2) / 2 &&
                    a <= m.x2 &&
                    f >= m.y4 - m.borderThickness / 2 &&
                    f <= m.y4 + m.borderThickness / 2)
                )
                  c.push({
                    dataPoint: d,
                    dataPointIndex: g,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(m.x1 - a),
                      Math.abs(m.x2 - a),
                      Math.abs(m.y2 - f),
                      Math.abs(m.y3 - f)
                    ),
                  }),
                    (l = !0);
            }
            if (l || (1e3 < k && 1e3 < r)) break;
          }
        } else if (0 > q - e && q + e >= this.dataPoints.length) break;
        -1 === h ? (e++, (h = 1)) : (h = -1);
      }
      a = null;
      for (f = 0; f < c.length; f++)
        a ? c[f].distance <= a.distance && (a = c[f]) : (a = c[f]);
      return a;
    };
    S.prototype.getMarkerProperties = function (a, f, b, c) {
      var e = this.dataPoints;
      return {
        x: f,
        y: b,
        ctx: c,
        type: e[a].markerType ? e[a].markerType : this.markerType,
        size: e[a].markerSize ? e[a].markerSize : this.markerSize,
        color: e[a].markerColor
          ? e[a].markerColor
          : this.markerColor
          ? this.markerColor
          : e[a].color
          ? e[a].color
          : this.color
          ? this.color
          : this._colorSet[a % this._colorSet.length],
        borderColor: e[a].markerBorderColor
          ? e[a].markerBorderColor
          : this.markerBorderColor
          ? this.markerBorderColor
          : null,
        borderThickness: e[a].markerBorderThickness
          ? e[a].markerBorderThickness
          : this.markerBorderThickness
          ? this.markerBorderThickness
          : null,
      };
    };
    ma(z, T);
    z.prototype.createExtraLabelsForLog = function (a) {
      a = (a || 0) + 1;
      if (!(5 < a)) {
        var f = this.logLabelValues[0] || this.intervalStartPosition;
        if (
          Math.log(this.range) / Math.log(f / this.viewportMinimum) <
          this.noTicks - 1
        ) {
          for (
            var b = z.getNiceNumber(
                (f - this.viewportMinimum) /
                  Math.min(
                    Math.max(2, this.noTicks - this.logLabelValues.length),
                    3
                  ),
                !0
              ),
              c = Math.ceil(this.viewportMinimum / b) * b;
            c < f;
            c += b
          )
            c < this.viewportMinimum || this.logLabelValues.push(c);
          this.logLabelValues.sort(Oa);
          this.createExtraLabelsForLog(a);
        }
      }
    };
    z.prototype.createLabels = function () {
      var a,
        f,
        b = 0,
        c = 0,
        e,
        g = 0,
        h = 0,
        c = 0,
        c = this.interval,
        l = 0,
        n,
        k = 0.6 * this.chart.height,
        r;
      a = !1;
      var q = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
        m = q.length
          ? y(this.scaleBreaks.firstBreakIndex)
            ? 0
            : this.scaleBreaks.firstBreakIndex
          : 0;
      if (
        "axisX" !== this.type ||
        "dateTime" !== this.valueType ||
        this.logarithmic
      ) {
        e = this.viewportMaximum;
        if (this.labels) {
          a = Math.ceil(c);
          for (
            var c = Math.ceil(this.intervalStartPosition), d = !1, b = c;
            b < this.viewportMaximum;
            b += a
          )
            if (this.labels[b]) d = !0;
            else {
              d = !1;
              break;
            }
          d && ((this.interval = a), (this.intervalStartPosition = c));
        }
        if (this.logarithmic && !this.equidistantInterval)
          for (
            this.logLabelValues ||
              ((this.logLabelValues = []), this.createExtraLabelsForLog()),
              c = 0,
              d = m;
            c < this.logLabelValues.length;
            c++
          )
            if (((b = this.logLabelValues[c]), b < this.viewportMinimum)) c++;
            else {
              for (; d < q.length && b > q[d].endValue; d++);
              a = d < q.length && b >= q[d].startValue && b <= q[d].endValue;
              r = b;
              a ||
                ((a = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.options,
                      value: r,
                      label: this.labels[r] ? this.labels[r] : null,
                    })
                  : "axisX" === this.type && this.labels[r]
                  ? this.labels[r]
                  : X(r, this.valueFormatString, this.chart._cultureInfo)),
                (a = new ia(this.ctx, {
                  x: 0,
                  y: 0,
                  maxWidth: g,
                  maxHeight: h,
                  angle: this.labelAngle,
                  text: this.prefix + a + this.suffix,
                  backgroundColor: this.labelBackgroundColor,
                  borderColor: this.labelBorderColor,
                  borderThickness: this.labelBorderThickness,
                  cornerRadius: this.labelCornerRadius,
                  horizontalAlign: "left",
                  fontSize: this.labelFontSize,
                  fontFamily: this.labelFontFamily,
                  fontWeight: this.labelFontWeight,
                  fontColor: this.labelFontColor,
                  fontStyle: this.labelFontStyle,
                  textBaseline: "middle",
                  borderThickness: 0,
                })),
                this._labels.push({
                  position: r,
                  textBlock: a,
                  effectiveHeight: null,
                }));
            }
        d = m;
        for (
          b = this.intervalStartPosition;
          b <= e;
          b = parseFloat(
            (this.logarithmic && this.equidistantInterval
              ? b * Math.pow(this.logarithmBase, this.interval)
              : b + this.interval
            ).toFixed(12)
          )
        ) {
          for (; d < q.length && b > q[d].endValue; d++);
          a = d < q.length && b >= q[d].startValue && b <= q[d].endValue;
          r = b;
          a ||
            ((a = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.options,
                  value: r,
                  label: this.labels[r] ? this.labels[r] : null,
                })
              : "axisX" === this.type && this.labels[r]
              ? this.labels[r]
              : X(r, this.valueFormatString, this.chart._cultureInfo)),
            (a = new ia(this.ctx, {
              x: 0,
              y: 0,
              maxWidth: g,
              maxHeight: h,
              angle: this.labelAngle,
              text: this.prefix + a + this.suffix,
              horizontalAlign: "left",
              backgroundColor: this.labelBackgroundColor,
              borderColor: this.labelBorderColor,
              borderThickness: this.labelBorderThickness,
              cornerRadius: this.labelCornerRadius,
              fontSize: this.labelFontSize,
              fontFamily: this.labelFontFamily,
              fontWeight: this.labelFontWeight,
              fontColor: this.labelFontColor,
              fontStyle: this.labelFontStyle,
              textBaseline: "middle",
            })),
            this._labels.push({
              position: r,
              textBlock: a,
              effectiveHeight: null,
            }));
        }
      } else
        for (
          this.intervalStartPosition = this.getLabelStartPoint(
            new Date(this.viewportMinimum),
            this.intervalType,
            this.interval
          ),
            e = Sa(
              new Date(this.viewportMaximum),
              this.interval,
              this.intervalType
            ),
            d = m,
            b = this.intervalStartPosition;
          b < e;
          Sa(b, c, this.intervalType)
        ) {
          for (a = b.getTime(); d < q.length && a > q[d].endValue; d++);
          r = a;
          a = d < q.length && a >= q[d].startValue && a <= q[d].endValue;
          a ||
            ((a = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.options,
                  value: new Date(r),
                  label: this.labels[r] ? this.labels[r] : null,
                })
              : "axisX" === this.type && this.labels[r]
              ? this.labels[r]
              : za(r, this.valueFormatString, this.chart._cultureInfo)),
            (a = new ia(this.ctx, {
              x: 0,
              y: 0,
              maxWidth: g,
              backgroundColor: this.labelBackgroundColor,
              borderColor: this.labelBorderColor,
              borderThickness: this.labelBorderThickness,
              cornerRadius: this.labelCornerRadius,
              maxHeight: h,
              angle: this.labelAngle,
              text: this.prefix + a + this.suffix,
              horizontalAlign: "left",
              fontSize: this.labelFontSize,
              fontFamily: this.labelFontFamily,
              fontWeight: this.labelFontWeight,
              fontColor: this.labelFontColor,
              fontStyle: this.labelFontStyle,
              textBaseline: "middle",
            })),
            this._labels.push({
              position: r,
              textBlock: a,
              effectiveHeight: null,
              breaksLabelType: void 0,
            }));
        }
      if ("bottom" === this._position || "top" === this._position)
        (l =
          this.logarithmic &&
          !this.equidistantInterval &&
          2 <= this._labels.length
            ? (this.lineCoordinates.width *
                Math.log(
                  Math.min(
                    this._labels[this._labels.length - 1].position /
                      this._labels[this._labels.length - 2].position,
                    this._labels[1].position / this._labels[0].position
                  )
                )) /
              Math.log(this.range)
            : (this.lineCoordinates.width /
                (this.logarithmic && this.equidistantInterval
                  ? Math.log(this.range) / Math.log(this.logarithmBase)
                  : Math.abs(this.range))) *
              V[this.intervalType + "Duration"] *
              this.interval),
          (g =
            "undefined" === typeof this.options.labelMaxWidth
              ? (0.5 * this.chart.width) >> 0
              : this.options.labelMaxWidth),
          this.chart.panEnabled ||
            (h =
              "undefined" === typeof this.options.labelWrap || this.labelWrap
                ? (0.8 * this.chart.height) >> 0
                : 1.5 * this.labelFontSize);
      else if ("left" === this._position || "right" === this._position)
        (l =
          this.logarithmic &&
          !this.equidistantInterval &&
          2 <= this._labels.length
            ? (this.lineCoordinates.height *
                Math.log(
                  Math.min(
                    this._labels[this._labels.length - 1].position /
                      this._labels[this._labels.length - 2].position,
                    this._labels[1].position / this._labels[0].position
                  )
                )) /
              Math.log(this.range)
            : (this.lineCoordinates.height /
                (this.logarithmic && this.equidistantInterval
                  ? Math.log(this.range) / Math.log(this.logarithmBase)
                  : Math.abs(this.range))) *
              V[this.intervalType + "Duration"] *
              this.interval),
          this.chart.panEnabled ||
            (g =
              "undefined" === typeof this.options.labelMaxWidth
                ? (0.3 * this.chart.width) >> 0
                : this.options.labelMaxWidth),
          (h =
            "undefined" === typeof this.options.labelWrap || this.labelWrap
              ? (0.3 * this.chart.height) >> 0
              : 1.5 * this.labelFontSize);
      for (c = 0; c < this._labels.length; c++) {
        a = this._labels[c].textBlock;
        a.maxWidth = g;
        a.maxHeight = h;
        var p = a.measureText();
        n = p.height;
      }
      e = [];
      m = q = 0;
      if (this.labelAutoFit || this.options.labelAutoFit)
        if (
          (y(this.labelAngle) ||
            ((this.labelAngle = ((this.labelAngle % 360) + 360) % 360),
            90 < this.labelAngle && 270 > this.labelAngle
              ? (this.labelAngle -= 180)
              : 270 <= this.labelAngle &&
                360 >= this.labelAngle &&
                (this.labelAngle -= 360)),
          "bottom" === this._position || "top" === this._position)
        )
          if (
            ((g = (0.9 * l) >> 0),
            (m = 0),
            !this.chart.panEnabled && 1 <= this._labels.length)
          ) {
            this.sessionVariables.labelFontSize = this.labelFontSize;
            this.sessionVariables.labelMaxWidth = g;
            this.sessionVariables.labelMaxHeight = h;
            this.sessionVariables.labelAngle = this.labelAngle;
            this.sessionVariables.labelWrap = this.labelWrap;
            for (b = 0; b < this._labels.length; b++)
              if (!this._labels[b].breaksLabelType) {
                a = this._labels[b].textBlock;
                for (var s, d = a.text.split(" "), c = 0; c < d.length; c++)
                  (r = d[c]),
                    (this.ctx.font =
                      a.fontStyle +
                      " " +
                      a.fontWeight +
                      " " +
                      a.fontSize +
                      "px " +
                      a.fontFamily),
                    (r = this.ctx.measureText(r)),
                    r.width > m && ((s = b), (m = r.width));
              }
            b = 0;
            for (
              b = this.intervalStartPosition < this.viewportMinimum ? 1 : 0;
              b < this._labels.length;
              b++
            )
              if (!this._labels[b].breaksLabelType) {
                a = this._labels[b].textBlock;
                p = a.measureText();
                for (d = b + 1; d < this._labels.length; d++)
                  if (!this._labels[d].breaksLabelType) {
                    f = this._labels[d].textBlock;
                    f = f.measureText();
                    break;
                  }
                e.push(a.height);
                this.sessionVariables.labelMaxHeight = Math.max.apply(Math, e);
                Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                Math.sin((Math.PI / 180) * Math.abs(this.labelAngle));
                c =
                  g * Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (h - a.fontSize / 2) *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                if (
                  y(this.options.labelAngle) &&
                  isNaN(this.options.labelAngle) &&
                  0 !== this.options.labelAngle
                )
                  if (
                    ((this.sessionVariables.labelMaxHeight =
                      0 === this.labelAngle
                        ? h
                        : Math.min(
                            (c -
                              g *
                                Math.cos(
                                  (Math.PI / 180) * Math.abs(this.labelAngle)
                                )) /
                              Math.sin(
                                (Math.PI / 180) * Math.abs(this.labelAngle)
                              ),
                            c
                          )),
                    (r =
                      (k -
                        (n + a.fontSize / 2) *
                          Math.cos((Math.PI / 180) * Math.abs(-25))) /
                      Math.sin((Math.PI / 180) * Math.abs(-25))),
                    !y(this.options.labelWrap))
                  )
                    this.labelWrap
                      ? y(this.options.labelMaxWidth)
                        ? ((this.sessionVariables.labelMaxWidth = Math.min(
                            Math.max(g, m),
                            r
                          )),
                          (this.sessionVariables.labelWrap = this.labelWrap),
                          (p.width + f.width) >> 0 > 2 * g &&
                            (this.sessionVariables.labelAngle = -25))
                        : ((this.sessionVariables.labelWrap = this.labelWrap),
                          (this.sessionVariables.labelMaxWidth =
                            this.options.labelMaxWidth),
                          (this.sessionVariables.labelAngle =
                            this.sessionVariables.labelMaxWidth > g
                              ? -25
                              : this.sessionVariables.labelAngle))
                      : y(this.options.labelMaxWidth)
                      ? ((this.sessionVariables.labelWrap = this.labelWrap),
                        (this.sessionVariables.labelMaxHeight = h),
                        (this.sessionVariables.labelMaxWidth = g),
                        (p.width + f.width) >> 0 > 2 * g &&
                          ((this.sessionVariables.labelAngle = -25),
                          (this.sessionVariables.labelMaxWidth = r)))
                      : ((this.sessionVariables.labelAngle =
                          this.sessionVariables.labelMaxWidth > g
                            ? -25
                            : this.sessionVariables.labelAngle),
                        (this.sessionVariables.labelMaxWidth =
                          this.options.labelMaxWidth),
                        (this.sessionVariables.labelMaxHeight = h),
                        (this.sessionVariables.labelWrap = this.labelWrap));
                  else {
                    if (y(this.options.labelWrap))
                      if (!y(this.options.labelMaxWidth))
                        this.options.labelMaxWidth < g
                          ? ((this.sessionVariables.labelMaxWidth =
                              this.options.labelMaxWidth),
                            (this.sessionVariables.labelMaxHeight = c))
                          : ((this.sessionVariables.labelAngle = -25),
                            (this.sessionVariables.labelMaxWidth =
                              this.options.labelMaxWidth),
                            (this.sessionVariables.labelMaxHeight = h));
                      else if (!y(f))
                        if (
                          ((c = (p.width + f.width) >> 0),
                          (d = this.labelFontSize),
                          m < g)
                        )
                          c - 2 * g > q &&
                            ((q = c - 2 * g),
                            c >= 2 * g && c < 2.2 * g
                              ? ((this.sessionVariables.labelMaxWidth = g),
                                y(this.options.labelFontSize) &&
                                  12 < d &&
                                  ((d = Math.floor((12 / 13) * d)),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = y(
                                  this.options.labelFontSize
                                )
                                  ? d
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelAngle =
                                  this.labelAngle))
                              : c >= 2.2 * g && c < 2.8 * g
                              ? ((this.sessionVariables.labelAngle = -25),
                                (this.sessionVariables.labelMaxWidth = r),
                                (this.sessionVariables.labelFontSize = d))
                              : c >= 2.8 * g && c < 3.2 * g
                              ? ((this.sessionVariables.labelMaxWidth =
                                  Math.max(g, m)),
                                (this.sessionVariables.labelWrap = !0),
                                y(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = y(
                                  this.options.labelFontSize
                                )
                                  ? d
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelAngle =
                                  this.labelAngle))
                              : c >= 3.2 * g && c < 3.6 * g
                              ? ((this.sessionVariables.labelAngle = -25),
                                (this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelMaxWidth = r),
                                (this.sessionVariables.labelFontSize =
                                  this.labelFontSize))
                              : c > 3.6 * g && c < 5 * g
                              ? (y(this.options.labelFontSize) &&
                                  12 < d &&
                                  ((d = Math.floor((12 / 13) * d)),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = y(
                                  this.options.labelFontSize
                                )
                                  ? d
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelAngle = -25),
                                (this.sessionVariables.labelMaxWidth = r))
                              : c > 5 * g &&
                                ((this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelMaxWidth = g),
                                (this.sessionVariables.labelFontSize = d),
                                (this.sessionVariables.labelMaxHeight = h),
                                (this.sessionVariables.labelAngle =
                                  this.labelAngle)));
                        else if (
                          s === b &&
                          ((0 === s &&
                            m +
                              this._labels[s + 1].textBlock.measureText()
                                .width -
                              2 * g >
                              q) ||
                            (s === this._labels.length - 1 &&
                              m +
                                this._labels[s - 1].textBlock.measureText()
                                  .width -
                                2 * g >
                                q) ||
                            (0 < s &&
                              s < this._labels.length - 1 &&
                              m +
                                this._labels[s + 1].textBlock.measureText()
                                  .width -
                                2 * g >
                                q &&
                              m +
                                this._labels[s - 1].textBlock.measureText()
                                  .width -
                                2 * g >
                                q))
                        )
                          (q =
                            0 === s
                              ? m +
                                this._labels[s + 1].textBlock.measureText()
                                  .width -
                                2 * g
                              : m +
                                this._labels[s - 1].textBlock.measureText()
                                  .width -
                                2 * g),
                            (this.sessionVariables.labelFontSize = y(
                              this.options.labelFontSize
                            )
                              ? d
                              : this.options.labelFontSize),
                            (this.sessionVariables.labelWrap = !0),
                            (this.sessionVariables.labelAngle = -25),
                            (this.sessionVariables.labelMaxWidth = r);
                        else if (0 === q)
                          for (
                            this.sessionVariables.labelFontSize = y(
                              this.options.labelFontSize
                            )
                              ? d
                              : this.options.labelFontSize,
                              this.sessionVariables.labelWrap = !0,
                              c = 0;
                            c < this._labels.length;
                            c++
                          )
                            (a = this._labels[c].textBlock),
                              (a.maxWidth =
                                this.sessionVariables.labelMaxWidth =
                                  Math.min(Math.max(g, m), r)),
                              (p = a.measureText()),
                              c < this._labels.length - 1 &&
                                ((d = c + 1),
                                (f = this._labels[d].textBlock),
                                (f.maxWidth =
                                  this.sessionVariables.labelMaxWidth =
                                    Math.min(Math.max(g, m), r)),
                                (f = f.measureText()),
                                (p.width + f.width) >> 0 > 2 * g &&
                                  (this.sessionVariables.labelAngle = -25));
                  }
                else
                  ((this.sessionVariables.labelAngle = this.labelAngle),
                  (this.sessionVariables.labelMaxHeight =
                    0 === this.labelAngle
                      ? h
                      : Math.min(
                          (c -
                            g *
                              Math.cos(
                                (Math.PI / 180) * Math.abs(this.labelAngle)
                              )) /
                            Math.sin(
                              (Math.PI / 180) * Math.abs(this.labelAngle)
                            ),
                          c
                        )),
                  (r =
                    0 != this.labelAngle
                      ? (k -
                          (n + a.fontSize / 2) *
                            Math.cos(
                              (Math.PI / 180) * Math.abs(this.labelAngle)
                            )) /
                        Math.sin((Math.PI / 180) * Math.abs(this.labelAngle))
                      : g),
                  (this.sessionVariables.labelMaxHeight = h =
                    this.labelWrap
                      ? (k -
                          r *
                            Math.sin(
                              (Math.PI / 180) * Math.abs(this.labelAngle)
                            )) /
                        Math.cos((Math.PI / 180) * Math.abs(this.labelAngle))
                      : 1.5 * this.labelFontSize),
                  y(this.options.labelWrap))
                    ? y(this.options.labelWrap) &&
                      (this.labelWrap && !y(this.options.labelMaxWidth)
                        ? ((this.sessionVariables.labelWrap = this.labelWrap),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : r),
                          (this.sessionVariables.labelMaxHeight = h))
                        : ((this.sessionVariables.labelAngle = this.labelAngle),
                          (this.sessionVariables.labelMaxWidth = r),
                          (this.sessionVariables.labelMaxHeight =
                            c < 0.9 * l ? 0.9 * l : c),
                          (this.sessionVariables.labelWrap = this.labelWrap)))
                    : (this.options.labelWrap
                        ? ((this.sessionVariables.labelWrap = this.labelWrap),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : r))
                        : (y(this.options.labelMaxWidth),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : r),
                          (this.sessionVariables.labelWrap = this.labelWrap)),
                      (this.sessionVariables.labelMaxHeight = h));
              }
            for (c = 0; c < this._labels.length; c++)
              (a = this._labels[c].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  this.sessionVariables.labelMaxWidth),
                (a.fontSize = this.sessionVariables.labelFontSize),
                (a.angle = this.labelAngle = this.sessionVariables.labelAngle),
                (a.wrap = this.labelWrap = this.sessionVariables.labelWrap),
                (a.maxHeight = this.sessionVariables.labelMaxHeight),
                a.measureText();
          } else
            for (b = 0; b < this._labels.length; b++)
              (a = this._labels[b].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  y(this.options.labelMaxWidth)
                    ? this.sessionVariables.labelMaxWidth
                    : this.options.labelMaxWidth),
                (a.fontSize = this.labelFontSize =
                  y(this.options.labelFontSize)
                    ? this.sessionVariables.labelFontSize
                    : this.options.labelFontSize),
                (a.angle = this.labelAngle =
                  y(this.options.labelAngle)
                    ? this.sessionVariables.labelAngle
                    : this.labelAngle),
                (a.wrap = this.labelWrap =
                  y(this.options.labelWrap)
                    ? this.sessionVariables.labelWrap
                    : this.options.labelWrap),
                (a.maxHeight = this.sessionVariables.labelMaxHeight),
                a.measureText();
        else if ("left" === this._position || "right" === this._position)
          if (
            ((g = y(this.options.labelMaxWidth)
              ? (0.3 * this.chart.width) >> 0
              : this.options.labelMaxWidth),
            (h =
              "undefined" === typeof this.options.labelWrap || this.labelWrap
                ? (0.3 * this.chart.height) >> 0
                : 1.5 * this.labelFontSize),
            !this.chart.panEnabled && 1 <= this._labels.length)
          ) {
            this.sessionVariables.labelFontSize = this.labelFontSize;
            this.sessionVariables.labelMaxWidth = g;
            this.sessionVariables.labelMaxHeight = h;
            this.sessionVariables.labelAngle = y(
              this.sessionVariables.labelAngle
            )
              ? 0
              : this.sessionVariables.labelAngle;
            this.sessionVariables.labelWrap = this.labelWrap;
            for (b = 0; b < this._labels.length; b++)
              if (!this._labels[b].breaksLabelType) {
                a = this._labels[b].textBlock;
                p = a.measureText();
                for (d = b + 1; d < this._labels.length; d++)
                  if (!this._labels[d].breaksLabelType) {
                    f = this._labels[d].textBlock;
                    f = f.measureText();
                    break;
                  }
                e.push(a.height);
                this.sessionVariables.labelMaxHeight = Math.max.apply(Math, e);
                c =
                  g * Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (h - a.fontSize / 2) *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                Math.sin((Math.PI / 180) * Math.abs(this.labelAngle));
                y(this.options.labelAngle) &&
                isNaN(this.options.labelAngle) &&
                0 !== this.options.labelAngle
                  ? y(this.options.labelWrap)
                    ? y(this.options.labelWrap) &&
                      (y(this.options.labelMaxWidth)
                        ? y(f) ||
                          ((l = (p.height + f.height) >> 0),
                          l - 2 * h > m &&
                            ((m = l - 2 * h),
                            l >= 2 * h && l < 2.4 * h
                              ? (y(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelMaxHeight = h),
                                (this.sessionVariables.labelFontSize = y(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize))
                              : l >= 2.4 * h && l < 2.8 * h
                              ? ((this.sessionVariables.labelMaxHeight = c),
                                (this.sessionVariables.labelFontSize =
                                  this.labelFontSize),
                                (this.sessionVariables.labelWrap = !0))
                              : l >= 2.8 * h && l < 3.2 * h
                              ? ((this.sessionVariables.labelMaxHeight = h),
                                (this.sessionVariables.labelWrap = !0),
                                y(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = y(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelAngle = y(
                                  this.sessionVariables.labelAngle
                                )
                                  ? 0
                                  : this.sessionVariables.labelAngle))
                              : l >= 3.2 * h && l < 3.6 * h
                              ? ((this.sessionVariables.labelMaxHeight = c),
                                (this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelFontSize =
                                  this.labelFontSize))
                              : l > 3.6 * h && l < 10 * h
                              ? (y(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = y(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelMaxWidth = g),
                                (this.sessionVariables.labelMaxHeight = h),
                                (this.sessionVariables.labelAngle = y(
                                  this.sessionVariables.labelAngle
                                )
                                  ? 0
                                  : this.sessionVariables.labelAngle))
                              : l > 10 * h &&
                                l < 50 * h &&
                                (y(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = y(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelMaxHeight = h),
                                (this.sessionVariables.labelMaxWidth = g),
                                (this.sessionVariables.labelAngle = y(
                                  this.sessionVariables.labelAngle
                                )
                                  ? 0
                                  : this.sessionVariables.labelAngle))))
                        : ((this.sessionVariables.labelMaxHeight = h),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : this.sessionVariables.labelMaxWidth)))
                    : ((this.sessionVariables.labelMaxWidth = this.labelWrap
                        ? this.options.labelMaxWidth
                          ? this.options.labelMaxWidth
                          : this.sessionVariables.labelMaxWidth
                        : this.labelMaxWidth
                        ? this.options.labelMaxWidth
                          ? this.options.labelMaxWidth
                          : this.sessionVariables.labelMaxWidth
                        : g),
                      (this.sessionVariables.labelMaxHeight = h))
                  : ((this.sessionVariables.labelAngle = this.labelAngle),
                    (this.sessionVariables.labelMaxWidth =
                      0 === this.labelAngle
                        ? g
                        : Math.min(
                            (c -
                              h *
                                Math.sin(
                                  (Math.PI / 180) * Math.abs(this.labelAngle)
                                )) /
                              Math.cos(
                                (Math.PI / 180) * Math.abs(this.labelAngle)
                              ),
                            h
                          )),
                    y(this.options.labelWrap))
                  ? y(this.options.labelWrap) &&
                    (this.labelWrap && !y(this.options.labelMaxWidth)
                      ? ((this.sessionVariables.labelMaxWidth = this.options
                          .labelMaxWidth
                          ? this.options.labelMaxWidth >
                            this.options.labelMaxWidth
                          : this.sessionVariables.labelMaxWidth),
                        (this.sessionVariables.labelWrap = this.labelWrap),
                        (this.sessionVariables.labelMaxHeight = c))
                      : ((this.sessionVariables.labelMaxWidth = this.options
                          .labelMaxWidth
                          ? this.options.labelMaxWidth
                          : g),
                        (this.sessionVariables.labelMaxHeight =
                          0 === this.labelAngle ? h : c),
                        y(this.options.labelMaxWidth) &&
                          (this.sessionVariables.labelAngle = this.labelAngle)))
                  : this.options.labelWrap
                  ? ((this.sessionVariables.labelMaxHeight =
                      0 === this.labelAngle ? h : c),
                    (this.sessionVariables.labelWrap = this.labelWrap),
                    (this.sessionVariables.labelMaxWidth = g))
                  : ((this.sessionVariables.labelMaxHeight = h),
                    y(this.options.labelMaxWidth),
                    (this.sessionVariables.labelMaxWidth = this.options
                      .labelMaxWidth
                      ? this.options.labelMaxWidth
                      : this.sessionVariables.labelMaxWidth),
                    (this.sessionVariables.labelWrap = this.labelWrap));
              }
            for (c = 0; c < this._labels.length; c++)
              (a = this._labels[c].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  this.sessionVariables.labelMaxWidth),
                (a.fontSize = this.labelFontSize =
                  this.sessionVariables.labelFontSize),
                (a.angle = this.labelAngle = this.sessionVariables.labelAngle),
                (a.wrap = this.labelWrap = this.sessionVariables.labelWrap),
                (a.maxHeight = this.sessionVariables.labelMaxHeight),
                a.measureText();
          } else
            for (b = 0; b < this._labels.length; b++)
              (a = this._labels[b].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  y(this.options.labelMaxWidth)
                    ? this.sessionVariables.labelMaxWidth
                    : this.options.labelMaxWidth),
                (a.fontSize = this.labelFontSize =
                  y(this.options.labelFontSize)
                    ? this.sessionVariables.labelFontSize
                    : this.options.labelFontSize),
                (a.angle = this.labelAngle =
                  y(this.options.labelAngle)
                    ? this.sessionVariables.labelAngle
                    : this.labelAngle),
                (a.wrap = this.labelWrap =
                  y(this.options.labelWrap)
                    ? this.sessionVariables.labelWrap
                    : this.options.labelWrap),
                (a.maxHeight = this.sessionVariables.labelMaxHeight),
                a.measureText();
      for (b = 0; b < this.stripLines.length; b++) {
        var g = this.stripLines[b],
          t;
        if ("outside" === g.labelPlacement) {
          h = this.sessionVariables.labelMaxWidth;
          if ("bottom" === this._position || "top" === this._position)
            t = y(g.options.labelWrap)
              ? this.sessionVariables.labelMaxHeight
              : g.labelWrap
              ? (0.8 * this.chart.height) >> 0
              : 1.5 * this.labelFontSize;
          if ("left" === this._position || "right" === this._position)
            t = y(g.options.labelWrap)
              ? this.sessionVariables.labelMaxHeight
              : g.labelWrap
              ? (0.8 * this.chart.width) >> 0
              : 1.5 * this.labelFontSize;
          y(g.labelBackgroundColor) && (g.labelBackgroundColor = "#EEEEEE");
        } else
          (h =
            "bottom" === this._position || "top" === this._position
              ? (0.9 * this.chart.width) >> 0
              : (0.9 * this.chart.height) >> 0),
            (t =
              y(g.options.labelWrap) || g.labelWrap
                ? "bottom" === this._position || "top" === this._position
                  ? (0.8 * this.chart.width) >> 0
                  : (0.8 * this.chart.height) >> 0
                : 1.5 * this.labelFontSize),
            y(g.labelBackgroundColor) &&
              (y(g.startValue) && 0 !== g.startValue
                ? (g.labelBackgroundColor = v ? "transparent" : null)
                : (g.labelBackgroundColor = "#EEEEEE"));
        a = new ia(this.ctx, {
          x: 0,
          y: 0,
          backgroundColor: g.labelBackgroundColor,
          borderColor: g.labelBorderColor,
          borderThickness: g.labelBorderThickness,
          cornerRadius: g.labelCornerRadius,
          maxWidth: g.options.labelMaxWidth ? g.options.labelMaxWidth : h,
          maxHeight: t,
          angle: this.labelAngle,
          text: g.labelFormatter
            ? g.labelFormatter({ chart: this.chart, axis: this, stripLine: g })
            : g.label,
          horizontalAlign: "left",
          fontSize:
            "outside" === g.labelPlacement
              ? g.options.labelFontSize
                ? g.labelFontSize
                : this.labelFontSize
              : g.labelFontSize,
          fontFamily:
            "outside" === g.labelPlacement
              ? g.options.labelFontFamily
                ? g.labelFontFamily
                : this.labelFontFamily
              : g.labelFontFamily,
          fontWeight:
            "outside" === g.labelPlacement
              ? g.options.labelFontWeight
                ? g.labelFontWeight
                : this.labelFontWeight
              : g.labelFontWeight,
          fontColor: g.labelFontColor || g.color,
          fontStyle:
            "outside" === g.labelPlacement
              ? g.options.labelFontStyle
                ? g.labelFontStyle
                : this.fontWeight
              : g.labelFontStyle,
          textBaseline: "middle",
        });
        this._stripLineLabels.push({
          position: g.value,
          textBlock: a,
          effectiveHeight: null,
          stripLine: g,
        });
      }
    };
    z.prototype.createLabelsAndCalculateWidth = function () {
      var a = 0,
        f = 0;
      this._labels = [];
      this._stripLineLabels = [];
      if ("left" === this._position || "right" === this._position) {
        this.createLabels();
        for (f = 0; f < this._labels.length; f++) {
          var b = this._labels[f].textBlock,
            c = b.measureText(),
            e = 0,
            e =
              0 === this.labelAngle
                ? c.width
                : c.width *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (c.height - b.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(this.labelAngle));
          a < e && (a = e);
          this._labels[f].effectiveWidth = e;
        }
        for (f = 0; f < this._stripLineLabels.length; f++)
          "outside" === this._stripLineLabels[f].stripLine.labelPlacement &&
            this._stripLineLabels[f].stripLine.value > this.viewportMinimum &&
            this._stripLineLabels[f].stripLine.value < this.viewportMaximum &&
            ((b = this._stripLineLabels[f].textBlock),
            (c = b.measureText()),
            (e =
              0 === this.labelAngle
                ? c.width
                : c.width *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (c.height - b.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(this.labelAngle))),
            a < e && (a = e),
            (this._stripLineLabels[f].effectiveWidth = e));
      }
      f = this.title ? this._titleTextBlock.measureText().height + 2 : 0;
      return (b =
        "inside" === this.labelPlacement
          ? (b = f + 5)
          : f + a + this.tickLength + 5);
    };
    z.prototype.createLabelsAndCalculateHeight = function () {
      var a = 0;
      this._labels = [];
      this._stripLineLabels = [];
      var f,
        b = 0;
      this.createLabels();
      if ("bottom" === this._position || "top" === this._position) {
        for (b = 0; b < this._labels.length; b++) {
          f = this._labels[b].textBlock;
          var c = f.measureText(),
            e = 0,
            e =
              0 === this.labelAngle
                ? c.height
                : c.width *
                    Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (c.height - f.fontSize / 2) *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
          a < e && (a = e);
          this._labels[b].effectiveHeight = e;
        }
        for (b = 0; b < this._stripLineLabels.length; b++)
          "outside" === this._stripLineLabels[b].stripLine.labelPlacement &&
            ((f = this._stripLineLabels[b].textBlock),
            (c = f.measureText()),
            (e =
              0 === this.labelAngle
                ? c.height
                : c.width *
                    Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (c.height - f.fontSize / 2) *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle))),
            a < e && (a = e),
            (this._stripLineLabels[b].effectiveHeight = e));
      }
      f = this.title ? this._titleTextBlock.measureText().height + 2 : 0;
      return (b =
        "inside" === this.labelPlacement
          ? (b = f + 5)
          : f + a + this.tickLength + 5);
    };
    z.setLayoutAndRender = function (a, f, b, c, e, g) {
      var h,
        l,
        n,
        k,
        r = a[0] ? a[0].chart : f[0].chart,
        q = r.ctx,
        m = r._axes;
      if (a && 0 < a.length)
        for (var d = 0; d < a.length; d++)
          a[d] && a[d].calculateAxisParameters();
      if (f && 0 < f.length)
        for (d = 0; d < f.length; d++) f[d].calculateAxisParameters();
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++) b[d].calculateAxisParameters();
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++) c[d].calculateAxisParameters();
      for (d = 0; d < m.length; d++)
        if (m[d] && m[d].scaleBreaks && m[d].scaleBreaks._appliedBreaks.length)
          for (
            var p = m[d].scaleBreaks._appliedBreaks, s = 0;
            s < p.length && !(p[s].startValue > m[d].viewportMaximum);
            s++
          )
            p[s].endValue < m[d].viewportMinimum ||
              (y(m[d].scaleBreaks.firstBreakIndex) &&
                (m[d].scaleBreaks.firstBreakIndex = s),
              p[s].startValue >= m[d].viewPortMinimum &&
                (m[d].scaleBreaks.lastBreakIndex = s));
      for (
        var t = (s = 0),
          u = 0,
          x = 0,
          z = 0,
          B = 0,
          F = 0,
          A,
          J,
          I = (l = 0),
          M,
          K,
          L,
          p = (M = K = L = !1),
          d = 0;
        d < m.length;
        d++
      )
        m[d] &&
          m[d].title &&
          (m[d]._titleTextBlock = new ia(m[d].ctx, {
            text: m[d].title,
            horizontalAlign: "center",
            fontSize: m[d].titleFontSize,
            fontFamily: m[d].titleFontFamily,
            fontWeight: m[d].titleFontWeight,
            fontColor: m[d].titleFontColor,
            fontStyle: m[d].titleFontStyle,
            borderColor: m[d].titleBorderColor,
            borderThickness: m[d].titleBorderThickness,
            backgroundColor: m[d].titleBackgroundColor,
            cornerRadius: m[d].titleCornerRadius,
            textBaseline: "top",
          }));
      for (d = 0; d < m.length; d++)
        if (m[d].title)
          switch (m[d]._position) {
            case "left":
              m[d]._titleTextBlock.maxWidth = m[d].titleMaxWidth || g.height;
              m[d]._titleTextBlock.maxHeight = m[d].titleWrap
                ? 0.8 * g.width
                : 1.5 * m[d].titleFontSize;
              m[d]._titleTextBlock.angle = -90;
              break;
            case "right":
              m[d]._titleTextBlock.maxWidth = m[d].titleMaxWidth || g.height;
              m[d]._titleTextBlock.maxHeight = m[d].titleWrap
                ? 0.8 * g.width
                : 1.5 * m[d].titleFontSize;
              m[d]._titleTextBlock.angle = 90;
              break;
            default:
              (m[d]._titleTextBlock.maxWidth = m[d].titleMaxWidth || g.width),
                (m[d]._titleTextBlock.maxHeight = m[d].titleWrap
                  ? 0.8 * g.height
                  : 1.5 * m[d].titleFontSize),
                (m[d]._titleTextBlock.angle = 0);
          }
      if ("normal" === e) {
        for (
          var x = [], z = [], B = [], F = [], P = [], Q = [], R = [], S = [];
          4 > s;

        ) {
          var D = 0,
            T = 0,
            U = 0,
            V = 0,
            W = (e = 0),
            N = 0,
            $ = 0,
            Y = 0,
            X = 0,
            O = 0,
            aa = 0;
          if (b && 0 < b.length)
            for (B = [], d = O = 0; d < b.length; d++)
              B.push(
                Math.ceil(b[d] ? b[d].createLabelsAndCalculateWidth() : 0)
              ),
                (O += B[d]),
                (N += b[d] ? b[d].margin : 0);
          else
            B.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateWidth() : 0));
          R.push(B);
          if (c && 0 < c.length)
            for (F = [], d = aa = 0; d < c.length; d++)
              F.push(
                Math.ceil(c[d] ? c[d].createLabelsAndCalculateWidth() : 0)
              ),
                (aa += F[d]),
                ($ += c[d] ? c[d].margin : 0);
          else
            F.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateWidth() : 0));
          S.push(F);
          h = Math.round(g.x1 + O + N);
          n = Math.round(
            g.x2 - aa - $ > r.width - 10 ? r.width - 10 : g.x2 - aa - $
          );
          if (a && 0 < a.length)
            for (x = [], d = Y = 0; d < a.length; d++)
              a[d] && (a[d].lineCoordinates = {}),
                (a[d].lineCoordinates.width = Math.abs(n - h)),
                a[d].title &&
                  (a[d]._titleTextBlock.maxWidth =
                    0 < a[d].titleMaxWidth &&
                    a[d].titleMaxWidth < a[d].lineCoordinates.width
                      ? a[d].titleMaxWidth
                      : a[d].lineCoordinates.width),
                x.push(
                  Math.ceil(a[d] ? a[d].createLabelsAndCalculateHeight() : 0)
                ),
                (Y += x[d]),
                (e += a[d] ? a[d].margin : 0);
          else
            x.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateHeight() : 0));
          P.push(x);
          if (f && 0 < f.length)
            for (z = [], d = X = 0; d < f.length; d++)
              f[d] && (f[d].lineCoordinates = {}),
                (f[d].lineCoordinates.width = Math.abs(n - h)),
                f[d].title &&
                  (f[d]._titleTextBlock.maxWidth =
                    0 < f[d].titleMaxWidth &&
                    f[d].titleMaxWidth < f[d].lineCoordinates.width
                      ? f[d].titleMaxWidth
                      : f[d].lineCoordinates.width),
                z.push(
                  Math.ceil(f[d] ? f[d].createLabelsAndCalculateHeight() : 0)
                ),
                (X += z[d]),
                (W += f[d] ? f[d].margin : 0);
          else
            z.push(Math.ceil(f[0] ? f[0].createLabelsAndCalculateHeight() : 0));
          Q.push(z);
          if (a && 0 < a.length)
            for (d = 0; d < a.length; d++)
              a[d] &&
                ((a[d].lineCoordinates.x1 = h),
                (n = Math.round(
                  g.x2 - aa - $ > r.width - 10 ? r.width - 10 : g.x2 - aa - $
                )),
                a[d]._labels &&
                  1 < a[d]._labels.length &&
                  ((l = k = 0),
                  (k = a[d]._labels[1]),
                  (l =
                    "dateTime" === a[d].valueType
                      ? a[d]._labels[a[d]._labels.length - 2]
                      : a[d]._labels[a[d]._labels.length - 1]),
                  (t =
                    k.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                    (k.textBlock.height - l.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle))),
                  (u =
                    l.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(l.textBlock.angle)) +
                    (l.textBlock.height - l.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(l.textBlock.angle)))),
                a[d] &&
                  a[d].labelAutoFit &&
                  !y(A) &&
                  !y(J) &&
                  ((l = 0),
                  0 < a[d].labelAngle
                    ? J + u > n &&
                      (l += 0 < a[d].labelAngle ? J + u - n - aa : 0)
                    : 0 > a[d].labelAngle
                    ? A - t < h &&
                      A - t < a[d].viewportMinimum &&
                      (I =
                        h -
                        (N +
                          a[d].tickLength +
                          B +
                          A -
                          t +
                          a[d].labelFontSize / 2))
                    : 0 === a[d].labelAngle &&
                      (J + u > n && (l = J + u / 2 - n - aa),
                      A - t < h &&
                        A - t < a[d].viewportMinimum &&
                        (I = h - N - a[d].tickLength - B - A + t / 2)),
                  a[d].viewportMaximum === a[d].maximum &&
                  a[d].viewportMinimum === a[d].minimum &&
                  0 < a[d].labelAngle &&
                  0 < l
                    ? (n -= l)
                    : a[d].viewportMaximum === a[d].maximum &&
                      a[d].viewportMinimum === a[d].minimum &&
                      0 > a[d].labelAngle &&
                      0 < I
                    ? (h += I)
                    : a[d].viewportMaximum === a[d].maximum &&
                      a[d].viewportMinimum === a[d].minimum &&
                      0 === a[d].labelAngle &&
                      (0 < I && (h += I), 0 < l && (n -= l))),
                r.panEnabled
                  ? (Y = r.sessionVariables.axisX.height)
                  : (r.sessionVariables.axisX.height = Y),
                (l = Math.round(g.y2 - Y - e + D)),
                (k = Math.round(g.y2)),
                (a[d].lineCoordinates.x2 = n),
                (a[d].lineCoordinates.width = n - h),
                (a[d].lineCoordinates.y1 = l),
                (a[d].lineCoordinates.y2 = l),
                (a[d].bounds = {
                  x1: h,
                  y1: l,
                  x2: n,
                  y2: k - (Y + e - x[d] - D),
                  width: n - h,
                  height: k - l,
                })),
                (D += x[d] + a[d].margin);
          if (f && 0 < f.length)
            for (d = 0; d < f.length; d++)
              (f[d].lineCoordinates.x1 = Math.round(g.x1 + O + N)),
                (f[d].lineCoordinates.x2 = Math.round(
                  g.x2 - aa - $ > r.width - 10 ? r.width - 10 : g.x2 - aa - $
                )),
                (f[d].lineCoordinates.width = Math.abs(n - h)),
                f[d]._labels &&
                  1 < f[d]._labels.length &&
                  ((k = f[d]._labels[1]),
                  (l =
                    "dateTime" === f[d].valueType
                      ? f[d]._labels[f[d]._labels.length - 2]
                      : f[d]._labels[f[d]._labels.length - 1]),
                  (t =
                    k.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                    (k.textBlock.height - l.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle))),
                  (u =
                    l.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(l.textBlock.angle)) +
                    (l.textBlock.height - l.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(l.textBlock.angle)))),
                r.panEnabled
                  ? (X = r.sessionVariables.axisX2.height)
                  : (r.sessionVariables.axisX2.height = X),
                (l = Math.round(g.y1)),
                (k = Math.round(g.y2 + f[d].margin)),
                (f[d].lineCoordinates.y1 = l + X + W - T),
                (f[d].lineCoordinates.y2 = l),
                (f[d].bounds = {
                  x1: h,
                  y1: l + (X + W - z[d] - T),
                  x2: n,
                  y2: k,
                  width: n - h,
                  height: k - l,
                }),
                (T += z[d] + f[d].margin);
          if (b && 0 < b.length)
            for (d = 0; d < b.length; d++)
              (N = 10),
                b[d] &&
                  ((h = Math.round(
                    a[0] ? a[0].lineCoordinates.x1 : f[0].lineCoordinates.x1
                  )),
                  (N =
                    b[d]._labels && 0 < b[d]._labels.length
                      ? b[d]._labels[b[d]._labels.length - 1].textBlock.height /
                        2
                      : 10),
                  (l = Math.round(
                    g.y1 + X + W < Math.max(N, 10)
                      ? Math.max(N, 10)
                      : g.y1 + X + W
                  )),
                  (n = Math.round(
                    a[0] ? a[0].lineCoordinates.x1 : f[0].lineCoordinates.x1
                  )),
                  (N =
                    0 < a.length
                      ? 0
                      : b[d]._labels && 0 < b[d]._labels.length
                      ? b[d]._labels[0].textBlock.height / 2
                      : 10),
                  (k = Math.round(g.y2 - Y - e - N)),
                  (b[d].lineCoordinates = {
                    x1: n - U,
                    y1: l,
                    x2: n - U,
                    y2: k,
                    height: Math.abs(k - l),
                  }),
                  (b[d].bounds = {
                    x1: h - (B[d] + U),
                    y1: l,
                    x2: n,
                    y2: k,
                    width: n - h,
                    height: k - l,
                  }),
                  b[d].title &&
                    (b[d]._titleTextBlock.maxWidth =
                      0 < b[d].titleMaxWidth &&
                      b[d].titleMaxWidth < b[d].lineCoordinates.height
                        ? b[d].titleMaxWidth
                        : b[d].lineCoordinates.height),
                  (U += B[d] + b[d].margin));
          if (c && 0 < c.length)
            for (d = 0; d < c.length; d++)
              c[d] &&
                ((h = Math.round(
                  a[0] ? a[0].lineCoordinates.x2 : f[0].lineCoordinates.x2
                )),
                (n = Math.round(h)),
                (N =
                  c[d]._labels && 0 < c[d]._labels.length
                    ? c[d]._labels[c[d]._labels.length - 1].textBlock.height / 2
                    : 0),
                (l = Math.round(
                  g.y1 + X + W < Math.max(N, 10)
                    ? Math.max(N, 10)
                    : g.y1 + X + W
                )),
                (N =
                  0 < a.length
                    ? 0
                    : c[d]._labels && 0 < c[d]._labels.length
                    ? c[d]._labels[0].textBlock.height / 2
                    : 0),
                (k = Math.round(g.y2 - (Y + e + N))),
                (c[d].lineCoordinates = {
                  x1: h + V,
                  y1: l,
                  x2: h + V,
                  y2: k,
                  height: Math.abs(k - l),
                }),
                (c[d].bounds = {
                  x1: h,
                  y1: l,
                  x2: n + (F[d] + V),
                  y2: k,
                  width: n - h,
                  height: k - l,
                }),
                c[d].title &&
                  (c[d]._titleTextBlock.maxWidth =
                    0 < c[d].titleMaxWidth &&
                    c[d].titleMaxWidth < c[d].lineCoordinates.height
                      ? c[d].titleMaxWidth
                      : c[d].lineCoordinates.height),
                (V += F[d] + c[d].margin));
          if (a && 0 < a.length)
            for (d = 0; d < a.length; d++)
              a[d] &&
                (a[d].calculateValueToPixelConversionParameters(),
                a[d].calculateBreaksSizeInValues(),
                a[d]._labels &&
                  1 < a[d]._labels.length &&
                  ((A =
                    (a[d].logarithmic
                      ? Math.log(
                          a[d]._labels[1].position / a[d].viewportMinimum
                        ) / a[d].conversionParameters.lnLogarithmBase
                      : a[d]._labels[1].position - a[d].viewportMinimum) *
                      Math.abs(a[d].conversionParameters.pixelPerUnit) +
                    a[d].lineCoordinates.x1),
                  (h =
                    a[d]._labels[
                      a[d]._labels.length -
                        ("dateTime" === a[d].valueType ? 2 : 1)
                    ].position),
                  (h = a[d].getApparentDifference(a[d].viewportMinimum, h)),
                  (J = a[d].logarithmic
                    ? (1 < h
                        ? (Math.log(h) /
                            a[d].conversionParameters.lnLogarithmBase) *
                          Math.abs(a[d].conversionParameters.pixelPerUnit)
                        : 0) + a[d].lineCoordinates.x1
                    : (0 < h
                        ? h * Math.abs(a[d].conversionParameters.pixelPerUnit)
                        : 0) + a[d].lineCoordinates.x1)));
          if (f && 0 < f.length)
            for (d = 0; d < f.length; d++)
              f[d].calculateValueToPixelConversionParameters(),
                f[d].calculateBreaksSizeInValues(),
                f[d]._labels &&
                  1 < f[d]._labels.length &&
                  ((A =
                    (f[d].logarithmic
                      ? Math.log(
                          f[d]._labels[1].position / f[d].viewportMinimum
                        ) / f[d].conversionParameters.lnLogarithmBase
                      : f[d]._labels[1].position - f[d].viewportMinimum) *
                      Math.abs(f[d].conversionParameters.pixelPerUnit) +
                    f[d].lineCoordinates.x1),
                  (h =
                    f[d]._labels[
                      f[d]._labels.length -
                        ("dateTime" === f[d].valueType ? 2 : 1)
                    ].position),
                  (h = f[d].getApparentDifference(f[d].viewportMinimum, h)),
                  (J = f[d].logarithmic
                    ? (1 < h
                        ? (Math.log(h) /
                            f[d].conversionParameters.lnLogarithmBase) *
                          Math.abs(f[d].conversionParameters.pixelPerUnit)
                        : 0) + f[d].lineCoordinates.x1
                    : (0 < h
                        ? h * Math.abs(f[d].conversionParameters.pixelPerUnit)
                        : 0) + f[d].lineCoordinates.x1));
          for (d = 0; d < m.length; d++)
            "axisY" === m[d].type &&
              (m[d].calculateValueToPixelConversionParameters(),
              m[d].calculateBreaksSizeInValues());
          if (0 < s) {
            if (a && 0 < a.length)
              for (d = 0; d < a.length; d++)
                p = P[s - 1][d] === P[s][d] ? !0 : !1;
            else p = !0;
            if (f && 0 < f.length)
              for (d = 0; d < f.length; d++)
                M = Q[s - 1][d] === Q[s][d] ? !0 : !1;
            else M = !0;
            if (b && 0 < b.length)
              for (d = 0; d < b.length; d++)
                K = R[s - 1][d] === R[s][d] ? !0 : !1;
            else K = !0;
            if (c && 0 < c.length)
              for (d = 0; d < c.length; d++)
                L = S[s - 1][d] === S[s][d] ? !0 : !1;
            else L = !0;
          }
          if (p && M && K && L) break;
          s++;
        }
        q.save();
        q.beginPath();
        a[0] &&
          q.rect(5, a[0].bounds.y1, a[0].chart.width - 10, a[0].bounds.height);
        f[0] &&
          q.rect(
            5,
            f[f.length - 1].bounds.y1,
            f[0].chart.width - 10,
            f[0].bounds.height
          );
        q.clip();
        if (a && 0 < a.length)
          for (d = 0; d < a.length; d++)
            a[d].calculateStripLinesThicknessInValues(),
              a[d].calculateBreaksInPixels(),
              a[d].renderLabelsTicksAndTitle();
        if (f && 0 < f.length)
          for (d = 0; d < f.length; d++)
            f[d].calculateStripLinesThicknessInValues(),
              f[d].calculateBreaksInPixels(),
              f[d].renderLabelsTicksAndTitle();
        q.restore();
        if (b && 0 < b.length)
          for (d = 0; d < b.length; d++)
            b[d].calculateStripLinesThicknessInValues(),
              b[d].calculateBreaksInPixels(),
              b[d].renderLabelsTicksAndTitle();
        if (c && 0 < c.length)
          for (d = 0; d < c.length; d++)
            c[d].calculateStripLinesThicknessInValues(),
              c[d].calculateBreaksInPixels(),
              c[d].renderLabelsTicksAndTitle();
      } else {
        A = [];
        I = [];
        t = [];
        J = [];
        u = [];
        P = [];
        Q = [];
        for (R = []; 4 > s; ) {
          X = Y = O = V = $ = N = W = e = U = S = T = D = 0;
          if (a && 0 < a.length)
            for (t = [], d = Y = 0; d < a.length; d++)
              t.push(
                Math.ceil(a[d] ? a[d].createLabelsAndCalculateWidth() : 0)
              ),
                (Y += t[d]),
                (e += a[d] ? a[d].margin : 0);
          else
            t.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateWidth() : 0));
          Q.push(t);
          if (f && 0 < f.length)
            for (J = [], d = X = 0; d < f.length; d++)
              J.push(
                Math.ceil(f[d] ? f[d].createLabelsAndCalculateWidth() : 0)
              ),
                (X += J[d]),
                (W += f[d] ? f[d].margin : 0);
          else
            J.push(Math.ceil(f[0] ? f[0].createLabelsAndCalculateWidth() : 0));
          R.push(J);
          if (b && 0 < b.length)
            for (d = 0; d < b.length; d++)
              (b[d].lineCoordinates = {}),
                (h = Math.round(g.x1 + Y + e)),
                (n = Math.round(
                  g.x2 - X - W > r.width - 10 ? r.width - 10 : g.x2 - X - W
                )),
                b[d].labelAutoFit &&
                  !y(x) &&
                  (0 < !a.length &&
                    (h =
                      0 > b[d].labelAngle
                        ? Math.max(h, x)
                        : 0 === b[d].labelAngle
                        ? Math.max(h, x / 2)
                        : h),
                  0 < !f.length &&
                    (n =
                      0 < b[d].labelAngle
                        ? n - z / 2
                        : 0 === b[d].labelAngle
                        ? n - z / 2
                        : n)),
                (b[d].lineCoordinates.x1 = h),
                (b[d].lineCoordinates.x2 = n),
                (b[d].lineCoordinates.width = Math.abs(n - h)),
                b[d].title &&
                  (b[d]._titleTextBlock.maxWidth =
                    0 < b[d].titleMaxWidth &&
                    b[d].titleMaxWidth < b[d].lineCoordinates.width
                      ? b[d].titleMaxWidth
                      : b[d].lineCoordinates.width);
          if (c && 0 < c.length)
            for (d = 0; d < c.length; d++)
              (c[d].lineCoordinates = {}),
                (h = Math.round(g.x1 + Y + e)),
                (n = Math.round(
                  g.x2 - X - W > c[d].chart.width - 10
                    ? c[d].chart.width - 10
                    : g.x2 - X - W
                )),
                c[d] &&
                  c[d].labelAutoFit &&
                  !y(B) &&
                  (0 < !a.length &&
                    (h =
                      0 < c[d].labelAngle
                        ? Math.max(h, B)
                        : 0 === c[d].labelAngle
                        ? Math.max(h, B / 2)
                        : h),
                  0 < !f.length && (n -= F / 2)),
                (c[d].lineCoordinates.x1 = h),
                (c[d].lineCoordinates.x2 = n),
                (c[d].lineCoordinates.width = Math.abs(n - h)),
                c[d].title &&
                  (c[d]._titleTextBlock.maxWidth =
                    0 < c[d].titleMaxWidth &&
                    c[d].titleMaxWidth < c[d].lineCoordinates.width
                      ? c[d].titleMaxWidth
                      : c[d].lineCoordinates.width);
          if (b && 0 < b.length)
            for (A = [], d = V = 0; d < b.length; d++)
              A.push(
                Math.ceil(b[d] ? b[d].createLabelsAndCalculateHeight() : 0)
              ),
                (V += A[d] + b[d].margin),
                (N += b[d].margin);
          else
            A.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateHeight() : 0));
          u.push(A);
          if (c && 0 < c.length)
            for (I = [], d = O = 0; d < c.length; d++)
              I.push(
                Math.ceil(c[d] ? c[d].createLabelsAndCalculateHeight() : 0)
              ),
                (O += I[d]),
                ($ += c[d].margin);
          else
            I.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateHeight() : 0));
          P.push(I);
          if (b && 0 < b.length)
            for (d = 0; d < b.length; d++)
              0 < b[d]._labels.length &&
                ((k = b[d]._labels[0]),
                (l = b[d]._labels[b[d]._labels.length - 1]),
                (x =
                  k.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                  (k.textBlock.height - l.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle))),
                (z =
                  l.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(l.textBlock.angle)) +
                  (l.textBlock.height - l.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(l.textBlock.angle))));
          if (c && 0 < c.length)
            for (d = 0; d < c.length; d++)
              c[d] &&
                0 < c[d]._labels.length &&
                ((k = c[d]._labels[0]),
                (l = c[d]._labels[c[d]._labels.length - 1]),
                (B =
                  k.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                  (k.textBlock.height - l.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle))),
                (F =
                  l.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(l.textBlock.angle)) +
                  (l.textBlock.height - l.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(l.textBlock.angle))));
          if (r.panEnabled)
            for (d = 0; d < b.length; d++)
              A[d] = r.sessionVariables.axisY.height;
          else
            for (d = 0; d < b.length; d++)
              r.sessionVariables.axisY.height = A[d];
          if (b && 0 < b.length)
            for (d = b.length - 1; 0 <= d; d--)
              (l = Math.round(g.y2)),
                (k = Math.round(
                  g.y2 > b[d].chart.height - 10 ? b[d].chart.height - 10 : g.y2
                )),
                (b[d].lineCoordinates.y1 = l - (A[d] + b[d].margin + D)),
                (b[d].lineCoordinates.y2 = l - (A[d] + b[d].margin + D)),
                (b[d].bounds = {
                  x1: h,
                  y1: l - (A[d] + D + b[d].margin),
                  x2: n,
                  y2: k - (D + b[d].margin),
                  width: n - h,
                  height: A[d],
                }),
                b[d].title &&
                  (b[d]._titleTextBlock.maxWidth =
                    0 < b[d].titleMaxWidth &&
                    b[d].titleMaxWidth < b[d].lineCoordinates.width
                      ? b[d].titleMaxWidth
                      : b[d].lineCoordinates.width),
                (D += A[d] + b[d].margin);
          if (c && 0 < c.length)
            for (d = c.length - 1; 0 <= d; d--)
              c[d] &&
                ((l = Math.round(g.y1)),
                (k = Math.round(g.y1 + (I[d] + c[d].margin + T))),
                (c[d].lineCoordinates.y1 = k),
                (c[d].lineCoordinates.y2 = k),
                (c[d].bounds = {
                  x1: h,
                  y1: l + (c[d].margin + T),
                  x2: n,
                  y2: k,
                  width: n - h,
                  height: O,
                }),
                c[d].title &&
                  (c[d]._titleTextBlock.maxWidth =
                    0 < c[d].titleMaxWidth &&
                    c[d].titleMaxWidth < c[d].lineCoordinates.width
                      ? c[d].titleMaxWidth
                      : c[d].lineCoordinates.width),
                (T += I[d] + c[d].margin));
          if (a && 0 < a.length)
            for (d = 0; d < a.length; d++) {
              N =
                a[d]._labels && 0 < a[d]._labels.length
                  ? a[d]._labels[0].textBlock.fontSize / 2
                  : 0;
              h = Math.round(g.x1 + e);
              l =
                c && 0 < c.length
                  ? Math.round(
                      c[0]
                        ? c[0].lineCoordinates.y2
                        : g.y1 < Math.max(N, 10)
                        ? Math.max(N, 10)
                        : g.y1
                    )
                  : g.y1 < Math.max(N, 10)
                  ? Math.max(N, 10)
                  : g.y1;
              n = Math.round(g.x1 + Y + e);
              k =
                b && 0 < b.length
                  ? Math.round(
                      b[0]
                        ? b[0].lineCoordinates.y1
                        : g.y2 - V > r.height - Math.max(N, 10)
                        ? r.height - Math.max(N, 10)
                        : g.y2 - V
                    )
                  : g.y2 > r.height - Math.max(N, 10)
                  ? r.height - Math.max(N, 10)
                  : g.y2;
              if (b && 0 < b.length)
                for (N = 0; N < b.length; N++)
                  b[N] &&
                    b[N].labelAutoFit &&
                    ((n =
                      0 > b[N].labelAngle
                        ? Math.max(n, x)
                        : 0 === b[N].labelAngle
                        ? Math.max(n, x / 2)
                        : n),
                    (h =
                      0 > b[N].labelAngle || 0 === b[N].labelAngle
                        ? n - Y
                        : h));
              if (c && 0 < c.length)
                for (N = 0; N < c.length; N++)
                  c[N] &&
                    c[N].labelAutoFit &&
                    ((n = c[N].lineCoordinates.x1), (h = n - Y));
              a[d].lineCoordinates = {
                x1: n - S,
                y1: l,
                x2: n - S,
                y2: k,
                height: Math.abs(k - l),
              };
              a[d].bounds = {
                x1: n - (t[d] + S),
                y1: l,
                x2: n,
                y2: k,
                width: n - h,
                height: k - l,
              };
              a[d].title &&
                (a[d]._titleTextBlock.maxWidth =
                  0 < a[d].titleMaxWidth &&
                  a[d].titleMaxWidth < a[d].lineCoordinates.height
                    ? a[d].titleMaxWidth
                    : a[d].lineCoordinates.height);
              a[d].calculateValueToPixelConversionParameters();
              a[d].calculateBreaksSizeInValues();
              S += t[d] + a[d].margin;
            }
          if (f && 0 < f.length)
            for (d = 0; d < f.length; d++) {
              N =
                f[d]._labels && 0 < f[d]._labels.length
                  ? f[d]._labels[0].textBlock.fontSize / 2
                  : 0;
              h = Math.round(g.x1 - e);
              l =
                c && 0 < c.length
                  ? Math.round(
                      c[0]
                        ? c[0].lineCoordinates.y2
                        : g.y1 < Math.max(N, 10)
                        ? Math.max(N, 10)
                        : g.y1
                    )
                  : g.y1 < Math.max(N, 10)
                  ? Math.max(N, 10)
                  : g.y1;
              n = Math.round(g.x2 - X - W);
              k =
                b && 0 < b.length
                  ? Math.round(
                      b[0]
                        ? b[0].lineCoordinates.y1
                        : g.y2 - V > r.height - Math.max(N, 10)
                        ? r.height - Math.max(N, 10)
                        : g.y2 - V
                    )
                  : g.y2 > r.height - Math.max(N, 10)
                  ? r.height - Math.max(N, 10)
                  : g.y2;
              if (b && 0 < b.length)
                for (N = 0; N < b.length; N++)
                  b[N] &&
                    b[N].labelAutoFit &&
                    ((n =
                      0 > b[N].labelAngle
                        ? Math.max(n, x)
                        : 0 === b[N].labelAngle
                        ? Math.max(n, x / 2)
                        : n),
                    (h =
                      0 > b[N].labelAngle || 0 === b[N].labelAngle
                        ? n - X
                        : h));
              if (c && 0 < c.length)
                for (N = 0; N < c.length; N++)
                  c[N] &&
                    c[N].labelAutoFit &&
                    ((n = c[N].lineCoordinates.x2), (h = n - X));
              f[d].lineCoordinates = {
                x1: n + U,
                y1: l,
                x2: n + U,
                y2: k,
                height: Math.abs(k - l),
              };
              f[d].bounds = {
                x1: h,
                y1: l,
                x2: n + J[d] + U,
                y2: k,
                width: n - h,
                height: k - l,
              };
              f[d].title &&
                (f[d]._titleTextBlock.maxWidth =
                  0 < f[d].titleMaxWidth &&
                  f[d].titleMaxWidth < f[d].lineCoordinates.height
                    ? f[d].titleMaxWidth
                    : f[d].lineCoordinates.height);
              f[d].calculateValueToPixelConversionParameters();
              f[d].calculateBreaksSizeInValues();
              U += J[d] + f[d].margin;
            }
          for (d = 0; d < m.length; d++)
            "axisY" === m[d].type &&
              (m[d].calculateValueToPixelConversionParameters(),
              m[d].calculateBreaksSizeInValues());
          if (0 < s) {
            if (a && 0 < a.length)
              for (d = 0; d < a.length; d++)
                p = Q[s - 1][d] === Q[s][d] ? !0 : !1;
            else p = !0;
            if (f && 0 < f.length)
              for (d = 0; d < f.length; d++)
                M = R[s - 1][d] === R[s][d] ? !0 : !1;
            else M = !0;
            if (b && 0 < b.length)
              for (d = 0; d < b.length; d++)
                K = u[s - 1][d] === u[s][d] ? !0 : !1;
            else K = !0;
            if (c && 0 < c.length)
              for (d = 0; d < c.length; d++)
                L = P[s - 1][d] === P[s][d] ? !0 : !1;
            else L = !0;
          }
          if (p && M && K && L) break;
          s++;
        }
        if (b && 0 < b.length)
          for (d = 0; d < b.length; d++)
            b[d].calculateStripLinesThicknessInValues(),
              b[d].calculateBreaksInPixels(),
              b[d].renderLabelsTicksAndTitle();
        if (c && 0 < c.length)
          for (d = 0; d < c.length; d++)
            c[d].calculateStripLinesThicknessInValues(),
              c[d].calculateBreaksInPixels(),
              c[d].renderLabelsTicksAndTitle();
        if (a && 0 < a.length)
          for (d = 0; d < a.length; d++)
            a[d].calculateStripLinesThicknessInValues(),
              a[d].calculateBreaksInPixels(),
              a[d].renderLabelsTicksAndTitle();
        if (f && 0 < f.length)
          for (d = 0; d < f.length; d++)
            f[d].calculateStripLinesThicknessInValues(),
              f[d].calculateBreaksInPixels(),
              f[d].renderLabelsTicksAndTitle();
      }
      r.preparePlotArea();
      g = r.plotArea;
      q.save();
      q.beginPath();
      q.rect(g.x1, g.y1, Math.abs(g.x2 - g.x1), Math.abs(g.y2 - g.y1));
      q.clip();
      if (a && 0 < a.length)
        for (d = 0; d < m.length; d++)
          m[d].renderStripLinesOfThicknessType("value");
      if (f && 0 < f.length)
        for (d = 0; d < f.length; d++)
          f[d].renderStripLinesOfThicknessType("value");
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++)
          b[d].renderStripLinesOfThicknessType("value");
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++)
          c[d].renderStripLinesOfThicknessType("value");
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++) a[d].renderInterlacedColors();
      if (f && 0 < f.length)
        for (d = 0; d < f.length; d++) f[d].renderInterlacedColors();
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++) b[d].renderInterlacedColors();
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++) c[d].renderInterlacedColors();
      q.restore();
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++)
          a[d].renderGrid(),
            v && (a[d].createMask(), a[d].renderBreaksBackground());
      if (f && 0 < f.length)
        for (d = 0; d < f.length; d++)
          f[d].renderGrid(),
            v && (f[d].createMask(), f[d].renderBreaksBackground());
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++)
          b[d].renderGrid(),
            v && (b[d].createMask(), b[d].renderBreaksBackground());
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++)
          c[d].renderGrid(),
            v && (c[d].createMask(), c[d].renderBreaksBackground());
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++) a[d].renderAxisLine();
      if (f && 0 < f.length)
        for (d = 0; d < f.length; d++) f[d].renderAxisLine();
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++) b[d].renderAxisLine();
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++) c[d].renderAxisLine();
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++)
          a[d].renderStripLinesOfThicknessType("pixel");
      if (f && 0 < f.length)
        for (d = 0; d < f.length; d++)
          f[d].renderStripLinesOfThicknessType("pixel");
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++)
          b[d].renderStripLinesOfThicknessType("pixel");
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++)
          c[d].renderStripLinesOfThicknessType("pixel");
    };
    z.prototype.calculateStripLinesThicknessInValues = function () {
      for (var a = 0; a < this.stripLines.length; a++)
        if (
          null !== this.stripLines[a].startValue &&
          null !== this.stripLines[a].endValue
        ) {
          var f = Math.min(
              this.stripLines[a].startValue,
              this.stripLines[a].endValue
            ),
            b = Math.max(
              this.stripLines[a].startValue,
              this.stripLines[a].endValue
            ),
            f = this.getApparentDifference(f, b);
          this.stripLines[a].value = this.logarithmic
            ? this.stripLines[a].value *
              Math.sqrt(
                Math.log(
                  this.stripLines[a].endValue / this.stripLines[a].startValue
                ) / Math.log(f)
              )
            : this.stripLines[a].value +
              (Math.abs(
                this.stripLines[a].endValue - this.stripLines[a].startValue
              ) -
                f) /
                2;
          this.stripLines[a].thickness = f;
          this.stripLines[a]._thicknessType = "value";
        }
    };
    z.prototype.calculateBreaksSizeInValues = function () {
      for (
        var a =
            "left" === this._position || "right" === this._position
              ? this.lineCoordinates.height || this.chart.height
              : this.lineCoordinates.width || this.chart.width,
          f = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
          b =
            this.conversionParameters.pixelPerUnit ||
            a /
              (this.logarithmic
                ? this.conversionParameters.maximum /
                  this.conversionParameters.minimum
                : this.conversionParameters.maximum -
                  this.conversionParameters.minimum),
          c = this.scaleBreaks && !y(this.scaleBreaks.options.spacing),
          e,
          g = 0;
        g < f.length;
        g++
      )
        (e = c || !y(f[g].options.spacing)),
          (f[g].spacing =
            J(f[g].spacing, a, 8, e ? 0.1 * a : 8, e ? 0 : 3) << 0),
          (f[g].size = 0 > f[g].spacing ? 0 : Math.abs(f[g].spacing / b)),
          this.logarithmic &&
            (f[g].size = Math.pow(this.logarithmBase, f[g].size));
    };
    z.prototype.calculateBreaksInPixels = function () {
      if (!(this.scaleBreaks && 0 >= this.scaleBreaks._appliedBreaks.length)) {
        var a = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];
        a.length &&
          (this.scaleBreaks.firstBreakIndex = this.scaleBreaks.lastBreakIndex =
            null);
        for (
          var f = 0;
          f < a.length &&
          !(a[f].startValue > this.conversionParameters.maximum);
          f++
        )
          a[f].endValue < this.conversionParameters.minimum ||
            (y(this.scaleBreaks.firstBreakIndex) &&
              (this.scaleBreaks.firstBreakIndex = f),
            a[f].startValue >= this.conversionParameters.minimum &&
              ((a[f].startPixel = this.convertValueToPixel(a[f].startValue)),
              (this.scaleBreaks.lastBreakIndex = f)),
            a[f].endValue <= this.conversionParameters.maximum &&
              (a[f].endPixel = this.convertValueToPixel(a[f].endValue)));
      }
    };
    z.prototype.renderLabelsTicksAndTitle = function () {
      var a = this,
        f = !1,
        b = 0,
        c = 0,
        e = 1,
        g = 0;
      0 !== this.labelAngle && 360 !== this.labelAngle && (e = 1.2);
      if ("undefined" === typeof this.options.interval) {
        if ("bottom" === this._position || "top" === this._position)
          if (
            this.logarithmic &&
            !this.equidistantInterval &&
            this.labelAutoFit
          ) {
            for (
              var b = [],
                e = 0 !== this.labelAngle && 360 !== this.labelAngle ? 1 : 1.2,
                h,
                l = this.viewportMaximum,
                n = this.lineCoordinates.width / Math.log(this.range),
                k = this._labels.length - 1;
              0 <= k;
              k--
            ) {
              q = this._labels[k];
              if (q.position < this.viewportMinimum) break;
              q.position > this.viewportMaximum ||
                !(
                  k === this._labels.length - 1 ||
                  h < (Math.log(l / q.position) * n) / e
                ) ||
                (b.push(q),
                (l = q.position),
                (h =
                  q.textBlock.width *
                    Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                  q.textBlock.height *
                    Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))));
            }
            this._labels = b;
          } else {
            for (k = 0; k < this._labels.length; k++)
              (q = this._labels[k]),
                q.position < this.viewportMinimum ||
                  ((h =
                    q.textBlock.width *
                      Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                    q.textBlock.height *
                      Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))),
                  (b += h));
            b > this.lineCoordinates.width * e && this.labelAutoFit && (f = !0);
          }
        if ("left" === this._position || "right" === this._position)
          if (
            this.logarithmic &&
            !this.equidistantInterval &&
            this.labelAutoFit
          ) {
            for (
              var b = [],
                r,
                l = this.viewportMaximum,
                n = this.lineCoordinates.height / Math.log(this.range),
                k = this._labels.length - 1;
              0 <= k;
              k--
            ) {
              q = this._labels[k];
              if (q.position < this.viewportMinimum) break;
              q.position > this.viewportMaximum ||
                !(
                  k === this._labels.length - 1 ||
                  r < Math.log(l / q.position) * n
                ) ||
                (b.push(q),
                (l = q.position),
                (r =
                  q.textBlock.height *
                    Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                  q.textBlock.width *
                    Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))));
            }
            this._labels = b;
          } else {
            for (k = 0; k < this._labels.length; k++)
              (q = this._labels[k]),
                q.position < this.viewportMinimum ||
                  ((r =
                    q.textBlock.height *
                      Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                    q.textBlock.width *
                      Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))),
                  (c += r));
            c > this.lineCoordinates.height * e &&
              this.labelAutoFit &&
              (f = !0);
          }
      }
      this.logarithmic &&
        !this.equidistantInterval &&
        this.labelAutoFit &&
        this._labels.sort(function (a, b) {
          return a.position - b.position;
        });
      var k = 0,
        q,
        m;
      if ("bottom" === this._position) {
        for (k = 0; k < this._labels.length; k++)
          (q = this._labels[k]),
            q.position < this.viewportMinimum ||
              q.position > this.viewportMaximum ||
              (f && 0 !== g++ % 2 && this.labelAutoFit) ||
              ((m = this.getPixelCoordinatesOnAxis(q.position)),
              this.tickThickness &&
                "inside" != this.labelPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (m.x << 0) + 0.5 : m.x << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(c, m.y << 0),
                this.ctx.lineTo(c, (m.y + this.tickLength) << 0),
                this.ctx.stroke()),
              0 === q.textBlock.angle
                ? ((m.x -= q.textBlock.width / 2),
                  (m.y =
                    "inside" === this.labelPlacement
                      ? m.y - (this.tickLength + q.textBlock.fontSize / 2)
                      : m.y + this.tickLength + q.textBlock.fontSize / 2))
                : ((m.x =
                    "inside" === this.labelPlacement
                      ? 0 > this.labelAngle
                        ? m.x
                        : m.x -
                          q.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle)
                      : m.x -
                        (0 > this.labelAngle
                          ? q.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle)
                          : 0)),
                  (m.y =
                    "inside" === this.labelPlacement
                      ? 0 > this.labelAngle
                        ? m.y - this.tickLength - 5
                        : m.y -
                          this.tickLength -
                          Math.abs(
                            q.textBlock.width *
                              Math.sin((Math.PI / 180) * this.labelAngle) +
                              5
                          )
                      : m.y +
                        this.tickLength +
                        Math.abs(
                          0 > this.labelAngle
                            ? q.textBlock.width *
                                Math.sin((Math.PI / 180) * this.labelAngle) -
                                5
                            : 5
                        ))),
              (q.textBlock.x = m.x),
              (q.textBlock.y = m.y));
        "inside" === this.labelPlacement &&
          this.chart.addEventListener(
            "dataAnimationIterationEnd",
            function () {
              for (k = 0; k < a._labels.length; k++)
                if (
                  ((q = a._labels[k]),
                  !(
                    q.position < a.viewportMinimum ||
                    q.position > a.viewportMaximum ||
                    (f && 0 !== g++ % 2 && a.labelAutoFit)
                  ) &&
                    ((m = a.getPixelCoordinatesOnAxis(q.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === a.ctx.lineWidth % 2 ? (m.x << 0) + 0.5 : m.x << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(b, m.y << 0);
                  a.ctx.lineTo(b, (m.y - a.tickLength) << 0);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x =
            this.lineCoordinates.x1 +
            this.lineCoordinates.width / 2 -
            this._titleTextBlock.width / 2),
          (this._titleTextBlock.y =
            this.bounds.y2 - this._titleTextBlock.height - 3),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      } else if ("top" === this._position) {
        for (k = 0; k < this._labels.length; k++)
          (q = this._labels[k]),
            q.position < this.viewportMinimum ||
              q.position > this.viewportMaximum ||
              (f && 0 !== g++ % 2 && this.labelAutoFit) ||
              ((m = this.getPixelCoordinatesOnAxis(q.position)),
              this.tickThickness &&
                "inside" != this.labelPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (m.x << 0) + 0.5 : m.x << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(c, m.y << 0),
                this.ctx.lineTo(c, (m.y - this.tickLength) << 0),
                this.ctx.stroke()),
              0 === q.textBlock.angle
                ? ((m.x -= q.textBlock.width / 2),
                  (m.y =
                    "inside" === this.labelPlacement
                      ? m.y + this.labelFontSize / 2 + this.tickLength + 5
                      : m.y -
                        (this.tickLength +
                          q.textBlock.height -
                          q.textBlock.fontSize / 2)))
                : ((m.x =
                    "inside" === this.labelPlacement
                      ? 0 < this.labelAngle
                        ? m.x
                        : m.x -
                          q.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle)
                      : m.x +
                        (q.textBlock.height -
                          this.tickLength -
                          this.labelFontSize) *
                          Math.sin((Math.PI / 180) * this.labelAngle) -
                        (0 < this.labelAngle
                          ? q.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle)
                          : 0)),
                  (m.y =
                    "inside" === this.labelPlacement
                      ? 0 < this.labelAngle
                        ? m.y + this.tickLength + 5
                        : m.y -
                          q.textBlock.width *
                            Math.sin((Math.PI / 180) * this.labelAngle) +
                          this.tickLength +
                          5
                      : m.y -
                        (this.tickLength +
                          ((q.textBlock.height - q.textBlock.fontSize / 2) *
                            Math.cos((Math.PI / 180) * this.labelAngle) +
                            (0 < this.labelAngle
                              ? q.textBlock.width *
                                Math.sin((Math.PI / 180) * this.labelAngle)
                              : 0))))),
              (q.textBlock.x = m.x),
              (q.textBlock.y = m.y));
        "inside" === this.labelPlacement &&
          this.chart.addEventListener(
            "dataAnimationIterationEnd",
            function () {
              for (k = 0; k < a._labels.length; k++)
                if (
                  ((q = a._labels[k]),
                  !(
                    q.position < a.viewportMinimum ||
                    q.position > a.viewportMaximum ||
                    (f && 0 !== g++ % 2 && a.labelAutoFit)
                  ) &&
                    ((m = a.getPixelCoordinatesOnAxis(q.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === this.ctx.lineWidth % 2 ? (m.x << 0) + 0.5 : m.x << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(b, m.y << 0);
                  a.ctx.lineTo(b, (m.y + a.tickLength) << 0);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x =
            this.lineCoordinates.x1 +
            this.lineCoordinates.width / 2 -
            this._titleTextBlock.width / 2),
          (this._titleTextBlock.y = this.bounds.y1 + 1),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      } else if ("left" === this._position) {
        for (k = 0; k < this._labels.length; k++)
          (q = this._labels[k]),
            q.position < this.viewportMinimum ||
              q.position > this.viewportMaximum ||
              (f && 0 !== g++ % 2 && this.labelAutoFit) ||
              ((m = this.getPixelCoordinatesOnAxis(q.position)),
              this.tickThickness &&
                "inside" != this.labelPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (m.y << 0) + 0.5 : m.y << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(m.x << 0, c),
                this.ctx.lineTo((m.x - this.tickLength) << 0, c),
                this.ctx.stroke()),
              0 === this.labelAngle
                ? ((q.textBlock.y = m.y),
                  (q.textBlock.x =
                    "inside" === this.labelPlacement
                      ? m.x + this.tickLength + 5
                      : m.x -
                        q.textBlock.width *
                          Math.cos((Math.PI / 180) * this.labelAngle) -
                        this.tickLength -
                        5))
                : ((q.textBlock.y =
                    "inside" === this.labelPlacement
                      ? m.y
                      : m.y -
                        q.textBlock.width *
                          Math.sin((Math.PI / 180) * this.labelAngle)),
                  (q.textBlock.x =
                    "inside" === this.labelPlacement
                      ? m.x + this.tickLength + 5
                      : 0 < this.labelAngle
                      ? m.x -
                        q.textBlock.width *
                          Math.cos((Math.PI / 180) * this.labelAngle) -
                        this.tickLength -
                        5
                      : m.x -
                        q.textBlock.width *
                          Math.cos((Math.PI / 180) * this.labelAngle) +
                        (q.textBlock.height - q.textBlock.fontSize / 2 - 5) *
                          Math.sin((Math.PI / 180) * this.labelAngle) -
                        this.tickLength)));
        "inside" === this.labelPlacement &&
          this.chart.addEventListener(
            "dataAnimationIterationEnd",
            function () {
              for (k = 0; k < a._labels.length; k++)
                if (
                  ((q = a._labels[k]),
                  !(
                    q.position < a.viewportMinimum ||
                    q.position > a.viewportMaximum ||
                    (f && 0 !== g++ % 2 && a.labelAutoFit)
                  ) &&
                    ((m = a.getPixelCoordinatesOnAxis(q.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === a.ctx.lineWidth % 2 ? (m.y << 0) + 0.5 : m.y << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(m.x << 0, b);
                  a.ctx.lineTo((m.x + a.tickLength) << 0, b);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x = this.bounds.x1 + 1),
          (this._titleTextBlock.y =
            this.lineCoordinates.height / 2 +
            this._titleTextBlock.width / 2 +
            this.lineCoordinates.y1),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      } else if ("right" === this._position) {
        for (k = 0; k < this._labels.length; k++)
          (q = this._labels[k]),
            q.position < this.viewportMinimum ||
              q.position > this.viewportMaximum ||
              (f && 0 !== g++ % 2 && this.labelAutoFit) ||
              ((m = this.getPixelCoordinatesOnAxis(q.position)),
              this.tickThickness &&
                "inside" != this.labelPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (m.y << 0) + 0.5 : m.y << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(m.x << 0, c),
                this.ctx.lineTo((m.x + this.tickLength) << 0, c),
                this.ctx.stroke()),
              0 === this.labelAngle
                ? ((q.textBlock.y = m.y),
                  (q.textBlock.x =
                    "inside" === this.labelPlacement
                      ? m.x - q.textBlock.width - this.tickLength - 5
                      : m.x + this.tickLength + 5))
                : ((q.textBlock.y =
                    "inside" === this.labelPlacement
                      ? m.y -
                        q.textBlock.width *
                          Math.sin((Math.PI / 180) * this.labelAngle)
                      : 0 > this.labelAngle
                      ? m.y
                      : m.y -
                        (q.textBlock.height - q.textBlock.fontSize / 2 - 5) *
                          Math.cos((Math.PI / 180) * this.labelAngle)),
                  (q.textBlock.x =
                    "inside" === this.labelPlacement
                      ? m.x -
                        q.textBlock.width *
                          Math.cos((Math.PI / 180) * this.labelAngle) -
                        this.tickLength -
                        5
                      : 0 < this.labelAngle
                      ? m.x +
                        (q.textBlock.height - q.textBlock.fontSize / 2 - 5) *
                          Math.sin((Math.PI / 180) * this.labelAngle) +
                        this.tickLength
                      : m.x + this.tickLength + 5)));
        "inside" === this.labelPlacement &&
          this.chart.addEventListener(
            "dataAnimationIterationEnd",
            function () {
              for (k = 0; k < a._labels.length; k++)
                if (
                  ((q = a._labels[k]),
                  !(
                    q.position < a.viewportMinimum ||
                    q.position > a.viewportMaximum ||
                    (f && 0 !== g++ % 2 && a.labelAutoFit)
                  ) &&
                    ((m = a.getPixelCoordinatesOnAxis(q.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === a.ctx.lineWidth % 2 ? (m.y << 0) + 0.5 : m.y << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(m.x << 0, b);
                  a.ctx.lineTo((m.x - a.tickLength) << 0, b);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x = this.bounds.x2 - 1),
          (this._titleTextBlock.y =
            this.lineCoordinates.height / 2 -
            this._titleTextBlock.width / 2 +
            this.lineCoordinates.y1),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      }
      g = 0;
      if ("inside" === this.labelPlacement)
        this.chart.addEventListener(
          "dataAnimationIterationEnd",
          function () {
            for (k = 0; k < a._labels.length; k++)
              (q = a._labels[k]),
                q.position < a.viewportMinimum ||
                  q.position > a.viewportMaximum ||
                  (f && 0 !== g++ % 2 && a.labelAutoFit && q.skipFlag) ||
                  (a.ctx.save(),
                  a.ctx.beginPath(),
                  q.textBlock.render(!0),
                  a.ctx.restore());
          },
          q.textBlock
        );
      else
        for (k = 0; k < this._labels.length; k++)
          (q = this._labels[k]),
            q.position < this.viewportMinimum ||
              q.position > this.viewportMaximum ||
              (f && 0 !== g++ % 2 && this.labelAutoFit && q.skipFlag) ||
              q.textBlock.render(!0);
    };
    z.prototype.renderInterlacedColors = function () {
      var a = this.chart.plotArea.ctx,
        f,
        b,
        c = this.chart.plotArea,
        e = 0;
      f = !0;
      if (
        ("bottom" === this._position || "top" === this._position) &&
        this.interlacedColor
      )
        for (
          a.fillStyle = this.interlacedColor, e = 0;
          e < this._labels.length;
          e++
        )
          f
            ? ((f = this.getPixelCoordinatesOnAxis(this._labels[e].position)),
              (b =
                e + 1 > this._labels.length - 1
                  ? this.getPixelCoordinatesOnAxis(this.viewportMaximum)
                  : this.getPixelCoordinatesOnAxis(
                      this._labels[e + 1].position
                    )),
              a.fillRect(
                Math.min(b.x, f.x),
                c.y1,
                Math.abs(b.x - f.x),
                Math.abs(c.y1 - c.y2)
              ),
              (f = !1))
            : (f = !0);
      else if (
        ("left" === this._position || "right" === this._position) &&
        this.interlacedColor
      )
        for (
          a.fillStyle = this.interlacedColor, e = 0;
          e < this._labels.length;
          e++
        )
          f
            ? ((b = this.getPixelCoordinatesOnAxis(this._labels[e].position)),
              (f =
                e + 1 > this._labels.length - 1
                  ? this.getPixelCoordinatesOnAxis(this.viewportMaximum)
                  : this.getPixelCoordinatesOnAxis(
                      this._labels[e + 1].position
                    )),
              a.fillRect(
                c.x1,
                Math.min(b.y, f.y),
                Math.abs(c.x1 - c.x2),
                Math.abs(f.y - b.y)
              ),
              (f = !1))
            : (f = !0);
      a.beginPath();
    };
    z.prototype.renderStripLinesOfThicknessType = function (a) {
      if (this.stripLines && 0 < this.stripLines.length && a) {
        for (
          var f = this,
            b,
            c = 0,
            e = 0,
            g = !1,
            h = !1,
            l = [],
            n = [],
            h = !1,
            c = 0;
          c < this.stripLines.length;
          c++
        ) {
          var k = this.stripLines[c];
          k._thicknessType === a &&
            (("pixel" === a &&
              (k.value < this.viewportMinimum ||
                k.value > this.viewportMaximum ||
                y(k.value) ||
                isNaN(this.range))) ||
              l.push(k));
        }
        for (c = 0; c < this._stripLineLabels.length; c++)
          if (
            ((k = this.stripLines[c]),
            (b = this._stripLineLabels[c]),
            !(
              b.position < this.viewportMinimum ||
              b.position > this.viewportMaximum ||
              isNaN(this.range)
            ))
          ) {
            a = this.getPixelCoordinatesOnAxis(b.position);
            if ("outside" === b.stripLine.labelPlacement)
              if (
                (k &&
                  ((this.ctx.strokeStyle = k.color),
                  "pixel" === k._thicknessType &&
                    (this.ctx.lineWidth = k.thickness)),
                "bottom" === this._position)
              ) {
                var r =
                  1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0;
                this.ctx.beginPath();
                this.ctx.moveTo(r, a.y << 0);
                this.ctx.lineTo(r, (a.y + this.tickLength) << 0);
                this.ctx.stroke();
                0 === this.labelAngle
                  ? ((a.x -= b.textBlock.width / 2),
                    (a.y += this.tickLength + b.textBlock.fontSize / 2))
                  : ((a.x -=
                      0 > this.labelAngle
                        ? b.textBlock.width *
                          Math.cos((Math.PI / 180) * this.labelAngle)
                        : 0),
                    (a.y +=
                      this.tickLength +
                      Math.abs(
                        0 > this.labelAngle
                          ? b.textBlock.width *
                              Math.sin((Math.PI / 180) * this.labelAngle) -
                              5
                          : 5
                      )));
              } else
                "top" === this._position
                  ? ((r =
                      1 === this.ctx.lineWidth % 2
                        ? (a.x << 0) + 0.5
                        : a.x << 0),
                    this.ctx.beginPath(),
                    this.ctx.moveTo(r, a.y << 0),
                    this.ctx.lineTo(r, (a.y - this.tickLength) << 0),
                    this.ctx.stroke(),
                    0 === this.labelAngle
                      ? ((a.x -= b.textBlock.width / 2),
                        (a.y -= this.tickLength + b.textBlock.height))
                      : ((a.x +=
                          (b.textBlock.height -
                            this.tickLength -
                            this.labelFontSize / 2) *
                            Math.sin((Math.PI / 180) * this.labelAngle) -
                          (0 < this.labelAngle
                            ? b.textBlock.width *
                              Math.cos((Math.PI / 180) * this.labelAngle)
                            : 0)),
                        (a.y -=
                          this.tickLength +
                          (b.textBlock.height *
                            Math.cos((Math.PI / 180) * this.labelAngle) +
                            (0 < this.labelAngle
                              ? b.textBlock.width *
                                Math.sin((Math.PI / 180) * this.labelAngle)
                              : 0)))))
                  : "left" === this._position
                  ? ((r =
                      1 === this.ctx.lineWidth % 2
                        ? (a.y << 0) + 0.5
                        : a.y << 0),
                    this.ctx.beginPath(),
                    this.ctx.moveTo(a.x << 0, r),
                    this.ctx.lineTo((a.x - this.tickLength) << 0, r),
                    this.ctx.stroke(),
                    0 === this.labelAngle
                      ? (a.x =
                          a.x -
                          b.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle) -
                          this.tickLength -
                          5)
                      : ((a.y -=
                          b.textBlock.width *
                          Math.sin((Math.PI / 180) * this.labelAngle)),
                        (a.x =
                          0 < this.labelAngle
                            ? a.x -
                              b.textBlock.width *
                                Math.cos((Math.PI / 180) * this.labelAngle) -
                              this.tickLength -
                              5
                            : a.x -
                              b.textBlock.width *
                                Math.cos((Math.PI / 180) * this.labelAngle) +
                              (b.textBlock.height -
                                b.textBlock.fontSize / 2 -
                                5) *
                                Math.sin((Math.PI / 180) * this.labelAngle) -
                              this.tickLength)))
                  : "right" === this._position &&
                    ((r =
                      1 === this.ctx.lineWidth % 2
                        ? (a.y << 0) + 0.5
                        : a.y << 0),
                    this.ctx.beginPath(),
                    this.ctx.moveTo(a.x << 0, r),
                    this.ctx.lineTo((a.x + this.tickLength) << 0, r),
                    this.ctx.stroke(),
                    0 === this.labelAngle
                      ? (a.x = a.x + this.tickLength + 5)
                      : ((a.y =
                          0 > this.labelAngle
                            ? a.y
                            : a.y -
                              (b.textBlock.height -
                                b.textBlock.fontSize / 2 -
                                5) *
                                Math.cos((Math.PI / 180) * this.labelAngle)),
                        (a.x =
                          0 < this.labelAngle
                            ? a.x +
                              (b.textBlock.height -
                                b.textBlock.fontSize / 2 -
                                5) *
                                Math.sin((Math.PI / 180) * this.labelAngle) +
                              this.tickLength
                            : a.x + this.tickLength + 5)));
            else
              (b.textBlock.angle = -90),
                "bottom" === this._position
                  ? ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.height - 3),
                    b.textBlock.measureText(),
                    a.x - b.textBlock.height > this.chart.plotArea.x1
                      ? y(k.startValue)
                        ? (a.x -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.x -=
                            b.textBlock.height / 2 -
                            b.textBlock.fontSize / 2 +
                            3)
                      : ((b.textBlock.angle = 90),
                        y(k.startValue)
                          ? (a.x +=
                              b.textBlock.height - b.textBlock.fontSize / 2)
                          : (a.x +=
                              b.textBlock.height / 2 -
                              b.textBlock.fontSize / 2 +
                              3)),
                    (a.y =
                      -90 === b.textBlock.angle
                        ? "near" === b.stripLine.labelAlign
                          ? this.chart.plotArea.y2 - 3
                          : "center" === b.stripLine.labelAlign
                          ? (this.chart.plotArea.y2 +
                              this.chart.plotArea.y1 +
                              b.textBlock.width) /
                            2
                          : this.chart.plotArea.y1 + b.textBlock.width + 3
                        : "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.y2 - b.textBlock.width - 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.y2 +
                            this.chart.plotArea.y1 -
                            b.textBlock.width) /
                          2
                        : this.chart.plotArea.y1 + 3))
                  : "top" === this._position
                  ? ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.height - 3),
                    b.textBlock.measureText(),
                    a.x - b.textBlock.height > this.chart.plotArea.x1
                      ? y(k.startValue)
                        ? (a.x -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.x -=
                            b.textBlock.height / 2 -
                            b.textBlock.fontSize / 2 +
                            3)
                      : ((b.textBlock.angle = 90),
                        y(k.startValue)
                          ? (a.x +=
                              b.textBlock.height - b.textBlock.fontSize / 2)
                          : (a.x +=
                              b.textBlock.height / 2 -
                              b.textBlock.fontSize / 2 +
                              3)),
                    (a.y =
                      -90 === b.textBlock.angle
                        ? "near" === b.stripLine.labelAlign
                          ? this.chart.plotArea.y1 + b.textBlock.width + 3
                          : "center" === b.stripLine.labelAlign
                          ? (this.chart.plotArea.y2 +
                              this.chart.plotArea.y1 +
                              b.textBlock.width) /
                            2
                          : this.chart.plotArea.y2 - 3
                        : "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.y1 + 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.y2 +
                            this.chart.plotArea.y1 -
                            b.textBlock.width) /
                          2
                        : this.chart.plotArea.y2 - b.textBlock.width - 3))
                  : "left" === this._position
                  ? ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.width - 3),
                    (b.textBlock.angle = 0),
                    b.textBlock.measureText(),
                    a.y - b.textBlock.height > this.chart.plotArea.y1
                      ? y(k.startValue)
                        ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.y -=
                            b.textBlock.height / 2 - b.textBlock.fontSize + 3)
                      : a.y - b.textBlock.height < this.chart.plotArea.y2
                      ? (a.y += b.textBlock.fontSize / 2 + 3)
                      : y(k.startValue)
                      ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                      : (a.y -=
                          b.textBlock.height / 2 - b.textBlock.fontSize + 3),
                    (a.x =
                      "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.x1 + 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.x2 + this.chart.plotArea.x1) /
                            2 -
                          b.textBlock.width / 2
                        : this.chart.plotArea.x2 - b.textBlock.width - 3))
                  : "right" === this._position &&
                    ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.width - 3),
                    (b.textBlock.angle = 0),
                    b.textBlock.measureText(),
                    a.y - +b.textBlock.height > this.chart.plotArea.y1
                      ? y(k.startValue)
                        ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.y -=
                            b.textBlock.height / 2 -
                            b.textBlock.fontSize / 2 -
                            3)
                      : a.y - b.textBlock.height < this.chart.plotArea.y2
                      ? (a.y += b.textBlock.fontSize / 2 + 3)
                      : y(k.startValue)
                      ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                      : (a.y -=
                          b.textBlock.height / 2 -
                          b.textBlock.fontSize / 2 +
                          3),
                    (a.x =
                      "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.x2 - b.textBlock.width - 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.x2 + this.chart.plotArea.x1) /
                            2 -
                          b.textBlock.width / 2
                        : this.chart.plotArea.x1 + 3));
            b.textBlock.x = a.x;
            b.textBlock.y = a.y;
            n.push(b);
          }
        if (!h) {
          h = !1;
          this.ctx.save();
          this.ctx.beginPath();
          this.ctx.rect(
            this.chart.plotArea.x1,
            this.chart.plotArea.y1,
            this.chart.plotArea.width,
            this.chart.plotArea.height
          );
          this.ctx.clip();
          for (c = 0; c < l.length; c++)
            (k = l[c]),
              k.showOnTop
                ? g ||
                  ((g = !0),
                  this.chart.addEventListener(
                    "dataAnimationIterationEnd",
                    function () {
                      this.ctx.save();
                      this.ctx.beginPath();
                      this.ctx.rect(
                        this.chart.plotArea.x1,
                        this.chart.plotArea.y1,
                        this.chart.plotArea.width,
                        this.chart.plotArea.height
                      );
                      this.ctx.clip();
                      for (e = 0; e < l.length; e++)
                        (k = l[e]), k.showOnTop && k.render();
                      this.ctx.restore();
                    },
                    k
                  ))
                : k.render();
          for (c = 0; c < n.length; c++)
            (b = n[c]),
              b.stripLine.showOnTop
                ? h ||
                  ((h = !0),
                  this.chart.addEventListener(
                    "dataAnimationIterationEnd",
                    function () {
                      for (e = 0; e < n.length; e++)
                        (b = n[e]),
                          "inside" === b.stripLine.labelPlacement &&
                            b.stripLine.showOnTop &&
                            (f.ctx.save(),
                            f.ctx.beginPath(),
                            f.ctx.rect(
                              f.chart.plotArea.x1,
                              f.chart.plotArea.y1,
                              f.chart.plotArea.width,
                              f.chart.plotArea.height
                            ),
                            f.ctx.clip(),
                            b.textBlock.render(!0),
                            f.ctx.restore());
                    },
                    b.textBlock
                  ))
                : "inside" === b.stripLine.labelPlacement &&
                  b.textBlock.render(!0);
          this.ctx.restore();
          h = !0;
        }
        if (h)
          for (h = !1, c = 0; c < n.length; c++)
            (b = n[c]),
              b.stripLine.showOnTop
                ? h ||
                  ((h = !0),
                  this.chart.addEventListener(
                    "dataAnimationIterationEnd",
                    function () {
                      for (e = 0; e < n.length; e++)
                        (b = n[e]),
                          "outside" === b.stripLine.labelPlacement &&
                            b.stripLine.showOnTop &&
                            b.textBlock.render(!0);
                    },
                    b.textBlock
                  ))
                : "outside" === b.stripLine.labelPlacement &&
                  b.textBlock.render(!0);
      }
    };
    z.prototype.renderBreaksBackground = function () {
      this.chart._breaksCanvas &&
        this.scaleBreaks &&
        0 < this.scaleBreaks._appliedBreaks.length &&
        this.maskCanvas &&
        (this.chart._breaksCanvasCtx.save(),
        this.chart._breaksCanvasCtx.beginPath(),
        this.chart._breaksCanvasCtx.rect(
          this.chart.plotArea.x1,
          this.chart.plotArea.y1,
          this.chart.plotArea.width,
          this.chart.plotArea.height
        ),
        this.chart._breaksCanvasCtx.clip(),
        this.chart._breaksCanvasCtx.drawImage(
          this.maskCanvas,
          0,
          0,
          this.chart.width,
          this.chart.height
        ),
        this.chart._breaksCanvasCtx.restore());
    };
    z.prototype.createMask = function () {
      if (this.scaleBreaks && 0 < this.scaleBreaks._appliedBreaks.length) {
        var a = this.scaleBreaks._appliedBreaks;
        v
          ? ((this.maskCanvas = ta(this.chart.width, this.chart.height)),
            (this.maskCtx = this.maskCanvas.getContext("2d")))
          : ((this.maskCanvas = this.chart.plotArea.canvas),
            (this.maskCtx = this.chart.plotArea.ctx));
        this.maskCtx.save();
        this.maskCtx.beginPath();
        this.maskCtx.rect(
          this.chart.plotArea.x1,
          this.chart.plotArea.y1,
          this.chart.plotArea.width,
          this.chart.plotArea.height
        );
        this.maskCtx.clip();
        for (var f = 0; f < a.length; f++)
          a[f].endValue < this.viewportMinimum ||
            a[f].startValue > this.viewportMaximum ||
            isNaN(this.range) ||
            a[f].render(this.maskCtx);
        this.maskCtx.restore();
      }
    };
    z.prototype.renderCrosshair = function (a, f) {
      this.crosshair.render(a, f);
    };
    z.prototype.renderGrid = function () {
      if (this.gridThickness && 0 < this.gridThickness) {
        var a = this.chart.ctx;
        a.save();
        var f,
          b = this.chart.plotArea;
        a.lineWidth = this.gridThickness;
        a.strokeStyle = this.gridColor;
        a.setLineDash &&
          a.setLineDash(F(this.gridDashType, this.gridThickness));
        if ("bottom" === this._position || "top" === this._position)
          for (c = 0; c < this._labels.length; c++)
            this._labels[c].position < this.viewportMinimum ||
              this._labels[c].position > this.viewportMaximum ||
              this._labels[c].breaksLabelType ||
              (a.beginPath(),
              (f = this.getPixelCoordinatesOnAxis(this._labels[c].position)),
              (f = 1 === a.lineWidth % 2 ? (f.x << 0) + 0.5 : f.x << 0),
              a.moveTo(f, b.y1 << 0),
              a.lineTo(f, b.y2 << 0),
              a.stroke());
        else if ("left" === this._position || "right" === this._position)
          for (var c = 0; c < this._labels.length; c++)
            this._labels[c].position < this.viewportMinimum ||
              this._labels[c].position > this.viewportMaximum ||
              this._labels[c].breaksLabelType ||
              (a.beginPath(),
              (f = this.getPixelCoordinatesOnAxis(this._labels[c].position)),
              (f = 1 === a.lineWidth % 2 ? (f.y << 0) + 0.5 : f.y << 0),
              a.moveTo(b.x1 << 0, f),
              a.lineTo(b.x2 << 0, f),
              a.stroke());
        a.restore();
      }
    };
    z.prototype.renderAxisLine = function () {
      var a = this.chart.ctx,
        f = v ? this.chart._preRenderCtx : a,
        b = Math.ceil(this.tickThickness / (this.reversed ? -2 : 2)),
        c = Math.ceil(this.tickThickness / (this.reversed ? 2 : -2)),
        e,
        g;
      f.save();
      if ("bottom" === this._position || "top" === this._position) {
        if (this.lineThickness) {
          this.reversed
            ? ((e = this.lineCoordinates.x2), (g = this.lineCoordinates.x1))
            : ((e = this.lineCoordinates.x1), (g = this.lineCoordinates.x2));
          f.lineWidth = this.lineThickness;
          f.strokeStyle = this.lineColor ? this.lineColor : "black";
          f.setLineDash &&
            f.setLineDash(F(this.lineDashType, this.lineThickness));
          var h =
            1 === this.lineThickness % 2
              ? (this.lineCoordinates.y1 << 0) + 0.5
              : this.lineCoordinates.y1 << 0;
          f.beginPath();
          if (this.scaleBreaks && !y(this.scaleBreaks.firstBreakIndex))
            if (y(this.scaleBreaks.lastBreakIndex))
              e =
                this.scaleBreaks._appliedBreaks[
                  this.scaleBreaks.firstBreakIndex
                ].endPixel + c;
            else
              for (
                var l = this.scaleBreaks.firstBreakIndex;
                l <= this.scaleBreaks.lastBreakIndex;
                l++
              )
                f.moveTo(e, h),
                  f.lineTo(
                    this.scaleBreaks._appliedBreaks[l].startPixel + b,
                    h
                  ),
                  (e = this.scaleBreaks._appliedBreaks[l].endPixel + c);
          e && (f.moveTo(e, h), f.lineTo(g, h));
          f.stroke();
        }
      } else if (
        ("left" === this._position || "right" === this._position) &&
        this.lineThickness
      ) {
        this.reversed
          ? ((e = this.lineCoordinates.y1), (g = this.lineCoordinates.y2))
          : ((e = this.lineCoordinates.y2), (g = this.lineCoordinates.y1));
        f.lineWidth = this.lineThickness;
        f.strokeStyle = this.lineColor;
        f.setLineDash &&
          f.setLineDash(F(this.lineDashType, this.lineThickness));
        h =
          1 === this.lineThickness % 2
            ? (this.lineCoordinates.x1 << 0) + 0.5
            : this.lineCoordinates.x1 << 0;
        f.beginPath();
        if (this.scaleBreaks && !y(this.scaleBreaks.firstBreakIndex))
          if (y(this.scaleBreaks.lastBreakIndex))
            e =
              this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex]
                .endPixel + b;
          else
            for (
              l = this.scaleBreaks.firstBreakIndex;
              l <= this.scaleBreaks.lastBreakIndex;
              l++
            )
              f.moveTo(h, e),
                f.lineTo(h, this.scaleBreaks._appliedBreaks[l].startPixel + c),
                (e = this.scaleBreaks._appliedBreaks[l].endPixel + b);
        e && (f.moveTo(h, e), f.lineTo(h, g));
        f.stroke();
      }
      v &&
        (a.drawImage(
          this.chart._preRenderCanvas,
          0,
          0,
          this.chart.width,
          this.chart.height
        ),
        this.chart._breaksCanvasCtx &&
          this.chart._breaksCanvasCtx.drawImage(
            this.chart._preRenderCanvas,
            0,
            0,
            this.chart.width,
            this.chart.height
          ),
        f.clearRect(0, 0, this.chart.width, this.chart.height));
      f.restore();
    };
    z.prototype.getPixelCoordinatesOnAxis = function (a) {
      var f = {};
      if ("bottom" === this._position || "top" === this._position)
        (f.x = this.convertValueToPixel(a)), (f.y = this.lineCoordinates.y1);
      if ("left" === this._position || "right" === this._position)
        (f.y = this.convertValueToPixel(a)), (f.x = this.lineCoordinates.x2);
      return f;
    };
    z.prototype.convertPixelToValue = function (a) {
      if ("undefined" === typeof a) return null;
      var f = 0,
        b = 0,
        c,
        f = !0,
        e = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
        b =
          "number" === typeof a
            ? a
            : "left" === this._position || "right" === this._position
            ? a.y
            : a.x;
      if (this.logarithmic) {
        a = c = Math.pow(
          this.logarithmBase,
          (b - this.conversionParameters.reference) /
            this.conversionParameters.pixelPerUnit
        );
        if (
          (b <= this.conversionParameters.reference ===
            ("left" === this._position || "right" === this._position)) !==
          this.reversed
        )
          for (b = 0; b < e.length; b++) {
            if (!(e[b].endValue < this.conversionParameters.minimum))
              if (f)
                if (e[b].startValue < this.conversionParameters.minimum) {
                  if (
                    1 < e[b].size &&
                    this.conversionParameters.minimum *
                      Math.pow(
                        e[b].endValue / e[b].startValue,
                        Math.log(c) / Math.log(e[b].size)
                      ) <
                      e[b].endValue
                  ) {
                    a = Math.pow(
                      e[b].endValue / e[b].startValue,
                      Math.log(c) / Math.log(e[b].size)
                    );
                    break;
                  } else
                    (a *=
                      e[b].endValue /
                      this.conversionParameters.minimum /
                      Math.pow(
                        e[b].size,
                        Math.log(
                          e[b].endValue / this.conversionParameters.minimum
                        ) / Math.log(e[b].endValue / e[b].startValue)
                      )),
                      (c /= Math.pow(
                        e[b].size,
                        Math.log(
                          e[b].endValue / this.conversionParameters.minimum
                        ) / Math.log(e[b].endValue / e[b].startValue)
                      ));
                  f = !1;
                } else if (
                  c >
                  e[b].startValue / this.conversionParameters.minimum
                ) {
                  c /= e[b].startValue / this.conversionParameters.minimum;
                  if (c < e[b].size) {
                    a *=
                      Math.pow(
                        e[b].endValue / e[b].startValue,
                        1 === e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)
                      ) / c;
                    break;
                  } else a *= e[b].endValue / e[b].startValue / e[b].size;
                  c /= e[b].size;
                  f = !1;
                } else break;
              else if (c > e[b].startValue / e[b - 1].endValue) {
                c /= e[b].startValue / e[b - 1].endValue;
                if (c < e[b].size) {
                  a *=
                    Math.pow(
                      e[b].endValue / e[b].startValue,
                      1 === e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)
                    ) / c;
                  break;
                } else a *= e[b].endValue / e[b].startValue / e[b].size;
                c /= e[b].size;
              } else break;
          }
        else
          for (b = e.length - 1; 0 <= b; b--)
            if (!(e[b].startValue > this.conversionParameters.minimum))
              if (f)
                if (e[b].endValue > this.conversionParameters.minimum) {
                  if (
                    1 < e[b].size &&
                    this.conversionParameters.minimum *
                      Math.pow(
                        e[b].endValue / e[b].startValue,
                        Math.log(c) / Math.log(e[b].size)
                      ) >
                      e[b].startValue
                  ) {
                    a = Math.pow(
                      e[b].endValue / e[b].startValue,
                      Math.log(c) / Math.log(e[b].size)
                    );
                    break;
                  } else
                    (a *=
                      (e[b].startValue / this.conversionParameters.minimum) *
                      Math.pow(
                        e[b].size,
                        Math.log(
                          e[b].startValue / this.conversionParameters.minimum
                        ) / Math.log(e[b].endValue / e[b].startValue)
                      ) *
                      c),
                      (c *= Math.pow(
                        e[b].size,
                        Math.log(
                          this.conversionParameters.minimum / e[b].startValue
                        ) / Math.log(e[b].endValue / e[b].startValue)
                      ));
                  f = !1;
                } else if (
                  c <
                  e[b].endValue / this.conversionParameters.minimum
                ) {
                  c /= e[b].endValue / this.conversionParameters.minimum;
                  if (c > 1 / e[b].size) {
                    a *=
                      Math.pow(
                        e[b].endValue / e[b].startValue,
                        1 >= e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)
                      ) * c;
                    break;
                  } else a /= e[b].endValue / e[b].startValue / e[b].size;
                  c *= e[b].size;
                  f = !1;
                } else break;
              else if (c < e[b].endValue / e[b + 1].startValue) {
                c /= e[b].endValue / e[b + 1].startValue;
                if (c > 1 / e[b].size) {
                  a *=
                    Math.pow(
                      e[b].endValue / e[b].startValue,
                      1 >= e[b].size ? 1 : Math.log(c) / Math.log(e[b].size)
                    ) * c;
                  break;
                } else a /= e[b].endValue / e[b].startValue / e[b].size;
                c *= e[b].size;
              } else break;
        f = a * this.viewportMinimum;
      } else {
        a = c =
          (b - this.conversionParameters.reference) /
          this.conversionParameters.pixelPerUnit;
        if (
          (b <= this.conversionParameters.reference ===
            ("left" === this._position || "right" === this._position)) !==
          this.reversed
        )
          for (b = 0; b < e.length; b++) {
            if (!(e[b].endValue < this.conversionParameters.minimum))
              if (f)
                if (e[b].startValue < this.conversionParameters.minimum) {
                  if (
                    e[b].size &&
                    this.conversionParameters.minimum +
                      (c * (e[b].endValue - e[b].startValue)) / e[b].size <
                      e[b].endValue
                  ) {
                    a =
                      0 >= e[b].size
                        ? 0
                        : (c * (e[b].endValue - e[b].startValue)) / e[b].size;
                    break;
                  } else
                    (a +=
                      e[b].endValue -
                      this.conversionParameters.minimum -
                      (e[b].size *
                        (e[b].endValue - this.conversionParameters.minimum)) /
                        (e[b].endValue - e[b].startValue)),
                      (c -=
                        (e[b].size *
                          (e[b].endValue - this.conversionParameters.minimum)) /
                        (e[b].endValue - e[b].startValue));
                  f = !1;
                } else if (
                  c >
                  e[b].startValue - this.conversionParameters.minimum
                ) {
                  c -= e[b].startValue - this.conversionParameters.minimum;
                  if (c < e[b].size) {
                    a +=
                      (e[b].endValue - e[b].startValue) *
                        (0 === e[b].size ? 1 : c / e[b].size) -
                      c;
                    break;
                  } else a += e[b].endValue - e[b].startValue - e[b].size;
                  c -= e[b].size;
                  f = !1;
                } else break;
              else if (c > e[b].startValue - e[b - 1].endValue) {
                c -= e[b].startValue - e[b - 1].endValue;
                if (c < e[b].size) {
                  a +=
                    (e[b].endValue - e[b].startValue) *
                      (0 === e[b].size ? 1 : c / e[b].size) -
                    c;
                  break;
                } else a += e[b].endValue - e[b].startValue - e[b].size;
                c -= e[b].size;
              } else break;
          }
        else
          for (b = e.length - 1; 0 <= b; b--)
            if (!(e[b].startValue > this.conversionParameters.minimum))
              if (f)
                if (e[b].endValue > this.conversionParameters.minimum)
                  if (
                    e[b].size &&
                    this.conversionParameters.minimum +
                      (c * (e[b].endValue - e[b].startValue)) / e[b].size >
                      e[b].startValue
                  ) {
                    a =
                      0 >= e[b].size
                        ? 0
                        : (c * (e[b].endValue - e[b].startValue)) / e[b].size;
                    break;
                  } else
                    (a +=
                      e[b].startValue -
                      this.conversionParameters.minimum +
                      (e[b].size *
                        (this.conversionParameters.minimum - e[b].startValue)) /
                        (e[b].endValue - e[b].startValue)),
                      (c +=
                        (e[b].size *
                          (this.conversionParameters.minimum -
                            e[b].startValue)) /
                        (e[b].endValue - e[b].startValue)),
                      (f = !1);
                else if (
                  c <
                  e[b].endValue - this.conversionParameters.minimum
                ) {
                  c -= e[b].endValue - this.conversionParameters.minimum;
                  if (c > -1 * e[b].size) {
                    a +=
                      (e[b].endValue - e[b].startValue) *
                        (0 === e[b].size ? 1 : c / e[b].size) +
                      c;
                    break;
                  } else a -= e[b].endValue - e[b].startValue - e[b].size;
                  c += e[b].size;
                  f = !1;
                } else break;
              else if (c < e[b].endValue - e[b + 1].startValue) {
                c -= e[b].endValue - e[b + 1].startValue;
                if (c > -1 * e[b].size) {
                  a +=
                    (e[b].endValue - e[b].startValue) *
                      (0 === e[b].size ? 1 : c / e[b].size) +
                    c;
                  break;
                } else a -= e[b].endValue - e[b].startValue - e[b].size;
                c += e[b].size;
              } else break;
        f = this.conversionParameters.minimum + a;
      }
      return f;
    };
    z.prototype.convertValueToPixel = function (a) {
      a = this.getApparentDifference(this.conversionParameters.minimum, a, a);
      return this.logarithmic
        ? (this.conversionParameters.reference +
            (this.conversionParameters.pixelPerUnit *
              Math.log(a / this.conversionParameters.minimum)) /
              this.conversionParameters.lnLogarithmBase +
            0.5) <<
            0
        : (this.conversionParameters.reference +
            this.conversionParameters.pixelPerUnit *
              (a - this.conversionParameters.minimum) +
            0.5) <<
            0;
    };
    z.prototype.getApparentDifference = function (a, f, b, c) {
      var e = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];
      if (this.logarithmic) {
        b = y(b) ? f / a : b;
        for (var g = 0; g < e.length && !(f < e[g].startValue); g++)
          a > e[g].endValue ||
            (a <= e[g].startValue && f >= e[g].endValue
              ? (b = (b / e[g].endValue) * e[g].startValue * e[g].size)
              : a >= e[g].startValue && f >= e[g].endValue
              ? (b =
                  (b / e[g].endValue) *
                  a *
                  Math.pow(
                    e[g].size,
                    Math.log(e[g].endValue / a) /
                      Math.log(e[g].endValue / e[g].startValue)
                  ))
              : a <= e[g].startValue && f <= e[g].endValue
              ? (b =
                  (b / f) *
                  e[g].startValue *
                  Math.pow(
                    e[g].size,
                    Math.log(f / e[g].startValue) /
                      Math.log(e[g].endValue / e[g].startValue)
                  ))
              : !c &&
                a > e[g].startValue &&
                f < e[g].endValue &&
                (b =
                  a *
                  Math.pow(
                    e[g].size,
                    Math.log(f / a) / Math.log(e[g].endValue / e[g].startValue)
                  )));
      } else
        for (
          b = y(b) ? Math.abs(f - a) : b, g = 0;
          g < e.length && !(f < e[g].startValue);
          g++
        )
          a > e[g].endValue ||
            (a <= e[g].startValue && f >= e[g].endValue
              ? (b = b - e[g].endValue + e[g].startValue + e[g].size)
              : a > e[g].startValue && f >= e[g].endValue
              ? (b =
                  b -
                  e[g].endValue +
                  a +
                  (e[g].size * (e[g].endValue - a)) /
                    (e[g].endValue - e[g].startValue))
              : a <= e[g].startValue && f < e[g].endValue
              ? (b =
                  b -
                  f +
                  e[g].startValue +
                  (e[g].size * (f - e[g].startValue)) /
                    (e[g].endValue - e[g].startValue))
              : !c &&
                a > e[g].startValue &&
                f < e[g].endValue &&
                (b =
                  a +
                  (e[g].size * (f - a)) / (e[g].endValue - e[g].startValue)));
      return b;
    };
    z.prototype.setViewPortRange = function (a, f) {
      this.sessionVariables.newViewportMinimum = this.viewportMinimum =
        Math.min(a, f);
      this.sessionVariables.newViewportMaximum = this.viewportMaximum =
        Math.max(a, f);
    };
    z.prototype.getXValueAt = function (a) {
      if (!a) return null;
      var f = null;
      "left" === this._position
        ? (f = this.convertPixelToValue(a.y))
        : "bottom" === this._position && (f = this.convertPixelToValue(a.x));
      return f;
    };
    z.prototype.calculateValueToPixelConversionParameters = function (a) {
      a = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];
      var f = { pixelPerUnit: null, minimum: null, reference: null },
        b = this.lineCoordinates.width,
        c = this.lineCoordinates.height,
        b = "bottom" === this._position || "top" === this._position ? b : c,
        c = Math.abs(this.range);
      if (this.logarithmic)
        for (
          var e = 0;
          e < a.length && !(this.viewportMaximum < a[e].startValue);
          e++
        )
          this.viewportMinimum > a[e].endValue ||
            (this.viewportMinimum >= a[e].startValue &&
            this.viewportMaximum <= a[e].endValue
              ? (b = 0)
              : this.viewportMinimum <= a[e].startValue &&
                this.viewportMaximum >= a[e].endValue
              ? ((c = (c / a[e].endValue) * a[e].startValue),
                (b =
                  0 < a[e].spacing.toString().indexOf("%")
                    ? b * (1 - parseFloat(a[e].spacing) / 100)
                    : b - Math.min(a[e].spacing, 0.1 * b)))
              : this.viewportMinimum > a[e].startValue &&
                this.viewportMaximum >= a[e].endValue
              ? ((c = (c / a[e].endValue) * this.viewportMinimum),
                (b =
                  0 < a[e].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[e].spacing) / 100) *
                          Math.log(a[e].endValue / this.viewportMinimum)) /
                          Math.log(a[e].endValue / a[e].startValue))
                    : b -
                      (Math.min(a[e].spacing, 0.1 * b) *
                        Math.log(a[e].endValue / this.viewportMinimum)) /
                        Math.log(a[e].endValue / a[e].startValue)))
              : this.viewportMinimum <= a[e].startValue &&
                this.viewportMaximum < a[e].endValue &&
                ((c = (c / this.viewportMaximum) * a[e].startValue),
                (b =
                  0 < a[e].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[e].spacing) / 100) *
                          Math.log(this.viewportMaximum / a[e].startValue)) /
                          Math.log(a[e].endValue / a[e].startValue))
                    : b -
                      (Math.min(a[e].spacing, 0.1 * b) *
                        Math.log(this.viewportMaximum / a[e].startValue)) /
                        Math.log(a[e].endValue / a[e].startValue))));
      else
        for (
          e = 0;
          e < a.length && !(this.viewportMaximum < a[e].startValue);
          e++
        )
          this.viewportMinimum > a[e].endValue ||
            (this.viewportMinimum >= a[e].startValue &&
            this.viewportMaximum <= a[e].endValue
              ? (b = 0)
              : this.viewportMinimum <= a[e].startValue &&
                this.viewportMaximum >= a[e].endValue
              ? ((c = c - a[e].endValue + a[e].startValue),
                (b =
                  0 < a[e].spacing.toString().indexOf("%")
                    ? b * (1 - parseFloat(a[e].spacing) / 100)
                    : b - Math.min(a[e].spacing, 0.1 * b)))
              : this.viewportMinimum > a[e].startValue &&
                this.viewportMaximum >= a[e].endValue
              ? ((c = c - a[e].endValue + this.viewportMinimum),
                (b =
                  0 < a[e].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[e].spacing) / 100) *
                          (a[e].endValue - this.viewportMinimum)) /
                          (a[e].endValue - a[e].startValue))
                    : b -
                      (Math.min(a[e].spacing, 0.1 * b) *
                        (a[e].endValue - this.viewportMinimum)) /
                        (a[e].endValue - a[e].startValue)))
              : this.viewportMinimum <= a[e].startValue &&
                this.viewportMaximum < a[e].endValue &&
                ((c = c - this.viewportMaximum + a[e].startValue),
                (b =
                  0 < a[e].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[e].spacing) / 100) *
                          (this.viewportMaximum - a[e].startValue)) /
                          (a[e].endValue - a[e].startValue))
                    : b -
                      (Math.min(a[e].spacing, 0.1 * b) *
                        (this.viewportMaximum - a[e].startValue)) /
                        (a[e].endValue - a[e].startValue))));
      f.minimum = this.viewportMinimum;
      f.maximum = this.viewportMaximum;
      f.range = c;
      if ("bottom" === this._position || "top" === this._position)
        this.logarithmic
          ? ((f.lnLogarithmBase = Math.log(this.logarithmBase)),
            (f.pixelPerUnit =
              ((this.reversed ? -1 : 1) * b * f.lnLogarithmBase) /
              Math.log(Math.abs(c))))
          : (f.pixelPerUnit = ((this.reversed ? -1 : 1) * b) / Math.abs(c)),
          (f.reference = this.reversed
            ? this.lineCoordinates.x2
            : this.lineCoordinates.x1);
      if ("left" === this._position || "right" === this._position)
        this.logarithmic
          ? ((f.lnLogarithmBase = Math.log(this.logarithmBase)),
            (f.pixelPerUnit =
              ((this.reversed ? 1 : -1) * b * f.lnLogarithmBase) /
              Math.log(Math.abs(c))))
          : (f.pixelPerUnit = ((this.reversed ? 1 : -1) * b) / Math.abs(c)),
          (f.reference = this.reversed
            ? this.lineCoordinates.y1
            : this.lineCoordinates.y2);
      this.conversionParameters = f;
    };
    z.prototype.calculateAxisParameters = function () {
      if (this.logarithmic) this.calculateLogarithmicAxisParameters();
      else {
        var a = this.chart.layoutManager.getFreeSpace(),
          f = !1,
          b = !1;
        "bottom" === this._position || "top" === this._position
          ? ((this.maxWidth = a.width), (this.maxHeight = a.height))
          : ((this.maxWidth = a.height), (this.maxHeight = a.width));
        var a =
            "axisX" === this.type
              ? "xySwapped" === this.chart.plotInfo.axisPlacement
                ? 62
                : 70
              : "xySwapped" === this.chart.plotInfo.axisPlacement
              ? 50
              : 40,
          c = 4;
        "axisX" === this.type && (c = 600 > this.maxWidth ? 8 : 6);
        var a = Math.max(c, Math.floor(this.maxWidth / a)),
          e,
          g,
          h,
          c = 0;
        !y(this.options.viewportMinimum) &&
          !y(this.options.viewportMaximum) &&
          this.options.viewportMinimum >= this.options.viewportMaximum &&
          (this.viewportMinimum = this.viewportMaximum = null);
        if (
          y(this.options.viewportMinimum) &&
          !y(this.sessionVariables.newViewportMinimum) &&
          !isNaN(this.sessionVariables.newViewportMinimum)
        )
          this.viewportMinimum = this.sessionVariables.newViewportMinimum;
        else if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
          this.viewportMinimum = this.minimum;
        if (
          y(this.options.viewportMaximum) &&
          !y(this.sessionVariables.newViewportMaximum) &&
          !isNaN(this.sessionVariables.newViewportMaximum)
        )
          this.viewportMaximum = this.sessionVariables.newViewportMaximum;
        else if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
          this.viewportMaximum = this.maximum;
        if (this.scaleBreaks)
          for (c = 0; c < this.scaleBreaks._appliedBreaks.length; c++)
            if (
              ((!y(this.sessionVariables.newViewportMinimum) &&
                this.sessionVariables.newViewportMinimum >=
                  this.scaleBreaks._appliedBreaks[c].startValue) ||
                (!y(this.options.minimum) &&
                  this.options.minimum >=
                    this.scaleBreaks._appliedBreaks[c].startValue) ||
                (!y(this.options.viewportMinimum) &&
                  this.viewportMinimum >=
                    this.scaleBreaks._appliedBreaks[c].startValue)) &&
              ((!y(this.sessionVariables.newViewportMaximum) &&
                this.sessionVariables.newViewportMaximum <=
                  this.scaleBreaks._appliedBreaks[c].endValue) ||
                (!y(this.options.maximum) &&
                  this.options.maximum <=
                    this.scaleBreaks._appliedBreaks[c].endValue) ||
                (!y(this.options.viewportMaximum) &&
                  this.viewportMaximum <=
                    this.scaleBreaks._appliedBreaks[c].endValue))
            ) {
              this.scaleBreaks._appliedBreaks.splice(c, 1);
              break;
            }
        if ("axisX" === this.type) {
          if (this.dataSeries && 0 < this.dataSeries.length)
            for (e = 0; e < this.dataSeries.length; e++)
              "dateTime" === this.dataSeries[e].xValueType && (b = !0);
          e =
            null !== this.viewportMinimum
              ? this.viewportMinimum
              : this.dataInfo.viewPortMin;
          g =
            null !== this.viewportMaximum
              ? this.viewportMaximum
              : this.dataInfo.viewPortMax;
          0 === g - e &&
            ((c =
              "undefined" === typeof this.options.interval
                ? 0.4
                : this.options.interval),
            (g += c),
            (e -= c));
          Infinity !== this.dataInfo.minDiff
            ? (h = this.dataInfo.minDiff)
            : 1 < g - e
            ? (h = 0.5 * Math.abs(g - e))
            : ((h = 1), b && (f = !0));
        } else
          "axisY" === this.type &&
            ((e =
              null !== this.viewportMinimum
                ? this.viewportMinimum
                : this.dataInfo.viewPortMin),
            (g =
              null !== this.viewportMaximum
                ? this.viewportMaximum
                : this.dataInfo.viewPortMax),
            isFinite(e) || isFinite(g)
              ? isFinite(e)
                ? isFinite(g) || (g = e)
                : (e = g)
              : ((g =
                  "undefined" === typeof this.options.interval
                    ? -Infinity
                    : this.options.interval),
                (e =
                  "undefined" !== typeof this.options.interval ||
                  isFinite(this.dataInfo.minDiff)
                    ? 0
                    : Infinity)),
            0 === e && 0 === g
              ? ((g += 9), (e = 0))
              : 0 === g - e
              ? ((c = Math.min(Math.abs(0.01 * Math.abs(g)), 5)),
                (g += c),
                (e -= c))
              : e > g
              ? ((c = Math.min(
                  0.01 * Math.abs(this.getApparentDifference(g, e, null, !0)),
                  5
                )),
                0 <= g ? (e = g - c) : (g = isFinite(e) ? e + c : 0))
              : ((c = Math.min(
                  0.01 * Math.abs(this.getApparentDifference(e, g, null, !0)),
                  0.05
                )),
                0 !== g && (g += c),
                0 !== e && (e -= c)),
            (h =
              Infinity !== this.dataInfo.minDiff
                ? this.dataInfo.minDiff
                : 1 < g - e
                ? 0.5 * Math.abs(g - e)
                : 1),
            this.includeZero &&
              (null === this.viewportMinimum || isNaN(this.viewportMinimum)) &&
              0 < e &&
              (e = 0),
            this.includeZero &&
              (null === this.viewportMaximum || isNaN(this.viewportMaximum)) &&
              0 > g &&
              (g = 0));
        c = this.getApparentDifference(
          isNaN(this.viewportMinimum) || null === this.viewportMinimum
            ? e
            : this.viewportMinimum,
          isNaN(this.viewportMaximum) || null === this.viewportMaximum
            ? g
            : this.viewportMaximum,
          null,
          !0
        );
        if ("axisX" === this.type && b) {
          this.intervalType ||
            (c / 1 <= a
              ? ((this.interval = 1), (this.intervalType = "millisecond"))
              : c / 2 <= a
              ? ((this.interval = 2), (this.intervalType = "millisecond"))
              : c / 5 <= a
              ? ((this.interval = 5), (this.intervalType = "millisecond"))
              : c / 10 <= a
              ? ((this.interval = 10), (this.intervalType = "millisecond"))
              : c / 20 <= a
              ? ((this.interval = 20), (this.intervalType = "millisecond"))
              : c / 50 <= a
              ? ((this.interval = 50), (this.intervalType = "millisecond"))
              : c / 100 <= a
              ? ((this.interval = 100), (this.intervalType = "millisecond"))
              : c / 200 <= a
              ? ((this.interval = 200), (this.intervalType = "millisecond"))
              : c / 250 <= a
              ? ((this.interval = 250), (this.intervalType = "millisecond"))
              : c / 300 <= a
              ? ((this.interval = 300), (this.intervalType = "millisecond"))
              : c / 400 <= a
              ? ((this.interval = 400), (this.intervalType = "millisecond"))
              : c / 500 <= a
              ? ((this.interval = 500), (this.intervalType = "millisecond"))
              : c / (1 * V.secondDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "second"))
              : c / (2 * V.secondDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "second"))
              : c / (5 * V.secondDuration) <= a
              ? ((this.interval = 5), (this.intervalType = "second"))
              : c / (10 * V.secondDuration) <= a
              ? ((this.interval = 10), (this.intervalType = "second"))
              : c / (15 * V.secondDuration) <= a
              ? ((this.interval = 15), (this.intervalType = "second"))
              : c / (20 * V.secondDuration) <= a
              ? ((this.interval = 20), (this.intervalType = "second"))
              : c / (30 * V.secondDuration) <= a
              ? ((this.interval = 30), (this.intervalType = "second"))
              : c / (1 * V.minuteDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "minute"))
              : c / (2 * V.minuteDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "minute"))
              : c / (5 * V.minuteDuration) <= a
              ? ((this.interval = 5), (this.intervalType = "minute"))
              : c / (10 * V.minuteDuration) <= a
              ? ((this.interval = 10), (this.intervalType = "minute"))
              : c / (15 * V.minuteDuration) <= a
              ? ((this.interval = 15), (this.intervalType = "minute"))
              : c / (20 * V.minuteDuration) <= a
              ? ((this.interval = 20), (this.intervalType = "minute"))
              : c / (30 * V.minuteDuration) <= a
              ? ((this.interval = 30), (this.intervalType = "minute"))
              : c / (1 * V.hourDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "hour"))
              : c / (2 * V.hourDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "hour"))
              : c / (3 * V.hourDuration) <= a
              ? ((this.interval = 3), (this.intervalType = "hour"))
              : c / (6 * V.hourDuration) <= a
              ? ((this.interval = 6), (this.intervalType = "hour"))
              : c / (1 * V.dayDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "day"))
              : c / (2 * V.dayDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "day"))
              : c / (4 * V.dayDuration) <= a
              ? ((this.interval = 4), (this.intervalType = "day"))
              : c / (1 * V.weekDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "week"))
              : c / (2 * V.weekDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "week"))
              : c / (3 * V.weekDuration) <= a
              ? ((this.interval = 3), (this.intervalType = "week"))
              : c / (1 * V.monthDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "month"))
              : c / (2 * V.monthDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "month"))
              : c / (3 * V.monthDuration) <= a
              ? ((this.interval = 3), (this.intervalType = "month"))
              : c / (6 * V.monthDuration) <= a
              ? ((this.interval = 6), (this.intervalType = "month"))
              : ((this.interval =
                  c / (1 * V.yearDuration) <= a
                    ? 1
                    : c / (2 * V.yearDuration) <= a
                    ? 2
                    : c / (4 * V.yearDuration) <= a
                    ? 4
                    : Math.floor(
                        z.getNiceNumber(c / (a - 1), !0) / V.yearDuration
                      )),
                (this.intervalType = "year")));
          if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
            this.viewportMinimum = e - h / 2;
          if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
            this.viewportMaximum = g + h / 2;
          f
            ? (this.autoValueFormatString = "MMM DD YYYY HH:mm")
            : "year" === this.intervalType
            ? (this.autoValueFormatString = "YYYY")
            : "month" === this.intervalType
            ? (this.autoValueFormatString = "MMM YYYY")
            : "week" === this.intervalType
            ? (this.autoValueFormatString = "MMM DD YYYY")
            : "day" === this.intervalType
            ? (this.autoValueFormatString = "MMM DD YYYY")
            : "hour" === this.intervalType
            ? (this.autoValueFormatString = "hh:mm TT")
            : "minute" === this.intervalType
            ? (this.autoValueFormatString = "hh:mm TT")
            : "second" === this.intervalType
            ? (this.autoValueFormatString = "hh:mm:ss TT")
            : "millisecond" === this.intervalType &&
              (this.autoValueFormatString = "fff'ms'");
          this.valueFormatString ||
            (this.valueFormatString = this.autoValueFormatString);
        } else {
          this.intervalType = "number";
          c = z.getNiceNumber(c, !1);
          this.interval =
            this.options && 0 < this.options.interval
              ? this.options.interval
              : z.getNiceNumber(c / (a - 1), !0);
          if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
            this.viewportMinimum =
              "axisX" === this.type
                ? e - h / 2
                : Math.floor(e / this.interval) * this.interval;
          if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
            this.viewportMaximum =
              "axisX" === this.type
                ? g + h / 2
                : Math.ceil(g / this.interval) * this.interval;
          0 === this.viewportMaximum &&
            0 === this.viewportMinimum &&
            (0 === this.options.viewportMinimum
              ? (this.viewportMaximum += 10)
              : 0 === this.options.viewportMaximum &&
                (this.viewportMinimum -= 10),
            this.options &&
              "undefined" === typeof this.options.interval &&
              (this.interval = z.getNiceNumber(
                (this.viewportMaximum - this.viewportMinimum) / (a - 1),
                !0
              )));
        }
        if (null === this.minimum || null === this.maximum)
          if (
            ("axisX" === this.type
              ? ((e = null !== this.minimum ? this.minimum : this.dataInfo.min),
                (g = null !== this.maximum ? this.maximum : this.dataInfo.max),
                0 === g - e &&
                  ((c =
                    "undefined" === typeof this.options.interval
                      ? 0.4
                      : this.options.interval),
                  (g += c),
                  (e -= c)),
                (h =
                  Infinity !== this.dataInfo.minDiff
                    ? this.dataInfo.minDiff
                    : 1 < g - e
                    ? 0.5 * Math.abs(g - e)
                    : 1))
              : "axisY" === this.type &&
                ((e = null !== this.minimum ? this.minimum : this.dataInfo.min),
                (g = null !== this.maximum ? this.maximum : this.dataInfo.max),
                isFinite(e) || isFinite(g)
                  ? 0 === e && 0 === g
                    ? ((g += 9), (e = 0))
                    : 0 === g - e
                    ? ((c = Math.min(Math.abs(0.01 * Math.abs(g)), 5)),
                      (g += c),
                      (e -= c))
                    : e > g
                    ? ((c = Math.min(
                        0.01 *
                          Math.abs(this.getApparentDifference(g, e, null, !0)),
                        5
                      )),
                      0 <= g ? (e = g - c) : (g = isFinite(e) ? e + c : 0))
                    : ((c = Math.min(
                        0.01 *
                          Math.abs(this.getApparentDifference(e, g, null, !0)),
                        0.05
                      )),
                      0 !== g && (g += c),
                      0 !== e && (e -= c))
                  : ((g =
                      "undefined" === typeof this.options.interval
                        ? -Infinity
                        : this.options.interval),
                    (e =
                      "undefined" !== typeof this.options.interval ||
                      isFinite(this.dataInfo.minDiff)
                        ? 0
                        : Infinity)),
                (h =
                  Infinity !== this.dataInfo.minDiff
                    ? this.dataInfo.minDiff
                    : 1 < g - e
                    ? 0.5 * Math.abs(g - e)
                    : 1),
                this.includeZero &&
                  (null === this.minimum || isNaN(this.minimum)) &&
                  0 < e &&
                  (e = 0),
                this.includeZero &&
                  (null === this.maximum || isNaN(this.maximum)) &&
                  0 > g &&
                  (g = 0)),
            Math.abs(this.getApparentDifference(e, g, null, !0)),
            "axisX" === this.type && b)
          ) {
            this.valueType = "dateTime";
            if (null === this.minimum || isNaN(this.minimum))
              this.minimum = e - h / 2;
            if (null === this.maximum || isNaN(this.maximum))
              this.maximum = g + h / 2;
          } else
            (this.intervalType = this.valueType = "number"),
              null === this.minimum &&
                ((this.minimum =
                  "axisX" === this.type
                    ? e - h / 2
                    : Math.floor(e / this.interval) * this.interval),
                (this.minimum = Math.min(
                  this.minimum,
                  null === this.sessionVariables.viewportMinimum ||
                    isNaN(this.sessionVariables.viewportMinimum)
                    ? Infinity
                    : this.sessionVariables.viewportMinimum
                ))),
              null === this.maximum &&
                ((this.maximum =
                  "axisX" === this.type
                    ? g + h / 2
                    : Math.ceil(g / this.interval) * this.interval),
                (this.maximum = Math.max(
                  this.maximum,
                  null === this.sessionVariables.viewportMaximum ||
                    isNaN(this.sessionVariables.viewportMaximum)
                    ? -Infinity
                    : this.sessionVariables.viewportMaximum
                ))),
              0 === this.maximum &&
                0 === this.minimum &&
                (0 === this.options.minimum
                  ? (this.maximum += 10)
                  : 0 === this.options.maximum && (this.minimum -= 10));
        y(this.sessionVariables.newViewportMinimum) &&
          (this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum));
        y(this.sessionVariables.newViewportMaximum) &&
          (this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum));
        this.range = this.viewportMaximum - this.viewportMinimum;
        this.intervalStartPosition =
          "axisX" === this.type && b
            ? this.getLabelStartPoint(
                new Date(this.viewportMinimum),
                this.intervalType,
                this.interval
              )
            : Math.floor(
                (this.viewportMinimum + 0.2 * this.interval) / this.interval
              ) * this.interval;
        this.valueFormatString ||
          (this.valueFormatString = z.generateValueFormatString(this.range, 2));
      }
    };
    z.prototype.calculateLogarithmicAxisParameters = function () {
      var a = this.chart.layoutManager.getFreeSpace(),
        f = Math.log(this.logarithmBase),
        b;
      "bottom" === this._position || "top" === this._position
        ? ((this.maxWidth = a.width), (this.maxHeight = a.height))
        : ((this.maxWidth = a.height), (this.maxHeight = a.width));
      var a =
          "axisX" === this.type
            ? 500 > this.maxWidth
              ? 7
              : Math.max(7, Math.floor(this.maxWidth / 100))
            : Math.max(Math.floor(this.maxWidth / 50), 3),
        c,
        e,
        g,
        h;
      h = 1;
      if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
        this.viewportMinimum = this.minimum;
      if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
        this.viewportMaximum = this.maximum;
      if (this.scaleBreaks)
        for (h = 0; h < this.scaleBreaks._appliedBreaks.length; h++)
          if (
            ((!y(this.sessionVariables.newViewportMinimum) &&
              this.sessionVariables.newViewportMinimum >=
                this.scaleBreaks._appliedBreaks[h].startValue) ||
              (!y(this.options.minimum) &&
                this.options.minimum >=
                  this.scaleBreaks._appliedBreaks[h].startValue) ||
              (!y(this.options.viewportMinimum) &&
                this.viewportMinimum >=
                  this.scaleBreaks._appliedBreaks[h].startValue)) &&
            ((!y(this.sessionVariables.newViewportMaximum) &&
              this.sessionVariables.newViewportMaximum <=
                this.scaleBreaks._appliedBreaks[h].endValue) ||
              (!y(this.options.maximum) &&
                this.options.maximum <=
                  this.scaleBreaks._appliedBreaks[h].endValue) ||
              (!y(this.options.viewportMaximum) &&
                this.viewportMaximum <=
                  this.scaleBreaks._appliedBreaks[h].endValue))
          ) {
            this.scaleBreaks._appliedBreaks.splice(h, 1);
            break;
          }
      "axisX" === this.type
        ? ((c =
            null !== this.viewportMinimum
              ? this.viewportMinimum
              : this.dataInfo.viewPortMin),
          (e =
            null !== this.viewportMaximum
              ? this.viewportMaximum
              : this.dataInfo.viewPortMax),
          1 === e / c &&
            ((h = Math.pow(
              this.logarithmBase,
              "undefined" === typeof this.options.interval
                ? 0.4
                : this.options.interval
            )),
            (e *= h),
            (c /= h)),
          (g =
            Infinity !== this.dataInfo.minDiff
              ? this.dataInfo.minDiff
              : e / c > this.logarithmBase
              ? (e / c) * Math.pow(this.logarithmBase, 0.5)
              : this.logarithmBase))
        : "axisY" === this.type &&
          ((c =
            null !== this.viewportMinimum
              ? this.viewportMinimum
              : this.dataInfo.viewPortMin),
          (e =
            null !== this.viewportMaximum
              ? this.viewportMaximum
              : this.dataInfo.viewPortMax),
          0 >= c && !isFinite(e)
            ? ((e =
                "undefined" === typeof this.options.interval
                  ? 0
                  : this.options.interval),
              (c = 1))
            : 0 >= c
            ? (c = e)
            : isFinite(e) || (e = c),
          1 === c && 1 === e
            ? ((e *= this.logarithmBase - 1 / this.logarithmBase), (c = 1))
            : 1 === e / c
            ? ((h = Math.min(
                e * Math.pow(this.logarithmBase, 0.01),
                Math.pow(this.logarithmBase, 5)
              )),
              (e *= h),
              (c /= h))
            : c > e
            ? ((h = Math.min(
                (c / e) * Math.pow(this.logarithmBase, 0.01),
                Math.pow(this.logarithmBase, 5)
              )),
              1 <= e ? (c = e / h) : (e = c * h))
            : ((h = Math.min(
                (e / c) * Math.pow(this.logarithmBase, 0.01),
                Math.pow(this.logarithmBase, 0.04)
              )),
              1 !== e && (e *= h),
              1 !== c && (c /= h)),
          (g =
            Infinity !== this.dataInfo.minDiff
              ? this.dataInfo.minDiff
              : e / c > this.logarithmBase
              ? (e / c) * Math.pow(this.logarithmBase, 0.5)
              : this.logarithmBase),
          this.includeZero &&
            (null === this.viewportMinimum || isNaN(this.viewportMinimum)) &&
            1 < c &&
            (c = 1),
          this.includeZero &&
            (null === this.viewportMaximum || isNaN(this.viewportMaximum)) &&
            1 > e &&
            (e = 1));
      h =
        (isNaN(this.viewportMaximum) || null === this.viewportMaximum
          ? e
          : this.viewportMaximum) /
        (isNaN(this.viewportMinimum) || null === this.viewportMinimum
          ? c
          : this.viewportMinimum);
      linearRange =
        (isNaN(this.viewportMaximum) || null === this.viewportMaximum
          ? e
          : this.viewportMaximum) -
        (isNaN(this.viewportMinimum) || null === this.viewportMinimum
          ? c
          : this.viewportMinimum);
      this.intervalType = "number";
      h = Math.pow(
        this.logarithmBase,
        z.getNiceNumber(Math.abs(Math.log(h) / f), !1)
      );
      this.options && 0 < this.options.interval
        ? (this.interval = this.options.interval)
        : ((this.interval = z.getNiceExponent(Math.log(h) / f / (a - 1), !0)),
          (b = z.getNiceNumber(linearRange / (a - 1), !0)));
      if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
        this.viewportMinimum =
          "axisX" === this.type
            ? c / Math.sqrt(g)
            : Math.pow(
                this.logarithmBase,
                this.interval * Math.floor(Math.log(c) / f / this.interval)
              );
      if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
        this.viewportMaximum =
          "axisX" === this.type
            ? e * Math.sqrt(g)
            : Math.pow(
                this.logarithmBase,
                this.interval * Math.ceil(Math.log(e) / f / this.interval)
              );
      1 === this.viewportMaximum &&
        1 === this.viewportMinimum &&
        (1 === this.options.viewportMinimum
          ? (this.viewportMaximum *=
              this.logarithmBase - 1 / this.logarithmBase)
          : 1 === this.options.viewportMaximum &&
            (this.viewportMinimum /=
              this.logarithmBase - 1 / this.logarithmBase),
        this.options &&
          "undefined" === typeof this.options.interval &&
          ((this.interval = z.getNiceExponent(
            Math.ceil(Math.log(h) / f) / (a - 1)
          )),
          (b = z.getNiceNumber(
            (this.viewportMaximum - this.viewportMinimum) / (a - 1),
            !0
          ))));
      if (null === this.minimum || null === this.maximum)
        "axisX" === this.type
          ? ((c = null !== this.minimum ? this.minimum : this.dataInfo.min),
            (e = null !== this.maximum ? this.maximum : this.dataInfo.max),
            1 === e / c &&
              ((h = Math.pow(
                this.logarithmBase,
                "undefined" === typeof this.options.interval
                  ? 0.4
                  : this.options.interval
              )),
              (e *= h),
              (c /= h)),
            (g =
              Infinity !== this.dataInfo.minDiff
                ? this.dataInfo.minDiff
                : e / c > this.logarithmBase
                ? (e / c) * Math.pow(this.logarithmBase, 0.5)
                : this.logarithmBase))
          : "axisY" === this.type &&
            ((c = null !== this.minimum ? this.minimum : this.dataInfo.min),
            (e = null !== this.maximum ? this.maximum : this.dataInfo.max),
            isFinite(c) || isFinite(e)
              ? 1 === c && 1 === e
                ? ((e *= this.logarithmBase), (c /= this.logarithmBase))
                : 1 === e / c
                ? ((h = Math.pow(this.logarithmBase, this.interval)),
                  (e *= h),
                  (c /= h))
                : c > e
                ? ((h = Math.min(0.01 * (c / e), 5)),
                  1 <= e ? (c = e / h) : (e = c * h))
                : ((h = Math.min(
                    (e / c) * Math.pow(this.logarithmBase, 0.01),
                    Math.pow(this.logarithmBase, 0.04)
                  )),
                  1 !== e && (e *= h),
                  1 !== c && (c /= h))
              : ((e =
                  "undefined" === typeof this.options.interval
                    ? 0
                    : this.options.interval),
                (c = 1)),
            (g =
              Infinity !== this.dataInfo.minDiff
                ? this.dataInfo.minDiff
                : e / c > this.logarithmBase
                ? (e / c) * Math.pow(this.logarithmBase, 0.5)
                : this.logarithmBase),
            this.includeZero &&
              (null === this.minimum || isNaN(this.minimum)) &&
              1 < c &&
              (c = 1),
            this.includeZero &&
              (null === this.maximum || isNaN(this.maximum)) &&
              1 > e &&
              (e = 1)),
          (this.intervalType = "number"),
          null === this.minimum &&
            ((this.minimum =
              "axisX" === this.type
                ? c / Math.sqrt(g)
                : Math.pow(
                    this.logarithmBase,
                    this.interval * Math.floor(Math.log(c) / f / this.interval)
                  )),
            (this.minimum = Math.min(
              this.minimum,
              null === this.sessionVariables.viewportMinimum ||
                isNaN(this.sessionVariables.viewportMinimum)
                ? "undefined" ===
                  typeof this.sessionVariables.newViewportMinimum
                  ? Infinity
                  : this.sessionVariables.newViewportMinimum
                : this.sessionVariables.viewportMinimum
            ))),
          null === this.maximum &&
            ((this.maximum =
              "axisX" === this.type
                ? e * Math.sqrt(g)
                : Math.pow(
                    this.logarithmBase,
                    this.interval * Math.ceil(Math.log(e) / f / this.interval)
                  )),
            (this.maximum = Math.max(
              this.maximum,
              null === this.sessionVariables.viewportMaximum ||
                isNaN(this.sessionVariables.viewportMaximum)
                ? "undefined" ===
                  typeof this.sessionVariables.newViewportMaximum
                  ? 0
                  : this.sessionVariables.newViewportMaximum
                : this.sessionVariables.viewportMaximum
            ))),
          1 === this.maximum &&
            1 === this.minimum &&
            (1 === this.options.minimum
              ? (this.maximum *= this.logarithmBase - 1 / this.logarithmBase)
              : 1 === this.options.maximum &&
                (this.minimum /= this.logarithmBase - 1 / this.logarithmBase));
      this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum);
      this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum);
      this.viewportMinimum > this.viewportMaximum &&
        ((!this.options.viewportMinimum && !this.options.minimum) ||
        this.options.viewportMaximum ||
        this.options.maximum
          ? this.options.viewportMinimum ||
            this.options.minimum ||
            (!this.options.viewportMaximum && !this.options.maximum) ||
            (this.viewportMinimum = this.minimum =
              (this.options.viewportMaximum || this.options.maximum) /
              Math.pow(this.logarithmBase, 2 * Math.ceil(this.interval)))
          : (this.viewportMaximum = this.maximum =
              this.options.viewportMinimum || this.options.minimum));
      c = Math.pow(
        this.logarithmBase,
        Math.floor(Math.log(this.viewportMinimum) / (f * this.interval) + 0.2) *
          this.interval
      );
      this.range = this.viewportMaximum / this.viewportMinimum;
      this.noTicks = a;
      if (
        !this.options.interval &&
        this.range <
          Math.pow(
            this.logarithmBase,
            8 > this.viewportMaximum || 3 > a ? 2 : 3
          )
      ) {
        for (
          f = Math.floor(this.viewportMinimum / b + 0.5) * b;
          f < this.viewportMinimum;

        )
          f += b;
        this.equidistantInterval = !1;
        this.intervalStartPosition = f;
        this.interval = b;
      } else
        this.options.interval ||
          ((b = Math.ceil(this.interval)),
          this.range > this.interval &&
            ((this.interval = b),
            (c = Math.pow(
              this.logarithmBase,
              Math.floor(
                Math.log(this.viewportMinimum) / (f * this.interval) + 0.2
              ) * this.interval
            )))),
          (this.equidistantInterval = !0),
          (this.intervalStartPosition = c);
      if (
        !this.valueFormatString &&
        ((this.valueFormatString = "#,##0.##"), 1 > this.viewportMinimum)
      ) {
        f =
          Math.floor(Math.abs(Math.log(this.viewportMinimum) / Math.LN10)) + 2;
        if (isNaN(f) || !isFinite(f)) f = 2;
        if (2 < f) for (h = 0; h < f - 2; h++) this.valueFormatString += "#";
      }
    };
    z.generateValueFormatString = function (a, f) {
      var b = "#,##0.",
        c = f;
      1 > a &&
        ((c += Math.floor(Math.abs(Math.log(a) / Math.LN10))),
        isNaN(c) || !isFinite(c)) &&
        (c = f);
      for (var e = 0; e < c; e++) b += "#";
      return b;
    };
    z.getNiceExponent = function (a, f) {
      var b = Math.floor(Math.log(a) / Math.LN10),
        c = a / Math.pow(10, b),
        c = 0 > b ? (1 >= c ? 1 : 5 >= c ? 5 : 10) : Math.max(Math.floor(c), 1);
      return Number((c * Math.pow(10, b)).toFixed(20));
    };
    z.getNiceNumber = function (a, f) {
      var b = Math.floor(Math.log(a) / Math.LN10),
        c = a / Math.pow(10, b);
      return Number(
        (
          (f
            ? 1.5 > c
              ? 1
              : 3 > c
              ? 2
              : 7 > c
              ? 5
              : 10
            : 1 >= c
            ? 1
            : 2 >= c
            ? 2
            : 5 >= c
            ? 5
            : 10) * Math.pow(10, b)
        ).toFixed(20)
      );
    };
    z.prototype.getLabelStartPoint = function () {
      var a = V[this.intervalType + "Duration"] * this.interval,
        a = new Date(Math.floor(this.viewportMinimum / a) * a);
      if ("millisecond" !== this.intervalType)
        if ("second" === this.intervalType)
          0 < a.getMilliseconds() &&
            (a.setSeconds(a.getSeconds() + 1), a.setMilliseconds(0));
        else if ("minute" === this.intervalType) {
          if (0 < a.getSeconds() || 0 < a.getMilliseconds())
            a.setMinutes(a.getMinutes() + 1),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("hour" === this.intervalType) {
          if (
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setHours(a.getHours() + 1),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("day" === this.intervalType) {
          if (
            0 < a.getHours() ||
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setDate(a.getDate() + 1),
              a.setHours(0),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("week" === this.intervalType) {
          if (
            0 < a.getDay() ||
            0 < a.getHours() ||
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setDate(a.getDate() + (7 - a.getDay())),
              a.setHours(0),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("month" === this.intervalType) {
          if (
            1 < a.getDate() ||
            0 < a.getHours() ||
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setMonth(a.getMonth() + 1),
              a.setDate(1),
              a.setHours(0),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else
          "year" === this.intervalType &&
            (0 < a.getMonth() ||
              1 < a.getDate() ||
              0 < a.getHours() ||
              0 < a.getMinutes() ||
              0 < a.getSeconds() ||
              0 < a.getMilliseconds()) &&
            (a.setFullYear(a.getFullYear() + 1),
            a.setMonth(0),
            a.setDate(1),
            a.setHours(0),
            a.setMinutes(0),
            a.setSeconds(0),
            a.setMilliseconds(0));
      return a;
    };
    ma(Q, T);
    ma(Y, T);
    Y.prototype.createUserOptions = function (a) {
      if ("undefined" !== typeof a || this.options._isPlaceholder) {
        var f = 0;
        this.parent.options._isPlaceholder && this.parent.createUserOptions();
        this.options._isPlaceholder ||
          (Ba(this.parent[this.optionsName]),
          (f = this.parent.options[this.optionsName].indexOf(this.options)));
        this.options = "undefined" === typeof a ? {} : a;
        this.parent.options[this.optionsName][f] = this.options;
      }
    };
    Y.prototype.render = function (a) {
      if (
        0 !== this.spacing ||
        (0 !== this.options.lineThickness &&
          ("undefined" !== typeof this.options.lineThickness ||
            0 !== this.parent.lineThickness))
      ) {
        var f = this.ctx,
          b = this.ctx.globalAlpha;
        this.ctx = a || this.ctx;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.rect(
          this.chart.plotArea.x1,
          this.chart.plotArea.y1,
          this.chart.plotArea.width,
          this.chart.plotArea.height
        );
        this.ctx.clip();
        var c = this.scaleBreaks.parent.getPixelCoordinatesOnAxis(
            this.startValue
          ),
          e = this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.endValue);
        this.ctx.strokeStyle = this.lineColor;
        this.ctx.fillStyle = this.color;
        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;
        R(this.id);
        var g, h, l, n, k, r;
        a = Math.max(this.spacing, 3);
        var q = Math.max(0, this.lineThickness);
        this.ctx.lineWidth = q;
        this.ctx.setLineDash && this.ctx.setLineDash(F(this.lineDashType, q));
        if (
          "bottom" === this.scaleBreaks.parent._position ||
          "top" === this.scaleBreaks.parent._position
        )
          if (
            ((c = 1 === q % 2 ? (c.x << 0) + 0.5 : c.x << 0),
            (h = 1 === q % 2 ? (e.x << 0) + 0.5 : e.x << 0),
            "top" === this.scaleBreaks.parent._position
              ? ((e = this.chart.plotArea.y1),
                (l = (this.chart.plotArea.y2 + q / 2 + 0.5) << 0))
              : ((e = this.chart.plotArea.y2),
                (l = (this.chart.plotArea.y1 - q / 2 + 0.5) << 0),
                (a *= -1)),
            (this.bounds = { x1: c - q / 2, y1: e, x2: h + q / 2, y2: l }),
            this.ctx.moveTo(c, e),
            "straight" === this.type ||
              ("top" === this.scaleBreaks.parent._position && 0 >= a) ||
              ("bottom" === this.scaleBreaks.parent._position && 0 <= a))
          )
            this.ctx.lineTo(c, l), this.ctx.lineTo(h, l), this.ctx.lineTo(h, e);
          else if ("wavy" === this.type) {
            n = c;
            k = e;
            g = 0.5;
            r = (l - k) / a / 3;
            for (var m = 0; m < r; m++)
              this.ctx.bezierCurveTo(
                n + g * a,
                k + a,
                n + g * a,
                k + 2 * a,
                n,
                k + 3 * a
              ),
                (k += 3 * a),
                (g *= -1);
            this.ctx.bezierCurveTo(
              n + g * a,
              k + a,
              n + g * a,
              k + 2 * a,
              n,
              k + 3 * a
            );
            n = h;
            g *= -1;
            this.ctx.lineTo(n, k);
            for (m = 0; m < r; m++)
              this.ctx.bezierCurveTo(
                n + g * a,
                k - a,
                n + g * a,
                k - 2 * a,
                n,
                k - 3 * a
              ),
                (k -= 3 * a),
                (g *= -1);
          } else {
            if ("zigzag" === this.type) {
              g = -1;
              k = e + a;
              n = c + a;
              r = (l - k) / a / 2;
              for (m = 0; m < r; m++)
                this.ctx.lineTo(n, k),
                  (n += 2 * g * a),
                  (k += 2 * a),
                  (g *= -1);
              this.ctx.lineTo(n, k);
              n += h - c;
              for (m = 0; m < r + 1; m++)
                this.ctx.lineTo(n, k),
                  (n += 2 * g * a),
                  (k -= 2 * a),
                  (g *= -1);
              this.ctx.lineTo(n + g * a, k + a);
            }
          }
        else if (
          "left" === this.scaleBreaks.parent._position ||
          "right" === this.scaleBreaks.parent._position
        )
          if (
            ((e = 1 === q % 2 ? (e.y << 0) + 0.5 : e.y << 0),
            (l = 1 === q % 2 ? (c.y << 0) + 0.5 : c.y << 0),
            "left" === this.scaleBreaks.parent._position
              ? ((c = this.chart.plotArea.x1),
                (h = (this.chart.plotArea.x2 + q / 2 + 0.5) << 0))
              : ((c = this.chart.plotArea.x2),
                (h = (this.chart.plotArea.x1 - q / 2 + 0.5) << 0),
                (a *= -1)),
            (this.bounds = { x1: c, y1: e - q / 2, x2: h, y2: l + q / 2 }),
            this.ctx.moveTo(c, e),
            "straight" === this.type ||
              ("left" === this.scaleBreaks.parent._position && 0 >= a) ||
              ("right" === this.scaleBreaks.parent._position && 0 <= a))
          )
            this.ctx.lineTo(h, e), this.ctx.lineTo(h, l), this.ctx.lineTo(c, l);
          else if ("wavy" === this.type) {
            n = c;
            k = e;
            g = 0.5;
            r = (h - n) / a / 3;
            for (m = 0; m < r; m++)
              this.ctx.bezierCurveTo(
                n + a,
                k + g * a,
                n + 2 * a,
                k + g * a,
                n + 3 * a,
                k
              ),
                (n += 3 * a),
                (g *= -1);
            this.ctx.bezierCurveTo(
              n + a,
              k + g * a,
              n + 2 * a,
              k + g * a,
              n + 3 * a,
              k
            );
            k = l;
            g *= -1;
            this.ctx.lineTo(n, k);
            for (m = 0; m < r; m++)
              this.ctx.bezierCurveTo(
                n - a,
                k + g * a,
                n - 2 * a,
                k + g * a,
                n - 3 * a,
                k
              ),
                (n -= 3 * a),
                (g *= -1);
          } else if ("zigzag" === this.type) {
            g = 1;
            k = e - a;
            n = c + a;
            r = (h - n) / a / 2;
            for (m = 0; m < r; m++)
              this.ctx.lineTo(n, k), (k += 2 * g * a), (n += 2 * a), (g *= -1);
            this.ctx.lineTo(n, k);
            k += l - e;
            for (m = 0; m < r + 1; m++)
              this.ctx.lineTo(n, k), (k += 2 * g * a), (n -= 2 * a), (g *= -1);
            this.ctx.lineTo(n + a, k + g * a);
          }
        0 < q && this.ctx.stroke();
        this.ctx.closePath();
        this.ctx.globalAlpha = this.fillOpacity;
        this.ctx.globalCompositeOperation = "destination-over";
        this.ctx.fill();
        this.ctx.restore();
        this.ctx.globalAlpha = b;
        this.ctx = f;
      }
    };
    ma(da, T);
    da.prototype.createUserOptions = function (a) {
      if ("undefined" !== typeof a || this.options._isPlaceholder) {
        var f = 0;
        this.parent.options._isPlaceholder && this.parent.createUserOptions();
        this.options._isPlaceholder ||
          (Ba(this.parent.stripLines),
          (f = this.parent.options.stripLines.indexOf(this.options)));
        this.options = "undefined" === typeof a ? {} : a;
        this.parent.options.stripLines[f] = this.options;
      }
    };
    da.prototype.render = function () {
      this.ctx.save();
      var a = this.parent.getPixelCoordinatesOnAxis(this.value),
        f = Math.abs(
          "pixel" === this._thicknessType
            ? this.thickness
            : this.parent.conversionParameters.pixelPerUnit * this.thickness
        );
      if (0 < f) {
        var b = null === this.opacity ? 1 : this.opacity;
        this.ctx.strokeStyle = this.color;
        this.ctx.beginPath();
        var c = this.ctx.globalAlpha;
        this.ctx.globalAlpha = b;
        R(this.id);
        var e, g, h, l;
        this.ctx.lineWidth = f;
        this.ctx.setLineDash && this.ctx.setLineDash(F(this.lineDashType, f));
        if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        )
          (e = g = 1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0),
            (h = this.chart.plotArea.y1),
            (l = this.chart.plotArea.y2),
            (this.bounds = { x1: e - f / 2, y1: h, x2: g + f / 2, y2: l });
        else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        )
          (h = l = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0),
            (e = this.chart.plotArea.x1),
            (g = this.chart.plotArea.x2),
            (this.bounds = { x1: e, y1: h - f / 2, x2: g, y2: l + f / 2 });
        this.ctx.moveTo(e, h);
        this.ctx.lineTo(g, l);
        this.ctx.stroke();
        this.ctx.globalAlpha = c;
      }
      this.ctx.restore();
    };
    ma(ea, T);
    ea.prototype.render = function (a, f) {
      var b,
        c,
        e,
        g,
        h = null,
        l = (h = null),
        n = "";
      if (!this.valueFormatString)
        if ("dateTime" === this.parent.valueType)
          this.valueFormatString = this.parent.valueFormatString;
        else {
          var k = 0,
            k =
              "xySwapped" === this.chart.plotInfo.axisPlacement
                ? 50 < this.parent.range
                  ? 0
                  : 500 < this.chart.width && 25 > this.parent.range
                  ? 2
                  : Math.floor(
                      Math.abs(Math.log(this.parent.range) / Math.LN10)
                    ) +
                    (5 > this.parent.range ? 2 : 10 > this.parent.range ? 1 : 0)
                : 50 < this.parent.range
                ? 0
                : Math.floor(
                    Math.abs(Math.log(this.parent.range) / Math.LN10)
                  ) +
                  (5 > this.parent.range ? 2 : 10 > this.parent.range ? 1 : 0);
          this.valueFormatString = z.generateValueFormatString(
            this.parent.range,
            k
          );
        }
      var l = null === this.opacity ? 1 : this.opacity,
        k = Math.abs(
          "pixel" === this._thicknessType
            ? this.thickness
            : this.parent.conversionParameters.pixelPerUnit * this.thickness
        ),
        r = this.chart.overlaidCanvasCtx,
        q = r.globalAlpha;
      r.globalAlpha = l;
      r.beginPath();
      r.strokeStyle = this.color;
      r.lineWidth = k;
      r.save();
      this.labelFontSize = y(this.options.labelFontSize)
        ? this.parent.labelFontSize
        : this.labelFontSize;
      if ("left" === this.parent._position || "right" === this.parent._position)
        (this.labelMaxWidth = y(this.options.labelMaxWidth)
          ? this.parent.bounds.x2 - this.parent.bounds.x1
          : this.labelMaxWidth),
          (this.labelMaxHeight =
            y(this.options.labelWrap) || this.labelWrap
              ? 3 * this.chart.height
              : 2 * this.labelFontSize);
      else if (
        "top" === this.parent._position ||
        "bottom" === this.parent._position
      )
        (this.labelMaxWidth = y(this.options.labelMaxWidth)
          ? 3 * this.chart.width
          : this.labelMaxWidth),
          (this.labelMaxHeight =
            y(this.options.labelWrap) || this.labelWrap
              ? this.parent.bounds.height
              : 2 * this.labelFontSize);
      0 < k && r.setLineDash && r.setLineDash(F(this.lineDashType, k));
      l = new ia(r, {
        x: 0,
        y: 0,
        padding: { top: 2, right: 3, bottom: 2, left: 4 },
        backgroundColor: this.labelBackgroundColor,
        borderColor: this.labelBorderColor,
        borderThickness: this.labelBorderThickness,
        cornerRadius: this.labelCornerRadius,
        maxWidth: this.labelMaxWidth,
        maxHeight: this.labelMaxHeight,
        angle: this.labelAngle,
        text: n,
        horizontalAlign: "left",
        fontSize: this.labelFontSize,
        fontFamily: this.labelFontFamily,
        fontWeight: this.labelFontWeight,
        fontColor: this.labelFontColor,
        fontStyle: this.labelFontStyle,
        textBaseline: "middle",
      });
      if (this.snapToDataPoint) {
        var m = 0,
          h = [];
        if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
          var d = null;
          if (
            "bottom" === this.parent._position ||
            "top" === this.parent._position
          )
            m = this.parent.dataSeries[0].axisX.convertPixelToValue({ y: f });
          else if (
            "left" === this.parent._position ||
            "right" === this.parent._position
          )
            m = this.parent.convertPixelToValue({ y: f });
          for (var p = 0; p < this.parent.dataSeries.length; p++)
            (d = this.parent.dataSeries[p].getDataPointAtX(m, !0)) &&
              0 <= d.index &&
              ((d.dataSeries = this.parent.dataSeries[p]),
              null !== d.dataPoint.y && h.push(d));
          d = null;
          if (0 === h.length) return;
          h.sort(function (a, b) {
            return a.distance - b.distance;
          });
          d = Math.abs(a - this.parent.convertValueToPixel(h[0].dataPoint.y));
          p = 0;
          if (
            "rangeBar" === h[0].dataSeries.type ||
            "error" === h[0].dataSeries.type
          )
            for (
              var d = Math.abs(
                  a - this.parent.convertValueToPixel(h[p].dataPoint.y[0])
                ),
                s = 0,
                m = 0;
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    a - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (s = Math.abs(
                  a - this.parent.convertValueToPixel(h[m].dataPoint.y)
                )),
                  s < d && ((d = s), (p = m));
          else if ("stackedBar" === h[0].dataSeries.type)
            for (
              var d = Math.abs(
                  a - this.parent.convertValueToPixel(h[0].dataPoint.y)
                ),
                t = (s = 0),
                m = (p = 0);
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    a - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (t += h[m].dataPoint.y),
                  (s = Math.abs(a - this.parent.convertValueToPixel(t))),
                  s < d && ((d = s), (p = m));
          else if ("stackedBar100" === h[0].dataSeries.type)
            for (
              var d = Math.abs(
                  a - this.parent.convertValueToPixel(h[0].dataPoint.y)
                ),
                u = (t = s = 0),
                m = 0;
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    a - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (t += h[m].dataPoint.y),
                  (u = h[m].dataPoint.x.getTime
                    ? h[m].dataPoint.x.getTime()
                    : h[m].dataPoint.x),
                  (u = 100 * (t / h[m].dataSeries.plotUnit.dataPointYSums[u])),
                  (s = Math.abs(a - this.parent.convertValueToPixel(u))),
                  s < d && ((d = s), (p = m));
          else
            for (
              d = Math.abs(
                a - this.parent.convertValueToPixel(h[0].dataPoint.y)
              ),
                m = p = s = 0;
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    a - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (s = Math.abs(
                  a - this.parent.convertValueToPixel(h[m].dataPoint.y)
                )),
                  s < d && ((d = s), (p = m));
          n = h[p];
          if (
            "bottom" === this.parent._position ||
            "top" === this.parent._position
          ) {
            b = 0;
            if (
              "rangeBar" === this.parent.dataSeries[p].type ||
              "error" === this.parent.dataSeries[p].type
            ) {
              d = Math.abs(
                a - this.parent.convertValueToPixel(n.dataPoint.y[0])
              );
              for (m = s = 0; m < n.dataPoint.y.length; m++)
                (s = Math.abs(
                  a - this.parent.convertValueToPixel(n.dataPoint.y[m])
                )),
                  s < d && ((d = s), (b = m));
              h =
                1 === r.lineWidth % 2
                  ? (this.parent.convertValueToPixel(n.dataPoint.y[b]) << 0) +
                    0.5
                  : this.parent.convertValueToPixel(n.dataPoint.y[b]) << 0;
              l.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: n.dataPoint.y[b],
                  })
                : y(this.options.label)
                ? X(
                    n.dataPoint.y[b],
                    this.valueFormatString,
                    this.chart._cultureInfo
                  )
                : this.label;
            } else if ("stackedBar" === this.parent.dataSeries[p].type) {
              d = Math.abs(
                a - this.parent.convertValueToPixel(h[0].dataPoint.y)
              );
              t = s = 0;
              for (m = p; 0 <= m; m--)
                (t += h[m].dataPoint.y),
                  (s = Math.abs(a - this.parent.convertValueToPixel(t))),
                  s < d && ((d = s), (b = m));
              h =
                1 === r.lineWidth % 2
                  ? (this.parent.convertValueToPixel(t) << 0) + 0.5
                  : this.parent.convertValueToPixel(t) << 0;
              l.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: n.dataPoint.y,
                  })
                : y(this.options.label)
                ? X(
                    n.dataPoint.y,
                    this.valueFormatString,
                    this.chart._cultureInfo
                  )
                : this.label;
            } else if ("stackedBar100" === this.parent.dataSeries[p].type) {
              d = Math.abs(
                a - this.parent.convertValueToPixel(h[0].dataPoint.y)
              );
              u = t = s = 0;
              for (m = p; 0 <= m; m--)
                (t += h[m].dataPoint.y),
                  (u = h[m].dataPoint.x.getTime
                    ? h[m].dataPoint.x.getTime()
                    : h[m].dataPoint.x),
                  (u = 100 * (t / h[m].dataSeries.plotUnit.dataPointYSums[u])),
                  (s = Math.abs(a - this.parent.convertValueToPixel(u))),
                  s < d && ((d = s), (b = m));
              h =
                1 === r.lineWidth % 2
                  ? (this.parent.convertValueToPixel(u) << 0) + 0.5
                  : this.parent.convertValueToPixel(u) << 0;
              l.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: u,
                  })
                : y(this.options.label)
                ? X(u, this.valueFormatString, this.chart._cultureInfo)
                : this.label;
            } else
              (h =
                1 === r.lineWidth % 2
                  ? (this.parent.convertValueToPixel(n.dataPoint.y) << 0) + 0.5
                  : this.parent.convertValueToPixel(n.dataPoint.y) << 0),
                (l.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: n.dataPoint.y,
                    })
                  : y(this.options.label)
                  ? X(
                      n.dataPoint.y,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label);
            b = c = h;
            e = this.chart.plotArea.y1;
            g = this.chart.plotArea.y2;
            this.bounds = { x1: b - k / 2, y1: e, x2: c + k / 2, y2: g };
            l.x = b - l.measureText().width / 2;
            l.x + l.width > this.chart.bounds.x2
              ? (l.x = this.chart.bounds.x2 - l.width)
              : l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1);
            l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2;
          } else if (
            "left" === this.parent._position ||
            "right" === this.parent._position
          ) {
            e =
              g =
              h =
                1 === r.lineWidth % 2
                  ? (this.parent.convertValueToPixel(n.dataPoint.x) << 0) + 0.5
                  : this.parent.convertValueToPixel(n.dataPoint.x) << 0;
            b = this.chart.plotArea.x1;
            c = this.chart.plotArea.x2;
            this.bounds = { x1: b, y1: e - k / 2, x2: c, y2: g + k / 2 };
            u = !1;
            if (this.parent.labels)
              for (
                h = Math.ceil(this.parent.interval), m = 0;
                m < this.parent.viewportMaximum;
                m += h
              )
                if (this.parent.labels[m]) u = !0;
                else {
                  u = !1;
                  break;
                }
            if (u) {
              if ("axisX" === this.parent.type)
                for (
                  m = this.parent.convertPixelToValue({ y: f }),
                    d = null,
                    p = 0;
                  p < this.parent.dataSeries.length;
                  p++
                )
                  (d = this.parent.dataSeries[p].getDataPointAtX(m, !0)) &&
                    0 <= d.index &&
                    (l.text = this.labelFormatter
                      ? this.labelFormatter({
                          chart: this.chart,
                          axis: this.parent.options,
                          crosshair: this.options,
                          value: n.dataPoint.x,
                        })
                      : y(this.options.label)
                      ? d.dataPoint.label
                      : this.label);
            } else
              "dateTime" === this.parent.valueType
                ? (l.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: n.dataPoint.x,
                      })
                    : y(this.options.label)
                    ? za(
                        n.dataPoint.x,
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label)
                : "number" === this.parent.valueType &&
                  (l.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: n.dataPoint.x,
                      })
                    : y(this.options.label)
                    ? X(
                        n.dataPoint.x,
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label);
            l.y = g + l.fontSize / 2 - l.measureText().height / 2 + 2;
            l.y - l.fontSize / 2 < this.chart.bounds.y1
              ? (l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2)
              : l.y + l.measureText().height - l.fontSize / 2 >
                  this.chart.bounds.y2 &&
                (l.y =
                  this.chart.bounds.y2 -
                  l.measureText().height +
                  l.fontSize / 2);
            "left" === this.parent._position
              ? (l.x = this.parent.lineCoordinates.x2 - l.measureText().width)
              : "right" === this.parent._position &&
                (l.x = this.parent.lineCoordinates.x2);
          }
        } else if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        ) {
          m = this.parent.convertPixelToValue({ x: a });
          for (p = 0; p < this.parent.dataSeries.length; p++)
            (d = this.parent.dataSeries[p].getDataPointAtX(m, !0)) &&
              0 <= d.index &&
              ((d.dataSeries = this.parent.dataSeries[p]),
              null !== d.dataPoint.y && h.push(d));
          if (0 === h.length) return;
          h.sort(function (a, b) {
            return a.distance - b.distance;
          });
          n = h[0];
          b =
            c =
            h =
              1 === r.lineWidth % 2
                ? (this.parent.convertValueToPixel(n.dataPoint.x) << 0) + 0.5
                : this.parent.convertValueToPixel(n.dataPoint.x) << 0;
          e = this.chart.plotArea.y1;
          g = this.chart.plotArea.y2;
          this.bounds = { x1: b - k / 2, y1: e, x2: c + k / 2, y2: g };
          u = !1;
          if (this.parent.labels)
            for (
              h = Math.ceil(this.parent.interval), m = 0;
              m < this.parent.viewportMaximum;
              m += h
            )
              if (this.parent.labels[m]) u = !0;
              else {
                u = !1;
                break;
              }
          if (u) {
            if ("axisX" === this.parent.type)
              for (
                m = this.parent.convertPixelToValue({ x: a }), d = null, p = 0;
                p < this.parent.dataSeries.length;
                p++
              )
                (d = this.parent.dataSeries[p].getDataPointAtX(m, !0)) &&
                  0 <= d.index &&
                  (l.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: n.dataPoint.x,
                      })
                    : y(this.options.label)
                    ? d.dataPoint.label
                    : this.label);
          } else
            "dateTime" === this.parent.valueType
              ? (l.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: n.dataPoint.x,
                    })
                  : y(this.options.label)
                  ? za(
                      n.dataPoint.x,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label)
              : "number" === this.parent.valueType &&
                (l.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: n.dataPoint.x,
                    })
                  : y(this.options.label)
                  ? X(
                      n.dataPoint.x,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label);
          l.x = b - l.measureText().width / 2;
          l.x + l.width > this.chart.bounds.x2 &&
            (l.x = this.chart.bounds.x2 - l.width);
          l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1);
          "bottom" === this.parent._position
            ? (l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2)
            : "top" === this.parent._position &&
              (l.y =
                this.parent.lineCoordinates.y1 - l.height + l.fontSize / 2 + 2);
        } else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        ) {
          !y(this.parent.dataSeries) &&
            0 < this.parent.dataSeries.length &&
            (m = this.parent.dataSeries[0].axisX.convertPixelToValue({ x: a }));
          for (p = 0; p < this.parent.dataSeries.length; p++)
            (d = this.parent.dataSeries[p].getDataPointAtX(m, !0)) &&
              0 <= d.index &&
              ((d.dataSeries = this.parent.dataSeries[p]),
              null !== d.dataPoint.y && h.push(d));
          if (0 === h.length) return;
          h.sort(function (a, b) {
            return a.distance - b.distance;
          });
          p = 0;
          if (
            "rangeColumn" === h[0].dataSeries.type ||
            "rangeArea" === h[0].dataSeries.type ||
            "error" === h[0].dataSeries.type ||
            "rangeSplineArea" === h[0].dataSeries.type ||
            "candlestick" === h[0].dataSeries.type ||
            "ohlc" === h[0].dataSeries.type ||
            "boxAndWhisker" === h[0].dataSeries.type
          )
            for (
              d = Math.abs(
                f - this.parent.convertValueToPixel(h[0].dataPoint.y[0])
              ),
                m = s = 0;
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    f - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (s = Math.abs(
                  f - this.parent.convertValueToPixel(h[m].dataPoint.y)
                )),
                  s < d && ((d = s), (p = m));
          else if (
            "stackedColumn" === h[0].dataSeries.type ||
            "stackedArea" === h[0].dataSeries.type
          )
            for (
              d = Math.abs(
                f - this.parent.convertValueToPixel(h[0].dataPoint.y)
              ),
                m = t = s = 0;
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    f - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (t += h[m].dataPoint.y),
                  (s = Math.abs(f - this.parent.convertValueToPixel(t))),
                  s < d && ((d = s), (p = m));
          else if (
            "stackedColumn100" === h[0].dataSeries.type ||
            "stackedArea100" === h[0].dataSeries.type
          )
            for (
              d = Math.abs(
                f - this.parent.convertValueToPixel(h[0].dataPoint.y)
              ),
                m = u = t = s = 0;
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    f - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (t += h[m].dataPoint.y),
                  (u = h[m].dataPoint.x.getTime
                    ? h[m].dataPoint.x.getTime()
                    : h[m].dataPoint.x),
                  (u = 100 * (t / h[m].dataSeries.plotUnit.dataPointYSums[u])),
                  (s = Math.abs(f - this.parent.convertValueToPixel(u))),
                  s < d && ((d = s), (p = m));
          else
            for (
              d = Math.abs(
                f - this.parent.convertValueToPixel(h[0].dataPoint.y)
              ),
                m = s = 0;
              m < h.length;
              m++
            )
              if (h[m].dataPoint.y && h[m].dataPoint.y.length)
                for (n = 0; n < h[m].dataPoint.y.length; n++)
                  (s = Math.abs(
                    f - this.parent.convertValueToPixel(h[m].dataPoint.y[n])
                  )),
                    s < d && ((d = s), (p = m));
              else
                (s = Math.abs(
                  f - this.parent.convertValueToPixel(h[m].dataPoint.y)
                )),
                  s < d && ((d = s), (p = m));
          n = h[p];
          b = 0;
          if (
            "rangeColumn" === this.parent.dataSeries[p].type ||
            "rangeArea" === this.parent.dataSeries[p].type ||
            "error" === this.parent.dataSeries[p].type ||
            "rangeSplineArea" === this.parent.dataSeries[p].type ||
            "candlestick" === this.parent.dataSeries[p].type ||
            "ohlc" === this.parent.dataSeries[p].type ||
            "boxAndWhisker" === this.parent.dataSeries[p].type
          ) {
            d = Math.abs(f - this.parent.convertValueToPixel(n.dataPoint.y[0]));
            for (m = s = 0; m < n.dataPoint.y.length; m++)
              (s = Math.abs(
                f - this.parent.convertValueToPixel(n.dataPoint.y[m])
              )),
                s < d && ((d = s), (b = m));
            h =
              1 === r.lineWidth % 2
                ? (this.parent.convertValueToPixel(n.dataPoint.y[b]) << 0) + 0.5
                : this.parent.convertValueToPixel(n.dataPoint.y[b]) << 0;
            l.text = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.parent.options,
                  crosshair: this.options,
                  value: n.dataPoint.y[b],
                })
              : y(this.options.label)
              ? X(
                  n.dataPoint.y[b],
                  this.valueFormatString,
                  this.chart._cultureInfo
                )
              : this.label;
          } else if (
            "stackedColumn" === this.parent.dataSeries[p].type ||
            "stackedArea" === this.parent.dataSeries[p].type
          ) {
            d = Math.abs(f - this.parent.convertValueToPixel(h[0].dataPoint.y));
            t = s = 0;
            for (m = p; 0 <= m; m--)
              (t += h[m].dataPoint.y),
                (s = Math.abs(f - this.parent.convertValueToPixel(t))),
                s < d && ((d = s), (b = m));
            h =
              1 === r.lineWidth % 2
                ? (this.parent.convertValueToPixel(t) << 0) + 0.5
                : this.parent.convertValueToPixel(t) << 0;
            l.text = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.parent.options,
                  crosshair: this.options,
                  value: n.dataPoint.y,
                })
              : y(this.options.label)
              ? X(
                  n.dataPoint.y,
                  this.valueFormatString,
                  this.chart._cultureInfo
                )
              : this.label;
          } else if (
            "stackedColumn100" === this.parent.dataSeries[p].type ||
            "stackedArea100" === this.parent.dataSeries[p].type
          ) {
            d = Math.abs(f - this.parent.convertValueToPixel(h[0].dataPoint.y));
            t = s = 0;
            for (m = p; 0 <= m; m--)
              (t += h[m].dataPoint.y),
                (u = h[m].dataPoint.x.getTime
                  ? h[m].dataPoint.x.getTime()
                  : h[m].dataPoint.x),
                (u = 100 * (t / h[m].dataSeries.plotUnit.dataPointYSums[u])),
                (s = Math.abs(f - this.parent.convertValueToPixel(u))),
                s < d && ((d = s), (b = m));
            h =
              1 === r.lineWidth % 2
                ? (this.parent.convertValueToPixel(u) << 0) + 0.5
                : this.parent.convertValueToPixel(u) << 0;
            l.text = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.parent.options,
                  crosshair: this.options,
                  value: u,
                })
              : y(this.options.label)
              ? X(u, this.valueFormatString, this.chart._cultureInfo)
              : this.label;
          } else
            "waterfall" === this.parent.dataSeries[p].type
              ? ((h =
                  1 === r.lineWidth % 2
                    ? (this.parent.convertValueToPixel(
                        n.dataSeries.dataPointEOs[n.index].cumulativeSum
                      ) <<
                        0) +
                      0.5
                    : this.parent.convertValueToPixel(
                        n.dataSeries.dataPointEOs[n.index].cumulativeSum
                      ) << 0),
                (l.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: n.dataSeries.dataPointEOs[n.index].cumulativeSum,
                    })
                  : y(this.options.label)
                  ? X(
                      n.dataSeries.dataPointEOs[n.index].cumulativeSum,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label))
              : ((h =
                  1 === r.lineWidth % 2
                    ? (this.parent.convertValueToPixel(n.dataPoint.y) << 0) +
                      0.5
                    : this.parent.convertValueToPixel(n.dataPoint.y) << 0),
                (l.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: n.dataPoint.y,
                    })
                  : y(this.options.label)
                  ? X(
                      n.dataPoint.y,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label));
          e = g = h;
          b = this.chart.plotArea.x1;
          c = this.chart.plotArea.x2;
          this.bounds = { x1: b, y1: e - k / 2, x2: c, y2: g + k / 2 };
          l.y = g + l.fontSize / 2 - l.measureText().height / 2 + 2;
          l.y - l.fontSize / 2 < this.chart.bounds.y1
            ? (l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2)
            : l.y + l.measureText().height - l.fontSize / 2 >
                this.chart.bounds.y2 &&
              (l.y =
                this.chart.bounds.y2 - l.measureText().height + l.fontSize / 2);
          "left" === this.parent._position
            ? (l.x = this.parent.lineCoordinates.x2 - l.measureText().width)
            : "right" === this.parent._position &&
              (l.x = this.parent.lineCoordinates.x2);
        }
        h = null;
        ("bottom" === this.parent._position ||
          "top" === this.parent._position) &&
          b >= this.parent.convertValueToPixel(this.parent.viewportMinimum) &&
          c <= this.parent.convertValueToPixel(this.parent.viewportMaximum) &&
          (0 < k && (r.moveTo(b, e), r.lineTo(c, g), r.stroke()),
          r.restore(),
          !y(l.text) &&
            ("number" === typeof l.text.valueOf() || 0 < l.text.length) &&
            l.render(!0));
        ("left" === this.parent._position ||
          "right" === this.parent._position) &&
          g >= this.parent.convertValueToPixel(this.parent.viewportMaximum) &&
          e <= this.parent.convertValueToPixel(this.parent.viewportMinimum) &&
          (0 < k && (r.moveTo(b, e), r.lineTo(c, g), r.stroke()),
          r.restore(),
          !y(l.text) &&
            ("number" === typeof l.text.valueOf() || 0 < l.text.length) &&
            l.render(!0));
      } else {
        if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        )
          (b = c = h = 1 === r.lineWidth % 2 ? (a << 0) + 0.5 : a << 0),
            (e = this.chart.plotArea.y1),
            (g = this.chart.plotArea.y2),
            (this.bounds = { x1: b - k / 2, y1: e, x2: c + k / 2, y2: g });
        else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        )
          (e = g = h = 1 === r.lineWidth % 2 ? (f << 0) + 0.5 : f << 0),
            (b = this.chart.plotArea.x1),
            (c = this.chart.plotArea.x2),
            (this.bounds = { x1: b, y1: e - k / 2, x2: c, y2: g + k / 2 });
        if ("xySwapped" === this.chart.plotInfo.axisPlacement)
          if (
            "left" === this.parent._position ||
            "right" === this.parent._position
          ) {
            u = !1;
            if (this.parent.labels)
              for (
                h = Math.ceil(this.parent.interval), m = 0;
                m < this.parent.viewportMaximum;
                m += h
              )
                if (this.parent.labels[m]) u = !0;
                else {
                  u = !1;
                  break;
                }
            if (u) {
              if ("axisX" === this.parent.type)
                for (
                  m = this.parent.convertPixelToValue({ y: f }),
                    d = null,
                    p = 0;
                  p < this.parent.dataSeries.length;
                  p++
                )
                  (d = this.parent.dataSeries[p].getDataPointAtX(m, !0)) &&
                    0 <= d.index &&
                    (l.text = this.labelFormatter
                      ? this.labelFormatter({
                          chart: this.chart,
                          axis: this.parent.options,
                          crosshair: this.options,
                          value: this.parent.convertPixelToValue(a),
                        })
                      : y(this.options.label)
                      ? d.dataPoint.label
                      : this.label);
            } else
              "dateTime" === this.parent.valueType
                ? (l.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: this.parent.convertPixelToValue(f),
                      })
                    : y(this.options.label)
                    ? za(
                        this.parent.convertPixelToValue(f),
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label)
                : "number" === this.parent.valueType &&
                  (l.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: this.parent.convertPixelToValue(f),
                      })
                    : y(this.options.label)
                    ? X(
                        this.parent.convertPixelToValue(f),
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label);
            l.y = f + l.fontSize / 2 - l.measureText().height / 2 + 2;
            l.y - l.fontSize / 2 < this.chart.bounds.y1
              ? (l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2)
              : l.y + l.measureText().height - l.fontSize / 2 >
                  this.chart.bounds.y2 &&
                (l.y =
                  this.chart.bounds.y2 -
                  l.measureText().height +
                  l.fontSize / 2);
            "left" === this.parent._position
              ? (l.x = this.parent.lineCoordinates.x1 - l.measureText().width)
              : "right" === this.parent._position &&
                (l.x = this.parent.lineCoordinates.x2);
          } else {
            if (
              "bottom" === this.parent._position ||
              "top" === this.parent._position
            )
              (l.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: this.parent.convertPixelToValue(a),
                  })
                : y(this.options.label)
                ? X(
                    this.parent.convertPixelToValue(a),
                    this.valueFormatString,
                    this.chart._cultureInfo
                  )
                : this.label),
                (l.x = b - l.measureText().width / 2),
                l.x + l.width > this.chart.bounds.x2 &&
                  (l.x = this.chart.bounds.x2 - l.width),
                l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1),
                "bottom" === this.parent._position &&
                  (l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2),
                "top" === this.parent._position &&
                  (l.y =
                    this.parent.lineCoordinates.y1 -
                    l.height +
                    l.fontSize / 2 +
                    2);
          }
        else if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        ) {
          u = !1;
          n = "";
          if (this.parent.labels)
            for (
              h = Math.ceil(this.parent.interval), m = 0;
              m < this.parent.viewportMaximum;
              m += h
            )
              if (this.parent.labels[m]) u = !0;
              else {
                u = !1;
                break;
              }
          if (u) {
            if ("axisX" === this.parent.type)
              for (
                m = this.parent.convertPixelToValue({ x: a }), d = null, p = 0;
                p < this.parent.dataSeries.length;
                p++
              )
                (d = this.parent.dataSeries[p].getDataPointAtX(m, !0)) &&
                  0 <= d.index &&
                  (l.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: this.parent.convertPixelToValue(a),
                      })
                    : y(this.options.label)
                    ? d.dataPoint.label
                    : this.label);
          } else
            "dateTime" === this.parent.valueType
              ? (l.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: this.parent.convertPixelToValue(a),
                    })
                  : y(this.options.label)
                  ? za(
                      this.parent.convertPixelToValue(a),
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label)
              : "number" === this.parent.valueType &&
                (l.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value:
                        0 < this.parent.dataSeries.length
                          ? this.parent.convertPixelToValue(a)
                          : "",
                    })
                  : y(this.options.label)
                  ? X(
                      this.parent.convertPixelToValue(a),
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label);
          l.x = b - l.measureText().width / 2;
          l.x + l.width > this.chart.bounds.x2 &&
            (l.x = this.chart.bounds.x2 - l.width);
          l.x < this.chart.bounds.x1 && (l.x = this.chart.bounds.x1);
          "bottom" === this.parent._position
            ? (l.y = this.parent.lineCoordinates.y2 + l.fontSize / 2 + 2)
            : "top" === this.parent._position &&
              (l.y =
                this.parent.lineCoordinates.y1 - l.height + l.fontSize / 2 + 2);
        } else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        )
          (l.text = this.labelFormatter
            ? this.labelFormatter({
                chart: this.chart,
                axis: this.parent.options,
                crosshair: this.options,
                value: this.parent.convertPixelToValue(f),
              })
            : y(this.options.label)
            ? X(
                this.parent.convertPixelToValue(f),
                this.valueFormatString,
                this.chart._cultureInfo
              )
            : this.label),
            (l.y = f + l.fontSize / 2 - l.measureText().height / 2 + 2),
            l.y - l.fontSize / 2 < this.chart.bounds.y1
              ? (l.y = this.chart.bounds.y1 + l.fontSize / 2 + 2)
              : l.y + l.measureText().height - l.fontSize / 2 >
                  this.chart.bounds.y2 &&
                (l.y =
                  this.chart.bounds.y2 -
                  l.measureText().height +
                  l.fontSize / 2),
            "left" === this.parent._position
              ? (l.x = this.parent.lineCoordinates.x2 - l.measureText().width)
              : "right" === this.parent._position &&
                (l.x = this.parent.lineCoordinates.x2);
        0 < k && (r.moveTo(b, e), r.lineTo(c, g), r.stroke());
        r.restore();
        !y(l.text) &&
          ("number" === typeof l.text.valueOf() || 0 < l.text.length) &&
          l.render(!0);
      }
      r.globalAlpha = q;
    };
    ma($, T);
    $.prototype._initialize = function () {
      if (this.enabled) {
        this.container = document.createElement("div");
        this.container.setAttribute("class", "canvasjs-chart-tooltip");
        this.container.style.position = "absolute";
        this.container.style.height = "auto";
        this.container.style.boxShadow = "1px 1px 2px 2px rgba(0,0,0,0.1)";
        this.container.style.zIndex = "1000";
        this.container.style.pointerEvents = "none";
        this.container.style.display = "none";
        var a;
        a = '<div style=" width: auto;height: auto;min-width: 50px;';
        a += "line-height: auto;";
        a += "margin: 0px 0px 0px 0px;";
        a += "padding: 5px;";
        a += "font-family: Calibri, Arial, Georgia, serif;";
        a += "font-weight: normal;";
        a += "font-style: " + (v ? "italic;" : "normal;");
        a += "font-size: 14px;";
        a += "color: #000000;";
        a += "text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);";
        a += "text-align: left;";
        a += "border: 2px solid grey;";
        a += v
          ? "background: rgba(255,255,255,.9);"
          : "background: rgb(255,255,255);";
        a += "text-indent: 0px;";
        a += "white-space: nowrap;";
        a += "border-radius: 5px;";
        a += "-moz-user-select:none;";
        a += "-khtml-user-select: none;";
        a += "-webkit-user-select: none;";
        a += "-ms-user-select: none;";
        a += "user-select: none;";
        v ||
          ((a += "filter: alpha(opacity = 90);"),
          (a +=
            "filter: progid:DXImageTransform.Microsoft.Shadow(Strength=3, Direction=135, Color='#666666');"));
        a += '} "> Sample Tooltip</div>';
        this.container.innerHTML = a;
        this.contentDiv = this.container.firstChild;
        this.container.style.borderRadius = this.contentDiv.style.borderRadius;
        this.chart._canvasJSContainer.appendChild(this.container);
      }
    };
    $.prototype.mouseMoveHandler = function (a, f) {
      (this._lastUpdated && 4 > new Date().getTime() - this._lastUpdated) ||
        ((this._lastUpdated = new Date().getTime()),
        this.chart.resetOverlayedCanvas(),
        this._updateToolTip(a, f));
    };
    $.prototype._updateToolTip = function (a, f, b) {
      b = "undefined" === typeof b ? !0 : b;
      this.container || this._initialize();
      this.enabled || this.hide();
      if (!this.chart.disableToolTip) {
        if ("undefined" === typeof a || "undefined" === typeof f) {
          if (isNaN(this._prevX) || isNaN(this._prevY)) return;
          a = this._prevX;
          f = this._prevY;
        } else (this._prevX = a), (this._prevY = f);
        var c = null,
          e = null,
          g = [],
          h = 0;
        if (
          this.shared &&
          this.enabled &&
          "none" !== this.chart.plotInfo.axisPlacement
        ) {
          if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
            var l = [];
            if (this.chart.axisX)
              for (var n = 0; n < this.chart.axisX.length; n++) {
                for (
                  var h = this.chart.axisX[n].convertPixelToValue({ y: f }),
                    k = null,
                    c = 0;
                  c < this.chart.axisX[n].dataSeries.length;
                  c++
                )
                  (k = this.chart.axisX[n].dataSeries[c].getDataPointAtX(
                    h,
                    b
                  )) &&
                    0 <= k.index &&
                    ((k.dataSeries = this.chart.axisX[n].dataSeries[c]),
                    null !== k.dataPoint.y && l.push(k));
                k = null;
              }
            if (this.chart.axisX2)
              for (n = 0; n < this.chart.axisX2.length; n++) {
                h = this.chart.axisX2[n].convertPixelToValue({ y: f });
                k = null;
                for (c = 0; c < this.chart.axisX2[n].dataSeries.length; c++)
                  (k = this.chart.axisX2[n].dataSeries[c].getDataPointAtX(
                    h,
                    b
                  )) &&
                    0 <= k.index &&
                    ((k.dataSeries = this.chart.axisX2[n].dataSeries[c]),
                    null !== k.dataPoint.y && l.push(k));
                k = null;
              }
          } else {
            l = [];
            if (this.chart.axisX)
              for (n = 0; n < this.chart.axisX.length; n++)
                for (
                  h = this.chart.axisX[n].convertPixelToValue({ x: a }),
                    k = null,
                    c = 0;
                  c < this.chart.axisX[n].dataSeries.length;
                  c++
                )
                  (k = this.chart.axisX[n].dataSeries[c].getDataPointAtX(
                    h,
                    b
                  )) &&
                    0 <= k.index &&
                    ((k.dataSeries = this.chart.axisX[n].dataSeries[c]),
                    null !== k.dataPoint.y && l.push(k));
            if (this.chart.axisX2)
              for (n = 0; n < this.chart.axisX2.length; n++)
                for (
                  h = this.chart.axisX2[n].convertPixelToValue({ x: a }),
                    k = null,
                    c = 0;
                  c < this.chart.axisX2[n].dataSeries.length;
                  c++
                )
                  (k = this.chart.axisX2[n].dataSeries[c].getDataPointAtX(
                    h,
                    b
                  )) &&
                    0 <= k.index &&
                    ((k.dataSeries = this.chart.axisX2[n].dataSeries[c]),
                    null !== k.dataPoint.y && l.push(k));
          }
          if (0 === l.length) return;
          l.sort(function (a, b) {
            return a.distance - b.distance;
          });
          b = l[0];
          for (c = 0; c < l.length; c++)
            l[c].dataPoint.x.valueOf() === b.dataPoint.x.valueOf() &&
              g.push(l[c]);
          l = null;
        } else {
          if ((k = this.chart.getDataPointAtXY(a, f, b)))
            (this.currentDataPointIndex = k.dataPointIndex),
              (this.currentSeriesIndex = k.dataSeries.index);
          else if (v)
            if (
              ((k = Va(a, f, this.chart._eventManager.ghostCtx)),
              0 < k &&
                "undefined" !== typeof this.chart._eventManager.objectMap[k])
            ) {
              k = this.chart._eventManager.objectMap[k];
              if ("legendItem" === k.objectType) return;
              this.currentSeriesIndex = k.dataSeriesIndex;
              this.currentDataPointIndex =
                0 <= k.dataPointIndex ? k.dataPointIndex : -1;
            } else this.currentDataPointIndex = -1;
          else this.currentDataPointIndex = -1;
          if (0 <= this.currentSeriesIndex) {
            e = this.chart.data[this.currentSeriesIndex];
            k = {};
            if (0 <= this.currentDataPointIndex)
              (c = e.dataPoints[this.currentDataPointIndex]),
                (k.dataSeries = e),
                (k.dataPoint = c),
                (k.index = this.currentDataPointIndex),
                (k.distance = Math.abs(c.x - h)),
                "waterfall" === e.type &&
                  ((k.cumulativeSumYStartValue =
                    e.dataPointEOs[
                      this.currentDataPointIndex
                    ].cumulativeSumYStartValue),
                  (k.cumulativeSum =
                    e.dataPointEOs[this.currentDataPointIndex].cumulativeSum));
            else {
              if (
                !this.enabled ||
                ("line" !== e.type &&
                  "stepLine" !== e.type &&
                  "spline" !== e.type &&
                  "area" !== e.type &&
                  "stepArea" !== e.type &&
                  "splineArea" !== e.type &&
                  "stackedArea" !== e.type &&
                  "stackedArea100" !== e.type &&
                  "rangeArea" !== e.type &&
                  "rangeSplineArea" !== e.type &&
                  "candlestick" !== e.type &&
                  "ohlc" !== e.type &&
                  "boxAndWhisker" !== e.type)
              )
                return;
              h = e.axisX.convertPixelToValue({ x: a });
              k = e.getDataPointAtX(h, b);
              k.dataSeries = e;
              this.currentDataPointIndex = k.index;
              c = k.dataPoint;
            }
            if (!y(k.dataPoint.y))
              if (k.dataSeries.axisY)
                if (0 < k.dataPoint.y.length) {
                  for (c = b = 0; c < k.dataPoint.y.length; c++)
                    k.dataPoint.y[c] < k.dataSeries.axisY.viewportMinimum
                      ? b--
                      : k.dataPoint.y[c] > k.dataSeries.axisY.viewportMaximum &&
                        b++;
                  b < k.dataPoint.y.length &&
                    b > -k.dataPoint.y.length &&
                    g.push(k);
                } else
                  "column" === e.type || "bar" === e.type
                    ? 0 > k.dataPoint.y
                      ? 0 > k.dataSeries.axisY.viewportMinimum &&
                        k.dataSeries.axisY.viewportMaximum >= k.dataPoint.y &&
                        g.push(k)
                      : k.dataSeries.axisY.viewportMinimum <= k.dataPoint.y &&
                        0 <= k.dataSeries.axisY.viewportMaximum &&
                        g.push(k)
                    : "bubble" === e.type
                    ? ((b =
                        this.chart._eventManager.objectMap[
                          e.dataPointIds[k.index]
                        ].size / 2),
                      k.dataPoint.y >= k.dataSeries.axisY.viewportMinimum - b &&
                        k.dataPoint.y <=
                          k.dataSeries.axisY.viewportMaximum + b &&
                        g.push(k))
                    : "waterfall" === e.type
                    ? ((b = 0),
                      k.cumulativeSumYStartValue <
                      k.dataSeries.axisY.viewportMinimum
                        ? b--
                        : k.cumulativeSumYStartValue >
                            k.dataSeries.axisY.viewportMaximum && b++,
                      k.cumulativeSum < k.dataSeries.axisY.viewportMinimum
                        ? b--
                        : k.cumulativeSum >
                            k.dataSeries.axisY.viewportMaximum && b++,
                      2 > b && -2 < b && g.push(k))
                    : (0 <= k.dataSeries.type.indexOf("100") ||
                        "stackedColumn" === e.type ||
                        "stackedBar" === e.type ||
                        (k.dataPoint.y >= k.dataSeries.axisY.viewportMinimum &&
                          k.dataPoint.y <=
                            k.dataSeries.axisY.viewportMaximum)) &&
                      g.push(k);
              else g.push(k);
          }
        }
        if (0 < g.length && (this.highlightObjects(g), this.enabled))
          if (
            ((b = ""),
            (b = this.getToolTipInnerHTML({ entries: g })),
            null !== b)
          ) {
            this.contentDiv.innerHTML = b;
            b = !1;
            "none" === this.container.style.display &&
              ((b = !0), (this.container.style.display = "block"));
            try {
              (this.contentDiv.style.background = this.backgroundColor
                ? this.backgroundColor
                : v
                ? "rgba(255,255,255,.9)"
                : "rgb(255,255,255)"),
                (this.borderColor =
                  "waterfall" === g[0].dataSeries.type
                    ? (this.contentDiv.style.borderRightColor =
                        this.contentDiv.style.borderLeftColor =
                        this.contentDiv.style.borderColor =
                          this.options.borderColor
                            ? this.options.borderColor
                            : g[0].dataPoint.color
                            ? g[0].dataPoint.color
                            : -1 < g[0].dataPoint.y
                            ? g[0].dataSeries.risingColor
                            : g[0].dataSeries.fallingColor)
                    : "error" === g[0].dataSeries.type
                    ? (this.contentDiv.style.borderRightColor =
                        this.contentDiv.style.borderLeftColor =
                        this.contentDiv.style.borderColor =
                          this.options.borderColor
                            ? this.options.borderColor
                            : g[0].dataSeries.color
                            ? g[0].dataSeries.color
                            : g[0].dataSeries._colorSet[
                                e.index % g[0].dataSeries._colorSet.length
                              ])
                    : (this.contentDiv.style.borderRightColor =
                        this.contentDiv.style.borderLeftColor =
                        this.contentDiv.style.borderColor =
                          this.options.borderColor
                            ? this.options.borderColor
                            : g[0].dataPoint.color
                            ? g[0].dataPoint.color
                            : g[0].dataSeries.color
                            ? g[0].dataSeries.color
                            : g[0].dataSeries._colorSet[
                                g[0].index % g[0].dataSeries._colorSet.length
                              ])),
                (this.contentDiv.style.borderWidth =
                  this.borderThickness || 0 === this.borderThickness
                    ? this.borderThickness + "px"
                    : "2px"),
                (this.contentDiv.style.borderRadius =
                  this.cornerRadius || 0 === this.cornerRadius
                    ? this.cornerRadius + "px"
                    : "5px"),
                (this.container.style.borderRadius =
                  this.contentDiv.style.borderRadius),
                (this.contentDiv.style.fontSize =
                  this.fontSize || 0 === this.fontSize
                    ? this.fontSize + "px"
                    : "14px"),
                (this.contentDiv.style.color = this.fontColor
                  ? this.fontColor
                  : "#000000"),
                (this.contentDiv.style.fontFamily = this.fontFamily
                  ? this.fontFamily
                  : "Calibri, Arial, Georgia, serif;"),
                (this.contentDiv.style.fontWeight = this.fontWeight
                  ? this.fontWeight
                  : "normal"),
                (this.contentDiv.style.fontStyle = this.fontStyle
                  ? this.fontStyle
                  : v
                  ? "italic"
                  : "normal");
            } catch (p) {}
            "pie" === g[0].dataSeries.type ||
            "doughnut" === g[0].dataSeries.type ||
            "funnel" === g[0].dataSeries.type ||
            "pyramid" === g[0].dataSeries.type ||
            "bar" === g[0].dataSeries.type ||
            "rangeBar" === g[0].dataSeries.type ||
            "stackedBar" === g[0].dataSeries.type ||
            "stackedBar100" === g[0].dataSeries.type
              ? (a = a - 10 - this.container.clientWidth)
              : ((a =
                  (g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x) -
                    this.container.clientWidth) <<
                  0),
                (a -= 10));
            0 > a && (a += this.container.clientWidth + 20);
            a + this.container.clientWidth >
              Math.max(this.chart.container.clientWidth, this.chart.width) &&
              (a = Math.max(
                0,
                Math.max(this.chart.container.clientWidth, this.chart.width) -
                  this.container.clientWidth
              ));
            f =
              1 !== g.length ||
              this.shared ||
              ("line" !== g[0].dataSeries.type &&
                "stepLine" !== g[0].dataSeries.type &&
                "spline" !== g[0].dataSeries.type &&
                "area" !== g[0].dataSeries.type &&
                "stepArea" !== g[0].dataSeries.type &&
                "splineArea" !== g[0].dataSeries.type)
                ? "bar" === g[0].dataSeries.type ||
                  "rangeBar" === g[0].dataSeries.type ||
                  "stackedBar" === g[0].dataSeries.type ||
                  "stackedBar100" === g[0].dataSeries.type
                  ? g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x)
                  : f
                : g[0].dataSeries.axisY.convertValueToPixel(g[0].dataPoint.y);
            f = -f + 10;
            0 < f + this.container.clientHeight + 5 &&
              (f -= f + this.container.clientHeight + 5 - 0);
            this.fixMozTransitionDelay(a, f);
            !this.animationEnabled || b
              ? this.disableAnimation()
              : (this.enableAnimation(),
                (this.container.style.MozTransition =
                  this.mozContainerTransition));
            this.container.style.left = a + "px";
            this.container.style.bottom = f + "px";
          } else this.hide(!1);
      }
    };
    $.prototype.highlightObjects = function (a) {
      var f = this.chart.overlaidCanvasCtx;
      this.chart.resetOverlayedCanvas();
      f.clearRect(0, 0, this.chart.width, this.chart.height);
      f.save();
      var b = this.chart.plotArea,
        c = 0;
      f.beginPath();
      f.rect(b.x1, b.y1, b.x2 - b.x1, b.y2 - b.y1);
      f.clip();
      for (b = 0; b < a.length; b++) {
        var e = a[b];
        if (
          (e =
            this.chart._eventManager.objectMap[
              e.dataSeries.dataPointIds[e.index]
            ]) &&
          e.objectType &&
          "dataPoint" === e.objectType
        ) {
          var c = this.chart.data[e.dataSeriesIndex],
            g = c.dataPoints[e.dataPointIndex],
            h = e.dataPointIndex;
          !1 === g.highlightEnabled ||
            (!0 !== c.highlightEnabled && !0 !== g.highlightEnabled) ||
            ("line" === c.type ||
            "stepLine" === c.type ||
            "spline" === c.type ||
            "scatter" === c.type ||
            "area" === c.type ||
            "stepArea" === c.type ||
            "splineArea" === c.type ||
            "stackedArea" === c.type ||
            "stackedArea100" === c.type ||
            "rangeArea" === c.type ||
            "rangeSplineArea" === c.type
              ? ((g = c.getMarkerProperties(
                  h,
                  e.x1,
                  e.y1,
                  this.chart.overlaidCanvasCtx
                )),
                (g.size = Math.max((1.5 * g.size) << 0, 10)),
                (g.borderColor = g.borderColor || "#FFFFFF"),
                (g.borderThickness =
                  g.borderThickness || Math.ceil(0.1 * g.size)),
                fa.drawMarkers([g]),
                "undefined" !== typeof e.y2 &&
                  ((g = c.getMarkerProperties(
                    h,
                    e.x1,
                    e.y2,
                    this.chart.overlaidCanvasCtx
                  )),
                  (g.size = Math.max((1.5 * g.size) << 0, 10)),
                  (g.borderColor = g.borderColor || "#FFFFFF"),
                  (g.borderThickness =
                    g.borderThickness || Math.ceil(0.1 * g.size)),
                  fa.drawMarkers([g])))
              : "bubble" === c.type
              ? ((g = c.getMarkerProperties(
                  h,
                  e.x1,
                  e.y1,
                  this.chart.overlaidCanvasCtx
                )),
                (g.size = e.size),
                (g.color = "white"),
                (g.borderColor = "white"),
                (f.globalAlpha = 0.3),
                fa.drawMarkers([g]),
                (f.globalAlpha = 1))
              : "column" === c.type ||
                "stackedColumn" === c.type ||
                "stackedColumn100" === c.type ||
                "bar" === c.type ||
                "rangeBar" === c.type ||
                "stackedBar" === c.type ||
                "stackedBar100" === c.type ||
                "rangeColumn" === c.type ||
                "waterfall" === c.type
              ? W(
                  f,
                  e.x1,
                  e.y1,
                  e.x2,
                  e.y2,
                  "white",
                  0,
                  null,
                  !1,
                  !1,
                  !1,
                  !1,
                  0.3
                )
              : "pie" === c.type || "doughnut" === c.type
              ? oa(
                  f,
                  e.center,
                  e.radius,
                  "white",
                  c.type,
                  e.startAngle,
                  e.endAngle,
                  0.3,
                  e.percentInnerRadius
                )
              : "funnel" === c.type || "pyramid" === c.type
              ? sa(f, e.funnelSection, 0.3, "white")
              : "candlestick" === c.type
              ? ((f.globalAlpha = 1),
                (f.strokeStyle = e.color),
                (f.lineWidth = 2 * e.borderThickness),
                (c = 0 === f.lineWidth % 2 ? 0 : 0.5),
                f.beginPath(),
                f.moveTo(e.x3 - c, Math.min(e.y2, e.y3)),
                f.lineTo(e.x3 - c, Math.min(e.y1, e.y4)),
                f.stroke(),
                f.beginPath(),
                f.moveTo(e.x3 - c, Math.max(e.y1, e.y4)),
                f.lineTo(e.x3 - c, Math.max(e.y2, e.y3)),
                f.stroke(),
                W(
                  f,
                  e.x1,
                  Math.min(e.y1, e.y4),
                  e.x2,
                  Math.max(e.y1, e.y4),
                  "transparent",
                  2 * e.borderThickness,
                  e.color,
                  !1,
                  !1,
                  !1,
                  !1
                ),
                (f.globalAlpha = 1))
              : "ohlc" === c.type
              ? ((f.globalAlpha = 1),
                (f.strokeStyle = e.color),
                (f.lineWidth = 2 * e.borderThickness),
                (c = 0 === f.lineWidth % 2 ? 0 : 0.5),
                f.beginPath(),
                f.moveTo(e.x3 - c, e.y2),
                f.lineTo(e.x3 - c, e.y3),
                f.stroke(),
                f.beginPath(),
                f.moveTo(e.x3, e.y1),
                f.lineTo(e.x1, e.y1),
                f.stroke(),
                f.beginPath(),
                f.moveTo(e.x3, e.y4),
                f.lineTo(e.x2, e.y4),
                f.stroke(),
                (f.globalAlpha = 1))
              : "boxAndWhisker" === c.type
              ? (f.save(),
                (f.globalAlpha = 1),
                (f.strokeStyle = e.stemColor),
                (f.lineWidth = 2 * e.stemThickness),
                0 < e.stemThickness &&
                  (f.beginPath(),
                  f.moveTo(e.x3, e.y2 + e.borderThickness / 2),
                  f.lineTo(e.x3, e.y1 + e.whiskerThickness / 2),
                  f.stroke(),
                  f.beginPath(),
                  f.moveTo(e.x3, e.y4 - e.whiskerThickness / 2),
                  f.lineTo(e.x3, e.y3 - e.borderThickness / 2),
                  f.stroke()),
                f.beginPath(),
                W(
                  f,
                  e.x1 - e.borderThickness / 2,
                  Math.max(
                    e.y2 + e.borderThickness / 2,
                    e.y3 + e.borderThickness / 2
                  ),
                  e.x2 + e.borderThickness / 2,
                  Math.min(
                    e.y2 - e.borderThickness / 2,
                    e.y3 - e.borderThickness / 2
                  ),
                  "transparent",
                  e.borderThickness,
                  e.color,
                  !1,
                  !1,
                  !1,
                  !1
                ),
                (f.globalAlpha = 1),
                (f.strokeStyle = e.whiskerColor),
                (f.lineWidth = 2 * e.whiskerThickness),
                0 < e.whiskerThickness &&
                  (f.beginPath(),
                  f.moveTo(Math.floor(e.x3 - e.whiskerLength / 2), e.y4),
                  f.lineTo(Math.ceil(e.x3 + e.whiskerLength / 2), e.y4),
                  f.stroke(),
                  f.beginPath(),
                  f.moveTo(Math.floor(e.x3 - e.whiskerLength / 2), e.y1),
                  f.lineTo(Math.ceil(e.x3 + e.whiskerLength / 2), e.y1),
                  f.stroke()),
                (f.globalAlpha = 1),
                (f.strokeStyle = e.lineColor),
                (f.lineWidth = 2 * e.lineThickness),
                0 < e.lineThickness &&
                  (f.beginPath(),
                  f.moveTo(e.x1, e.y5),
                  f.lineTo(e.x2, e.y5),
                  f.stroke()),
                f.restore(),
                (f.globalAlpha = 1))
              : "error" === c.type &&
                B(
                  f,
                  e.x1,
                  e.y1,
                  e.x2,
                  e.y2,
                  "white",
                  e.whiskerProperties,
                  e.stemProperties,
                  e.isXYSwapped,
                  0.3
                ));
        }
      }
      f.restore();
      f.globalAlpha = 1;
      f.beginPath();
    };
    $.prototype.getToolTipInnerHTML = function (a) {
      a = a.entries;
      for (
        var f = null, b = null, c = null, e = 0, g = "", h = !0, l = 0;
        l < a.length;
        l++
      )
        if (a[l].dataSeries.toolTipContent || a[l].dataPoint.toolTipContent) {
          h = !1;
          break;
        }
      if (
        h &&
        ((this.content && "function" === typeof this.content) ||
          this.contentFormatter)
      )
        (a = { chart: this.chart, toolTip: this.options, entries: a }),
          (f = this.contentFormatter
            ? this.contentFormatter(a)
            : this.content(a));
      else if (this.shared && "none" !== this.chart.plotInfo.axisPlacement) {
        for (var n = null, k = "", l = 0; l < a.length; l++)
          (b = a[l].dataSeries),
            (c = a[l].dataPoint),
            (e = a[l].index),
            (g = ""),
            0 === l &&
              h &&
              !this.content &&
              (this.chart.axisX && 0 < this.chart.axisX.length
                ? (k +=
                    "undefined" !== typeof this.chart.axisX[0].labels[c.x]
                      ? this.chart.axisX[0].labels[c.x]
                      : "{x}")
                : this.chart.axisX2 &&
                  0 < this.chart.axisX2.length &&
                  (k +=
                    "undefined" !== typeof this.chart.axisX2[0].labels[c.x]
                      ? this.chart.axisX2[0].labels[c.x]
                      : "{x}"),
              (k += "</br>"),
              (k = this.chart.replaceKeywordsWithValue(k, c, b, e))),
            null === c.toolTipContent ||
              ("undefined" === typeof c.toolTipContent &&
                null === b.options.toolTipContent) ||
              ("line" === b.type ||
              "stepLine" === b.type ||
              "spline" === b.type ||
              "area" === b.type ||
              "stepArea" === b.type ||
              "splineArea" === b.type ||
              "column" === b.type ||
              "bar" === b.type ||
              "scatter" === b.type ||
              "stackedColumn" === b.type ||
              "stackedColumn100" === b.type ||
              "stackedBar" === b.type ||
              "stackedBar100" === b.type ||
              "stackedArea" === b.type ||
              "stackedArea100" === b.type ||
              "waterfall" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (g +=
                      n != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (g += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span>&nbsp;&nbsp;{y}"),
                  (n = b.axisXIndex))
                : "bubble" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (g +=
                      n != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (g += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}"))
                : "rangeColumn" === b.type ||
                  "rangeBar" === b.type ||
                  "rangeArea" === b.type ||
                  "rangeSplineArea" === b.type ||
                  "error" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (g +=
                      n != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (g += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span>&nbsp;&nbsp;{y[0]},&nbsp;{y[1]}"))
                : "candlestick" === b.type || "ohlc" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (g +=
                      n != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (g += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low:&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}"))
                : "boxAndWhisker" === b.type &&
                  (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (g +=
                      n != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (g += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}")),
              null === f && (f = ""),
              !0 === this.reversed
                ? ((f = this.chart.replaceKeywordsWithValue(g, c, b, e) + f),
                  l < a.length - 1 && (f = "</br>" + f))
                : ((f += this.chart.replaceKeywordsWithValue(g, c, b, e)),
                  l < a.length - 1 && (f += "</br>")));
        null !== f && (f = k + f);
      } else {
        b = a[0].dataSeries;
        c = a[0].dataPoint;
        e = a[0].index;
        if (
          null === c.toolTipContent ||
          ("undefined" === typeof c.toolTipContent &&
            null === b.options.toolTipContent)
        )
          return null;
        "line" === b.type ||
        "stepLine" === b.type ||
        "spline" === b.type ||
        "area" === b.type ||
        "stepArea" === b.type ||
        "splineArea" === b.type ||
        "column" === b.type ||
        "bar" === b.type ||
        "scatter" === b.type ||
        "stackedColumn" === b.type ||
        "stackedColumn100" === b.type ||
        "stackedBar" === b.type ||
        "stackedBar100" === b.type ||
        "stackedArea" === b.type ||
        "stackedArea100" === b.type ||
        "waterfall" === b.type
          ? (g = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                ":</span>&nbsp;&nbsp;{y}")
          : "bubble" === b.type
          ? (g = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                ":</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}")
          : "pie" === b.type ||
            "doughnut" === b.type ||
            "funnel" === b.type ||
            "pyramid" === b.type
          ? (g = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.name
                  ? "{name}:</span>&nbsp;&nbsp;"
                  : c.label
                  ? "{label}:</span>&nbsp;&nbsp;"
                  : "</span>") +
                "{y}")
          : "rangeColumn" === b.type ||
            "rangeBar" === b.type ||
            "rangeArea" === b.type ||
            "rangeSplineArea" === b.type ||
            "error" === b.type
          ? (g = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                " :</span>&nbsp;&nbsp;{y[0]}, &nbsp;{y[1]}")
          : "candlestick" === b.type || "ohlc" === b.type
          ? (g = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                "</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low: &nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}")
          : "boxAndWhisker" === b.type &&
            (g = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                "</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}");
        null === f && (f = "");
        f += this.chart.replaceKeywordsWithValue(g, c, b, e);
      }
      return f;
    };
    $.prototype.enableAnimation = function () {
      if (!this.container.style.WebkitTransition) {
        var a = this.getContainerTransition(this.containerTransitionDuration);
        this.container.style.WebkitTransition = a;
        this.container.style.MsTransition = a;
        this.container.style.transition = a;
        this.container.style.MozTransition = this.mozContainerTransition;
      }
    };
    $.prototype.disableAnimation = function () {
      this.container.style.WebkitTransition &&
        ((this.container.style.WebkitTransition = ""),
        (this.container.style.MozTransition = ""),
        (this.container.style.MsTransition = ""),
        (this.container.style.transition = ""));
    };
    $.prototype.hide = function (a) {
      this.container &&
        ((this.container.style.display = "none"),
        (this.currentSeriesIndex = -1),
        (this._prevY = this._prevX = NaN),
        ("undefined" === typeof a || a) && this.chart.resetOverlayedCanvas());
    };
    $.prototype.show = function (a, f, b) {
      this._updateToolTip(a, f, "undefined" === typeof b ? !1 : b);
    };
    $.prototype.fixMozTransitionDelay = function (a, f) {
      if (20 < this.chart._eventManager.lastObjectId)
        this.mozContainerTransition = this.getContainerTransition(0);
      else {
        var b = parseFloat(this.container.style.left),
          b = isNaN(b) ? 0 : b,
          c = parseFloat(this.container.style.bottom),
          c = isNaN(c) ? 0 : c;
        10 < Math.sqrt(Math.pow(b - a, 2) + Math.pow(c - f, 2))
          ? (this.mozContainerTransition = this.getContainerTransition(0.1))
          : (this.mozContainerTransition = this.getContainerTransition(0));
      }
    };
    $.prototype.getContainerTransition = function (a) {
      return "left " + a + "s ease-out 0s, bottom " + a + "s ease-out 0s";
    };
    aa.prototype.reset = function () {
      this.lastObjectId = 0;
      this.objectMap = [];
      this.rectangularRegionEventSubscriptions = [];
      this.previousDataPointEventObject = null;
      this.eventObjects = [];
      v &&
        (this.ghostCtx.clearRect(0, 0, this.chart.width, this.chart.height),
        this.ghostCtx.beginPath());
    };
    aa.prototype.getNewObjectTrackingId = function () {
      return ++this.lastObjectId;
    };
    aa.prototype.mouseEventHandler = function (a) {
      if ("mousemove" === a.type || "click" === a.type) {
        var f = [],
          b = Na(a),
          c = null;
        if (
          (c = this.chart.getObjectAtXY(b.x, b.y, !1)) &&
          "undefined" !== typeof this.objectMap[c]
        )
          if (((c = this.objectMap[c]), "dataPoint" === c.objectType)) {
            var e = this.chart.data[c.dataSeriesIndex],
              g = e.dataPoints[c.dataPointIndex],
              h = c.dataPointIndex;
            c.eventParameter = {
              x: b.x,
              y: b.y,
              dataPoint: g,
              dataSeries: e.options,
              dataPointIndex: h,
              dataSeriesIndex: e.index,
              chart: this.chart,
            };
            c.eventContext = {
              context: g,
              userContext: g,
              mouseover: "mouseover",
              mousemove: "mousemove",
              mouseout: "mouseout",
              click: "click",
            };
            f.push(c);
            c = this.objectMap[e.id];
            c.eventParameter = {
              x: b.x,
              y: b.y,
              dataPoint: g,
              dataSeries: e.options,
              dataPointIndex: h,
              dataSeriesIndex: e.index,
              chart: this.chart,
            };
            c.eventContext = {
              context: e,
              userContext: e.options,
              mouseover: "mouseover",
              mousemove: "mousemove",
              mouseout: "mouseout",
              click: "click",
            };
            f.push(this.objectMap[e.id]);
          } else
            "legendItem" === c.objectType &&
              ((e = this.chart.data[c.dataSeriesIndex]),
              (g =
                null !== c.dataPointIndex
                  ? e.dataPoints[c.dataPointIndex]
                  : null),
              (c.eventParameter = {
                x: b.x,
                y: b.y,
                dataSeries: e.options,
                dataPoint: g,
                dataPointIndex: c.dataPointIndex,
                dataSeriesIndex: c.dataSeriesIndex,
                chart: this.chart,
              }),
              (c.eventContext = {
                context: this.chart.legend,
                userContext: this.chart.legend.options,
                mouseover: "itemmouseover",
                mousemove: "itemmousemove",
                mouseout: "itemmouseout",
                click: "itemclick",
              }),
              f.push(c));
        e = [];
        for (b = 0; b < this.mouseoveredObjectMaps.length; b++) {
          g = !0;
          for (c = 0; c < f.length; c++)
            if (f[c].id === this.mouseoveredObjectMaps[b].id) {
              g = !1;
              break;
            }
          g
            ? this.fireEvent(this.mouseoveredObjectMaps[b], "mouseout", a)
            : e.push(this.mouseoveredObjectMaps[b]);
        }
        this.mouseoveredObjectMaps = e;
        for (b = 0; b < f.length; b++) {
          e = !1;
          for (c = 0; c < this.mouseoveredObjectMaps.length; c++)
            if (f[b].id === this.mouseoveredObjectMaps[c].id) {
              e = !0;
              break;
            }
          e ||
            (this.fireEvent(f[b], "mouseover", a),
            this.mouseoveredObjectMaps.push(f[b]));
          "click" === a.type
            ? this.fireEvent(f[b], "click", a)
            : "mousemove" === a.type && this.fireEvent(f[b], "mousemove", a);
        }
      }
    };
    aa.prototype.fireEvent = function (a, f, b) {
      if (a && f) {
        var c = a.eventParameter,
          e = a.eventContext,
          g = a.eventContext.userContext;
        g && e && g[e[f]] && g[e[f]].call(g, c);
        "mouseout" !== f
          ? g.cursor &&
            g.cursor !== b.target.style.cursor &&
            (b.target.style.cursor = g.cursor)
          : ((b.target.style.cursor = this.chart._defaultCursor),
            delete a.eventParameter,
            delete a.eventContext);
        "click" === f &&
          "dataPoint" === a.objectType &&
          this.chart.pieDoughnutClickHandler &&
          this.chart.pieDoughnutClickHandler.call(
            this.chart.data[a.dataSeriesIndex],
            c
          );
        "click" === f &&
          "dataPoint" === a.objectType &&
          this.chart.funnelPyramidClickHandler &&
          this.chart.funnelPyramidClickHandler.call(
            this.chart.data[a.dataSeriesIndex],
            c
          );
      }
    };
    ha.prototype.animate = function (a, f, b, c, e) {
      var g = this;
      this.chart.isAnimating = !0;
      e = e || L.easing.linear;
      b &&
        this.animations.push({
          startTime: new Date().getTime() + (a ? a : 0),
          duration: f,
          animationCallback: b,
          onComplete: c,
        });
      for (a = []; 0 < this.animations.length; )
        if (
          ((f = this.animations.shift()),
          (b = new Date().getTime()),
          (c = 0),
          f.startTime <= b &&
            ((c = e(Math.min(b - f.startTime, f.duration), 0, 1, f.duration)),
            (c = Math.min(c, 1)),
            isNaN(c) || !isFinite(c)) &&
            (c = 1),
          1 > c && a.push(f),
          f.animationCallback(c),
          1 <= c && f.onComplete)
        )
          f.onComplete();
      this.animations = a;
      0 < this.animations.length
        ? (this.animationRequestId = this.chart.requestAnimFrame.call(
            window,
            function () {
              g.animate.call(g);
            }
          ))
        : (this.chart.isAnimating = !1);
    };
    ha.prototype.cancelAllAnimations = function () {
      this.animations = [];
      this.animationRequestId &&
        this.chart.cancelRequestAnimFrame.call(window, this.animationRequestId);
      this.animationRequestId = null;
      this.chart.isAnimating = !1;
    };
    var L = {
        yScaleAnimation: function (a, f) {
          if (0 !== a) {
            var b = f.dest,
              c = f.source.canvas,
              e = f.animationBase;
            b.drawImage(
              c,
              0,
              0,
              c.width,
              c.height,
              0,
              e - e * a,
              b.canvas.width / ga,
              (a * b.canvas.height) / ga
            );
          }
        },
        xScaleAnimation: function (a, f) {
          if (0 !== a) {
            var b = f.dest,
              c = f.source.canvas,
              e = f.animationBase;
            b.drawImage(
              c,
              0,
              0,
              c.width,
              c.height,
              e - e * a,
              0,
              (a * b.canvas.width) / ga,
              b.canvas.height / ga
            );
          }
        },
        xClipAnimation: function (a, f) {
          if (0 !== a) {
            var b = f.dest,
              c = f.source.canvas;
            b.save();
            0 < a &&
              b.drawImage(
                c,
                0,
                0,
                c.width * a,
                c.height,
                0,
                0,
                (c.width * a) / ga,
                c.height / ga
              );
            b.restore();
          }
        },
        fadeInAnimation: function (a, f) {
          if (0 !== a) {
            var b = f.dest,
              c = f.source.canvas;
            b.save();
            b.globalAlpha = a;
            b.drawImage(
              c,
              0,
              0,
              c.width,
              c.height,
              0,
              0,
              b.canvas.width / ga,
              b.canvas.height / ga
            );
            b.restore();
          }
        },
        easing: {
          linear: function (a, f, b, c) {
            return (b * a) / c + f;
          },
          easeOutQuad: function (a, f, b, c) {
            return -b * (a /= c) * (a - 2) + f;
          },
          easeOutQuart: function (a, f, b, c) {
            return -b * ((a = a / c - 1) * a * a * a - 1) + f;
          },
          easeInQuad: function (a, f, b, c) {
            return b * (a /= c) * a + f;
          },
          easeInQuart: function (a, f, b, c) {
            return b * (a /= c) * a * a * a + f;
          },
        },
      },
      fa = {
        drawMarker: function (a, f, b, c, e, g, h, l) {
          if (b) {
            var n = 1;
            b.fillStyle = g ? g : "#000000";
            b.strokeStyle = h ? h : "#000000";
            b.lineWidth = l ? l : 0;
            "circle" === c
              ? (b.moveTo(a, f),
                b.beginPath(),
                b.arc(a, f, e / 2, 0, 2 * Math.PI, !1),
                g && b.fill(),
                l &&
                  (h
                    ? b.stroke()
                    : ((n = b.globalAlpha),
                      (b.globalAlpha = 0.15),
                      (b.strokeStyle = "black"),
                      b.stroke(),
                      (b.globalAlpha = n))))
              : "square" === c
              ? (b.beginPath(),
                b.rect(a - e / 2, f - e / 2, e, e),
                g && b.fill(),
                l &&
                  (h
                    ? b.stroke()
                    : ((n = b.globalAlpha),
                      (b.globalAlpha = 0.15),
                      (b.strokeStyle = "black"),
                      b.stroke(),
                      (b.globalAlpha = n))))
              : "triangle" === c
              ? (b.beginPath(),
                b.moveTo(a - e / 2, f + e / 2),
                b.lineTo(a + e / 2, f + e / 2),
                b.lineTo(a, f - e / 2),
                b.closePath(),
                g && b.fill(),
                l &&
                  (h
                    ? b.stroke()
                    : ((n = b.globalAlpha),
                      (b.globalAlpha = 0.15),
                      (b.strokeStyle = "black"),
                      b.stroke(),
                      (b.globalAlpha = n))),
                b.beginPath())
              : "cross" === c &&
                ((b.strokeStyle = g),
                (b.lineWidth = e / 4),
                b.beginPath(),
                b.moveTo(a - e / 2, f - e / 2),
                b.lineTo(a + e / 2, f + e / 2),
                b.stroke(),
                b.moveTo(a + e / 2, f - e / 2),
                b.lineTo(a - e / 2, f + e / 2),
                b.stroke());
          }
        },
        drawMarkers: function (a) {
          for (var f = 0; f < a.length; f++) {
            var b = a[f];
            fa.drawMarker(
              b.x,
              b.y,
              b.ctx,
              b.type,
              b.size,
              b.color,
              b.borderColor,
              b.borderThickness
            );
          }
        },
      };
    return s;
  })();
  x.Chart.version = "v2.0.1 GA";
})();

/*
  excanvas is used to support IE678 which do not implement HTML5 Canvas Element. You can safely remove the following excanvas code if you don't need to support older browsers.

  Copyright 2006 Google Inc. https://code.google.com/p/explorercanvas/
  Licensed under the Apache License, Version 2.0
*/
document.createElement("canvas").getContext ||
  (function () {
    function V() {
      return this.context_ || (this.context_ = new C(this));
    }
    function W(a, b, c) {
      var g = M.call(arguments, 2);
      return function () {
        return a.apply(b, g.concat(M.call(arguments)));
      };
    }
    function N(a) {
      return String(a).replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    }
    function O(a) {
      a.namespaces.g_vml_ ||
        a.namespaces.add(
          "g_vml_",
          "urn:schemas-microsoft-com:vml",
          "#default#VML"
        );
      a.namespaces.g_o_ ||
        a.namespaces.add(
          "g_o_",
          "urn:schemas-microsoft-com:office:office",
          "#default#VML"
        );
      a.styleSheets.ex_canvas_ ||
        ((a = a.createStyleSheet()),
        (a.owningElement.id = "ex_canvas_"),
        (a.cssText =
          "canvas{display:inline-block;overflow:hidden;text-align:left;width:300px;height:150px}"));
    }
    function X(a) {
      var b = a.srcElement;
      switch (a.propertyName) {
        case "width":
          b.getContext().clearRect();
          b.style.width = b.attributes.width.nodeValue + "px";
          b.firstChild.style.width = b.clientWidth + "px";
          break;
        case "height":
          b.getContext().clearRect(),
            (b.style.height = b.attributes.height.nodeValue + "px"),
            (b.firstChild.style.height = b.clientHeight + "px");
      }
    }
    function Y(a) {
      a = a.srcElement;
      a.firstChild &&
        ((a.firstChild.style.width = a.clientWidth + "px"),
        (a.firstChild.style.height = a.clientHeight + "px"));
    }
    function D() {
      return [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1],
      ];
    }
    function t(a, b) {
      for (var c = D(), g = 0; 3 > g; g++)
        for (var e = 0; 3 > e; e++) {
          for (var f = 0, d = 0; 3 > d; d++) f += a[g][d] * b[d][e];
          c[g][e] = f;
        }
      return c;
    }
    function P(a, b) {
      b.fillStyle = a.fillStyle;
      b.lineCap = a.lineCap;
      b.lineJoin = a.lineJoin;
      b.lineWidth = a.lineWidth;
      b.miterLimit = a.miterLimit;
      b.shadowBlur = a.shadowBlur;
      b.shadowColor = a.shadowColor;
      b.shadowOffsetX = a.shadowOffsetX;
      b.shadowOffsetY = a.shadowOffsetY;
      b.strokeStyle = a.strokeStyle;
      b.globalAlpha = a.globalAlpha;
      b.font = a.font;
      b.textAlign = a.textAlign;
      b.textBaseline = a.textBaseline;
      b.arcScaleX_ = a.arcScaleX_;
      b.arcScaleY_ = a.arcScaleY_;
      b.lineScale_ = a.lineScale_;
    }
    function Q(a) {
      var b = a.indexOf("(", 3),
        c = a.indexOf(")", b + 1),
        b = a.substring(b + 1, c).split(",");
      if (4 != b.length || "a" != a.charAt(3)) b[3] = 1;
      return b;
    }
    function E(a, b, c) {
      return Math.min(c, Math.max(b, a));
    }
    function F(a, b, c) {
      0 > c && c++;
      1 < c && c--;
      return 1 > 6 * c
        ? a + 6 * (b - a) * c
        : 1 > 2 * c
        ? b
        : 2 > 3 * c
        ? a + 6 * (b - a) * (2 / 3 - c)
        : a;
    }
    function G(a) {
      if (a in H) return H[a];
      var b,
        c = 1;
      a = String(a);
      if ("#" == a.charAt(0)) b = a;
      else if (/^rgb/.test(a)) {
        c = Q(a);
        b = "#";
        for (var g, e = 0; 3 > e; e++)
          (g =
            -1 != c[e].indexOf("%")
              ? Math.floor(255 * (parseFloat(c[e]) / 100))
              : +c[e]),
            (b += v[E(g, 0, 255)]);
        c = +c[3];
      } else if (/^hsl/.test(a)) {
        e = c = Q(a);
        b = (parseFloat(e[0]) / 360) % 360;
        0 > b && b++;
        g = E(parseFloat(e[1]) / 100, 0, 1);
        e = E(parseFloat(e[2]) / 100, 0, 1);
        if (0 == g) g = e = b = e;
        else {
          var f = 0.5 > e ? e * (1 + g) : e + g - e * g,
            d = 2 * e - f;
          g = F(d, f, b + 1 / 3);
          e = F(d, f, b);
          b = F(d, f, b - 1 / 3);
        }
        b =
          "#" +
          v[Math.floor(255 * g)] +
          v[Math.floor(255 * e)] +
          v[Math.floor(255 * b)];
        c = c[3];
      } else b = Z[a] || a;
      return (H[a] = { color: b, alpha: c });
    }
    function C(a) {
      this.m_ = D();
      this.mStack_ = [];
      this.aStack_ = [];
      this.currentPath_ = [];
      this.fillStyle = this.strokeStyle = "#000";
      this.lineWidth = 1;
      this.lineJoin = "miter";
      this.lineCap = "butt";
      this.miterLimit = 1 * q;
      this.globalAlpha = 1;
      this.font = "10px sans-serif";
      this.textAlign = "left";
      this.textBaseline = "alphabetic";
      this.canvas = a;
      var b =
          "width:" +
          a.clientWidth +
          "px;height:" +
          a.clientHeight +
          "px;overflow:hidden;position:absolute",
        c = a.ownerDocument.createElement("div");
      c.style.cssText = b;
      a.appendChild(c);
      b = c.cloneNode(!1);
      b.style.backgroundColor = "red";
      b.style.filter = "alpha(opacity=0)";
      a.appendChild(b);
      this.element_ = c;
      this.lineScale_ = this.arcScaleY_ = this.arcScaleX_ = 1;
    }
    function R(a, b, c, g) {
      a.currentPath_.push({
        type: "bezierCurveTo",
        cp1x: b.x,
        cp1y: b.y,
        cp2x: c.x,
        cp2y: c.y,
        x: g.x,
        y: g.y,
      });
      a.currentX_ = g.x;
      a.currentY_ = g.y;
    }
    function S(a, b) {
      var c = G(a.strokeStyle),
        g = c.color,
        c = c.alpha * a.globalAlpha,
        e = a.lineScale_ * a.lineWidth;
      1 > e && (c *= e);
      b.push(
        "<g_vml_:stroke",
        ' opacity="',
        c,
        '"',
        ' joinstyle="',
        a.lineJoin,
        '"',
        ' miterlimit="',
        a.miterLimit,
        '"',
        ' endcap="',
        $[a.lineCap] || "square",
        '"',
        ' weight="',
        e,
        'px"',
        ' color="',
        g,
        '" />'
      );
    }
    function T(a, b, c, g) {
      var e = a.fillStyle,
        f = a.arcScaleX_,
        d = a.arcScaleY_,
        k = g.x - c.x,
        n = g.y - c.y;
      if (e instanceof w) {
        var h = 0,
          l = (g = 0),
          u = 0,
          m = 1;
        if ("gradient" == e.type_) {
          h = e.x1_ / f;
          c = e.y1_ / d;
          var p = s(a, e.x0_ / f, e.y0_ / d),
            h = s(a, h, c),
            h = (180 * Math.atan2(h.x - p.x, h.y - p.y)) / Math.PI;
          0 > h && (h += 360);
          1e-6 > h && (h = 0);
        } else
          (p = s(a, e.x0_, e.y0_)),
            (g = (p.x - c.x) / k),
            (l = (p.y - c.y) / n),
            (k /= f * q),
            (n /= d * q),
            (m = x.max(k, n)),
            (u = (2 * e.r0_) / m),
            (m = (2 * e.r1_) / m - u);
        f = e.colors_;
        f.sort(function (a, b) {
          return a.offset - b.offset;
        });
        d = f.length;
        p = f[0].color;
        c = f[d - 1].color;
        k = f[0].alpha * a.globalAlpha;
        a = f[d - 1].alpha * a.globalAlpha;
        for (var n = [], r = 0; r < d; r++) {
          var t = f[r];
          n.push(t.offset * m + u + " " + t.color);
        }
        b.push(
          '<g_vml_:fill type="',
          e.type_,
          '"',
          ' method="none" focus="100%"',
          ' color="',
          p,
          '"',
          ' color2="',
          c,
          '"',
          ' colors="',
          n.join(","),
          '"',
          ' opacity="',
          a,
          '"',
          ' g_o_:opacity2="',
          k,
          '"',
          ' angle="',
          h,
          '"',
          ' focusposition="',
          g,
          ",",
          l,
          '" />'
        );
      } else
        e instanceof I
          ? k &&
            n &&
            b.push(
              "<g_vml_:fill",
              ' position="',
              (-c.x / k) * f * f,
              ",",
              (-c.y / n) * d * d,
              '"',
              ' type="tile"',
              ' src="',
              e.src_,
              '" />'
            )
          : ((e = G(a.fillStyle)),
            b.push(
              '<g_vml_:fill color="',
              e.color,
              '" opacity="',
              e.alpha * a.globalAlpha,
              '" />'
            ));
    }
    function s(a, b, c) {
      a = a.m_;
      return {
        x: q * (b * a[0][0] + c * a[1][0] + a[2][0]) - r,
        y: q * (b * a[0][1] + c * a[1][1] + a[2][1]) - r,
      };
    }
    function z(a, b, c) {
      isFinite(b[0][0]) &&
        isFinite(b[0][1]) &&
        isFinite(b[1][0]) &&
        isFinite(b[1][1]) &&
        isFinite(b[2][0]) &&
        isFinite(b[2][1]) &&
        ((a.m_ = b),
        c && (a.lineScale_ = aa(ba(b[0][0] * b[1][1] - b[0][1] * b[1][0]))));
    }
    function w(a) {
      this.type_ = a;
      this.r1_ = this.y1_ = this.x1_ = this.r0_ = this.y0_ = this.x0_ = 0;
      this.colors_ = [];
    }
    function I(a, b) {
      if (!a || 1 != a.nodeType || "IMG" != a.tagName)
        throw new A("TYPE_MISMATCH_ERR");
      if ("complete" != a.readyState) throw new A("INVALID_STATE_ERR");
      switch (b) {
        case "repeat":
        case null:
        case "":
          this.repetition_ = "repeat";
          break;
        case "repeat-x":
        case "repeat-y":
        case "no-repeat":
          this.repetition_ = b;
          break;
        default:
          throw new A("SYNTAX_ERR");
      }
      this.src_ = a.src;
      this.width_ = a.width;
      this.height_ = a.height;
    }
    function A(a) {
      this.code = this[a];
      this.message = a + ": DOM Exception " + this.code;
    }
    var x = Math,
      k = x.round,
      J = x.sin,
      K = x.cos,
      ba = x.abs,
      aa = x.sqrt,
      q = 10,
      r = q / 2;
    navigator.userAgent.match(/MSIE ([\d.]+)?/);
    var M = Array.prototype.slice;
    O(document);
    var U = {
      init: function (a) {
        a = a || document;
        a.createElement("canvas");
        a.attachEvent("onreadystatechange", W(this.init_, this, a));
      },
      init_: function (a) {
        a = a.getElementsByTagName("canvas");
        for (var b = 0; b < a.length; b++) this.initElement(a[b]);
      },
      initElement: function (a) {
        if (!a.getContext) {
          a.getContext = V;
          O(a.ownerDocument);
          a.innerHTML = "";
          a.attachEvent("onpropertychange", X);
          a.attachEvent("onresize", Y);
          var b = a.attributes;
          b.width && b.width.specified
            ? (a.style.width = b.width.nodeValue + "px")
            : (a.width = a.clientWidth);
          b.height && b.height.specified
            ? (a.style.height = b.height.nodeValue + "px")
            : (a.height = a.clientHeight);
        }
        return a;
      },
    };
    U.init();
    for (var v = [], d = 0; 16 > d; d++)
      for (var B = 0; 16 > B; B++)
        v[16 * d + B] = d.toString(16) + B.toString(16);
    var Z = {
        aliceblue: "#F0F8FF",
        antiquewhite: "#FAEBD7",
        aquamarine: "#7FFFD4",
        azure: "#F0FFFF",
        beige: "#F5F5DC",
        bisque: "#FFE4C4",
        black: "#000000",
        blanchedalmond: "#FFEBCD",
        blueviolet: "#8A2BE2",
        brown: "#A52A2A",
        burlywood: "#DEB887",
        cadetblue: "#5F9EA0",
        chartreuse: "#7FFF00",
        chocolate: "#D2691E",
        coral: "#FF7F50",
        cornflowerblue: "#6495ED",
        cornsilk: "#FFF8DC",
        crimson: "#DC143C",
        cyan: "#00FFFF",
        darkblue: "#00008B",
        darkcyan: "#008B8B",
        darkgoldenrod: "#B8860B",
        darkgrey: "#A9A9A9",
        darkgreen: "#006400",
        darkgrey: "#A9A9A9",
        darkkhaki: "#BDB76B",
        darkmagenta: "#8B008B",
        darkolivegreen: "#556B2F",
        darkorange: "#FF8C00",
        darkorchid: "#9932CC",
        darkred: "#8B0000",
        darksalmon: "#E9967A",
        darkseagreen: "#8FBC8F",
        darkslateblue: "#483D8B",
        darkslategrey: "#2F4F4F",
        darkslategrey: "#2F4F4F",
        darkturquoise: "#00CED1",
        darkviolet: "#9400D3",
        deeppink: "#FF1493",
        deepskyblue: "#00BFFF",
        dimgrey: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1E90FF",
        firebrick: "#B22222",
        floralwhite: "#FFFAF0",
        forestgreen: "#228B22",
        gainsboro: "#DCDCDC",
        ghostwhite: "#F8F8FF",
        gold: "#FFD700",
        goldenrod: "#DAA520",
        grey: "#808080",
        greenyellow: "#ADFF2F",
        honeydew: "#F0FFF0",
        hotpink: "#FF69B4",
        indianred: "#CD5C5C",
        indigo: "#4B0082",
        ivory: "#FFFFF0",
        khaki: "#F0E68C",
        lavender: "#E6E6FA",
        lavenderblush: "#FFF0F5",
        lawngreen: "#7CFC00",
        lemonchiffon: "#FFFACD",
        lightblue: "#ADD8E6",
        lightcoral: "#F08080",
        lightcyan: "#E0FFFF",
        lightgoldenrodyellow: "#FAFAD2",
        lightgreen: "#90EE90",
        lightgrey: "#D3D3D3",
        lightpink: "#FFB6C1",
        lightsalmon: "#FFA07A",
        lightseagreen: "#20B2AA",
        lightskyblue: "#87CEFA",
        lightslategrey: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#B0C4DE",
        lightyellow: "#FFFFE0",
        limegreen: "#32CD32",
        linen: "#FAF0E6",
        magenta: "#FF00FF",
        mediumaquamarine: "#66CDAA",
        mediumblue: "#0000CD",
        mediumorchid: "#BA55D3",
        mediumpurple: "#9370DB",
        mediumseagreen: "#3CB371",
        mediumslateblue: "#7B68EE",
        mediumspringgreen: "#00FA9A",
        mediumturquoise: "#48D1CC",
        mediumvioletred: "#C71585",
        midnightblue: "#191970",
        mintcream: "#F5FFFA",
        mistyrose: "#FFE4E1",
        moccasin: "#FFE4B5",
        navajowhite: "#FFDEAD",
        oldlace: "#FDF5E6",
        olivedrab: "#6B8E23",
        orange: "#FFA500",
        orangered: "#FF4500",
        orchid: "#DA70D6",
        palegoldenrod: "#EEE8AA",
        palegreen: "#98FB98",
        paleturquoise: "#AFEEEE",
        palevioletred: "#DB7093",
        papayawhip: "#FFEFD5",
        peachpuff: "#FFDAB9",
        peru: "#CD853F",
        pink: "#FFC0CB",
        plum: "#DDA0DD",
        powderblue: "#B0E0E6",
        rosybrown: "#BC8F8F",
        royalblue: "#4169E1",
        saddlebrown: "#8B4513",
        salmon: "#FA8072",
        sandybrown: "#F4A460",
        seagreen: "#2E8B57",
        seashell: "#FFF5EE",
        sienna: "#A0522D",
        skyblue: "#87CEEB",
        slateblue: "#6A5ACD",
        slategrey: "#708090",
        slategrey: "#708090",
        snow: "#FFFAFA",
        springgreen: "#00FF7F",
        steelblue: "#4682B4",
        tan: "#D2B48C",
        thistle: "#D8BFD8",
        tomato: "#FF6347",
        turquoise: "#40E0D0",
        violet: "#EE82EE",
        wheat: "#F5DEB3",
        whitesmoke: "#F5F5F5",
        yellowgreen: "#9ACD32",
      },
      H = {},
      L = {},
      $ = { butt: "flat", round: "round" },
      d = C.prototype;
    d.clearRect = function () {
      this.textMeasureEl_ &&
        (this.textMeasureEl_.removeNode(!0), (this.textMeasureEl_ = null));
      this.element_.innerHTML = "";
    };
    d.beginPath = function () {
      this.currentPath_ = [];
    };
    d.moveTo = function (a, b) {
      var c = s(this, a, b);
      this.currentPath_.push({ type: "moveTo", x: c.x, y: c.y });
      this.currentX_ = c.x;
      this.currentY_ = c.y;
    };
    d.lineTo = function (a, b) {
      var c = s(this, a, b);
      this.currentPath_.push({ type: "lineTo", x: c.x, y: c.y });
      this.currentX_ = c.x;
      this.currentY_ = c.y;
    };
    d.bezierCurveTo = function (a, b, c, g, e, f) {
      e = s(this, e, f);
      a = s(this, a, b);
      c = s(this, c, g);
      R(this, a, c, e);
    };
    d.quadraticCurveTo = function (a, b, c, g) {
      a = s(this, a, b);
      c = s(this, c, g);
      g = {
        x: this.currentX_ + (2 / 3) * (a.x - this.currentX_),
        y: this.currentY_ + (2 / 3) * (a.y - this.currentY_),
      };
      R(
        this,
        g,
        {
          x: g.x + (c.x - this.currentX_) / 3,
          y: g.y + (c.y - this.currentY_) / 3,
        },
        c
      );
    };
    d.arc = function (a, b, c, g, e, f) {
      c *= q;
      var d = f ? "at" : "wa",
        k = a + K(g) * c - r,
        n = b + J(g) * c - r;
      g = a + K(e) * c - r;
      e = b + J(e) * c - r;
      k != g || f || (k += 0.125);
      a = s(this, a, b);
      k = s(this, k, n);
      g = s(this, g, e);
      this.currentPath_.push({
        type: d,
        x: a.x,
        y: a.y,
        radius: c,
        xStart: k.x,
        yStart: k.y,
        xEnd: g.x,
        yEnd: g.y,
      });
    };
    d.rect = function (a, b, c, g) {
      this.moveTo(a, b);
      this.lineTo(a + c, b);
      this.lineTo(a + c, b + g);
      this.lineTo(a, b + g);
      this.closePath();
    };
    d.strokeRect = function (a, b, c, g) {
      var e = this.currentPath_;
      this.beginPath();
      this.moveTo(a, b);
      this.lineTo(a + c, b);
      this.lineTo(a + c, b + g);
      this.lineTo(a, b + g);
      this.closePath();
      this.stroke();
      this.currentPath_ = e;
    };
    d.fillRect = function (a, b, c, g) {
      var e = this.currentPath_;
      this.beginPath();
      this.moveTo(a, b);
      this.lineTo(a + c, b);
      this.lineTo(a + c, b + g);
      this.lineTo(a, b + g);
      this.closePath();
      this.fill();
      this.currentPath_ = e;
    };
    d.createLinearGradient = function (a, b, c, g) {
      var e = new w("gradient");
      e.x0_ = a;
      e.y0_ = b;
      e.x1_ = c;
      e.y1_ = g;
      return e;
    };
    d.createRadialGradient = function (a, b, c, g, e, f) {
      var d = new w("gradientradial");
      d.x0_ = a;
      d.y0_ = b;
      d.r0_ = c;
      d.x1_ = g;
      d.y1_ = e;
      d.r1_ = f;
      return d;
    };
    d.drawImage = function (a, b) {
      var c, g, e, d, r, y, n, h;
      e = a.runtimeStyle.width;
      d = a.runtimeStyle.height;
      a.runtimeStyle.width = "auto";
      a.runtimeStyle.height = "auto";
      var l = a.width,
        u = a.height;
      a.runtimeStyle.width = e;
      a.runtimeStyle.height = d;
      if (3 == arguments.length)
        (c = arguments[1]),
          (g = arguments[2]),
          (r = y = 0),
          (n = e = l),
          (h = d = u);
      else if (5 == arguments.length)
        (c = arguments[1]),
          (g = arguments[2]),
          (e = arguments[3]),
          (d = arguments[4]),
          (r = y = 0),
          (n = l),
          (h = u);
      else if (9 == arguments.length)
        (r = arguments[1]),
          (y = arguments[2]),
          (n = arguments[3]),
          (h = arguments[4]),
          (c = arguments[5]),
          (g = arguments[6]),
          (e = arguments[7]),
          (d = arguments[8]);
      else throw Error("Invalid number of arguments");
      var m = s(this, c, g),
        p = [];
      p.push(
        " <g_vml_:group",
        ' coordsize="',
        10 * q,
        ",",
        10 * q,
        '"',
        ' coordorigin="0,0"',
        ' style="width:',
        10,
        "px;height:",
        10,
        "px;position:absolute;"
      );
      if (
        1 != this.m_[0][0] ||
        this.m_[0][1] ||
        1 != this.m_[1][1] ||
        this.m_[1][0]
      ) {
        var t = [];
        t.push(
          "M11=",
          this.m_[0][0],
          ",",
          "M12=",
          this.m_[1][0],
          ",",
          "M21=",
          this.m_[0][1],
          ",",
          "M22=",
          this.m_[1][1],
          ",",
          "Dx=",
          k(m.x / q),
          ",",
          "Dy=",
          k(m.y / q),
          ""
        );
        var v = s(this, c + e, g),
          w = s(this, c, g + d);
        c = s(this, c + e, g + d);
        m.x = x.max(m.x, v.x, w.x, c.x);
        m.y = x.max(m.y, v.y, w.y, c.y);
        p.push(
          "padding:0 ",
          k(m.x / q),
          "px ",
          k(m.y / q),
          "px 0;filter:progid:DXImageTransform.Microsoft.Matrix(",
          t.join(""),
          ", sizingmethod='clip');"
        );
      } else p.push("top:", k(m.y / q), "px;left:", k(m.x / q), "px;");
      p.push(
        ' ">',
        '<g_vml_:image src="',
        a.src,
        '"',
        ' style="width:',
        q * e,
        "px;",
        " height:",
        q * d,
        'px"',
        ' cropleft="',
        r / l,
        '"',
        ' croptop="',
        y / u,
        '"',
        ' cropright="',
        (l - r - n) / l,
        '"',
        ' cropbottom="',
        (u - y - h) / u,
        '"',
        " />",
        "</g_vml_:group>"
      );
      this.element_.insertAdjacentHTML("BeforeEnd", p.join(""));
    };
    d.stroke = function (a) {
      var b = [];
      b.push(
        "<g_vml_:shape",
        ' filled="',
        !!a,
        '"',
        ' style="position:absolute;width:',
        10,
        "px;height:",
        10,
        'px;"',
        ' coordorigin="0,0"',
        ' coordsize="',
        10 * q,
        ",",
        10 * q,
        '"',
        ' stroked="',
        !a,
        '"',
        ' path="'
      );
      for (
        var c = { x: null, y: null }, d = { x: null, y: null }, e = 0;
        e < this.currentPath_.length;
        e++
      ) {
        var f = this.currentPath_[e];
        switch (f.type) {
          case "moveTo":
            b.push(" m ", k(f.x), ",", k(f.y));
            break;
          case "lineTo":
            b.push(" l ", k(f.x), ",", k(f.y));
            break;
          case "close":
            b.push(" x ");
            f = null;
            break;
          case "bezierCurveTo":
            b.push(
              " c ",
              k(f.cp1x),
              ",",
              k(f.cp1y),
              ",",
              k(f.cp2x),
              ",",
              k(f.cp2y),
              ",",
              k(f.x),
              ",",
              k(f.y)
            );
            break;
          case "at":
          case "wa":
            b.push(
              " ",
              f.type,
              " ",
              k(f.x - this.arcScaleX_ * f.radius),
              ",",
              k(f.y - this.arcScaleY_ * f.radius),
              " ",
              k(f.x + this.arcScaleX_ * f.radius),
              ",",
              k(f.y + this.arcScaleY_ * f.radius),
              " ",
              k(f.xStart),
              ",",
              k(f.yStart),
              " ",
              k(f.xEnd),
              ",",
              k(f.yEnd)
            );
        }
        if (f) {
          if (null == c.x || f.x < c.x) c.x = f.x;
          if (null == d.x || f.x > d.x) d.x = f.x;
          if (null == c.y || f.y < c.y) c.y = f.y;
          if (null == d.y || f.y > d.y) d.y = f.y;
        }
      }
      b.push(' ">');
      a ? T(this, b, c, d) : S(this, b);
      b.push("</g_vml_:shape>");
      this.element_.insertAdjacentHTML("beforeEnd", b.join(""));
    };
    d.fill = function () {
      this.stroke(!0);
    };
    d.closePath = function () {
      this.currentPath_.push({ type: "close" });
    };
    d.save = function () {
      var a = {};
      P(this, a);
      this.aStack_.push(a);
      this.mStack_.push(this.m_);
      this.m_ = t(D(), this.m_);
    };
    d.restore = function () {
      this.aStack_.length &&
        (P(this.aStack_.pop(), this), (this.m_ = this.mStack_.pop()));
    };
    d.translate = function (a, b) {
      z(
        this,
        t(
          [
            [1, 0, 0],
            [0, 1, 0],
            [a, b, 1],
          ],
          this.m_
        ),
        !1
      );
    };
    d.rotate = function (a) {
      var b = K(a);
      a = J(a);
      z(
        this,
        t(
          [
            [b, a, 0],
            [-a, b, 0],
            [0, 0, 1],
          ],
          this.m_
        ),
        !1
      );
    };
    d.scale = function (a, b) {
      this.arcScaleX_ *= a;
      this.arcScaleY_ *= b;
      z(
        this,
        t(
          [
            [a, 0, 0],
            [0, b, 0],
            [0, 0, 1],
          ],
          this.m_
        ),
        !0
      );
    };
    d.transform = function (a, b, c, d, e, f) {
      z(
        this,
        t(
          [
            [a, b, 0],
            [c, d, 0],
            [e, f, 1],
          ],
          this.m_
        ),
        !0
      );
    };
    d.setTransform = function (a, b, c, d, e, f) {
      z(
        this,
        [
          [a, b, 0],
          [c, d, 0],
          [e, f, 1],
        ],
        !0
      );
    };
    d.drawText_ = function (a, b, c, d, e) {
      var f = this.m_;
      d = 0;
      var r = 1e3,
        t = 0,
        n = [],
        h;
      h = this.font;
      if (L[h]) h = L[h];
      else {
        var l = document.createElement("div").style;
        try {
          l.font = h;
        } catch (u) {}
        h = L[h] = {
          style: l.fontStyle || "normal",
          variant: l.fontVariant || "normal",
          weight: l.fontWeight || "normal",
          size: l.fontSize || 10,
          family: l.fontFamily || "sans-serif",
        };
      }
      var l = h,
        m = this.element_;
      h = {};
      for (var p in l) h[p] = l[p];
      p = parseFloat(m.currentStyle.fontSize);
      m = parseFloat(l.size);
      "number" == typeof l.size
        ? (h.size = l.size)
        : -1 != l.size.indexOf("px")
        ? (h.size = m)
        : -1 != l.size.indexOf("em")
        ? (h.size = p * m)
        : -1 != l.size.indexOf("%")
        ? (h.size = (p / 100) * m)
        : -1 != l.size.indexOf("pt")
        ? (h.size = m / 0.75)
        : (h.size = p);
      h.size *= 0.981;
      p =
        h.style +
        " " +
        h.variant +
        " " +
        h.weight +
        " " +
        h.size +
        "px " +
        h.family;
      m = this.element_.currentStyle;
      l = this.textAlign.toLowerCase();
      switch (l) {
        case "left":
        case "center":
        case "right":
          break;
        case "end":
          l = "ltr" == m.direction ? "right" : "left";
          break;
        case "start":
          l = "rtl" == m.direction ? "right" : "left";
          break;
        default:
          l = "left";
      }
      switch (this.textBaseline) {
        case "hanging":
        case "top":
          t = h.size / 1.75;
          break;
        case "middle":
          break;
        default:
        case null:
        case "alphabetic":
        case "ideographic":
        case "bottom":
          t = -h.size / 2.25;
      }
      switch (l) {
        case "right":
          d = 1e3;
          r = 0.05;
          break;
        case "center":
          d = r = 500;
      }
      b = s(this, b + 0, c + t);
      n.push(
        '<g_vml_:line from="',
        -d,
        ' 0" to="',
        r,
        ' 0.05" ',
        ' coordsize="100 100" coordorigin="0 0"',
        ' filled="',
        !e,
        '" stroked="',
        !!e,
        '" style="position:absolute;width:1px;height:1px;">'
      );
      e ? S(this, n) : T(this, n, { x: -d, y: 0 }, { x: r, y: h.size });
      e =
        f[0][0].toFixed(3) +
        "," +
        f[1][0].toFixed(3) +
        "," +
        f[0][1].toFixed(3) +
        "," +
        f[1][1].toFixed(3) +
        ",0,0";
      b = k(b.x / q) + "," + k(b.y / q);
      n.push(
        '<g_vml_:skew on="t" matrix="',
        e,
        '" ',
        ' offset="',
        b,
        '" origin="',
        d,
        ' 0" />',
        '<g_vml_:path textpathok="true" />',
        '<g_vml_:textpath on="true" string="',
        N(a),
        '" style="v-text-align:',
        l,
        ";font:",
        N(p),
        '" /></g_vml_:line>'
      );
      this.element_.insertAdjacentHTML("beforeEnd", n.join(""));
    };
    d.fillText = function (a, b, c, d) {
      this.drawText_(a, b, c, d, !1);
    };
    d.strokeText = function (a, b, c, d) {
      this.drawText_(a, b, c, d, !0);
    };
    d.measureText = function (a) {
      this.textMeasureEl_ ||
        (this.element_.insertAdjacentHTML(
          "beforeEnd",
          '<span style="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;"></span>'
        ),
        (this.textMeasureEl_ = this.element_.lastChild));
      var b = this.element_.ownerDocument;
      this.textMeasureEl_.innerHTML = "";
      this.textMeasureEl_.style.font = this.font;
      this.textMeasureEl_.appendChild(b.createTextNode(a));
      return { width: this.textMeasureEl_.offsetWidth };
    };
    d.clip = function () {};
    d.arcTo = function () {};
    d.createPattern = function (a, b) {
      return new I(a, b);
    };
    w.prototype.addColorStop = function (a, b) {
      b = G(b);
      this.colors_.push({ offset: a, color: b.color, alpha: b.alpha });
    };
    d = A.prototype = Error();
    d.INDEX_SIZE_ERR = 1;
    d.DOMSTRING_SIZE_ERR = 2;
    d.HIERARCHY_REQUEST_ERR = 3;
    d.WRONG_DOCUMENT_ERR = 4;
    d.INVALID_CHARACTER_ERR = 5;
    d.NO_DATA_ALLOWED_ERR = 6;
    d.NO_MODIFICATION_ALLOWED_ERR = 7;
    d.NOT_FOUND_ERR = 8;
    d.NOT_SUPPORTED_ERR = 9;
    d.INUSE_ATTRIBUTE_ERR = 10;
    d.INVALID_STATE_ERR = 11;
    d.SYNTAX_ERR = 12;
    d.INVALID_MODIFICATION_ERR = 13;
    d.NAMESPACE_ERR = 14;
    d.INVALID_ACCESS_ERR = 15;
    d.VALIDATION_ERR = 16;
    d.TYPE_MISMATCH_ERR = 17;
    G_vmlCanvasManager = U;
    CanvasRenderingContext2D = C;
    CanvasGradient = w;
    CanvasPattern = I;
    DOMException = A;
  })();
/*eslint-enable*/
